export const options = [
  { label: "Lost", value: "Lost" },
  { label: "Won", value: "Won" },
  { label: "All", value: "All" },
  { label: "Pending", value: "Pending" },
  { label: "Void", value: "Void" },
]

export const getData = (key = "") => {
  let data = [
    {
      totAmount: 3000,
      totWin: 800,
      product: "Romeo and Juliet",
      category: "Casino",
      username: 256774810030,
      ID: 17810,
      Date: "31/08/2021 11:29:02",
      channel: "Mobile",
      tax: 0,
      Status: "Pending",
    },
    {
      totAmount: 500.4,
      totWin: 0,
      product: "5 Lions Gold",
      category: "Casino",
      username: 256774810030,
      ID: 17809,
      Date: "31/08/2021 11:25:35",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 400,
      totWin: 0,
      product: "Fantastic League",
      category: "Virtuals",
      username: 256754267754,
      ID: 17808,
      Date: "31/08/2021 09:51:48",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 1000,
      totWin: 0,
      product: "Fantastic League",
      category: "Virtuals",
      username: 256754267754,
      ID: 17807,
      Date: "31/08/2021 09:47:01",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 17806,
      Date: "31/08/2021 06:44:17",
      channel: "Mobile",
      tax: 0,
      Status: "Won",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 17805,
      Date: "30/08/2021 15:41:35",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 17804,
      Date: "30/08/2021 15:41:34",
      channel: "Mobile",
      tax: 0,
      Status: "Won",
    },
    {
      totAmount: 1500,
      totWin: 0,
      product: "Gold Rush 250,000",
      category: "Scratch Cards",
      username: 256774810030,
      ID: 17803,
      Date: "30/08/2021 17:15:58",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 4500,
      totWin: 1050,
      product: "8 Dragons",
      category: "Casino",
      username: 256774810030,
      ID: 17802,
      Date: "30/08/2021 17:13:48",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 400,
      totWin: 0,
      product: "Penalty Shootout",
      category: "Virtuals",
      username: 256759766366,
      ID: 17801,
      Date: "30/08/2021 16:48:12",
      channel: "Mobile",
      tax: 0,
      Status: "Won",
    },
    {
      totAmount: 400,
      totWin: 0,
      product: "Penalty Shootout",
      category: "Virtuals",
      username: 256759766366,
      ID: 17800,
      Date: "30/08/2021 16:36:49",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 400,
      totWin: 1800,
      product: "Penalty Shootout",
      category: "Virtuals",
      username: 256759766366,
      ID: 17799,
      Date: "30/08/2021 16:35:44",
      channel: "Mobile",
      tax: 0,
      Status: "Won",
    },
    {
      totAmount: 10000,
      totWin: 7000,
      product: "Diamond Strike 100,000",
      category: "Scratch Cards",
      username: 256774810030,
      ID: 17798,
      Date: "30/08/2021 12:08:23",
      channel: "Mobile",
      tax: 0,
      Status: "Won",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 17797,
      Date: "30/08/2021 05:51:02",
      channel: "Mobile",
      tax: 0,
      Status: "Won",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 17796,
      Date: "30/08/2021 05:47:37",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 17795,
      Date: "30/08/2021 05:47:03",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 5000,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 17794,
      Date: "30/08/2021 05:46:01",
      channel: "Mobile",
      tax: 0,
      Status: "Won",
    },
    {
      totAmount: 0,
      totWin: 5000,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 17793,
      Date: "30/08/2021 05:45:22",
      channel: "Mobile",
      tax: 0,
      Status: "Won",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 17792,
      Date: "30/08/2021 05:43:51",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 17791,
      Date: "29/08/2021 21:17:25",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 17790,
      Date: "29/08/2021 21:16:49",
      channel: "Mobile",
      tax: 0,
      Status: "Won",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 17789,
      Date: "29/08/2021 21:15:34",
      channel: "Mobile",
      tax: 0,
      Status: "Won",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 17788,
      Date: "29/08/2021 21:00:27",
      channel: "Mobile",
      tax: 0,
      Status: "Won",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 17787,
      Date: "29/08/2021 20:59:17",
      channel: "Mobile",
      tax: 0,
      Status: "Won",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 17786,
      Date: "29/08/2021 20:58:34",
      channel: "Mobile",
      tax: 0,
      Status: "Won",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 17785,
      Date: "29/08/2021 20:57:54",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 500,
      totWin: 0,
      product: "Glorious Rome",
      category: "Casino",
      username: 256776843303,
      ID: 17784,
      Date: "29/08/2021 23:22:48",
      channel: "Online",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 400,
      totWin: 0,
      product: "Venetia",
      category: "Casino",
      username: 256776843303,
      ID: 17783,
      Date: "29/08/2021 23:22:17",
      channel: "Online",
      tax: 0,
      Status: "Won",
    },
    {
      totAmount: 0,
      totWin: 7500,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 17782,
      Date: "29/08/2021 20:17:08",
      channel: "Mobile",
      tax: 0,
      Status: "Won",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 17781,
      Date: "29/08/2021 20:14:41",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 17780,
      Date: "29/08/2021 20:14:15",
      channel: "Mobile",
      tax: 0,
      Status: "Won",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 17779,
      Date: "29/08/2021 20:12:57",
      channel: "Mobile",
      tax: 0,
      Status: "Won",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 17778,
      Date: "29/08/2021 20:05:20",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 2000,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 17777,
      Date: "29/08/2021 20:03:34",
      channel: "Mobile",
      tax: 0,
      Status: "Won",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 17776,
      Date: "29/08/2021 20:02:48",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 2325,
      totWin: 0,
      product: "Virtual World Cup",
      category: "Virtuals",
      username: 256771264376,
      ID: 17775,
      Date: "29/08/2021 15:31:04",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 3750,
      totWin: 0,
      product: "Virtual World Cup",
      category: "Virtuals",
      username: 256771264376,
      ID: 17774,
      Date: "29/08/2021 15:23:50",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 10500,
      totWin: 7000,
      product: "Diamond Strike 100,000",
      category: "Scratch Cards",
      username: 256774810030,
      ID: 17773,
      Date: "29/08/2021 14:25:39",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 200,
      totWin: 0,
      product: "Fantastic League",
      category: "Virtuals",
      username: 256775674516,
      ID: 17772,
      Date: "29/08/2021 13:20:51",
      channel: "Mobile",
      tax: 0,
      Status: "Won",
    },
    {
      totAmount: 1000,
      totWin: 0,
      product: "Fantastic League",
      category: "Virtuals",
      username: 256779451129,
      ID: 17771,
      Date: "29/08/2021 11:47:42",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 4500,
      totWin: 2000,
      product: "Gold Rush 250,000",
      category: "Scratch Cards",
      username: 256774810030,
      ID: 17770,
      Date: "29/08/2021 11:25:57",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 17769,
      Date: "29/08/2021 08:21:43",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 17768,
      Date: "29/08/2021 08:20:59",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 2000,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 17767,
      Date: "29/08/2021 08:20:03",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 21491.3,
      totWin: 15896.3,
      product: "Virtual Football Pro",
      category: "Virtuals",
      username: 256780850357,
      ID: 17766,
      Date: "28/08/2021 23:42:25",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 5000,
      totWin: 2045,
      product: "Virtual Football Pro",
      category: "Virtuals",
      username: 256780850357,
      ID: 17765,
      Date: "28/08/2021 23:11:26",
      channel: "Mobile",
      tax: 0,
      Status: "Pending",
    },
    {
      totAmount: 11361.98,
      totWin: 10200,
      product: "Virtual Football Pro",
      category: "Virtuals",
      username: 256780850357,
      ID: 17764,
      Date: "28/08/2021 23:04:17",
      channel: "Mobile",
      tax: 0,
      Status: "Won",
    },
    {
      totAmount: 12859.08,
      totWin: 22021.06,
      product: "Virtual Football Pro",
      category: "Virtuals",
      username: 256780850357,
      ID: 17763,
      Date: "28/08/2021 22:47:54",
      channel: "Mobile",
      tax: 0,
      Status: "Won",
    },
    {
      totAmount: 3100,
      totWin: 1100,
      product: "Virtual Football Pro",
      category: "Virtuals",
      username: 256780850357,
      ID: 17762,
      Date: "28/08/2021 21:44:10",
      channel: "Mobile",
      tax: 0,
      Status: "Won",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 17761,
      Date: "28/08/2021 16:15:55",
      channel: "Online",
      tax: 0,
      Status: "Won",
    },
    {
      totAmount: 0,
      totWin: 1000,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 17760,
      Date: "28/08/2021 16:14:09",
      channel: "Online",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 810,
      totWin: 570,
      product: "Diamonds are Forever 3 Lines",
      category: "Casino",
      username: 256776051045,
      ID: 17759,
      Date: "28/08/2021 18:08:40",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 2730,
      totWin: 1730,
      product: "Virtual Football Pro",
      category: "Virtuals",
      username: 256780850357,
      ID: 17758,
      Date: "28/08/2021 17:59:00",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 1501.2,
      totWin: 889.6,
      product: "Monkey Madness",
      category: "Casino",
      username: 256709634118,
      ID: 17757,
      Date: "28/08/2021 13:44:38",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 1500,
      totWin: 1100,
      product: "Ancient Gong",
      category: "Casino",
      username: 256778869682,
      ID: 17756,
      Date: "28/08/2021 00:22:01",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 1500,
      totWin: 0,
      product: "Glorious Rome",
      category: "Casino",
      username: 256778869682,
      ID: 17755,
      Date: "27/08/2021 23:57:08",
      channel: "Mobile",
      tax: 0,
      Status: "Pending",
    },
    {
      totAmount: 1000,
      totWin: 960,
      product: "Fantastic League",
      category: "Virtuals",
      username: 256753273651,
      ID: 17754,
      Date: "27/08/2021 22:54:37",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 1095,
      totWin: 855,
      product: "Irish Charms",
      category: "Casino",
      username: 256776051045,
      ID: 17753,
      Date: "27/08/2021 21:49:26",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 500,
      totWin: 0,
      product: "Hot to Burn",
      category: "Casino",
      username: 256776051045,
      ID: 17752,
      Date: "27/08/2021 21:37:04",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 316.5,
      totWin: 297,
      product: "Irish Charms",
      category: "Casino",
      username: 256776051045,
      ID: 17751,
      Date: "27/08/2021 21:29:46",
      channel: "Mobile",
      tax: 0,
      Status: "Won",
    },
    {
      totAmount: 2000,
      totWin: 0,
      product: "Virtual Soccer",
      category: "Virtuals",
      username: 256776839818,
      ID: 17750,
      Date: "27/08/2021 19:17:56",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 43250,
      totWin: 27770,
      product: "Virtual Soccer",
      category: "Virtuals",
      username: 256776839818,
      ID: 17749,
      Date: "27/08/2021 19:01:32",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 21000,
      totWin: 10315,
      product: "Virtual Soccer",
      category: "Virtuals",
      username: 256776839818,
      ID: 17748,
      Date: "27/08/2021 18:34:48",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 1500,
      totWin: 1267.25,
      product: "Virtual Soccer",
      category: "Virtuals",
      username: 256786916636,
      ID: 17747,
      Date: "27/08/2021 17:58:52",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 24250,
      totWin: 15237.5,
      product: "Virtual Soccer",
      category: "Virtuals",
      username: 256776839818,
      ID: 17746,
      Date: "27/08/2021 17:57:55",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 2500,
      totWin: 5900,
      product: "Virtual Soccer",
      category: "Virtuals",
      username: 256776839818,
      ID: 17745,
      Date: "27/08/2021 17:47:40",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 10000,
      totWin: 18893,
      product: "Virtual Soccer",
      category: "Virtuals",
      username: 256776839818,
      ID: 17744,
      Date: "27/08/2021 17:45:15",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 9500,
      totWin: 16865,
      product: "Virtual Soccer",
      category: "Virtuals",
      username: 256776839818,
      ID: 17743,
      Date: "27/08/2021 17:38:05",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 17250,
      totWin: 6482.25,
      product: "Virtual Soccer",
      category: "Virtuals",
      username: 256776839818,
      ID: 17742,
      Date: "27/08/2021 17:33:33",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 15500,
      totWin: 21370.98,
      product: "Virtual Soccer",
      category: "Virtuals",
      username: 256776839818,
      ID: 17741,
      Date: "27/08/2021 17:18:58",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 600,
      totWin: 0,
      product: "Fantastic League",
      category: "Virtuals",
      username: 256753273651,
      ID: 17740,
      Date: "27/08/2021 12:09:35",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 600,
      totWin: 866.67,
      product: "Fantastic League",
      category: "Virtuals",
      username: 256753273651,
      ID: 17739,
      Date: "27/08/2021 07:05:27",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 1400,
      totWin: 475,
      product: "Fantastic League",
      category: "Virtuals",
      username: 256753273651,
      ID: 17738,
      Date: "26/08/2021 23:58:11",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 1200,
      totWin: 1620,
      product: "Fantastic League",
      category: "Virtuals",
      username: 256753273651,
      ID: 17737,
      Date: "26/08/2021 23:42:38",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 2800,
      totWin: 1780,
      product: "Fantastic League",
      category: "Virtuals",
      username: 256753273651,
      ID: 17736,
      Date: "26/08/2021 23:27:25",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 4000,
      totWin: 4375,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256701052616,
      ID: 17735,
      Date: "26/08/2021 20:41:25",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 2500,
      totWin: 0,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256701052616,
      ID: 17734,
      Date: "26/08/2021 20:32:10",
      channel: "Mobile",
      tax: 0,
      Status: "Won",
    },
    {
      totAmount: 104,
      totWin: 6,
      product: "888 Gold",
      category: "Casino",
      username: 256773308690,
      ID: 17733,
      Date: "26/08/2021 11:34:13",
      channel: "Mobile",
      tax: 0,
      Status: "Won",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 17732,
      Date: "25/08/2021 22:47:58",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 17731,
      Date: "25/08/2021 22:39:29",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 17730,
      Date: "25/08/2021 19:16:55",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 17729,
      Date: "25/08/2021 19:15:35",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 17728,
      Date: "25/08/2021 17:58:08",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 17727,
      Date: "25/08/2021 17:45:24",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 17726,
      Date: "25/08/2021 17:11:37",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 17725,
      Date: "25/08/2021 17:10:51",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 7500,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 17724,
      Date: "25/08/2021 17:03:01",
      channel: "Mobile",
      tax: 0,
      Status: "Won",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 17723,
      Date: "25/08/2021 16:53:35",
      channel: "Mobile",
      tax: 0,
      Status: "Won",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 17722,
      Date: "25/08/2021 16:48:42",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 17721,
      Date: "25/08/2021 16:47:55",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 17720,
      Date: "25/08/2021 16:45:50",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 17719,
      Date: "25/08/2021 16:45:12",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 17718,
      Date: "25/08/2021 14:49:18",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 17717,
      Date: "25/08/2021 14:48:47",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 16200,
      totWin: 14200,
      product: "Virtual Football Pro",
      category: "Virtuals",
      username: 256780850357,
      ID: 17716,
      Date: "25/08/2021 17:30:02",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 17715,
      Date: "25/08/2021 13:23:02",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 17714,
      Date: "25/08/2021 13:22:12",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 17713,
      Date: "25/08/2021 13:19:32",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 4000,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 17712,
      Date: "25/08/2021 13:18:58",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 17711,
      Date: "25/08/2021 13:12:16",
      channel: "Mobile",
      tax: 0,
      Status: "Won",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 17710,
      Date: "25/08/2021 13:11:37",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 17709,
      Date: "25/08/2021 13:11:03",
      channel: "Mobile",
      tax: 0,
      Status: "Pending",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 17708,
      Date: "25/08/2021 13:09:39",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 6000,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 17707,
      Date: "25/08/2021 13:08:59",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 17706,
      Date: "25/08/2021 13:08:32",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 17705,
      Date: "25/08/2021 13:07:59",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 6000,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 17704,
      Date: "25/08/2021 13:06:58",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 17703,
      Date: "25/08/2021 13:06:35",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 8000,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 17702,
      Date: "25/08/2021 13:06:02",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 17701,
      Date: "25/08/2021 13:04:40",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 17700,
      Date: "25/08/2021 13:04:13",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 3000,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 17699,
      Date: "25/08/2021 13:03:20",
      channel: "Mobile",
      tax: 0,
      Status: "Won",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 17698,
      Date: "25/08/2021 13:02:47",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 17697,
      Date: "25/08/2021 13:01:45",
      channel: "Mobile",
      tax: 0,
      Status: "Won",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 17696,
      Date: "25/08/2021 12:57:44",
      channel: "Mobile",
      tax: 0,
      Status: "Won",
    },
    {
      totAmount: 0,
      totWin: 6000,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 17695,
      Date: "25/08/2021 12:56:37",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 17694,
      Date: "25/08/2021 12:55:50",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 17693,
      Date: "25/08/2021 12:55:23",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 17692,
      Date: "25/08/2021 12:54:12",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 3000,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 17691,
      Date: "25/08/2021 12:39:54",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 6000,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 17690,
      Date: "25/08/2021 12:37:59",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 7500,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 17689,
      Date: "25/08/2021 12:34:27",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 17688,
      Date: "25/08/2021 12:34:02",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 4000,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 17687,
      Date: "25/08/2021 12:32:21",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 17686,
      Date: "25/08/2021 12:31:52",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 10000,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 17685,
      Date: "25/08/2021 12:31:14",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 17684,
      Date: "25/08/2021 12:30:47",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 17683,
      Date: "25/08/2021 12:29:48",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 17682,
      Date: "25/08/2021 12:29:24",
      channel: "Mobile",
      tax: 0,
      Status: "Won",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 17681,
      Date: "25/08/2021 12:28:49",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 17680,
      Date: "25/08/2021 12:28:16",
      channel: "Mobile",
      tax: 0,
      Status: "Won",
    },
    {
      totAmount: 0,
      totWin: 6000,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 17679,
      Date: "25/08/2021 12:27:33",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 17678,
      Date: "25/08/2021 12:26:56",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 17677,
      Date: "25/08/2021 12:26:34",
      channel: "Mobile",
      tax: 0,
      Status: "Won",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 17676,
      Date: "25/08/2021 12:26:29",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 17675,
      Date: "25/08/2021 12:25:59",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 7500,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 17674,
      Date: "25/08/2021 12:25:15",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 8000,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 17673,
      Date: "25/08/2021 12:24:27",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 17672,
      Date: "25/08/2021 12:23:53",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 1000,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 17671,
      Date: "25/08/2021 12:22:14",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 17670,
      Date: "25/08/2021 12:21:51",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 3000,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 17669,
      Date: "25/08/2021 12:21:07",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 3000,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 17668,
      Date: "25/08/2021 12:20:28",
      channel: "Mobile",
      tax: 0,
      Status: "Won",
    },
    {
      totAmount: 0,
      totWin: 3000,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 17667,
      Date: "25/08/2021 12:17:18",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 17666,
      Date: "25/08/2021 12:16:44",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 17665,
      Date: "25/08/2021 12:16:03",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 5000,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 17664,
      Date: "25/08/2021 12:14:57",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 17663,
      Date: "25/08/2021 12:12:20",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 17662,
      Date: "25/08/2021 12:11:27",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 17661,
      Date: "25/08/2021 12:11:02",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 17660,
      Date: "25/08/2021 12:09:37",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 17659,
      Date: "25/08/2021 12:09:11",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 17658,
      Date: "25/08/2021 12:07:54",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 17657,
      Date: "25/08/2021 12:04:18",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 17656,
      Date: "25/08/2021 12:03:06",
      channel: "Mobile",
      tax: 0,
      Status: "Won",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 17655,
      Date: "25/08/2021 12:02:20",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 6000,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 17654,
      Date: "25/08/2021 12:01:35",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 17653,
      Date: "25/08/2021 11:56:16",
      channel: "Mobile",
      tax: 0,
      Status: "Won",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 17652,
      Date: "25/08/2021 11:54:21",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 17651,
      Date: "25/08/2021 11:53:49",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 4000,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 17650,
      Date: "25/08/2021 11:53:07",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 17649,
      Date: "25/08/2021 11:52:30",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 17648,
      Date: "25/08/2021 11:52:08",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 4000,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 17647,
      Date: "25/08/2021 11:51:25",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 2000,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 17646,
      Date: "25/08/2021 11:50:57",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 17645,
      Date: "25/08/2021 11:49:49",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 17644,
      Date: "25/08/2021 11:49:21",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 17643,
      Date: "25/08/2021 11:48:39",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 17642,
      Date: "25/08/2021 11:47:25",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 17641,
      Date: "25/08/2021 11:46:58",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 17640,
      Date: "25/08/2021 11:46:20",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 17639,
      Date: "25/08/2021 11:44:32",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 6000,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 17638,
      Date: "25/08/2021 11:43:40",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 6000,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 17637,
      Date: "25/08/2021 11:42:44",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 17636,
      Date: "25/08/2021 11:42:18",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 17635,
      Date: "25/08/2021 11:41:18",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 17634,
      Date: "25/08/2021 11:40:53",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 17633,
      Date: "25/08/2021 11:39:43",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 17632,
      Date: "25/08/2021 11:39:09",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 17631,
      Date: "25/08/2021 11:38:41",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 8000,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 17630,
      Date: "25/08/2021 11:38:00",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 17629,
      Date: "25/08/2021 11:37:13",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 6000,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 17628,
      Date: "25/08/2021 11:36:17",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 17627,
      Date: "25/08/2021 11:35:00",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 10000,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 17626,
      Date: "25/08/2021 11:34:57",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 17625,
      Date: "25/08/2021 11:34:34",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 17624,
      Date: "25/08/2021 11:34:25",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 17623,
      Date: "25/08/2021 11:34:05",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 17622,
      Date: "25/08/2021 11:33:36",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 17621,
      Date: "25/08/2021 11:33:35",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 17620,
      Date: "25/08/2021 11:32:46",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 17619,
      Date: "25/08/2021 11:32:04",
      channel: "Mobile",
      tax: 0,
      Status: "Won",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 17618,
      Date: "25/08/2021 11:31:09",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 17617,
      Date: "25/08/2021 11:30:33",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 17616,
      Date: "25/08/2021 11:29:32",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 17615,
      Date: "25/08/2021 11:28:43",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 4000,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 17614,
      Date: "25/08/2021 11:27:28",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 15000,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 17613,
      Date: "25/08/2021 11:26:20",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 17612,
      Date: "25/08/2021 11:25:28",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 17611,
      Date: "25/08/2021 11:24:51",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 17610,
      Date: "25/08/2021 11:22:45",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 17609,
      Date: "25/08/2021 11:22:02",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 17608,
      Date: "25/08/2021 11:15:46",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 17607,
      Date: "25/08/2021 11:14:53",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 17606,
      Date: "25/08/2021 11:10:41",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 4000,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 17605,
      Date: "25/08/2021 11:08:37",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 17604,
      Date: "25/08/2021 11:05:04",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 17603,
      Date: "25/08/2021 10:58:44",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 17602,
      Date: "25/08/2021 10:57:44",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 9805,
      totWin: 0,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256701052616,
      ID: 17601,
      Date: "25/08/2021 13:39:22",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 10330,
      totWin: 6805,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256701052616,
      ID: 17600,
      Date: "25/08/2021 13:31:14",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 19150,
      totWin: 12480,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256701052616,
      ID: 17599,
      Date: "25/08/2021 13:23:28",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 49650,
      totWin: 21650,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256701052616,
      ID: 17598,
      Date: "25/08/2021 13:12:12",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 5000,
      totWin: 4933,
      product: "Virtual Football Pro",
      category: "Virtuals",
      username: 256702423538,
      ID: 17597,
      Date: "25/08/2021 12:32:56",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 1500,
      totWin: 0,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256702423538,
      ID: 17596,
      Date: "25/08/2021 12:13:54",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 17595,
      Date: "24/08/2021 18:37:33",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 17594,
      Date: "24/08/2021 18:37:10",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 17593,
      Date: "24/08/2021 18:36:27",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 17592,
      Date: "24/08/2021 18:35:55",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 17591,
      Date: "24/08/2021 18:34:04",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 2500,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 17590,
      Date: "24/08/2021 18:32:11",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 17589,
      Date: "24/08/2021 18:31:33",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 2000,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 17588,
      Date: "24/08/2021 18:09:43",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 17587,
      Date: "24/08/2021 18:07:57",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 17586,
      Date: "24/08/2021 17:52:35",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 17585,
      Date: "24/08/2021 17:51:57",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 17584,
      Date: "24/08/2021 17:51:03",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 17583,
      Date: "24/08/2021 17:50:10",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 17582,
      Date: "24/08/2021 17:47:49",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 7500,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 17581,
      Date: "24/08/2021 17:45:44",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 4000,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 17580,
      Date: "24/08/2021 17:41:27",
      channel: "Mobile",
      tax: 0,
      Status: "Won",
    },
    {
      totAmount: 34300,
      totWin: 29375,
      product: "Virtual World Cup",
      category: "Virtuals",
      username: 256771264376,
      ID: 17579,
      Date: "24/08/2021 20:29:13",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 8000,
      totWin: 3000,
      product: "Virtual World Cup",
      category: "Virtuals",
      username: 256771264376,
      ID: 17578,
      Date: "24/08/2021 19:34:36",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 4000,
      totWin: 0,
      product: "Virtual World Cup",
      category: "Virtuals",
      username: 256771264376,
      ID: 17577,
      Date: "24/08/2021 18:59:18",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 2450,
      totWin: 1450,
      product: "Virtual World Cup",
      category: "Virtuals",
      username: 256771264376,
      ID: 17576,
      Date: "24/08/2021 18:54:22",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 2850,
      totWin: 0,
      product: "Virtual Europa",
      category: "Virtuals",
      username: 256778261972,
      ID: 17575,
      Date: "24/08/2021 16:11:51",
      channel: "Mobile",
      tax: 0,
      Status: "Won",
    },
    {
      totAmount: 46500,
      totWin: 42500,
      product: "Virtual World Cup",
      category: "Virtuals",
      username: 256771264376,
      ID: 17574,
      Date: "24/08/2021 13:51:56",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 7375,
      totWin: 0,
      product: "Virtual World Cup",
      category: "Virtuals",
      username: 256771264376,
      ID: 17573,
      Date: "24/08/2021 12:57:27",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 9000,
      totWin: 7000,
      product: "Virtual World Cup",
      category: "Virtuals",
      username: 256771264376,
      ID: 17572,
      Date: "24/08/2021 12:41:18",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 18000,
      totWin: 53875,
      product: "Virtual World Cup",
      category: "Virtuals",
      username: 256771264376,
      ID: 17571,
      Date: "24/08/2021 12:16:14",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 11750,
      totWin: 9500,
      product: "Virtual World Cup",
      category: "Virtuals",
      username: 256771264376,
      ID: 17570,
      Date: "24/08/2021 11:59:41",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 26500,
      totWin: 25750,
      product: "Virtual World Cup",
      category: "Virtuals",
      username: 256771264376,
      ID: 17569,
      Date: "24/08/2021 10:50:20",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 11250,
      totWin: 15750,
      product: "Virtual World Cup",
      category: "Virtuals",
      username: 256771264376,
      ID: 17568,
      Date: "24/08/2021 10:24:21",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 4000,
      totWin: 0,
      product: "Virtual World Cup",
      category: "Virtuals",
      username: 256771264376,
      ID: 17567,
      Date: "24/08/2021 10:08:30",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 14000,
      totWin: 9000,
      product: "Virtual Europa",
      category: "Virtuals",
      username: 256771264376,
      ID: 17566,
      Date: "24/08/2021 09:59:40",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 4500,
      totWin: 0,
      product: "Virtual World Cup",
      category: "Virtuals",
      username: 256771264376,
      ID: 17565,
      Date: "24/08/2021 09:47:46",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 6250,
      totWin: 35750,
      product: "Virtual World Cup",
      category: "Virtuals",
      username: 256771264376,
      ID: 17564,
      Date: "24/08/2021 09:36:48",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 4000,
      totWin: 0,
      product: "Virtual World Cup",
      category: "Virtuals",
      username: 256771264376,
      ID: 17563,
      Date: "24/08/2021 09:21:30",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 17562,
      Date: "23/08/2021 19:18:57",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 17561,
      Date: "23/08/2021 19:16:25",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 1375,
      totWin: 0,
      product: "Virtual World Cup",
      category: "Virtuals",
      username: 256771264376,
      ID: 17560,
      Date: "23/08/2021 18:43:31",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 12900,
      totWin: 11775,
      product: "Virtual World Cup",
      category: "Virtuals",
      username: 256771264376,
      ID: 17559,
      Date: "23/08/2021 18:36:54",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 17750,
      totWin: 1875,
      product: "Virtual World Cup",
      category: "Virtuals",
      username: 256771264376,
      ID: 17558,
      Date: "23/08/2021 18:24:49",
      channel: "Mobile",
      tax: 0,
      Status: "Won",
    },
    {
      totAmount: 32000,
      totWin: 21000,
      product: "Virtual World Cup",
      category: "Virtuals",
      username: 256771264376,
      ID: 17557,
      Date: "23/08/2021 18:14:12",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 14000,
      totWin: 28125,
      product: "Virtual World Cup",
      category: "Virtuals",
      username: 256771264376,
      ID: 17556,
      Date: "23/08/2021 17:55:28",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 1500,
      totWin: 7500,
      product: "Virtual World Cup",
      category: "Virtuals",
      username: 256771264376,
      ID: 17555,
      Date: "23/08/2021 17:46:09",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 17554,
      Date: "23/08/2021 13:35:46",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 17553,
      Date: "23/08/2021 13:33:59",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 17552,
      Date: "23/08/2021 13:32:13",
      channel: "Mobile",
      tax: 0,
      Status: "Won",
    },
    {
      totAmount: 0,
      totWin: 7500,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 17551,
      Date: "23/08/2021 13:24:17",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 4000,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 17550,
      Date: "23/08/2021 13:19:43",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 17549,
      Date: "23/08/2021 10:56:14",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 17548,
      Date: "23/08/2021 10:55:15",
      channel: "Mobile",
      tax: 0,
      Status: "Won",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 17547,
      Date: "23/08/2021 10:52:05",
      channel: "Mobile",
      tax: 0,
      Status: "Won",
    },
    {
      totAmount: 0,
      totWin: 1000,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 17546,
      Date: "23/08/2021 10:45:30",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 17545,
      Date: "23/08/2021 10:44:33",
      channel: "Mobile",
      tax: 0,
      Status: "Won",
    },
    {
      totAmount: 200,
      totWin: 0,
      product: "Fantastic League",
      category: "Virtuals",
      username: 256758418989,
      ID: 17544,
      Date: "23/08/2021 11:47:15",
      channel: "Mobile",
      tax: 0,
      Status: "Won",
    },
    {
      totAmount: 5000,
      totWin: 2080.8,
      product: "Virtual Football Pro",
      category: "Virtuals",
      username: 256758418989,
      ID: 17543,
      Date: "23/08/2021 11:40:59",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 500,
      totWin: 0,
      product: "Virtual Europa",
      category: "Virtuals",
      username: 256758418989,
      ID: 17542,
      Date: "23/08/2021 11:05:12",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 1000,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 17541,
      Date: "23/08/2021 07:59:21",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 500,
      totWin: 0,
      product: "Virtual Soccer",
      category: "Virtuals",
      username: 256758418989,
      ID: 17540,
      Date: "23/08/2021 10:45:00",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 17539,
      Date: "23/08/2021 07:09:39",
      channel: "Online",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 2500,
      totWin: 0,
      product: "Virtual Soccer",
      category: "Virtuals",
      username: 256783914548,
      ID: 17538,
      Date: "23/08/2021 03:01:51",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 1000,
      totWin: 0,
      product: "Fantastic League",
      category: "Virtuals",
      username: 256783914548,
      ID: 17537,
      Date: "23/08/2021 02:56:20",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 1605,
      totWin: 1623.5,
      product: "888 Gold",
      category: "Casino",
      username: 256701044560,
      ID: 17536,
      Date: "22/08/2021 23:24:07",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 17535,
      Date: "22/08/2021 17:51:43",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 6000,
      totWin: 11750,
      product: "Virtual World Cup",
      category: "Virtuals",
      username: 256771264376,
      ID: 17534,
      Date: "22/08/2021 12:45:18",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 15895.25,
      totWin: 13770.25,
      product: "Virtual Football Pro",
      category: "Virtuals",
      username: 256780850357,
      ID: 17533,
      Date: "21/08/2021 22:35:52",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 19500,
      totWin: 9400,
      product: "Great Reef",
      category: "Casino",
      username: 256708293084,
      ID: 17532,
      Date: "21/08/2021 22:29:45",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 19539,
      totWin: 9502.3,
      product: "Magic Crystals",
      category: "Casino",
      username: 256708293084,
      ID: 17531,
      Date: "21/08/2021 22:23:20",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 18000,
      totWin: 2900,
      product: "Vampires vs Wolves",
      category: "Casino",
      username: 256708293084,
      ID: 17530,
      Date: "21/08/2021 22:18:33",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 23000,
      totWin: 7150,
      product: "The Dog House",
      category: "Casino",
      username: 256708293084,
      ID: 17529,
      Date: "21/08/2021 22:14:41",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 17054.4,
      totWin: 28116,
      product: "Caishens Gold",
      category: "Casino",
      username: 256708293084,
      ID: 17528,
      Date: "21/08/2021 22:10:02",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 1000,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 17527,
      Date: "21/08/2021 19:07:31",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 17526,
      Date: "21/08/2021 19:05:42",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 1000,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 17525,
      Date: "21/08/2021 19:05:18",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 41583,
      totWin: 31295.8,
      product: "The Catfather II",
      category: "Casino",
      username: 256708293084,
      ID: 17524,
      Date: "21/08/2021 22:02:50",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 17523,
      Date: "21/08/2021 12:32:40",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 1000,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 17522,
      Date: "21/08/2021 12:31:53",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 3750,
      totWin: 3200,
      product: "Virtual World Cup",
      category: "Virtuals",
      username: 256786916636,
      ID: 17521,
      Date: "21/08/2021 15:31:42",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 2800,
      totWin: 3252,
      product: "Penalty Shootout",
      category: "Virtuals",
      username: 256786916636,
      ID: 17520,
      Date: "21/08/2021 14:42:05",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 500,
      totWin: 0,
      product: "Virtual World Cup",
      category: "Virtuals",
      username: 256786916636,
      ID: 17519,
      Date: "21/08/2021 14:27:39",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 10649,
      totWin: 7484,
      product: "Virtual Football Pro",
      category: "Virtuals",
      username: 256780850357,
      ID: 17518,
      Date: "21/08/2021 12:40:50",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 10000,
      totWin: 10290,
      product: "Virtual Football Pro",
      category: "Virtuals",
      username: 256780850357,
      ID: 17517,
      Date: "21/08/2021 12:24:29",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 2000,
      totWin: 0,
      product: "Virtual Football Pro",
      category: "Virtuals",
      username: 256780850357,
      ID: 17516,
      Date: "21/08/2021 12:06:37",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 6865,
      totWin: 3365,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256701052616,
      ID: 17515,
      Date: "21/08/2021 11:59:28",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 7000,
      totWin: 1200,
      product: "Ancient Gong",
      category: "Casino",
      username: 256708293084,
      ID: 17514,
      Date: "21/08/2021 10:41:37",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 2000,
      totWin: 920,
      product: "Venetia",
      category: "Casino",
      username: 256708293084,
      ID: 17513,
      Date: "21/08/2021 10:38:00",
      channel: "Mobile",
      tax: 0,
      Status: "Won",
    },
    {
      totAmount: 7.5,
      totWin: 12.5,
      product: "888 Gold",
      category: "Casino",
      username: 256708293084,
      ID: 17512,
      Date: "21/08/2021 10:36:15",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 5750,
      totWin: 2500,
      product: "Storming Flame",
      category: "Casino",
      username: 256708293084,
      ID: 17511,
      Date: "21/08/2021 10:34:30",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 23000,
      totWin: 13200,
      product: "Aladdin's Treasure",
      category: "Casino",
      username: 256708293084,
      ID: 17510,
      Date: "21/08/2021 10:30:56",
      channel: "Mobile",
      tax: 0,
      Status: "Won",
    },
    {
      totAmount: 1250,
      totWin: 0,
      product: "Virtual Europa",
      category: "Virtuals",
      username: 256786741663,
      ID: 17509,
      Date: "21/08/2021 10:30:04",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 17508,
      Date: "21/08/2021 06:50:22",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 17507,
      Date: "21/08/2021 06:46:30",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 1000,
      totWin: 0,
      product: "Hot to Burn",
      category: "Casino",
      username: 256756548434,
      ID: 17506,
      Date: "20/08/2021 23:55:30",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 17505,
      Date: "20/08/2021 19:28:33",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 13659.5,
      totWin: 12134.5,
      product: "Virtual Football Pro",
      category: "Virtuals",
      username: 256780850357,
      ID: 17504,
      Date: "20/08/2021 21:30:28",
      channel: "Mobile",
      tax: 0,
      Status: "Won",
    },
    {
      totAmount: 1500,
      totWin: 2750,
      product: "Virtual Football Pro",
      category: "Virtuals",
      username: 256780850357,
      ID: 17503,
      Date: "20/08/2021 20:59:35",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 13700,
      totWin: 15700,
      product: "Virtual Football Pro",
      category: "Virtuals",
      username: 256780850357,
      ID: 17502,
      Date: "20/08/2021 20:52:28",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 7756.34,
      totWin: 5712.32,
      product: "Virtual Football Pro",
      category: "Virtuals",
      username: 256780850357,
      ID: 17501,
      Date: "20/08/2021 20:21:46",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 4429.1,
      totWin: 2044.02,
      product: "Virtual Football Pro",
      category: "Virtuals",
      username: 256780850357,
      ID: 17500,
      Date: "20/08/2021 20:01:41",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 24776,
      totWin: 33205.1,
      product: "Virtual Football Pro",
      category: "Virtuals",
      username: 256780850357,
      ID: 17499,
      Date: "20/08/2021 17:44:17",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 17498,
      Date: "20/08/2021 14:18:29",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 500,
      totWin: 0,
      product: "7 Piggies 5,000",
      category: "Scratch Cards",
      username: 256758459003,
      ID: 17497,
      Date: "20/08/2021 17:17:40",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 17496,
      Date: "20/08/2021 13:36:12",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 1.25,
      totWin: 0,
      product: "Jacks or Better",
      category: "Table Games",
      username: 256700582145,
      ID: 17495,
      Date: "20/08/2021 12:11:44",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 501,
      totWin: 0,
      product: "Magic Crystals",
      category: "Casino",
      username: 256706686646,
      ID: 17494,
      Date: "20/08/2021 01:33:09",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 17493,
      Date: "19/08/2021 22:10:15",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 1000,
      totWin: 0,
      product: "Glorious Rome",
      category: "Casino",
      username: 256778869682,
      ID: 17492,
      Date: "19/08/2021 23:54:47",
      channel: "Mobile",
      tax: 0,
      Status: "Won",
    },
    {
      totAmount: 0.18,
      totWin: 0,
      product: "Diamonds are Forever 3 Lines",
      category: "Casino",
      username: 256700582145,
      ID: 17491,
      Date: "19/08/2021 23:25:01",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 500,
      totWin: 0,
      product: "Virtual Soccer",
      category: "Virtuals",
      username: 256700582145,
      ID: 17490,
      Date: "19/08/2021 22:54:10",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 250,
      totWin: 0,
      product: "Burning Flame",
      category: "Casino",
      username: 256700582145,
      ID: 17489,
      Date: "19/08/2021 22:38:38",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 17488,
      Date: "19/08/2021 18:10:57",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 18250,
      totWin: 8400,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256773044210,
      ID: 17487,
      Date: "19/08/2021 21:01:28",
      channel: "Mobile",
      tax: 0,
      Status: "Won",
    },
    {
      totAmount: 400,
      totWin: 0,
      product: "Force1",
      category: "Virtuals",
      username: 256773044210,
      ID: 17486,
      Date: "19/08/2021 19:23:11",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 10000,
      totWin: 2000,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256755717779,
      ID: 17485,
      Date: "19/08/2021 18:44:03",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 17484,
      Date: "19/08/2021 15:30:58",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 17483,
      Date: "19/08/2021 15:30:37",
      channel: "Mobile",
      tax: 0,
      Status: "Won",
    },
    {
      totAmount: 4000,
      totWin: 0,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256773044210,
      ID: 17482,
      Date: "19/08/2021 14:55:00",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 10500,
      totWin: 6165,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256755717779,
      ID: 17481,
      Date: "19/08/2021 14:48:15",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 17480,
      Date: "19/08/2021 03:10:57",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 17479,
      Date: "19/08/2021 03:09:43",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 1000,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 17478,
      Date: "19/08/2021 03:09:23",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 1000,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 17477,
      Date: "19/08/2021 03:08:25",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 1000,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 17476,
      Date: "19/08/2021 03:08:06",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 1000,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 17475,
      Date: "19/08/2021 03:04:18",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 1000,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 17474,
      Date: "19/08/2021 03:03:47",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 17473,
      Date: "19/08/2021 03:01:54",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 17472,
      Date: "19/08/2021 03:01:27",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 17471,
      Date: "19/08/2021 03:00:07",
      channel: "Mobile",
      tax: 0,
      Status: "Won",
    },
    {
      totAmount: 0,
      totWin: 1000,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 17470,
      Date: "19/08/2021 02:58:15",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 17469,
      Date: "19/08/2021 02:57:45",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 1000,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 17468,
      Date: "19/08/2021 02:56:33",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 1000,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 17467,
      Date: "19/08/2021 02:54:51",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 17466,
      Date: "19/08/2021 02:53:58",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 26700,
      totWin: 11020,
      product: "Battle for Atlantis",
      category: "Casino",
      username: 256754616944,
      ID: 17465,
      Date: "19/08/2021 02:41:15",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 17464,
      Date: "18/08/2021 21:25:29",
      channel: "Mobile",
      tax: 0,
      Status: "Won",
    },
    {
      totAmount: 320500,
      totWin: 221750,
      product: "Buffalo King",
      category: "Casino",
      username: 256775784921,
      ID: 17463,
      Date: "18/08/2021 23:29:04",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 17462,
      Date: "18/08/2021 20:27:27",
      channel: "Mobile",
      tax: 0,
      Status: "Won",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 17461,
      Date: "18/08/2021 20:26:29",
      channel: "Mobile",
      tax: 0,
      Status: "Won",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 17460,
      Date: "18/08/2021 20:25:39",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 17459,
      Date: "18/08/2021 20:24:43",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 17458,
      Date: "18/08/2021 20:23:42",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 17457,
      Date: "18/08/2021 20:23:11",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 17456,
      Date: "18/08/2021 20:22:44",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 17455,
      Date: "18/08/2021 20:22:06",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 17454,
      Date: "18/08/2021 20:21:21",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 4000,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 17453,
      Date: "18/08/2021 20:19:46",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 1500,
      totWin: 400,
      product: "Great Rhino Megaways",
      category: "Casino",
      username: 256775784921,
      ID: 17452,
      Date: "18/08/2021 23:13:20",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 112500,
      totWin: 22000,
      product: "Buffalo King",
      category: "Casino",
      username: 256775784921,
      ID: 17451,
      Date: "18/08/2021 23:11:33",
      channel: "Mobile",
      tax: 0,
      Status: "Won",
    },
    {
      totAmount: 138000,
      totWin: 38450,
      product: "Glorious Rome",
      category: "Casino",
      username: 256775784921,
      ID: 17450,
      Date: "18/08/2021 23:00:06",
      channel: "Mobile",
      tax: 0,
      Status: "Won",
    },
    {
      totAmount: 400,
      totWin: 0,
      product: "Thunder Bird",
      category: "Casino",
      username: 256776843303,
      ID: 17449,
      Date: "18/08/2021 15:03:18",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 500,
      totWin: 0,
      product: "Chili Quest",
      category: "Casino",
      username: 256776843303,
      ID: 17448,
      Date: "18/08/2021 14:35:26",
      channel: "Online",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 200,
      totWin: 0,
      product: "Tiger Heart",
      category: "Casino",
      username: 256776843303,
      ID: 17447,
      Date: "18/08/2021 14:33:59",
      channel: "Online",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 200,
      totWin: 0,
      product: "Star Cash",
      category: "Casino",
      username: 256776843303,
      ID: 17446,
      Date: "18/08/2021 13:35:15",
      channel: "Online",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 30749.44,
      totWin: 28749.11,
      product: "Virtual Europa",
      category: "Virtuals",
      username: 256701052616,
      ID: 17445,
      Date: "18/08/2021 11:14:17",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 3190,
      totWin: 2240,
      product: "Virtual Football Pro",
      category: "Virtuals",
      username: 256780850357,
      ID: 17444,
      Date: "18/08/2021 09:31:44",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 1500,
      totWin: 0,
      product: "Gold Rush 250,000",
      category: "Scratch Cards",
      username: 256787217790,
      ID: 17443,
      Date: "17/08/2021 17:25:21",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 28590,
      totWin: 23390,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256701052616,
      ID: 17442,
      Date: "17/08/2021 15:25:25",
      channel: "Mobile",
      tax: 0,
      Status: "Won",
    },
    {
      totAmount: 33433,
      totWin: 30633,
      product: "Virtual Europa",
      category: "Virtuals",
      username: 256701052616,
      ID: 17441,
      Date: "17/08/2021 15:04:45",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 19413,
      totWin: 17183,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256701052616,
      ID: 17440,
      Date: "17/08/2021 14:43:30",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 39000,
      totWin: 11730,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256701052616,
      ID: 17439,
      Date: "17/08/2021 14:34:39",
      channel: "Mobile",
      tax: 0,
      Status: "Won",
    },
    {
      totAmount: 30000,
      totWin: 15000,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256701052616,
      ID: 17438,
      Date: "17/08/2021 14:10:59",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 65000,
      totWin: 15000,
      product: "Tree of Riches",
      category: "Casino",
      username: 256708293084,
      ID: 17437,
      Date: "17/08/2021 10:41:22",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 32000,
      totWin: 1700,
      product: "5 Lions",
      category: "Casino",
      username: 256708293084,
      ID: 17436,
      Date: "17/08/2021 10:33:19",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 6250,
      totWin: 0,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256755717779,
      ID: 17435,
      Date: "17/08/2021 10:01:05",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 1000,
      totWin: 0,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256755717779,
      ID: 17434,
      Date: "17/08/2021 09:49:29",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 6000,
      totWin: 18500,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256755717779,
      ID: 17433,
      Date: "17/08/2021 09:46:52",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 2500,
      totWin: 0,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256755717779,
      ID: 17432,
      Date: "17/08/2021 09:16:19",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 23250,
      totWin: 17562.5,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256755717779,
      ID: 17431,
      Date: "17/08/2021 09:09:08",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 17430,
      Date: "17/08/2021 04:25:52",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 500,
      totWin: 0,
      product: "Pick 4",
      category: "Number Games",
      username: 256789510398,
      ID: 17429,
      Date: "17/08/2021 00:01:46",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 500,
      totWin: 0,
      product: "Pick 5",
      category: "Number Games",
      username: 256789510398,
      ID: 17428,
      Date: "16/08/2021 22:52:46",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 1800,
      totWin: 0,
      product: "Virtual Football Pro",
      category: "Virtuals",
      username: 256780850357,
      ID: 17427,
      Date: "16/08/2021 21:19:31",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 4875.5,
      totWin: 4675,
      product: "Virtual Football Pro",
      category: "Virtuals",
      username: 256780850357,
      ID: 17426,
      Date: "16/08/2021 21:01:46",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 500,
      totWin: 0,
      product: "Pick 3",
      category: "Number Games",
      username: 256789510398,
      ID: 17425,
      Date: "16/08/2021 20:57:40",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 18250,
      totWin: 38125,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256755717779,
      ID: 17424,
      Date: "16/08/2021 19:59:51",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 1000,
      totWin: 1600,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256784749646,
      ID: 17423,
      Date: "16/08/2021 19:11:57",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 1500,
      totWin: 0,
      product: "Virtual Football Pro",
      category: "Virtuals",
      username: 256780850357,
      ID: 17422,
      Date: "16/08/2021 19:00:39",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 17421,
      Date: "16/08/2021 11:44:37",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 17420,
      Date: "16/08/2021 11:44:06",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 17419,
      Date: "16/08/2021 11:43:44",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 17418,
      Date: "16/08/2021 11:43:12",
      channel: "Mobile",
      tax: 0,
      Status: "Won",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 17417,
      Date: "16/08/2021 11:42:50",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 17416,
      Date: "16/08/2021 11:42:20",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 17415,
      Date: "16/08/2021 11:39:03",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 17414,
      Date: "16/08/2021 11:38:07",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 17413,
      Date: "16/08/2021 11:34:44",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 17412,
      Date: "16/08/2021 11:34:16",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 1000,
      totWin: 0,
      product: "Wolf Gold 1,000,000",
      category: "Scratch Cards",
      username: 256786089878,
      ID: 17411,
      Date: "16/08/2021 14:33:28",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 10000,
      totWin: 25000,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256701052616,
      ID: 17410,
      Date: "16/08/2021 14:00:23",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 25000,
      totWin: 20000,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256701052616,
      ID: 17409,
      Date: "16/08/2021 13:55:20",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 128660,
      totWin: 191910,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256701052616,
      ID: 17408,
      Date: "16/08/2021 13:52:30",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 25000,
      totWin: 10500,
      product: "Virtual Europa",
      category: "Virtuals",
      username: 256701052616,
      ID: 17407,
      Date: "16/08/2021 13:27:26",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 133000,
      totWin: 143000,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256701052616,
      ID: 17406,
      Date: "16/08/2021 13:22:52",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 2500,
      totWin: 0,
      product: "Virtual World Cup",
      category: "Virtuals",
      username: 256786916636,
      ID: 17405,
      Date: "16/08/2021 13:16:30",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 17404,
      Date: "16/08/2021 09:53:55",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 2000,
      totWin: 0,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256701052616,
      ID: 17403,
      Date: "16/08/2021 12:51:18",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 2000,
      totWin: 2906.25,
      product: "Virtual World Cup",
      category: "Virtuals",
      username: 256786916636,
      ID: 17402,
      Date: "16/08/2021 12:43:53",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 3500,
      totWin: 3075,
      product: "Virtual Euros",
      category: "Virtuals",
      username: 256786916636,
      ID: 17401,
      Date: "16/08/2021 12:29:02",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 1500,
      totWin: 1100,
      product: "Virtual Euros",
      category: "Virtuals",
      username: 256786916636,
      ID: 17400,
      Date: "16/08/2021 11:52:57",
      channel: "Mobile",
      tax: 0,
      Status: "Won",
    },
    {
      totAmount: 700,
      totWin: 0,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256782673456,
      ID: 17399,
      Date: "16/08/2021 11:42:01",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 2000,
      totWin: 1000,
      product: "Virtual World Cup",
      category: "Virtuals",
      username: 256786916636,
      ID: 17398,
      Date: "15/08/2021 22:40:26",
      channel: "Mobile",
      tax: 0,
      Status: "Won",
    },
    {
      totAmount: 13000,
      totWin: 11100,
      product: "King Of Monkeys 2",
      category: "Casino",
      username: 256781054426,
      ID: 17397,
      Date: "15/08/2021 22:35:31",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 5250,
      totWin: 4350,
      product: "Circus of Horror",
      category: "Casino",
      username: 256781054426,
      ID: 17396,
      Date: "15/08/2021 22:28:12",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 13000,
      totWin: 12500,
      product: "888 Dragons",
      category: "Casino",
      username: 256781054426,
      ID: 17395,
      Date: "15/08/2021 22:19:52",
      channel: "Mobile",
      tax: 0,
      Status: "Won",
    },
    {
      totAmount: 15000,
      totWin: 5000,
      product: "Asgard",
      category: "Casino",
      username: 256781054426,
      ID: 17394,
      Date: "15/08/2021 22:16:59",
      channel: "Mobile",
      tax: 0,
      Status: "Won",
    },
    {
      totAmount: 16500,
      totWin: 10800,
      product: "Golden Dragon",
      category: "Casino",
      username: 256781054426,
      ID: 17393,
      Date: "15/08/2021 22:08:41",
      channel: "Mobile",
      tax: 0,
      Status: "Won",
    },
    {
      totAmount: 7250,
      totWin: 3250,
      product: "Burning Flame",
      category: "Casino",
      username: 256781054426,
      ID: 17392,
      Date: "15/08/2021 22:03:31",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 18000,
      totWin: 9900,
      product: "Crystal Mystery",
      category: "Casino",
      username: 256781054426,
      ID: 17391,
      Date: "15/08/2021 21:58:53",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 17390,
      Date: "15/08/2021 15:02:19",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 17389,
      Date: "15/08/2021 14:11:19",
      channel: "Online",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 17388,
      Date: "15/08/2021 14:10:39",
      channel: "Online",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 1000,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 17387,
      Date: "15/08/2021 14:10:03",
      channel: "Online",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 17386,
      Date: "15/08/2021 14:08:43",
      channel: "Online",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 17385,
      Date: "15/08/2021 14:04:23",
      channel: "Online",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 17384,
      Date: "15/08/2021 14:00:33",
      channel: "Online",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 17383,
      Date: "15/08/2021 13:58:45",
      channel: "Online",
      tax: 0,
      Status: "Won",
    },
    {
      totAmount: 0,
      totWin: 1000,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 17382,
      Date: "15/08/2021 13:57:53",
      channel: "Online",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 500,
      totWin: 0,
      product: "Pick 3",
      category: "Number Games",
      username: 256779628447,
      ID: 17381,
      Date: "15/08/2021 14:08:45",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 6500,
      totWin: 2000,
      product: "Emerald King",
      category: "Casino",
      username: 256772784678,
      ID: 17380,
      Date: "15/08/2021 12:46:19",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 870,
      totWin: 780,
      product: "Diamonds are Forever 3 Lines",
      category: "Casino",
      username: 256772784678,
      ID: 17379,
      Date: "15/08/2021 12:41:56",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 1.5,
      totWin: 2.5,
      product: "Irish Charms",
      category: "Casino",
      username: 256772784678,
      ID: 17378,
      Date: "15/08/2021 12:23:07",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 10000,
      totWin: 0,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256773044210,
      ID: 17377,
      Date: "15/08/2021 11:58:31",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 17376,
      Date: "15/08/2021 08:00:14",
      channel: "Online",
      tax: 0,
      Status: "Won",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 17375,
      Date: "15/08/2021 07:59:42",
      channel: "Online",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 17374,
      Date: "15/08/2021 07:58:57",
      channel: "Online",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 17373,
      Date: "15/08/2021 07:54:15",
      channel: "Online",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 7500,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 17372,
      Date: "15/08/2021 07:53:15",
      channel: "Online",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 1200,
      totWin: 0,
      product: "Virtual World Cup",
      category: "Virtuals",
      username: 256771264376,
      ID: 17371,
      Date: "15/08/2021 09:59:20",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 17850,
      totWin: 12850,
      product: "Virtual World Cup",
      category: "Virtuals",
      username: 256771264376,
      ID: 17370,
      Date: "15/08/2021 09:57:23",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 20000,
      totWin: 13370,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256755717779,
      ID: 17369,
      Date: "15/08/2021 09:19:03",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 3000,
      totWin: 2000,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256755717779,
      ID: 17368,
      Date: "15/08/2021 08:35:20",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 7000,
      totWin: 0,
      product: "Ultra Hold and Spin",
      category: "Casino",
      username: 256756907314,
      ID: 17367,
      Date: "15/08/2021 07:27:54",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 5,
      totWin: 4,
      product: "888 Gold",
      category: "Casino",
      username: 256756907314,
      ID: 17366,
      Date: "15/08/2021 07:16:57",
      channel: "Mobile",
      tax: 0,
      Status: "Won",
    },
    {
      totAmount: 2000,
      totWin: 0,
      product: "Gold Rush 250,000",
      category: "Scratch Cards",
      username: 256756907314,
      ID: 17365,
      Date: "15/08/2021 06:14:42",
      channel: "Mobile",
      tax: 0,
      Status: "Won",
    },
    {
      totAmount: 31000,
      totWin: 21937.5,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256755717779,
      ID: 17364,
      Date: "14/08/2021 22:56:23",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 200,
      totWin: 0,
      product: "Fantastic League",
      category: "Virtuals",
      username: 256753273651,
      ID: 17363,
      Date: "14/08/2021 22:53:02",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 22250,
      totWin: 19015,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256755717779,
      ID: 17362,
      Date: "14/08/2021 22:12:49",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 1450,
      totWin: 1450,
      product: "Virtual Football Pro",
      category: "Virtuals",
      username: 256780850357,
      ID: 17361,
      Date: "14/08/2021 20:45:53",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 1500,
      totWin: 0,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256773044210,
      ID: 17360,
      Date: "14/08/2021 17:45:17",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 8000,
      totWin: 5175,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256755717779,
      ID: 17359,
      Date: "14/08/2021 14:42:03",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 24500,
      totWin: 17673.5,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256755717779,
      ID: 17358,
      Date: "14/08/2021 14:16:35",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 5250,
      totWin: 5975,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256773044210,
      ID: 17357,
      Date: "14/08/2021 14:12:24",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 4000,
      totWin: 0,
      product: "Virtual World Cup",
      category: "Virtuals",
      username: 256771264376,
      ID: 17356,
      Date: "14/08/2021 11:53:53",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 2500,
      totWin: 8440,
      product: "Virtual World Cup",
      category: "Virtuals",
      username: 256771264376,
      ID: 17355,
      Date: "14/08/2021 11:22:28",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 19890,
      totWin: 27800,
      product: "Virtual World Cup",
      category: "Virtuals",
      username: 256771264376,
      ID: 17354,
      Date: "14/08/2021 11:14:43",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 1000,
      totWin: 0,
      product: "Virtual World Cup",
      category: "Virtuals",
      username: 256771264376,
      ID: 17353,
      Date: "14/08/2021 10:12:01",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 17352,
      Date: "14/08/2021 07:10:31",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 400,
      totWin: 0,
      product: "Penalty Shootout",
      category: "Virtuals",
      username: 256771264376,
      ID: 17351,
      Date: "14/08/2021 10:07:38",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 17350,
      Date: "14/08/2021 07:02:55",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 17349,
      Date: "14/08/2021 07:02:28",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 2500,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 17348,
      Date: "14/08/2021 07:01:08",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 17347,
      Date: "14/08/2021 07:00:31",
      channel: "Mobile",
      tax: 0,
      Status: "Won",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 17346,
      Date: "14/08/2021 04:30:20",
      channel: "Mobile",
      tax: 0,
      Status: "Won",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 17345,
      Date: "14/08/2021 04:29:47",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 1000,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 17344,
      Date: "14/08/2021 04:29:16",
      channel: "Mobile",
      tax: 0,
      Status: "Won",
    },
    {
      totAmount: 0,
      totWin: 1000,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 17343,
      Date: "14/08/2021 04:28:14",
      channel: "Mobile",
      tax: 0,
      Status: "Won",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 17342,
      Date: "14/08/2021 04:25:20",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 1000,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 17341,
      Date: "14/08/2021 04:24:41",
      channel: "Mobile",
      tax: 0,
      Status: "Won",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 17340,
      Date: "14/08/2021 04:24:13",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 17339,
      Date: "14/08/2021 04:23:39",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 17338,
      Date: "14/08/2021 04:23:15",
      channel: "Mobile",
      tax: 0,
      Status: "Won",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 17337,
      Date: "14/08/2021 04:21:25",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 17336,
      Date: "14/08/2021 04:20:51",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 17335,
      Date: "14/08/2021 04:19:46",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 17334,
      Date: "14/08/2021 04:19:06",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 17333,
      Date: "14/08/2021 04:16:59",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 17332,
      Date: "14/08/2021 04:14:10",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 17331,
      Date: "14/08/2021 04:12:50",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 17330,
      Date: "14/08/2021 04:12:21",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 1000,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 17329,
      Date: "14/08/2021 04:10:57",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 17328,
      Date: "14/08/2021 04:10:08",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 17327,
      Date: "13/08/2021 22:19:45",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 17326,
      Date: "13/08/2021 22:17:39",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 17325,
      Date: "13/08/2021 22:17:09",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 2000,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 17324,
      Date: "13/08/2021 22:16:28",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 1000,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 17323,
      Date: "13/08/2021 22:15:44",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 1000,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 17322,
      Date: "13/08/2021 22:15:01",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 2000,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 17321,
      Date: "13/08/2021 22:05:26",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 1000,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 17320,
      Date: "13/08/2021 21:56:34",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 1000,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 17319,
      Date: "13/08/2021 21:56:03",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 1000,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 17318,
      Date: "13/08/2021 21:55:05",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 1000,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 17317,
      Date: "13/08/2021 21:54:28",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 3400,
      totWin: 1300,
      product: "Crystal Mystery",
      category: "Casino",
      username: 256781054426,
      ID: 17316,
      Date: "14/08/2021 00:29:19",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 16500,
      totWin: 7100,
      product: "Money Farm 2",
      category: "Casino",
      username: 256781054426,
      ID: 17315,
      Date: "14/08/2021 00:21:24",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 2400,
      totWin: 600,
      product: "Ramses Treasure",
      category: "Casino",
      username: 256789156900,
      ID: 17314,
      Date: "14/08/2021 00:11:04",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 1000,
      totWin: 400,
      product: "Aladdin's Treasure",
      category: "Casino",
      username: 256781054426,
      ID: 17313,
      Date: "14/08/2021 00:10:09",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 7200,
      totWin: 2000,
      product: "Slot Of Money",
      category: "Casino",
      username: 256789156900,
      ID: 17312,
      Date: "14/08/2021 00:08:46",
      channel: "Mobile",
      tax: 0,
      Status: "Won",
    },
    {
      totAmount: 7800,
      totWin: 2760,
      product: "Battle for Atlantis",
      category: "Casino",
      username: 256781054426,
      ID: 17311,
      Date: "14/08/2021 00:06:10",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 3000,
      totWin: 1000,
      product: "Virtual Football Pro",
      category: "Virtuals",
      username: 256780850357,
      ID: 17310,
      Date: "13/08/2021 23:15:20",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 1690,
      totWin: 0,
      product: "Virtual Football Pro",
      category: "Virtuals",
      username: 256780850357,
      ID: 17309,
      Date: "13/08/2021 23:08:23",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 8684,
      totWin: 13561.3,
      product: "Virtual Football Pro",
      category: "Virtuals",
      username: 256780850357,
      ID: 17308,
      Date: "13/08/2021 21:59:11",
      channel: "Mobile",
      tax: 0,
      Status: "Won",
    },
    {
      totAmount: 7090,
      totWin: 10903.2,
      product: "Virtual Football Pro",
      category: "Virtuals",
      username: 256780850357,
      ID: 17307,
      Date: "13/08/2021 21:32:11",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 1050,
      totWin: 1000,
      product: "Virtual Football Pro",
      category: "Virtuals",
      username: 256780850357,
      ID: 17306,
      Date: "13/08/2021 21:18:16",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 400,
      totWin: 0,
      product: "Penalty Shootout",
      category: "Virtuals",
      username: 256775674516,
      ID: 17305,
      Date: "13/08/2021 21:06:25",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 9018,
      totWin: 1869.12,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256771264376,
      ID: 17304,
      Date: "13/08/2021 20:29:42",
      channel: "Mobile",
      tax: 0,
      Status: "Won",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 17303,
      Date: "13/08/2021 17:21:15",
      channel: "Online",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 17302,
      Date: "13/08/2021 17:20:55",
      channel: "Online",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 12250,
      totWin: 0,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256773044210,
      ID: 17301,
      Date: "13/08/2021 15:46:19",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 11500,
      totWin: 2500,
      product: "Tree of Riches",
      category: "Casino",
      username: 256700224243,
      ID: 17300,
      Date: "13/08/2021 15:35:55",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 500,
      totWin: 0,
      product: "Tree of Riches",
      category: "Casino",
      username: 256700224243,
      ID: 17299,
      Date: "13/08/2021 15:26:32",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 4000,
      totWin: 0,
      product: "Fantastic League",
      category: "Virtuals",
      username: 256772970520,
      ID: 17298,
      Date: "13/08/2021 15:25:03",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 17297,
      Date: "13/08/2021 12:02:03",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 17296,
      Date: "13/08/2021 12:01:37",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 20000,
      totWin: 0,
      product: "Virtual World Cup",
      category: "Virtuals",
      username: 256750669723,
      ID: 17295,
      Date: "13/08/2021 14:52:27",
      channel: "Online",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 30000,
      totWin: 10000,
      product: "Virtual World Cup",
      category: "Virtuals",
      username: 256750669723,
      ID: 17294,
      Date: "13/08/2021 14:38:37",
      channel: "Online",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 200,
      totWin: 0,
      product: "Horse Racing",
      category: "Virtuals",
      username: 256702621406,
      ID: 17293,
      Date: "13/08/2021 14:24:48",
      channel: "Mobile",
      tax: 0,
      Status: "Won",
    },
    {
      totAmount: 2500,
      totWin: 0,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256773044210,
      ID: 17292,
      Date: "13/08/2021 13:25:23",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 127000,
      totWin: 76970.62,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256773044210,
      ID: 17291,
      Date: "13/08/2021 13:19:51",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 2000,
      totWin: 0,
      product: "Virtual Football Pro",
      category: "Virtuals",
      username: 256705848834,
      ID: 17290,
      Date: "13/08/2021 12:33:40",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 500,
      totWin: 0,
      product: "Virtual Football Pro",
      category: "Virtuals",
      username: 256705848834,
      ID: 17289,
      Date: "13/08/2021 12:26:24",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 6000,
      totWin: 3165,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256773044210,
      ID: 17288,
      Date: "13/08/2021 12:09:28",
      channel: "Mobile",
      tax: 0,
      Status: "Won",
    },
    {
      totAmount: 2000,
      totWin: 0,
      product: "Penalty Shootout",
      category: "Virtuals",
      username: 256750533908,
      ID: 17287,
      Date: "13/08/2021 11:46:33",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 1200,
      totWin: 1988,
      product: "Penalty Shootout",
      category: "Virtuals",
      username: 256750533908,
      ID: 17286,
      Date: "13/08/2021 11:36:27",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 11000,
      totWin: 6000,
      product: "Hot to Burn",
      category: "Casino",
      username: 256789156900,
      ID: 17285,
      Date: "13/08/2021 00:51:56",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 20500,
      totWin: 68500,
      product: "Ultra Burn",
      category: "Casino",
      username: 256789156900,
      ID: 17284,
      Date: "13/08/2021 00:49:48",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 10000,
      totWin: 3900,
      product: "Slot Of Money",
      category: "Casino",
      username: 256789156900,
      ID: 17283,
      Date: "13/08/2021 00:42:37",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 500,
      totWin: 0,
      product: "Tree of Riches",
      category: "Casino",
      username: 256700224243,
      ID: 17282,
      Date: "12/08/2021 23:37:05",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 500,
      totWin: 0,
      product: "Virtual World Cup",
      category: "Virtuals",
      username: 256786916636,
      ID: 17281,
      Date: "12/08/2021 20:31:38",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 4500,
      totWin: 3000,
      product: "Virtual Europa",
      category: "Virtuals",
      username: 256773044210,
      ID: 17280,
      Date: "12/08/2021 19:25:25",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 25750,
      totWin: 29025,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256773044210,
      ID: 17279,
      Date: "12/08/2021 19:12:39",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 2500,
      totWin: 0,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256773044210,
      ID: 17278,
      Date: "12/08/2021 18:13:20",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 26000,
      totWin: 2400,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256773044210,
      ID: 17277,
      Date: "12/08/2021 17:53:35",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 3000,
      totWin: 7000,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256773044210,
      ID: 17276,
      Date: "12/08/2021 17:29:16",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 15250,
      totWin: 8650,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256773044210,
      ID: 17275,
      Date: "12/08/2021 17:21:21",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 17274,
      Date: "12/08/2021 13:31:26",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 11000,
      totWin: 1725,
      product: "Glorious Rome",
      category: "Casino",
      username: 256772368294,
      ID: 17273,
      Date: "12/08/2021 10:18:33",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 17272,
      Date: "12/08/2021 07:14:44",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 17271,
      Date: "12/08/2021 07:13:10",
      channel: "Mobile",
      tax: 0,
      Status: "Void",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 17270,
      Date: "12/08/2021 07:10:43",
      channel: "Mobile",
      tax: 0,
      Status: "Won",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 17269,
      Date: "12/08/2021 07:09:01",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 1000,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 17268,
      Date: "12/08/2021 07:07:20",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 2000,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 17267,
      Date: "12/08/2021 07:06:33",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 15500,
      totWin: 9500,
      product: "Mega Wheel",
      category: "Live Casino",
      username: 256772368294,
      ID: 17266,
      Date: "12/08/2021 10:03:51",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 2500,
      totWin: 0,
      product: "Mega Wheel",
      category: "Live Casino",
      username: 256772368294,
      ID: 17265,
      Date: "12/08/2021 09:34:31",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 1000,
      totWin: 1500,
      product: "Great Reef",
      category: "Casino",
      username: 256772368294,
      ID: 17264,
      Date: "12/08/2021 09:23:57",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 48500,
      totWin: 32127.5,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256773044210,
      ID: 17263,
      Date: "12/08/2021 08:14:20",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 2500,
      totWin: 13750,
      product: "Virtual Euros",
      category: "Virtuals",
      username: 256709259418,
      ID: 17262,
      Date: "12/08/2021 08:05:31",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 3500,
      totWin: 4500,
      product: "Virtual Euros",
      category: "Virtuals",
      username: 256709259418,
      ID: 17261,
      Date: "12/08/2021 07:58:20",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 1000,
      totWin: 0,
      product: "Virtual Euros",
      category: "Virtuals",
      username: 256709259418,
      ID: 17260,
      Date: "12/08/2021 06:45:19",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 17259,
      Date: "11/08/2021 22:33:45",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 17258,
      Date: "11/08/2021 22:33:26",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 17257,
      Date: "11/08/2021 22:30:10",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 2000,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 17256,
      Date: "11/08/2021 22:27:57",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 17255,
      Date: "11/08/2021 22:27:08",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 9750,
      totWin: 16283.75,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256773044210,
      ID: 17254,
      Date: "11/08/2021 23:36:15",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 17253,
      Date: "11/08/2021 20:24:15",
      channel: "Mobile",
      tax: 0,
      Status: "Won",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 17252,
      Date: "11/08/2021 20:23:21",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 15750,
      totWin: 5250,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256773044210,
      ID: 17251,
      Date: "11/08/2021 23:09:35",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 5750,
      totWin: 5902.49,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256773044210,
      ID: 17250,
      Date: "11/08/2021 22:46:45",
      channel: "Mobile",
      tax: 0,
      Status: "Won",
    },
    {
      totAmount: 34000,
      totWin: 24079.5,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256773044210,
      ID: 17249,
      Date: "11/08/2021 22:33:43",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 500,
      totWin: 0,
      product: "Pick 5",
      category: "Number Games",
      username: 256753273651,
      ID: 17248,
      Date: "11/08/2021 22:25:20",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 3500,
      totWin: 2500,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256773044210,
      ID: 17247,
      Date: "11/08/2021 21:57:43",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 8750,
      totWin: 0,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256773044210,
      ID: 17246,
      Date: "11/08/2021 21:44:25",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 500,
      totWin: 0,
      product: "Wolf Gold 1,000,000",
      category: "Scratch Cards",
      username: 256705848834,
      ID: 17245,
      Date: "11/08/2021 20:21:21",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 1000,
      totWin: 0,
      product: "Virtual Football Pro",
      category: "Virtuals",
      username: 256705848834,
      ID: 17244,
      Date: "11/08/2021 20:17:05",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 4065.52,
      totWin: 6565.52,
      product: "Virtual Football Pro",
      category: "Virtuals",
      username: 256705848834,
      ID: 17243,
      Date: "11/08/2021 20:12:49",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 6250,
      totWin: 0,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256773044210,
      ID: 17242,
      Date: "11/08/2021 20:00:29",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 1000,
      totWin: 0,
      product: "Virtual Football Pro",
      category: "Virtuals",
      username: 256705848834,
      ID: 17241,
      Date: "11/08/2021 19:57:16",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 3000,
      totWin: 0,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256773044210,
      ID: 17240,
      Date: "11/08/2021 19:54:19",
      channel: "Mobile",
      tax: 0,
      Status: "Won",
    },
    {
      totAmount: 1000,
      totWin: 0,
      product: "Virtual Football Pro",
      category: "Virtuals",
      username: 256705848834,
      ID: 17239,
      Date: "11/08/2021 19:48:20",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 200,
      totWin: 0,
      product: "Fantastic League",
      category: "Virtuals",
      username: 256707062387,
      ID: 17238,
      Date: "11/08/2021 17:21:06",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 400,
      totWin: 0,
      product: "Fantastic League",
      category: "Virtuals",
      username: 256707062387,
      ID: 17237,
      Date: "11/08/2021 17:09:02",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 1000,
      totWin: 0,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256773044210,
      ID: 17236,
      Date: "11/08/2021 16:59:21",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 7000,
      totWin: 2500,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256773044210,
      ID: 17235,
      Date: "11/08/2021 16:56:55",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 1000,
      totWin: 0,
      product: "Virtual Football Pro",
      category: "Virtuals",
      username: 256705848834,
      ID: 17234,
      Date: "11/08/2021 16:47:14",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 1000,
      totWin: 0,
      product: "Virtual Football Pro",
      category: "Virtuals",
      username: 256705848834,
      ID: 17233,
      Date: "11/08/2021 16:38:15",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 1928,
      totWin: 6928,
      product: "Virtual Football Pro",
      category: "Virtuals",
      username: 256705848834,
      ID: 17232,
      Date: "11/08/2021 16:32:29",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 2400,
      totWin: 5400,
      product: "Virtual Football Pro",
      category: "Virtuals",
      username: 256705848834,
      ID: 17231,
      Date: "11/08/2021 16:17:05",
      channel: "Mobile",
      tax: 0,
      Status: "Won",
    },
    {
      totAmount: 2000,
      totWin: 3840,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256773044210,
      ID: 17230,
      Date: "11/08/2021 14:51:44",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 6250,
      totWin: 0,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256773044210,
      ID: 17229,
      Date: "11/08/2021 14:47:10",
      channel: "Mobile",
      tax: 0,
      Status: "Won",
    },
    {
      totAmount: 32500,
      totWin: 0,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256773044210,
      ID: 17228,
      Date: "11/08/2021 13:52:38",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 22000,
      totWin: 54721.87,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256773044210,
      ID: 17227,
      Date: "11/08/2021 13:07:15",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 3500,
      totWin: 0,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256773044210,
      ID: 17226,
      Date: "11/08/2021 12:25:16",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 13500,
      totWin: 15067.5,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256773044210,
      ID: 17225,
      Date: "11/08/2021 11:20:26",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 4000,
      totWin: 0,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256773044210,
      ID: 17224,
      Date: "11/08/2021 10:12:24",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 2.5,
      totWin: 0,
      product: "888 Gold",
      category: "Casino",
      username: 256708293084,
      ID: 17223,
      Date: "11/08/2021 07:44:00",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 11500,
      totWin: 1500,
      product: "Return of the Dead",
      category: "Casino",
      username: 256708293084,
      ID: 17222,
      Date: "11/08/2021 07:43:16",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 6000,
      totWin: 1400,
      product: "Gold Of Ra",
      category: "Casino",
      username: 256708293084,
      ID: 17221,
      Date: "11/08/2021 07:40:44",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 1200,
      totWin: 0,
      product: "More Cash",
      category: "Casino",
      username: 256708293084,
      ID: 17220,
      Date: "11/08/2021 07:38:43",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 4500,
      totWin: 10100,
      product: "Fortune Lions",
      category: "Casino",
      username: 256708293084,
      ID: 17219,
      Date: "11/08/2021 07:37:29",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 12900,
      totWin: 3480,
      product: "88 Riches",
      category: "Casino",
      username: 256708293084,
      ID: 17218,
      Date: "11/08/2021 07:33:21",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 15600,
      totWin: 53600,
      product: "Tiger Heart",
      category: "Casino",
      username: 256708293084,
      ID: 17217,
      Date: "11/08/2021 07:24:14",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 15549.6,
      totWin: 12144,
      product: "Caishens Gold",
      category: "Casino",
      username: 256708293084,
      ID: 17216,
      Date: "11/08/2021 07:15:44",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 2400,
      totWin: 692,
      product: "Penalty Shootout",
      category: "Virtuals",
      username: 256702621406,
      ID: 17215,
      Date: "11/08/2021 00:30:08",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 17400,
      totWin: 12900,
      product: "Penalty Shootout",
      category: "Virtuals",
      username: 256702621406,
      ID: 17214,
      Date: "11/08/2021 00:18:19",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 153000,
      totWin: 103000,
      product: "Tree of Riches",
      category: "Casino",
      username: 256708293084,
      ID: 17213,
      Date: "11/08/2021 00:03:26",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 2000,
      totWin: 1730,
      product: "Penalty Shootout",
      category: "Virtuals",
      username: 256702621406,
      ID: 17212,
      Date: "10/08/2021 23:57:08",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 200,
      totWin: 0,
      product: "Ramses Treasure",
      category: "Casino",
      username: 256789156900,
      ID: 17211,
      Date: "10/08/2021 23:54:54",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 45200,
      totWin: 38700,
      product: "Slot Of Money",
      category: "Casino",
      username: 256789156900,
      ID: 17210,
      Date: "10/08/2021 23:54:13",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 10400,
      totWin: 10032,
      product: "Penalty Shootout",
      category: "Virtuals",
      username: 256702621406,
      ID: 17209,
      Date: "10/08/2021 23:50:58",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 18000,
      totWin: 38000,
      product: "Tree of Riches",
      category: "Casino",
      username: 256708293084,
      ID: 17208,
      Date: "10/08/2021 23:46:15",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 22500,
      totWin: 12500,
      product: "Three Star Fortune",
      category: "Casino",
      username: 256708293084,
      ID: 17207,
      Date: "10/08/2021 23:40:26",
      channel: "Mobile",
      tax: 0,
      Status: "Won",
    },
    {
      totAmount: 19000,
      totWin: 9000,
      product: "Curse of the Werewolf Megaways",
      category: "Casino",
      username: 256708293084,
      ID: 17206,
      Date: "10/08/2021 23:36:02",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 53000,
      totWin: 53000,
      product: "Hot to Burn",
      category: "Casino",
      username: 256708293084,
      ID: 17205,
      Date: "10/08/2021 23:31:45",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 1250,
      totWin: 0,
      product: "Virtual World Cup",
      category: "Virtuals",
      username: 256786916636,
      ID: 17204,
      Date: "10/08/2021 22:53:44",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 1500,
      totWin: 1025,
      product: "Virtual World Cup",
      category: "Virtuals",
      username: 256786916636,
      ID: 17203,
      Date: "10/08/2021 22:48:07",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 3400,
      totWin: 5740,
      product: "Penalty Shootout",
      category: "Virtuals",
      username: 256702621406,
      ID: 17202,
      Date: "10/08/2021 22:39:18",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 500,
      totWin: 0,
      product: "Virtual Europa",
      category: "Virtuals",
      username: 256786916636,
      ID: 17201,
      Date: "10/08/2021 22:38:14",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 28000,
      totWin: 23500,
      product: "Mega Sic Bo",
      category: "Live Casino",
      username: 256753273651,
      ID: 17200,
      Date: "10/08/2021 22:29:56",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 1000,
      totWin: 0,
      product: "Penalty Shootout",
      category: "Virtuals",
      username: 256702621406,
      ID: 17199,
      Date: "10/08/2021 22:27:17",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 1000,
      totWin: 0,
      product: "Virtual World Cup",
      category: "Virtuals",
      username: 256786916636,
      ID: 17198,
      Date: "10/08/2021 22:25:35",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 1400,
      totWin: 2100,
      product: "Penalty Shootout",
      category: "Virtuals",
      username: 256702621406,
      ID: 17197,
      Date: "10/08/2021 22:24:58",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 2250,
      totWin: 1450,
      product: "Virtual World Cup",
      category: "Virtuals",
      username: 256786916636,
      ID: 17196,
      Date: "10/08/2021 22:17:29",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 2400,
      totWin: 1360,
      product: "Penalty Shootout",
      category: "Virtuals",
      username: 256702621406,
      ID: 17195,
      Date: "10/08/2021 22:16:03",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 1000,
      totWin: 0,
      product: "Virtual World Cup",
      category: "Virtuals",
      username: 256786916636,
      ID: 17194,
      Date: "10/08/2021 22:06:50",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 1000,
      totWin: 2200,
      product: "Penalty Shootout",
      category: "Virtuals",
      username: 256702621406,
      ID: 17193,
      Date: "10/08/2021 22:06:37",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 2000,
      totWin: 1000,
      product: "Mega Wheel",
      category: "Live Casino",
      username: 256753273651,
      ID: 17192,
      Date: "10/08/2021 22:03:48",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 1000,
      totWin: 0,
      product: "Penalty Shootout",
      category: "Virtuals",
      username: 256786916636,
      ID: 17191,
      Date: "10/08/2021 22:01:33",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 1000,
      totWin: 0,
      product: "Virtual World Cup",
      category: "Virtuals",
      username: 256786916636,
      ID: 17190,
      Date: "10/08/2021 21:52:10",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 52.5,
      totWin: 51,
      product: "888 Gold",
      category: "Casino",
      username: 256753273651,
      ID: 17189,
      Date: "10/08/2021 21:49:54",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 1000,
      totWin: 0,
      product: "Virtual World Cup",
      category: "Virtuals",
      username: 256786916636,
      ID: 17188,
      Date: "10/08/2021 21:42:06",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 17187,
      Date: "10/08/2021 18:42:00",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 17186,
      Date: "10/08/2021 18:41:35",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 1000,
      totWin: 0,
      product: "Virtual World Cup",
      category: "Virtuals",
      username: 256786916636,
      ID: 17185,
      Date: "10/08/2021 21:32:38",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 25500,
      totWin: 29950,
      product: "5 Lions Dance",
      category: "Casino",
      username: 256708293084,
      ID: 17184,
      Date: "10/08/2021 21:31:04",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 6000,
      totWin: 2000,
      product: "Jade Treasure",
      category: "Casino",
      username: 256708293084,
      ID: 17183,
      Date: "10/08/2021 21:26:22",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 38800,
      totWin: 18400,
      product: "Thunder Bird",
      category: "Casino",
      username: 256708293084,
      ID: 17182,
      Date: "10/08/2021 21:22:14",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 13500,
      totWin: 3375,
      product: "Congo Cash",
      category: "Casino",
      username: 256708293084,
      ID: 17181,
      Date: "10/08/2021 20:50:37",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 14000,
      totWin: 64080,
      product: "Monkey Pirates",
      category: "Casino",
      username: 256708293084,
      ID: 17180,
      Date: "10/08/2021 20:45:11",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 23500,
      totWin: 43700,
      product: "Honey Honey Honey",
      category: "Casino",
      username: 256708293084,
      ID: 17179,
      Date: "10/08/2021 20:38:49",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 70000,
      totWin: 175000,
      product: "Tree of Riches",
      category: "Casino",
      username: 256708293084,
      ID: 17178,
      Date: "10/08/2021 19:05:48",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 27000,
      totWin: 22964.99,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256773044210,
      ID: 17177,
      Date: "10/08/2021 18:55:17",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 1600,
      totWin: 1836,
      product: "Penalty Shootout",
      category: "Virtuals",
      username: 256702621406,
      ID: 17176,
      Date: "10/08/2021 18:38:58",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 4500,
      totWin: 2000,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256773044210,
      ID: 17175,
      Date: "10/08/2021 18:11:05",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 6600,
      totWin: 5296,
      product: "Penalty Shootout",
      category: "Virtuals",
      username: 256702621406,
      ID: 17174,
      Date: "10/08/2021 18:04:36",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 3800,
      totWin: 2692,
      product: "Penalty Shootout",
      category: "Virtuals",
      username: 256702621406,
      ID: 17173,
      Date: "10/08/2021 17:39:49",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 17172,
      Date: "10/08/2021 14:26:00",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 1000,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 17171,
      Date: "10/08/2021 14:24:42",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 9000,
      totWin: 5250,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256773044210,
      ID: 17170,
      Date: "10/08/2021 17:16:48",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 8750,
      totWin: 8875,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256773044210,
      ID: 17169,
      Date: "10/08/2021 17:09:58",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 2000,
      totWin: 1368,
      product: "Penalty Shootout",
      category: "Virtuals",
      username: 256702621406,
      ID: 17168,
      Date: "10/08/2021 16:59:27",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 3000,
      totWin: 8000,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256773044210,
      ID: 17167,
      Date: "10/08/2021 16:56:00",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 2000,
      totWin: 4875,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256773044210,
      ID: 17166,
      Date: "10/08/2021 16:49:39",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 400,
      totWin: 0,
      product: "Penalty Shootout",
      category: "Virtuals",
      username: 256702621406,
      ID: 17165,
      Date: "10/08/2021 16:48:12",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 12600,
      totWin: 11440,
      product: "Penalty Shootout",
      category: "Virtuals",
      username: 256702621406,
      ID: 17164,
      Date: "10/08/2021 16:44:12",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 11250,
      totWin: 3125,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256773044210,
      ID: 17163,
      Date: "10/08/2021 16:43:35",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 3000,
      totWin: 0,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256773044210,
      ID: 17162,
      Date: "10/08/2021 16:15:46",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 10200,
      totWin: 5832,
      product: "Penalty Shootout",
      category: "Virtuals",
      username: 256702621406,
      ID: 17161,
      Date: "10/08/2021 16:14:09",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 800,
      totWin: 0,
      product: "Penalty Shootout",
      category: "Virtuals",
      username: 256702621406,
      ID: 17160,
      Date: "10/08/2021 15:49:02",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 1000,
      totWin: 2500,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256701052616,
      ID: 17159,
      Date: "10/08/2021 13:32:52",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 6000,
      totWin: 0,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256701052616,
      ID: 17158,
      Date: "10/08/2021 13:30:52",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 4200,
      totWin: 2000,
      product: "Fantastic League",
      category: "Virtuals",
      username: 256754124969,
      ID: 17157,
      Date: "10/08/2021 13:28:19",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 31910,
      totWin: 30995,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256701052616,
      ID: 17156,
      Date: "10/08/2021 12:22:27",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 12750,
      totWin: 2165,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256773044210,
      ID: 17155,
      Date: "10/08/2021 11:39:19",
      channel: "Mobile",
      tax: 0,
      Status: "Won",
    },
    {
      totAmount: 1250,
      totWin: 2750,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256773044210,
      ID: 17154,
      Date: "10/08/2021 11:32:06",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 1000,
      totWin: 0,
      product: "Virtual Football Pro",
      category: "Virtuals",
      username: 256773044210,
      ID: 17153,
      Date: "10/08/2021 11:25:22",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 12750,
      totWin: 6877.5,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256773044210,
      ID: 17152,
      Date: "10/08/2021 11:18:27",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 17151,
      Date: "10/08/2021 07:50:37",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 25250,
      totWin: 5000,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256773044210,
      ID: 17150,
      Date: "10/08/2021 07:47:53",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 3000,
      totWin: 3149.09,
      product: "Fantastic League",
      category: "Virtuals",
      username: 256754124969,
      ID: 17149,
      Date: "10/08/2021 00:51:51",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 1400,
      totWin: 1909.09,
      product: "Fantastic League",
      category: "Virtuals",
      username: 256754124969,
      ID: 17148,
      Date: "10/08/2021 00:40:02",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 2000,
      totWin: 0,
      product: "Fantastic League",
      category: "Virtuals",
      username: 256754124969,
      ID: 17147,
      Date: "10/08/2021 00:30:27",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 1200,
      totWin: 2320,
      product: "Fantastic League",
      category: "Virtuals",
      username: 256754124969,
      ID: 17146,
      Date: "10/08/2021 00:29:57",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 500,
      totWin: 1050,
      product: "Virtual Euros",
      category: "Virtuals",
      username: 256786916636,
      ID: 17145,
      Date: "09/08/2021 22:44:11",
      channel: "Mobile",
      tax: 0,
      Status: "Won",
    },
    {
      totAmount: 500,
      totWin: 0,
      product: "Virtual World Cup",
      category: "Virtuals",
      username: 256786916636,
      ID: 17144,
      Date: "09/08/2021 22:39:48",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 9000,
      totWin: 22275,
      product: "Virtual World Cup",
      category: "Virtuals",
      username: 256786916636,
      ID: 17143,
      Date: "09/08/2021 22:23:04",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 5750,
      totWin: 8440.62,
      product: "Virtual World Cup",
      category: "Virtuals",
      username: 256786916636,
      ID: 17142,
      Date: "09/08/2021 21:57:50",
      channel: "Mobile",
      tax: 0,
      Status: "Won",
    },
    {
      totAmount: 37750,
      totWin: 45651,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256773044210,
      ID: 17141,
      Date: "09/08/2021 21:52:15",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 500,
      totWin: 0,
      product: "Pick 1",
      category: "Number Games",
      username: 256753273651,
      ID: 17140,
      Date: "09/08/2021 21:49:44",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 1000,
      totWin: 1050,
      product: "Virtual World Cup",
      category: "Virtuals",
      username: 256786916636,
      ID: 17139,
      Date: "09/08/2021 21:32:44",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 500,
      totWin: 1050,
      product: "Virtual Europa",
      category: "Virtuals",
      username: 256786916636,
      ID: 17138,
      Date: "09/08/2021 21:23:58",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 9750,
      totWin: 9087.5,
      product: "Virtual World Cup",
      category: "Virtuals",
      username: 256786916636,
      ID: 17137,
      Date: "09/08/2021 21:10:20",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 21750,
      totWin: 15562.5,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256773044210,
      ID: 17136,
      Date: "09/08/2021 20:39:58",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 1750,
      totWin: 0,
      product: "Virtual World Cup",
      category: "Virtuals",
      username: 256786916636,
      ID: 17135,
      Date: "09/08/2021 20:32:07",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 500,
      totWin: 0,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256773044210,
      ID: 17134,
      Date: "09/08/2021 20:21:52",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 500,
      totWin: 0,
      product: "Virtual World Cup",
      category: "Virtuals",
      username: 256786916636,
      ID: 17133,
      Date: "09/08/2021 20:13:48",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 10000,
      totWin: 0,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256773044210,
      ID: 17132,
      Date: "09/08/2021 20:04:02",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 5000,
      totWin: 0,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256773044210,
      ID: 17131,
      Date: "09/08/2021 19:08:07",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 1000,
      totWin: 0,
      product: "Penalty Shootout",
      category: "Virtuals",
      username: 256702621406,
      ID: 17130,
      Date: "09/08/2021 18:29:16",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 9400,
      totWin: 2880,
      product: "Penalty Shootout",
      category: "Virtuals",
      username: 256702621406,
      ID: 17129,
      Date: "09/08/2021 18:20:16",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 8000,
      totWin: 7000,
      product: "Penalty Shootout",
      category: "Virtuals",
      username: 256702621406,
      ID: 17128,
      Date: "09/08/2021 17:49:45",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 400,
      totWin: 1000,
      product: "Penalty Shootout",
      category: "Virtuals",
      username: 256702621406,
      ID: 17127,
      Date: "09/08/2021 16:47:41",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 2000,
      totWin: 3400,
      product: "Penalty Shootout",
      category: "Virtuals",
      username: 256702621406,
      ID: 17126,
      Date: "09/08/2021 16:28:42",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 13800,
      totWin: 19040,
      product: "Penalty Shootout",
      category: "Virtuals",
      username: 256702621406,
      ID: 17125,
      Date: "09/08/2021 16:10:06",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 400,
      totWin: 0,
      product: "Penalty Shootout",
      category: "Virtuals",
      username: 256702621406,
      ID: 17124,
      Date: "09/08/2021 15:40:52",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 6000,
      totWin: 4988,
      product: "Penalty Shootout",
      category: "Virtuals",
      username: 256702621406,
      ID: 17123,
      Date: "09/08/2021 15:15:15",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 3000,
      totWin: 2980,
      product: "Penalty Shootout",
      category: "Virtuals",
      username: 256702621406,
      ID: 17122,
      Date: "09/08/2021 14:28:31",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 1000,
      totWin: 0,
      product: "Penalty Shootout",
      category: "Virtuals",
      username: 256702621406,
      ID: 17121,
      Date: "09/08/2021 14:02:26",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 8000,
      totWin: 6110,
      product: "Penalty Shootout",
      category: "Virtuals",
      username: 256702621406,
      ID: 17120,
      Date: "09/08/2021 13:49:05",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 2000,
      totWin: 1730,
      product: "Penalty Shootout",
      category: "Virtuals",
      username: 256702621406,
      ID: 17119,
      Date: "09/08/2021 13:32:23",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 1000,
      totWin: 1620,
      product: "Penalty Shootout",
      category: "Virtuals",
      username: 256702621406,
      ID: 17118,
      Date: "09/08/2021 13:26:53",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 25800,
      totWin: 31806,
      product: "Penalty Shootout",
      category: "Virtuals",
      username: 256702621406,
      ID: 17117,
      Date: "09/08/2021 13:19:17",
      channel: "Mobile",
      tax: 0,
      Status: "Won",
    },
    {
      totAmount: 2400,
      totWin: 3730,
      product: "Penalty Shootout",
      category: "Virtuals",
      username: 256702621406,
      ID: 17116,
      Date: "09/08/2021 11:35:50",
      channel: "Mobile",
      tax: 0,
      Status: "Won",
    },
    {
      totAmount: 800,
      totWin: 1200,
      product: "Penalty Shootout",
      category: "Virtuals",
      username: 256702621406,
      ID: 17115,
      Date: "09/08/2021 11:24:53",
      channel: "Mobile",
      tax: 0,
      Status: "Won",
    },
    {
      totAmount: 17500,
      totWin: 11275,
      product: "Glorious Rome",
      category: "Casino",
      username: 256789156900,
      ID: 17114,
      Date: "09/08/2021 01:25:32",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 400,
      totWin: 0,
      product: "Penalty Shootout",
      category: "Virtuals",
      username: 256702621406,
      ID: 17113,
      Date: "09/08/2021 00:27:50",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 17112,
      Date: "08/08/2021 19:37:41",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 5500,
      totWin: 3650,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256775356011,
      ID: 17111,
      Date: "08/08/2021 16:18:54",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 1825,
      totWin: 1150,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256775356011,
      ID: 17110,
      Date: "08/08/2021 16:00:09",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 1500,
      totWin: 0,
      product: "Virtual Soccer",
      category: "Virtuals",
      username: 256775356011,
      ID: 17109,
      Date: "08/08/2021 15:49:40",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 2500,
      totWin: 2675,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256775356011,
      ID: 17108,
      Date: "08/08/2021 15:43:00",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 5000,
      totWin: 1990,
      product: "Virtual Euros",
      category: "Virtuals",
      username: 256788548795,
      ID: 17107,
      Date: "08/08/2021 14:29:37",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 14000,
      totWin: 13188.5,
      product: "Virtual Euros",
      category: "Virtuals",
      username: 256788548795,
      ID: 17106,
      Date: "08/08/2021 14:09:19",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 500,
      totWin: 0,
      product: "Virtual Europa",
      category: "Virtuals",
      username: 256754609911,
      ID: 17105,
      Date: "08/08/2021 13:48:38",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 1000,
      totWin: 0,
      product: "Virtual Europa",
      category: "Virtuals",
      username: 256754609911,
      ID: 17104,
      Date: "08/08/2021 13:46:36",
      channel: "Mobile",
      tax: 0,
      Status: "Won",
    },
    {
      totAmount: 30,
      totWin: 15.5,
      product: "888 Gold",
      category: "Casino",
      username: 256700224243,
      ID: 17103,
      Date: "08/08/2021 13:16:42",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 15000,
      totWin: 7500,
      product: "Hot to Burn",
      category: "Casino",
      username: 256700224243,
      ID: 17102,
      Date: "08/08/2021 13:14:19",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 3000,
      totWin: 800,
      product: "5 Lions",
      category: "Casino",
      username: 256700224243,
      ID: 17101,
      Date: "08/08/2021 13:10:20",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 1500,
      totWin: 0,
      product: "Virtual Soccer",
      category: "Virtuals",
      username: 256770591882,
      ID: 17100,
      Date: "08/08/2021 08:41:28",
      channel: "Mobile",
      tax: 0,
      Status: "Won",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 17099,
      Date: "07/08/2021 22:09:38",
      channel: "Mobile",
      tax: 0,
      Status: "Won",
    },
    {
      totAmount: 44000,
      totWin: 20100,
      product: "Great Rhino Megaways",
      category: "Casino",
      username: 256708293084,
      ID: 17098,
      Date: "07/08/2021 23:20:09",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 3006,
      totWin: 1586.5,
      product: "The Catfather II",
      category: "Casino",
      username: 256707544108,
      ID: 17097,
      Date: "07/08/2021 23:11:53",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 11000,
      totWin: 5000,
      product: "Triple Tigers",
      category: "Casino",
      username: 256708293084,
      ID: 17096,
      Date: "07/08/2021 23:08:17",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 14700,
      totWin: 4780,
      product: "3 Kings",
      category: "Casino",
      username: 256708293084,
      ID: 17095,
      Date: "07/08/2021 23:05:58",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 15000,
      totWin: 9600,
      product: "Four Symbols",
      category: "Casino",
      username: 256708293084,
      ID: 17094,
      Date: "07/08/2021 23:00:28",
      channel: "Mobile",
      tax: 0,
      Status: "Won",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 17093,
      Date: "07/08/2021 19:58:15",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 17092,
      Date: "07/08/2021 19:57:42",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 17091,
      Date: "07/08/2021 19:57:17",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 17090,
      Date: "07/08/2021 19:55:55",
      channel: "Mobile",
      tax: 0,
      Status: "Won",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 17089,
      Date: "07/08/2021 19:53:15",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 2500,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 17088,
      Date: "07/08/2021 19:51:42",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 17087,
      Date: "07/08/2021 19:51:07",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 17086,
      Date: "07/08/2021 19:50:05",
      channel: "Mobile",
      tax: 0,
      Status: "Won",
    },
    {
      totAmount: 0,
      totWin: 2000,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 17085,
      Date: "07/08/2021 19:49:05",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 17084,
      Date: "07/08/2021 19:47:14",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 2000,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 17083,
      Date: "07/08/2021 19:46:16",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 17082,
      Date: "07/08/2021 19:45:25",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 25500,
      totWin: 242000,
      product: "Tree of Riches",
      category: "Casino",
      username: 256708293084,
      ID: 17081,
      Date: "07/08/2021 22:27:28",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 1000,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 17080,
      Date: "07/08/2021 19:25:29",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 11200,
      totWin: 3000,
      product: "Phoenix Princess",
      category: "Casino",
      username: 256708293084,
      ID: 17079,
      Date: "07/08/2021 22:17:32",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 4600,
      totWin: 1700,
      product: "Explosive Reels",
      category: "Casino",
      username: 256708293084,
      ID: 17078,
      Date: "07/08/2021 22:13:26",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 16000,
      totWin: 5750,
      product: "Big Bass Bonanza",
      category: "Casino",
      username: 256708293084,
      ID: 17077,
      Date: "07/08/2021 22:08:57",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 1400,
      totWin: 0,
      product: "Penalty Shootout",
      category: "Virtuals",
      username: 256786916636,
      ID: 17076,
      Date: "07/08/2021 21:41:12",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 6250,
      totWin: 0,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256773044210,
      ID: 17075,
      Date: "07/08/2021 21:21:36",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 2500,
      totWin: 0,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256773044210,
      ID: 17074,
      Date: "07/08/2021 21:15:21",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 13750,
      totWin: 9725,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256773044210,
      ID: 17073,
      Date: "07/08/2021 21:13:31",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 17072,
      Date: "07/08/2021 17:26:14",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 17071,
      Date: "07/08/2021 17:25:25",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 1000,
      totWin: 0,
      product: "Virtual Soccer",
      category: "Virtuals",
      username: 256770902575,
      ID: 17070,
      Date: "07/08/2021 20:23:38",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 17069,
      Date: "07/08/2021 14:16:02",
      channel: "Mobile",
      tax: 0,
      Status: "Won",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 17068,
      Date: "07/08/2021 14:14:34",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 17067,
      Date: "07/08/2021 14:14:17",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 17066,
      Date: "07/08/2021 14:13:50",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 17065,
      Date: "07/08/2021 14:13:33",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 17064,
      Date: "07/08/2021 14:11:38",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 500,
      totWin: 0,
      product: "Pick 5",
      category: "Number Games",
      username: 256776707079,
      ID: 17063,
      Date: "07/08/2021 17:10:36",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 115250,
      totWin: 108553,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256773044210,
      ID: 17062,
      Date: "07/08/2021 16:55:21",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 17061,
      Date: "07/08/2021 13:54:11",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 17060,
      Date: "07/08/2021 13:38:55",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 17059,
      Date: "07/08/2021 13:37:03",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 117250,
      totWin: 113756.25,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256773044210,
      ID: 17058,
      Date: "07/08/2021 15:51:47",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 83000,
      totWin: 83109.37,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256773044210,
      ID: 17057,
      Date: "07/08/2021 14:49:54",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 1501,
      totWin: 2533.06,
      product: "Virtual Football Pro",
      category: "Virtuals",
      username: 256700142068,
      ID: 17056,
      Date: "07/08/2021 14:13:29",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 116000,
      totWin: 75600,
      product: "Great Reef",
      category: "Casino",
      username: 256701044560,
      ID: 17055,
      Date: "07/08/2021 14:11:48",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 1000,
      totWin: 0,
      product: "Virtual Euros",
      category: "Virtuals",
      username: 256700142068,
      ID: 17054,
      Date: "07/08/2021 14:05:59",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 50000,
      totWin: 20000,
      product: "Tree of Riches",
      category: "Casino",
      username: 256701044560,
      ID: 17053,
      Date: "07/08/2021 13:56:35",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 53000,
      totWin: 24787.5,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256773044210,
      ID: 17052,
      Date: "07/08/2021 13:54:07",
      channel: "Mobile",
      tax: 0,
      Status: "Won",
    },
    {
      totAmount: 1000,
      totWin: 1800,
      product: "Virtual Euros",
      category: "Virtuals",
      username: 256700142068,
      ID: 17051,
      Date: "07/08/2021 13:52:50",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 1500,
      totWin: 0,
      product: "Virtual Euros",
      category: "Virtuals",
      username: 256700142068,
      ID: 17050,
      Date: "07/08/2021 13:50:52",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 49500,
      totWin: 37000,
      product: "Ancient Egypt",
      category: "Casino",
      username: 256701044560,
      ID: 17049,
      Date: "07/08/2021 13:48:19",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 32500,
      totWin: 19830,
      product: "3 Genie Wishes",
      category: "Casino",
      username: 256701044560,
      ID: 17048,
      Date: "07/08/2021 13:39:41",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 148000,
      totWin: 149650,
      product: "Aladdin's Treasure",
      category: "Casino",
      username: 256701044560,
      ID: 17047,
      Date: "07/08/2021 13:32:25",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 21250,
      totWin: 30575,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256773044210,
      ID: 17046,
      Date: "07/08/2021 13:05:40",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 12525,
      totWin: 53022.5,
      product: "Magic Crystals",
      category: "Casino",
      username: 256701044560,
      ID: 17045,
      Date: "07/08/2021 13:01:06",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 45000,
      totWin: 52200,
      product: "Romeo and Juliet",
      category: "Casino",
      username: 256701044560,
      ID: 17044,
      Date: "07/08/2021 12:55:17",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 500,
      totWin: 0,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256784701859,
      ID: 17043,
      Date: "07/08/2021 12:44:03",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 28500,
      totWin: 32775,
      product: "Glorious Rome",
      category: "Casino",
      username: 256701044560,
      ID: 17042,
      Date: "07/08/2021 12:41:46",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 33000,
      totWin: 25000,
      product: "888 Dragons",
      category: "Casino",
      username: 256701044560,
      ID: 17041,
      Date: "07/08/2021 12:34:12",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 53250,
      totWin: 46625,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256773044210,
      ID: 17040,
      Date: "07/08/2021 12:33:18",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 1200,
      totWin: 0,
      product: "Fantastic League",
      category: "Virtuals",
      username: 256753279976,
      ID: 17039,
      Date: "07/08/2021 11:40:29",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 6500,
      totWin: 4750,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256773044210,
      ID: 17038,
      Date: "07/08/2021 11:33:46",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 13750,
      totWin: 4000,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256773044210,
      ID: 17037,
      Date: "07/08/2021 11:20:40",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 62500,
      totWin: 52050,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256773044210,
      ID: 17036,
      Date: "07/08/2021 11:10:25",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 1200,
      totWin: 1000,
      product: "Fantastic League",
      category: "Virtuals",
      username: 256753279976,
      ID: 17035,
      Date: "07/08/2021 11:02:00",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 37500,
      totWin: 17650,
      product: "5 Lions",
      category: "Casino",
      username: 256708293084,
      ID: 17034,
      Date: "07/08/2021 08:37:42",
      channel: "Mobile",
      tax: 0,
      Status: "Won",
    },
    {
      totAmount: 12510,
      totWin: 2641,
      product: "5 Lions Gold",
      category: "Casino",
      username: 256708293084,
      ID: 17033,
      Date: "07/08/2021 08:31:10",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 13800,
      totWin: 3800,
      product: "More Cash",
      category: "Casino",
      username: 256708293084,
      ID: 17032,
      Date: "07/08/2021 08:28:18",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 16000,
      totWin: 5420,
      product: "Castle Blood",
      category: "Casino",
      username: 256708293084,
      ID: 17031,
      Date: "07/08/2021 08:23:34",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 9018,
      totWin: 25250.4,
      product: "The Catfather II",
      category: "Casino",
      username: 256708293084,
      ID: 17030,
      Date: "07/08/2021 08:15:05",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 7000,
      totWin: 1025,
      product: "Starz Megaways",
      category: "Casino",
      username: 256708293084,
      ID: 17029,
      Date: "07/08/2021 08:08:47",
      channel: "Mobile",
      tax: 0,
      Status: "Won",
    },
    {
      totAmount: 14000,
      totWin: 30000,
      product: "Triple Tigers",
      category: "Casino",
      username: 256708293084,
      ID: 17028,
      Date: "07/08/2021 08:06:39",
      channel: "Mobile",
      tax: 0,
      Status: "Won",
    },
    {
      totAmount: 32500,
      totWin: 42500,
      product: "Asgard",
      category: "Casino",
      username: 256708293084,
      ID: 17027,
      Date: "07/08/2021 07:59:45",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 6800,
      totWin: 4700,
      product: "Ramses Treasure",
      category: "Casino",
      username: 256789156900,
      ID: 17026,
      Date: "07/08/2021 00:34:42",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 2000,
      totWin: 0,
      product: "Ramses Treasure",
      category: "Casino",
      username: 256789156900,
      ID: 17025,
      Date: "07/08/2021 00:31:05",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 8750,
      totWin: 15075,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256773044210,
      ID: 17024,
      Date: "06/08/2021 23:29:26",
      channel: "Mobile",
      tax: 0,
      Status: "Won",
    },
    {
      totAmount: 34750,
      totWin: 31127.5,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256773044210,
      ID: 17023,
      Date: "06/08/2021 23:21:59",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 11000,
      totWin: 4000,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256773044210,
      ID: 17022,
      Date: "06/08/2021 22:24:23",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 1000,
      totWin: 300,
      product: "Great Reef",
      category: "Casino",
      username: 256702182014,
      ID: 17021,
      Date: "06/08/2021 22:15:00",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 400,
      totWin: 0,
      product: "Fantastic League",
      category: "Virtuals",
      username: 256702182014,
      ID: 17020,
      Date: "06/08/2021 22:13:29",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 17019,
      Date: "06/08/2021 19:11:36",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 13500,
      totWin: 6750,
      product: "Cowboys Gold",
      category: "Casino",
      username: 256708293084,
      ID: 17018,
      Date: "06/08/2021 21:46:59",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 10500,
      totWin: 3875,
      product: "Sugar Rush",
      category: "Casino",
      username: 256708293084,
      ID: 17017,
      Date: "06/08/2021 21:41:39",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 3000,
      totWin: 121750,
      product: "5 Lions",
      category: "Casino",
      username: 256708293084,
      ID: 17016,
      Date: "06/08/2021 21:13:35",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 500,
      totWin: 0,
      product: "Pick 5",
      category: "Number Games",
      username: 256708293084,
      ID: 17015,
      Date: "06/08/2021 20:59:16",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 17014,
      Date: "06/08/2021 17:57:47",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 22500,
      totWin: 11945,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256773044210,
      ID: 17013,
      Date: "06/08/2021 20:30:29",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 23547,
      totWin: 16349.3,
      product: "Magic Crystals",
      category: "Casino",
      username: 256708293084,
      ID: 17012,
      Date: "06/08/2021 19:28:22",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 22500,
      totWin: 54400,
      product: "Great Reef",
      category: "Casino",
      username: 256708293084,
      ID: 17011,
      Date: "06/08/2021 19:23:05",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 7.5,
      totWin: 1.7,
      product: "Irish Charms",
      category: "Casino",
      username: 256708293084,
      ID: 17010,
      Date: "06/08/2021 19:14:14",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 3600,
      totWin: 940,
      product: "African Sunset",
      category: "Casino",
      username: 256708293084,
      ID: 17009,
      Date: "06/08/2021 19:10:39",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 12750,
      totWin: 13500,
      product: "Storming Flame",
      category: "Casino",
      username: 256708293084,
      ID: 17008,
      Date: "06/08/2021 19:08:56",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 7750,
      totWin: 3950,
      product: "King Of Wealth",
      category: "Casino",
      username: 256708293084,
      ID: 17007,
      Date: "06/08/2021 19:04:19",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 3000,
      totWin: 0,
      product: "Ultra Hold and Spin",
      category: "Casino",
      username: 256708293084,
      ID: 17006,
      Date: "06/08/2021 19:00:35",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 7000,
      totWin: 5000,
      product: "888 Dragons",
      category: "Casino",
      username: 256708293084,
      ID: 17005,
      Date: "06/08/2021 18:57:15",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 14500,
      totWin: 13700,
      product: "Great Reef",
      category: "Casino",
      username: 256785666408,
      ID: 17004,
      Date: "06/08/2021 18:05:02",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 3000,
      totWin: 0,
      product: "Virtual World Cup",
      category: "Virtuals",
      username: 256701052616,
      ID: 17003,
      Date: "06/08/2021 14:11:38",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 3000,
      totWin: 2150,
      product: "Virtual Europa",
      category: "Virtuals",
      username: 256701052616,
      ID: 17002,
      Date: "06/08/2021 14:04:02",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 3000,
      totWin: 2165,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256701052616,
      ID: 17001,
      Date: "06/08/2021 13:58:48",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 3750,
      totWin: 0,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256773044210,
      ID: 17000,
      Date: "06/08/2021 13:23:27",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 14250,
      totWin: 4062.5,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256773044210,
      ID: 16999,
      Date: "06/08/2021 13:20:15",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 21750,
      totWin: 12625,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256773044210,
      ID: 16998,
      Date: "06/08/2021 13:13:30",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 32250,
      totWin: 29875,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256773044210,
      ID: 16997,
      Date: "06/08/2021 13:01:53",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 2500,
      totWin: 0,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256773044210,
      ID: 16996,
      Date: "06/08/2021 12:14:00",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 11250,
      totWin: 11900,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256773044210,
      ID: 16995,
      Date: "06/08/2021 12:10:07",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 26750,
      totWin: 28818,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256773044210,
      ID: 16994,
      Date: "06/08/2021 12:00:06",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 8750,
      totWin: 0,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256773044210,
      ID: 16993,
      Date: "06/08/2021 11:43:25",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 2250,
      totWin: 0,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256773044210,
      ID: 16992,
      Date: "06/08/2021 11:39:08",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 16000,
      totWin: 2750,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256773044210,
      ID: 16991,
      Date: "06/08/2021 11:37:24",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 90000,
      totWin: 95975,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256773044210,
      ID: 16990,
      Date: "06/08/2021 11:16:29",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 35000,
      totWin: 22975,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256773044210,
      ID: 16989,
      Date: "06/08/2021 10:41:08",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 31250,
      totWin: 33350,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256773044210,
      ID: 16988,
      Date: "06/08/2021 09:10:12",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 1500,
      totWin: 0,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256773044210,
      ID: 16987,
      Date: "06/08/2021 08:17:26",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 23500,
      totWin: 14575,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256773044210,
      ID: 16986,
      Date: "06/08/2021 08:14:17",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 43750,
      totWin: 34187.5,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256773044210,
      ID: 16985,
      Date: "06/08/2021 07:39:32",
      channel: "Mobile",
      tax: 0,
      Status: "Won",
    },
    {
      totAmount: 1000,
      totWin: 0,
      product: "Penalty Shootout",
      category: "Virtuals",
      username: 256702621406,
      ID: 16984,
      Date: "06/08/2021 07:36:52",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 17800,
      totWin: 15902,
      product: "Penalty Shootout",
      category: "Virtuals",
      username: 256702621406,
      ID: 16983,
      Date: "06/08/2021 07:34:32",
      channel: "Mobile",
      tax: 0,
      Status: "Won",
    },
    {
      totAmount: 500,
      totWin: 0,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256773044210,
      ID: 16982,
      Date: "06/08/2021 01:16:31",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 54250,
      totWin: 44566.25,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256773044210,
      ID: 16981,
      Date: "06/08/2021 01:13:55",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 18000,
      totWin: 0,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256773044210,
      ID: 16980,
      Date: "06/08/2021 00:25:55",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 84250,
      totWin: 131931.25,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256773044210,
      ID: 16979,
      Date: "06/08/2021 00:16:45",
      channel: "Mobile",
      tax: 0,
      Status: "Won",
    },
    {
      totAmount: 12500,
      totWin: 10500,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256773044210,
      ID: 16978,
      Date: "05/08/2021 23:21:50",
      channel: "Mobile",
      tax: 0,
      Status: "Won",
    },
    {
      totAmount: 7500,
      totWin: 0,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256773044210,
      ID: 16977,
      Date: "05/08/2021 23:17:11",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 10000,
      totWin: 0,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256773044210,
      ID: 16976,
      Date: "05/08/2021 23:15:03",
      channel: "Mobile",
      tax: 0,
      Status: "Won",
    },
    {
      totAmount: 12250,
      totWin: 3892.5,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256773044210,
      ID: 16975,
      Date: "05/08/2021 22:27:21",
      channel: "Mobile",
      tax: 0,
      Status: "Won",
    },
    {
      totAmount: 400,
      totWin: 1040,
      product: "Penalty Shootout",
      category: "Virtuals",
      username: 256702621406,
      ID: 16974,
      Date: "05/08/2021 22:26:51",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 26750,
      totWin: 6750,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256773044210,
      ID: 16973,
      Date: "05/08/2021 22:19:21",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 69500,
      totWin: 86075,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256773044210,
      ID: 16972,
      Date: "05/08/2021 22:03:24",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 12500,
      totWin: 6250,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256773044210,
      ID: 16971,
      Date: "05/08/2021 21:25:46",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 400,
      totWin: 800,
      product: "Penalty Shootout",
      category: "Virtuals",
      username: 256702621406,
      ID: 16970,
      Date: "05/08/2021 21:15:23",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 13000,
      totWin: 0,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256773044210,
      ID: 16969,
      Date: "05/08/2021 21:15:10",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 400,
      totWin: 0,
      product: "Penalty Shootout",
      category: "Virtuals",
      username: 256702621406,
      ID: 16968,
      Date: "05/08/2021 21:14:35",
      channel: "Mobile",
      tax: 0,
      Status: "Won",
    },
    {
      totAmount: 2000,
      totWin: 1000,
      product: "Virtual World Cup",
      category: "Virtuals",
      username: 256786916636,
      ID: 16967,
      Date: "05/08/2021 20:36:08",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 51250,
      totWin: 46000,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256773044210,
      ID: 16966,
      Date: "05/08/2021 19:05:53",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 18750,
      totWin: 18437.5,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256773044210,
      ID: 16965,
      Date: "05/08/2021 18:29:11",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 71250,
      totWin: 49150,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256773044210,
      ID: 16964,
      Date: "05/08/2021 18:22:57",
      channel: "Mobile",
      tax: 0,
      Status: "Won",
    },
    {
      totAmount: 11250,
      totWin: 11900,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256773044210,
      ID: 16963,
      Date: "05/08/2021 17:57:26",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 11250,
      totWin: 10000,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256773044210,
      ID: 16962,
      Date: "05/08/2021 17:50:19",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 15000,
      totWin: 55037.5,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256773044210,
      ID: 16961,
      Date: "05/08/2021 17:44:07",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 7500,
      totWin: 5000,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256773044210,
      ID: 16960,
      Date: "05/08/2021 17:16:16",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 7500,
      totWin: 7250,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256773044210,
      ID: 16959,
      Date: "05/08/2021 17:03:50",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 2000,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 16958,
      Date: "05/08/2021 12:41:06",
      channel: "Mobile",
      tax: 0,
      Status: "Won",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 16957,
      Date: "05/08/2021 12:40:33",
      channel: "Mobile",
      tax: 0,
      Status: "Won",
    },
    {
      totAmount: 4000,
      totWin: 5045,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256786916636,
      ID: 16956,
      Date: "05/08/2021 15:36:43",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 500,
      totWin: 0,
      product: "Virtual World Cup",
      category: "Virtuals",
      username: 256786916636,
      ID: 16955,
      Date: "05/08/2021 15:15:09",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 3800,
      totWin: 0,
      product: "Penalty Shootout",
      category: "Virtuals",
      username: 256702621406,
      ID: 16954,
      Date: "05/08/2021 13:22:16",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 112500,
      totWin: 155700,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256773044210,
      ID: 16953,
      Date: "05/08/2021 13:22:05",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 400,
      totWin: 0,
      product: "Penalty Shootout",
      category: "Virtuals",
      username: 256702621406,
      ID: 16952,
      Date: "05/08/2021 13:14:05",
      channel: "Mobile",
      tax: 0,
      Status: "Won",
    },
    {
      totAmount: 7500,
      totWin: 41187.5,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256773044210,
      ID: 16951,
      Date: "05/08/2021 12:47:48",
      channel: "Mobile",
      tax: 0,
      Status: "Won",
    },
    {
      totAmount: 8750,
      totWin: 0,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256773044210,
      ID: 16950,
      Date: "05/08/2021 12:38:01",
      channel: "Mobile",
      tax: 0,
      Status: "Won",
    },
    {
      totAmount: 5200,
      totWin: 7030,
      product: "Penalty Shootout",
      category: "Virtuals",
      username: 256702621406,
      ID: 16949,
      Date: "05/08/2021 12:28:50",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 22500,
      totWin: 26562.5,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256773044210,
      ID: 16948,
      Date: "05/08/2021 12:28:19",
      channel: "Mobile",
      tax: 0,
      Status: "Won",
    },
    {
      totAmount: 1250,
      totWin: 0,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256773044210,
      ID: 16947,
      Date: "05/08/2021 12:17:43",
      channel: "Mobile",
      tax: 0,
      Status: "Won",
    },
    {
      totAmount: 11250,
      totWin: 4000,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256773044210,
      ID: 16946,
      Date: "05/08/2021 12:15:23",
      channel: "Mobile",
      tax: 0,
      Status: "Won",
    },
    {
      totAmount: 1000,
      totWin: 1730,
      product: "Penalty Shootout",
      category: "Virtuals",
      username: 256702621406,
      ID: 16945,
      Date: "05/08/2021 12:09:40",
      channel: "Mobile",
      tax: 0,
      Status: "Won",
    },
    {
      totAmount: 2500,
      totWin: 2175,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256701052616,
      ID: 16944,
      Date: "05/08/2021 12:05:41",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 400,
      totWin: 0,
      product: "Penalty Shootout",
      category: "Virtuals",
      username: 256702621406,
      ID: 16943,
      Date: "05/08/2021 12:02:02",
      channel: "Mobile",
      tax: 0,
      Status: "Void",
    },
    {
      totAmount: 2400,
      totWin: 4240,
      product: "Penalty Shootout",
      category: "Virtuals",
      username: 256702621406,
      ID: 16942,
      Date: "05/08/2021 11:59:25",
      channel: "Mobile",
      tax: 0,
      Status: "Won",
    },
    {
      totAmount: 9000,
      totWin: 7750,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256701052616,
      ID: 16941,
      Date: "05/08/2021 11:57:42",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 46250,
      totWin: 52987.5,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256773044210,
      ID: 16940,
      Date: "05/08/2021 11:56:26",
      channel: "Mobile",
      tax: 0,
      Status: "Won",
    },
    {
      totAmount: 1400,
      totWin: 3014,
      product: "Penalty Shootout",
      category: "Virtuals",
      username: 256702621406,
      ID: 16939,
      Date: "05/08/2021 11:47:33",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 2400,
      totWin: 1800,
      product: "Penalty Shootout",
      category: "Virtuals",
      username: 256702621406,
      ID: 16938,
      Date: "05/08/2021 11:28:06",
      channel: "Mobile",
      tax: 0,
      Status: "Won",
    },
    {
      totAmount: 58750,
      totWin: 78450,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256773044210,
      ID: 16937,
      Date: "05/08/2021 11:19:05",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 1000,
      totWin: 1670,
      product: "Penalty Shootout",
      category: "Virtuals",
      username: 256702621406,
      ID: 16936,
      Date: "05/08/2021 11:07:13",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 84250,
      totWin: 108937.5,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256773044210,
      ID: 16935,
      Date: "05/08/2021 11:02:17",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 5000,
      totWin: 7752,
      product: "Penalty Shootout",
      category: "Virtuals",
      username: 256702621406,
      ID: 16934,
      Date: "05/08/2021 10:59:41",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 2000,
      totWin: 1148,
      product: "Penalty Shootout",
      category: "Virtuals",
      username: 256702621406,
      ID: 16933,
      Date: "05/08/2021 10:35:31",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 16932,
      Date: "05/08/2021 07:31:55",
      channel: "Mobile",
      tax: 0,
      Status: "Won",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 16931,
      Date: "05/08/2021 07:31:34",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 16930,
      Date: "05/08/2021 07:31:17",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 1000,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 16929,
      Date: "05/08/2021 07:30:47",
      channel: "Mobile",
      tax: 0,
      Status: "Won",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 16928,
      Date: "05/08/2021 07:30:31",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 16927,
      Date: "05/08/2021 07:30:07",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 16926,
      Date: "05/08/2021 07:29:50",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 16925,
      Date: "05/08/2021 07:29:28",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 16924,
      Date: "05/08/2021 07:29:05",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 1000,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 16923,
      Date: "05/08/2021 07:28:40",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 16922,
      Date: "05/08/2021 07:28:00",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 16921,
      Date: "05/08/2021 07:27:44",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 16920,
      Date: "05/08/2021 07:27:24",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 16919,
      Date: "05/08/2021 07:27:08",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 16918,
      Date: "05/08/2021 07:26:20",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 16917,
      Date: "05/08/2021 07:25:56",
      channel: "Mobile",
      tax: 0,
      Status: "Won",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 16916,
      Date: "05/08/2021 07:25:27",
      channel: "Mobile",
      tax: 0,
      Status: "Won",
    },
    {
      totAmount: 0,
      totWin: 2000,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 16915,
      Date: "05/08/2021 07:24:57",
      channel: "Mobile",
      tax: 0,
      Status: "Won",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 16914,
      Date: "05/08/2021 07:24:26",
      channel: "Mobile",
      tax: 0,
      Status: "Won",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 16913,
      Date: "05/08/2021 07:24:09",
      channel: "Mobile",
      tax: 0,
      Status: "Won",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 16912,
      Date: "05/08/2021 07:23:50",
      channel: "Mobile",
      tax: 0,
      Status: "Won",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 16911,
      Date: "05/08/2021 07:23:28",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 2500,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 16910,
      Date: "05/08/2021 07:22:59",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 16909,
      Date: "05/08/2021 07:21:51",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 16908,
      Date: "05/08/2021 07:21:35",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 26250,
      totWin: 17362.5,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256773044210,
      ID: 16907,
      Date: "05/08/2021 10:21:21",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 2000,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 16906,
      Date: "05/08/2021 07:20:59",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 16905,
      Date: "05/08/2021 07:20:32",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 4000,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 16904,
      Date: "05/08/2021 07:19:58",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 16903,
      Date: "05/08/2021 07:18:46",
      channel: "Mobile",
      tax: 0,
      Status: "Won",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 16902,
      Date: "05/08/2021 07:18:06",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 1000,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 16901,
      Date: "05/08/2021 07:17:22",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 1000,
      totWin: 0,
      product: "Glorious Rome",
      category: "Casino",
      username: 256774657147,
      ID: 16900,
      Date: "05/08/2021 10:15:14",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 5000,
      totWin: 4560,
      product: "Penalty Shootout",
      category: "Virtuals",
      username: 256702621406,
      ID: 16899,
      Date: "05/08/2021 10:13:57",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 16898,
      Date: "05/08/2021 07:06:31",
      channel: "Mobile",
      tax: 0,
      Status: "Won",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 16897,
      Date: "05/08/2021 07:06:03",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 16896,
      Date: "05/08/2021 07:05:26",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 16895,
      Date: "05/08/2021 07:04:01",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 16894,
      Date: "05/08/2021 07:00:58",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 16893,
      Date: "05/08/2021 07:00:36",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 16892,
      Date: "05/08/2021 06:59:59",
      channel: "Mobile",
      tax: 0,
      Status: "Won",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 16891,
      Date: "05/08/2021 06:59:26",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 16890,
      Date: "05/08/2021 06:59:06",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 16889,
      Date: "05/08/2021 06:57:01",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 16888,
      Date: "05/08/2021 06:56:33",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 1000,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 16887,
      Date: "05/08/2021 06:56:02",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 16886,
      Date: "05/08/2021 06:55:41",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 16885,
      Date: "05/08/2021 06:55:11",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 16884,
      Date: "05/08/2021 06:54:52",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 16883,
      Date: "05/08/2021 06:54:24",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 16882,
      Date: "05/08/2021 06:53:56",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 16881,
      Date: "05/08/2021 06:53:34",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 16880,
      Date: "05/08/2021 06:53:08",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 16879,
      Date: "05/08/2021 06:52:42",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 4000,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 16878,
      Date: "05/08/2021 06:52:06",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 16877,
      Date: "05/08/2021 06:50:27",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 1200,
      totWin: 1652,
      product: "Penalty Shootout",
      category: "Virtuals",
      username: 256702621406,
      ID: 16876,
      Date: "05/08/2021 09:50:16",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 16875,
      Date: "05/08/2021 06:49:12",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 16874,
      Date: "05/08/2021 06:48:51",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 4000,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 16873,
      Date: "05/08/2021 06:47:47",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 16872,
      Date: "05/08/2021 06:46:55",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 16871,
      Date: "05/08/2021 06:46:30",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 16870,
      Date: "05/08/2021 06:46:05",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 16869,
      Date: "05/08/2021 06:45:15",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 1000,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 16868,
      Date: "05/08/2021 06:44:29",
      channel: "Mobile",
      tax: 0,
      Status: "Won",
    },
    {
      totAmount: 0,
      totWin: 2500,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 16867,
      Date: "05/08/2021 06:42:50",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 16866,
      Date: "05/08/2021 06:42:29",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 2000,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 16865,
      Date: "05/08/2021 06:41:53",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 16864,
      Date: "05/08/2021 06:41:32",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 4000,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 16863,
      Date: "05/08/2021 06:40:57",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 16862,
      Date: "05/08/2021 06:40:04",
      channel: "Mobile",
      tax: 0,
      Status: "Won",
    },
    {
      totAmount: 0,
      totWin: 2000,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 16861,
      Date: "05/08/2021 06:38:41",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 1000,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 16860,
      Date: "05/08/2021 06:37:55",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 16859,
      Date: "05/08/2021 06:37:35",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 2000,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 16858,
      Date: "05/08/2021 06:36:56",
      channel: "Mobile",
      tax: 0,
      Status: "Won",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 16857,
      Date: "05/08/2021 06:36:38",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 16856,
      Date: "05/08/2021 06:35:37",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 2000,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 16855,
      Date: "05/08/2021 06:33:31",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 16854,
      Date: "05/08/2021 06:33:05",
      channel: "Mobile",
      tax: 0,
      Status: "Won",
    },
    {
      totAmount: 500,
      totWin: 0,
      product: "Pick 3",
      category: "Number Games",
      username: 256396866,
      ID: 16853,
      Date: "05/08/2021 09:32:59",
      channel: "Online",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 3000,
      totWin: 1925,
      product: "Glorious Rome",
      category: "Casino",
      username: 256396866,
      ID: 16852,
      Date: "05/08/2021 09:31:18",
      channel: "Online",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 16851,
      Date: "05/08/2021 06:30:49",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 16850,
      Date: "05/08/2021 06:28:02",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 16849,
      Date: "05/08/2021 06:25:59",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 1000,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 16848,
      Date: "05/08/2021 06:25:21",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 16847,
      Date: "05/08/2021 01:25:47",
      channel: "Mobile",
      tax: 0,
      Status: "Won",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 16846,
      Date: "05/08/2021 01:24:54",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 16845,
      Date: "05/08/2021 01:17:07",
      channel: "Mobile",
      tax: 0,
      Status: "Won",
    },
    {
      totAmount: 1000,
      totWin: 300,
      product: "Jungle Gorilla",
      category: "Casino",
      username: 256753164153,
      ID: 16844,
      Date: "05/08/2021 04:16:26",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 16843,
      Date: "05/08/2021 01:16:14",
      channel: "Mobile",
      tax: 0,
      Status: "Won",
    },
    {
      totAmount: 14500,
      totWin: 5250,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256700142068,
      ID: 16842,
      Date: "04/08/2021 21:30:24",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 200,
      totWin: 0,
      product: "Horse Racing",
      category: "Virtuals",
      username: 256702621406,
      ID: 16841,
      Date: "04/08/2021 13:10:54",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 1200,
      totWin: 0,
      product: "Penalty Shootout",
      category: "Virtuals",
      username: 256702621406,
      ID: 16840,
      Date: "04/08/2021 12:55:37",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 2400,
      totWin: 2820,
      product: "Penalty Shootout",
      category: "Virtuals",
      username: 256702621406,
      ID: 16839,
      Date: "04/08/2021 12:16:13",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 2400,
      totWin: 1732,
      product: "Penalty Shootout",
      category: "Virtuals",
      username: 256702621406,
      ID: 16838,
      Date: "04/08/2021 12:01:56",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 400,
      totWin: 800,
      product: "Penalty Shootout",
      category: "Virtuals",
      username: 256702621406,
      ID: 16837,
      Date: "04/08/2021 11:39:01",
      channel: "Mobile",
      tax: 0,
      Status: "Won",
    },
    {
      totAmount: 800,
      totWin: 692,
      product: "Penalty Shootout",
      category: "Virtuals",
      username: 256702621406,
      ID: 16836,
      Date: "04/08/2021 11:02:03",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 3200,
      totWin: 3528,
      product: "Penalty Shootout",
      category: "Virtuals",
      username: 256702621406,
      ID: 16835,
      Date: "04/08/2021 10:45:07",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 800,
      totWin: 1100,
      product: "Penalty Shootout",
      category: "Virtuals",
      username: 256702621406,
      ID: 16834,
      Date: "04/08/2021 10:26:38",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 800,
      totWin: 1200,
      product: "Penalty Shootout",
      category: "Virtuals",
      username: 256702621406,
      ID: 16833,
      Date: "04/08/2021 07:44:14",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 400,
      totWin: 0,
      product: "Penalty Shootout",
      category: "Virtuals",
      username: 256702621406,
      ID: 16832,
      Date: "04/08/2021 01:40:48",
      channel: "Mobile",
      tax: 0,
      Status: "Won",
    },
    {
      totAmount: 400,
      totWin: 720,
      product: "Penalty Shootout",
      category: "Virtuals",
      username: 256702621406,
      ID: 16831,
      Date: "04/08/2021 01:29:05",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 16830,
      Date: "03/08/2021 22:17:43",
      channel: "Mobile",
      tax: 0,
      Status: "Won",
    },
    {
      totAmount: 500,
      totWin: 0,
      product: "Pick 2",
      category: "Number Games",
      username: 256700101014,
      ID: 16829,
      Date: "03/08/2021 23:03:11",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 500,
      totWin: 0,
      product: "Pick 2",
      category: "Number Games",
      username: 256700101014,
      ID: 16828,
      Date: "03/08/2021 23:00:49",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 16827,
      Date: "03/08/2021 19:50:32",
      channel: "Online",
      tax: 0,
      Status: "Won",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 16826,
      Date: "03/08/2021 19:50:14",
      channel: "Online",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 16825,
      Date: "03/08/2021 19:49:25",
      channel: "Online",
      tax: 0,
      Status: "Won",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 16824,
      Date: "03/08/2021 19:49:03",
      channel: "Online",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 16823,
      Date: "03/08/2021 19:48:06",
      channel: "Online",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 2000,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 16822,
      Date: "03/08/2021 19:47:38",
      channel: "Online",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 16821,
      Date: "03/08/2021 19:46:54",
      channel: "Online",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 3000,
      totWin: 0,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256773044210,
      ID: 16820,
      Date: "03/08/2021 21:17:07",
      channel: "Mobile",
      tax: 0,
      Status: "Won",
    },
    {
      totAmount: 63500,
      totWin: 53425,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256773044210,
      ID: 16819,
      Date: "03/08/2021 21:11:04",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 9250,
      totWin: 0,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256773044210,
      ID: 16818,
      Date: "03/08/2021 20:26:27",
      channel: "Mobile",
      tax: 0,
      Status: "Won",
    },
    {
      totAmount: 500,
      totWin: 0,
      product: "Pick 1",
      category: "Number Games",
      username: 256776182014,
      ID: 16817,
      Date: "03/08/2021 17:28:30",
      channel: "Online",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 500,
      totWin: 0,
      product: "Pick 1",
      category: "Number Games",
      username: 256776182014,
      ID: 16816,
      Date: "03/08/2021 17:27:42",
      channel: "Online",
      tax: 0,
      Status: "Won",
    },
    {
      totAmount: 14000,
      totWin: 10000,
      product: "Diamond Strike 100,000",
      category: "Scratch Cards",
      username: 256776182014,
      ID: 16815,
      Date: "03/08/2021 17:27:13",
      channel: "Online",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 1,
      totWin: 0,
      product: "Baccarat",
      category: "Table Games",
      username: 256776182014,
      ID: 16814,
      Date: "03/08/2021 17:19:04",
      channel: "Online",
      tax: 0,
      Status: "Won",
    },
    {
      totAmount: 6000,
      totWin: 0,
      product: "Glorious Rome",
      category: "Casino",
      username: 256776182014,
      ID: 16813,
      Date: "03/08/2021 17:17:01",
      channel: "Online",
      tax: 0,
      Status: "Void",
    },
    {
      totAmount: 400,
      totWin: 4000,
      product: "Force1",
      category: "Virtuals",
      username: 256776182014,
      ID: 16812,
      Date: "03/08/2021 17:15:15",
      channel: "Online",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 400,
      totWin: 840,
      product: "Fantastic League",
      category: "Virtuals",
      username: 256396866,
      ID: 16811,
      Date: "03/08/2021 16:41:22",
      channel: "Online",
      tax: 0,
      Status: "Won",
    },
    {
      totAmount: 2000,
      totWin: 500,
      product: "8 Dragons",
      category: "Casino",
      username: 256396866,
      ID: 16810,
      Date: "03/08/2021 16:37:22",
      channel: "Online",
      tax: 0,
      Status: "Won",
    },
    {
      totAmount: 5000,
      totWin: 9250,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256700142068,
      ID: 16809,
      Date: "03/08/2021 15:32:56",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 4543,
      totWin: 2000,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256700142068,
      ID: 16808,
      Date: "03/08/2021 15:16:43",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 4787.8,
      totWin: 3600,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256700142068,
      ID: 16807,
      Date: "03/08/2021 15:04:42",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 22250,
      totWin: 18975,
      product: "Virtual Euros",
      category: "Virtuals",
      username: 256700142068,
      ID: 16806,
      Date: "03/08/2021 14:55:35",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 3500,
      totWin: 2850,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256700142068,
      ID: 16805,
      Date: "03/08/2021 14:10:56",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 500,
      totWin: 0,
      product: "Roulette A",
      category: "Live Casino",
      username: 256776843303,
      ID: 16804,
      Date: "03/08/2021 14:04:49",
      channel: "Online",
      tax: 0,
      Status: "Won",
    },
    {
      totAmount: 2000,
      totWin: 0,
      product: "Gold Rush 250,000",
      category: "Scratch Cards",
      username: 256776843303,
      ID: 16803,
      Date: "03/08/2021 14:01:57",
      channel: "Online",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 2000,
      totWin: 0,
      product: "Roulette",
      category: "Table Games",
      username: 256776843303,
      ID: 16802,
      Date: "03/08/2021 14:01:28",
      channel: "Online",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 2000,
      totWin: 0,
      product: "Sugar Rush",
      category: "Casino",
      username: 256776843303,
      ID: 16801,
      Date: "03/08/2021 14:00:51",
      channel: "Online",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 500,
      totWin: 0,
      product: "Pick 2",
      category: "Number Games",
      username: 256776843303,
      ID: 16800,
      Date: "03/08/2021 14:00:06",
      channel: "Online",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 500,
      totWin: 0,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256776843303,
      ID: 16799,
      Date: "03/08/2021 13:56:15",
      channel: "Online",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 400,
      totWin: 0,
      product: "Greyhound Racing",
      category: "Virtuals",
      username: 256776843303,
      ID: 16798,
      Date: "03/08/2021 13:55:39",
      channel: "Online",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 4000,
      totWin: 300,
      product: "Chili Quest",
      category: "Casino",
      username: 256756907314,
      ID: 16797,
      Date: "03/08/2021 13:51:39",
      channel: "Mobile",
      tax: 0,
      Status: "Won",
    },
    {
      totAmount: 43000,
      totWin: 37095,
      product: "Virtual Euros",
      category: "Virtuals",
      username: 256700142068,
      ID: 16796,
      Date: "03/08/2021 13:51:12",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 35000,
      totWin: 15000,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256773044210,
      ID: 16795,
      Date: "03/08/2021 12:41:08",
      channel: "Mobile",
      tax: 0,
      Status: "Won",
    },
    {
      totAmount: 11250,
      totWin: 0,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256773044210,
      ID: 16794,
      Date: "03/08/2021 12:28:06",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 11000,
      totWin: 2500,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256773044210,
      ID: 16793,
      Date: "03/08/2021 12:22:20",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 12500,
      totWin: 6000,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256773044210,
      ID: 16792,
      Date: "03/08/2021 12:04:16",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 2500,
      totWin: 0,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256773044210,
      ID: 16791,
      Date: "03/08/2021 11:54:59",
      channel: "Mobile",
      tax: 0,
      Status: "Won",
    },
    {
      totAmount: 45000,
      totWin: 0,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256773044210,
      ID: 16790,
      Date: "03/08/2021 11:50:01",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 15000,
      totWin: 0,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256773044210,
      ID: 16789,
      Date: "03/08/2021 11:37:44",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 38750,
      totWin: 0,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256773044210,
      ID: 16788,
      Date: "03/08/2021 11:31:48",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 1000,
      totWin: 1500,
      product: "Roulette A",
      category: "Live Casino",
      username: 256396866,
      ID: 16787,
      Date: "03/08/2021 11:26:36",
      channel: "Online",
      tax: 0,
      Status: "Won",
    },
    {
      totAmount: 42500,
      totWin: 56250,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256773044210,
      ID: 16786,
      Date: "03/08/2021 11:23:36",
      channel: "Mobile",
      tax: 0,
      Status: "Won",
    },
    {
      totAmount: 800,
      totWin: 800,
      product: "Fantastic League",
      category: "Virtuals",
      username: 256396866,
      ID: 16785,
      Date: "03/08/2021 11:22:47",
      channel: "Online",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 6250,
      totWin: 0,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256773044210,
      ID: 16784,
      Date: "03/08/2021 11:16:02",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 11250,
      totWin: 0,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256773044210,
      ID: 16783,
      Date: "03/08/2021 11:10:34",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 1000,
      totWin: 0,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256702621406,
      ID: 16782,
      Date: "03/08/2021 11:08:09",
      channel: "Mobile",
      tax: 0,
      Status: "Won",
    },
    {
      totAmount: 50000,
      totWin: 71750,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256773044210,
      ID: 16781,
      Date: "03/08/2021 11:06:44",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 2500,
      totWin: 0,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256773044210,
      ID: 16780,
      Date: "03/08/2021 10:58:45",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 22250,
      totWin: 0,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256773044210,
      ID: 16779,
      Date: "03/08/2021 10:56:44",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 10000,
      totWin: 0,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256773044210,
      ID: 16778,
      Date: "03/08/2021 10:32:39",
      channel: "Mobile",
      tax: 0,
      Status: "Won",
    },
    {
      totAmount: 20000,
      totWin: 50625,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256773044210,
      ID: 16777,
      Date: "03/08/2021 10:28:20",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 10000,
      totWin: 11250,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256773044210,
      ID: 16776,
      Date: "03/08/2021 10:20:00",
      channel: "Mobile",
      tax: 0,
      Status: "Won",
    },
    {
      totAmount: 1250,
      totWin: 0,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256773044210,
      ID: 16775,
      Date: "03/08/2021 10:14:32",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 1250,
      totWin: 0,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256773044210,
      ID: 16774,
      Date: "03/08/2021 10:12:12",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 3750,
      totWin: 5412.5,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256773044210,
      ID: 16773,
      Date: "03/08/2021 10:10:37",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 3750,
      totWin: 12500,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256773044210,
      ID: 16772,
      Date: "03/08/2021 10:02:46",
      channel: "Mobile",
      tax: 0,
      Status: "Won",
    },
    {
      totAmount: 500,
      totWin: 0,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256772350719,
      ID: 16771,
      Date: "03/08/2021 09:41:30",
      channel: "Mobile",
      tax: 0,
      Status: "Won",
    },
    {
      totAmount: 500,
      totWin: 0,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256772350719,
      ID: 16770,
      Date: "03/08/2021 09:36:31",
      channel: "Mobile",
      tax: 0,
      Status: "Won",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 16769,
      Date: "03/08/2021 06:34:30",
      channel: "Mobile",
      tax: 0,
      Status: "Won",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 16768,
      Date: "03/08/2021 06:30:35",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 16767,
      Date: "03/08/2021 06:30:02",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 16766,
      Date: "03/08/2021 06:29:44",
      channel: "Mobile",
      tax: 0,
      Status: "Won",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 16765,
      Date: "03/08/2021 06:29:26",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 16764,
      Date: "03/08/2021 06:28:48",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 3000,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 16763,
      Date: "03/08/2021 06:28:16",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 16762,
      Date: "03/08/2021 06:27:57",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 16761,
      Date: "03/08/2021 06:27:37",
      channel: "Mobile",
      tax: 0,
      Status: "Won",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 16760,
      Date: "03/08/2021 06:27:16",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 16759,
      Date: "03/08/2021 06:26:53",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 16758,
      Date: "03/08/2021 06:18:46",
      channel: "Mobile",
      tax: 0,
      Status: "Won",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 16757,
      Date: "03/08/2021 06:18:16",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 16756,
      Date: "03/08/2021 06:17:48",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 16755,
      Date: "03/08/2021 06:17:12",
      channel: "Mobile",
      tax: 0,
      Status: "Won",
    },
    {
      totAmount: 5502,
      totWin: 2362.5,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256700142068,
      ID: 16754,
      Date: "03/08/2021 09:09:27",
      channel: "Mobile",
      tax: 0,
      Status: "Won",
    },
    {
      totAmount: 16802,
      totWin: 11320,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256700142068,
      ID: 16753,
      Date: "03/08/2021 09:01:09",
      channel: "Mobile",
      tax: 0,
      Status: "Won",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 16752,
      Date: "03/08/2021 05:59:49",
      channel: "Mobile",
      tax: 0,
      Status: "Won",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 16751,
      Date: "03/08/2021 05:58:56",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 16750,
      Date: "03/08/2021 05:52:29",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 16749,
      Date: "03/08/2021 05:52:04",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 16748,
      Date: "03/08/2021 05:51:37",
      channel: "Mobile",
      tax: 0,
      Status: "Won",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 16747,
      Date: "03/08/2021 05:51:05",
      channel: "Mobile",
      tax: 0,
      Status: "Won",
    },
    {
      totAmount: 0,
      totWin: 4000,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 16746,
      Date: "03/08/2021 05:48:43",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 16745,
      Date: "03/08/2021 05:47:21",
      channel: "Mobile",
      tax: 0,
      Status: "Won",
    },
    {
      totAmount: 11720,
      totWin: 17905,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256700142068,
      ID: 16744,
      Date: "03/08/2021 08:46:36",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 4000,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 16743,
      Date: "03/08/2021 05:45:27",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 16742,
      Date: "03/08/2021 05:43:03",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 2500,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 16741,
      Date: "03/08/2021 05:42:06",
      channel: "Mobile",
      tax: 0,
      Status: "Won",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 16740,
      Date: "03/08/2021 05:41:36",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 16739,
      Date: "03/08/2021 05:40:39",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 16738,
      Date: "03/08/2021 05:40:12",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 16737,
      Date: "03/08/2021 05:39:40",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 16736,
      Date: "03/08/2021 05:39:14",
      channel: "Mobile",
      tax: 0,
      Status: "Won",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 16735,
      Date: "03/08/2021 05:38:26",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 2500,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 16734,
      Date: "03/08/2021 05:34:35",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 16733,
      Date: "03/08/2021 05:34:06",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 16732,
      Date: "03/08/2021 05:33:41",
      channel: "Mobile",
      tax: 0,
      Status: "Won",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 16731,
      Date: "03/08/2021 05:33:11",
      channel: "Mobile",
      tax: 0,
      Status: "Won",
    },
    {
      totAmount: 0,
      totWin: 2000,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 16730,
      Date: "03/08/2021 05:31:49",
      channel: "Mobile",
      tax: 0,
      Status: "Won",
    },
    {
      totAmount: 17500,
      totWin: 38625,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256773044210,
      ID: 16729,
      Date: "03/08/2021 08:31:14",
      channel: "Mobile",
      tax: 0,
      Status: "Won",
    },
    {
      totAmount: 0,
      totWin: 1000,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 16728,
      Date: "03/08/2021 05:30:36",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 3750,
      totWin: 0,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256773044210,
      ID: 16727,
      Date: "03/08/2021 08:10:35",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 500,
      totWin: 3600,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256700142068,
      ID: 16726,
      Date: "03/08/2021 08:02:59",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 10300,
      totWin: 14800,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256700142068,
      ID: 16725,
      Date: "03/08/2021 08:01:35",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 68750,
      totWin: 116875,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256773044210,
      ID: 16724,
      Date: "03/08/2021 07:57:45",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 22750,
      totWin: 5625,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256773044210,
      ID: 16723,
      Date: "03/08/2021 07:19:01",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 4800,
      totWin: 5360,
      product: "Battle for Atlantis",
      category: "Casino",
      username: 256789156900,
      ID: 16722,
      Date: "03/08/2021 01:36:30",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 8800,
      totWin: 2700,
      product: "Slot Of Money",
      category: "Casino",
      username: 256789156900,
      ID: 16721,
      Date: "03/08/2021 01:34:28",
      channel: "Mobile",
      tax: 0,
      Status: "Won",
    },
    {
      totAmount: 19500,
      totWin: 25700,
      product: "Golden Dragon",
      category: "Casino",
      username: 256789156900,
      ID: 16720,
      Date: "03/08/2021 01:31:45",
      channel: "Mobile",
      tax: 0,
      Status: "Won",
    },
    {
      totAmount: 12000,
      totWin: 2100,
      product: "Slot Of Money",
      category: "Casino",
      username: 256789156900,
      ID: 16719,
      Date: "03/08/2021 01:27:08",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 12500,
      totWin: 2040,
      product: "Gold Of Ra",
      category: "Casino",
      username: 256789156900,
      ID: 16718,
      Date: "03/08/2021 01:23:48",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 1000,
      totWin: 3550,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256700142068,
      ID: 16717,
      Date: "03/08/2021 00:10:13",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 3415,
      totWin: 2250,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256700142068,
      ID: 16716,
      Date: "03/08/2021 00:07:08",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 7003,
      totWin: 7500,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256700142068,
      ID: 16715,
      Date: "02/08/2021 23:52:42",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 6025,
      totWin: 7818.3,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256700142068,
      ID: 16714,
      Date: "02/08/2021 23:32:54",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 5200,
      totWin: 500,
      product: "Slot Of Money",
      category: "Casino",
      username: 256789156900,
      ID: 16713,
      Date: "02/08/2021 22:57:23",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 14500,
      totWin: 6600,
      product: "Flaming Reels",
      category: "Casino",
      username: 256789156900,
      ID: 16712,
      Date: "02/08/2021 22:55:24",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 300,
      totWin: 150,
      product: "Joan Of Arc",
      category: "Casino",
      username: 256789156900,
      ID: 16711,
      Date: "02/08/2021 22:50:41",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 2600,
      totWin: 440,
      product: "Fortune Panda",
      category: "Casino",
      username: 256789156900,
      ID: 16710,
      Date: "02/08/2021 22:49:21",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 2400,
      totWin: 200,
      product: "Slot Of Money",
      category: "Casino",
      username: 256789156900,
      ID: 16709,
      Date: "02/08/2021 22:43:58",
      channel: "Mobile",
      tax: 0,
      Status: "Won",
    },
    {
      totAmount: 1600,
      totWin: 0,
      product: "Ramses Treasure",
      category: "Casino",
      username: 256789156900,
      ID: 16708,
      Date: "02/08/2021 22:42:42",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 1000,
      totWin: 1125,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256700142068,
      ID: 16707,
      Date: "02/08/2021 22:22:22",
      channel: "Mobile",
      tax: 0,
      Status: "Won",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 16706,
      Date: "02/08/2021 19:02:41",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 16705,
      Date: "02/08/2021 18:59:31",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 1100,
      totWin: 0,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256784701859,
      ID: 16704,
      Date: "02/08/2021 17:09:21",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 500,
      totWin: 0,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256784701859,
      ID: 16703,
      Date: "02/08/2021 16:53:30",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 5940,
      totWin: 5490,
      product: "Virtual Football Pro",
      category: "Virtuals",
      username: 256780850357,
      ID: 16702,
      Date: "02/08/2021 16:18:45",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 2000,
      totWin: 0,
      product: "Panda Gold 10,000",
      category: "Scratch Cards",
      username: 256396866,
      ID: 16701,
      Date: "02/08/2021 15:43:49",
      channel: "Online",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 16700,
      Date: "02/08/2021 12:40:27",
      channel: "Mobile",
      tax: 0,
      Status: "Won",
    },
    {
      totAmount: 0.25,
      totWin: 0,
      product: "7 Piggies 5,000",
      category: "Scratch Cards",
      username: 256396866,
      ID: 16699,
      Date: "02/08/2021 15:36:18",
      channel: "Online",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 1250,
      totWin: 0,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256773044210,
      ID: 16698,
      Date: "02/08/2021 15:30:48",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 1250,
      totWin: 0,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256773044210,
      ID: 16697,
      Date: "02/08/2021 15:28:15",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 12500,
      totWin: 0,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256773044210,
      ID: 16696,
      Date: "02/08/2021 15:23:48",
      channel: "Mobile",
      tax: 0,
      Status: "Won",
    },
    {
      totAmount: 2000,
      totWin: 0,
      product: "Fruit Party",
      category: "Table Games",
      username: 256396866,
      ID: 16695,
      Date: "02/08/2021 15:03:22",
      channel: "Online",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 500,
      totWin: 0,
      product: "Pick 2",
      category: "Number Games",
      username: 256396866,
      ID: 16694,
      Date: "02/08/2021 15:00:57",
      channel: "Online",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 740,
      totWin: 0,
      product: "Virtual Football Pro",
      category: "Virtuals",
      username: 256780850357,
      ID: 16693,
      Date: "02/08/2021 15:00:32",
      channel: "Mobile",
      tax: 0,
      Status: "Won",
    },
    {
      totAmount: 500,
      totWin: 0,
      product: "Pick 3",
      category: "Number Games",
      username: 256396866,
      ID: 16692,
      Date: "02/08/2021 15:00:18",
      channel: "Online",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 500,
      totWin: 0,
      product: "Pick 2",
      category: "Number Games",
      username: 256396866,
      ID: 16691,
      Date: "02/08/2021 14:38:17",
      channel: "Online",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 500,
      totWin: 0,
      product: "Pick 2",
      category: "Number Games",
      username: 256396866,
      ID: 16690,
      Date: "02/08/2021 14:36:28",
      channel: "Online",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 600,
      totWin: 0,
      product: "Pick 2",
      category: "Number Games",
      username: 256776843303,
      ID: 16689,
      Date: "02/08/2021 14:31:54",
      channel: "Online",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 1500,
      totWin: 0,
      product: "Roulette A",
      category: "Live Casino",
      username: 256776843303,
      ID: 16688,
      Date: "02/08/2021 13:54:50",
      channel: "Online",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 16687,
      Date: "02/08/2021 10:52:42",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 16686,
      Date: "02/08/2021 10:51:02",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 500,
      totWin: 0,
      product: "Virtual World Cup",
      category: "Virtuals",
      username: 256776843303,
      ID: 16685,
      Date: "02/08/2021 13:43:29",
      channel: "Online",
      tax: 0,
      Status: "Won",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 16684,
      Date: "02/08/2021 10:37:24",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 2,
      totWin: 0,
      product: "Diamond Strike 100,000",
      category: "Scratch Cards",
      username: 256776843303,
      ID: 16683,
      Date: "02/08/2021 13:36:58",
      channel: "Online",
      tax: 0,
      Status: "Won",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 16682,
      Date: "02/08/2021 10:36:00",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 16681,
      Date: "02/08/2021 10:34:42",
      channel: "Mobile",
      tax: 0,
      Status: "Won",
    },
    {
      totAmount: 100,
      totWin: 0,
      product: "Roulette",
      category: "Table Games",
      username: 256776843303,
      ID: 16680,
      Date: "02/08/2021 13:33:39",
      channel: "Online",
      tax: 0,
      Status: "Won",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 16679,
      Date: "02/08/2021 10:31:33",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 2000,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 16678,
      Date: "02/08/2021 10:31:32",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 16677,
      Date: "02/08/2021 10:28:32",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 800,
      totWin: 160,
      product: "Lady Luck",
      category: "Casino",
      username: 256776843303,
      ID: 16676,
      Date: "02/08/2021 13:16:02",
      channel: "Online",
      tax: 0,
      Status: "Won",
    },
    {
      totAmount: 500,
      totWin: 0,
      product: "Pick 1",
      category: "Number Games",
      username: 256776843303,
      ID: 16675,
      Date: "02/08/2021 13:14:22",
      channel: "Online",
      tax: 0,
      Status: "Won",
    },
    {
      totAmount: 4000,
      totWin: 0,
      product: "Sugar Rush",
      category: "Casino",
      username: 256776843303,
      ID: 16674,
      Date: "02/08/2021 13:13:59",
      channel: "Online",
      tax: 0,
      Status: "Won",
    },
    {
      totAmount: 500,
      totWin: 0,
      product: "Pick 1",
      category: "Number Games",
      username: 256776843303,
      ID: 16673,
      Date: "02/08/2021 12:59:45",
      channel: "Online",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 500,
      totWin: 0,
      product: "Pick 1",
      category: "Number Games",
      username: 256776843303,
      ID: 16672,
      Date: "02/08/2021 12:59:37",
      channel: "Online",
      tax: 0,
      Status: "Won",
    },
    {
      totAmount: 500,
      totWin: 0,
      product: "Pick 1",
      category: "Number Games",
      username: 256776843303,
      ID: 16671,
      Date: "02/08/2021 12:59:30",
      channel: "Online",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 500,
      totWin: 0,
      product: "Pick 1",
      category: "Number Games",
      username: 256776843303,
      ID: 16670,
      Date: "02/08/2021 12:59:22",
      channel: "Online",
      tax: 0,
      Status: "Won",
    },
    {
      totAmount: 500,
      totWin: 0,
      product: "Pick 1",
      category: "Number Games",
      username: 256776843303,
      ID: 16669,
      Date: "02/08/2021 12:59:14",
      channel: "Online",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 500,
      totWin: 0,
      product: "Pick 1",
      category: "Number Games",
      username: 256776843303,
      ID: 16668,
      Date: "02/08/2021 12:59:06",
      channel: "Online",
      tax: 0,
      Status: "Won",
    },
    {
      totAmount: 500,
      totWin: 0,
      product: "Pick 1",
      category: "Number Games",
      username: 256776843303,
      ID: 16667,
      Date: "02/08/2021 12:58:59",
      channel: "Online",
      tax: 0,
      Status: "Won",
    },
    {
      totAmount: 500,
      totWin: 0,
      product: "Pick 1",
      category: "Number Games",
      username: 256776843303,
      ID: 16666,
      Date: "02/08/2021 12:58:52",
      channel: "Online",
      tax: 0,
      Status: "Won",
    },
    {
      totAmount: 500,
      totWin: 2500,
      product: "Pick 1",
      category: "Number Games",
      username: 256776843303,
      ID: 16665,
      Date: "02/08/2021 12:58:44",
      channel: "Online",
      tax: 0,
      Status: "Won",
    },
    {
      totAmount: 500,
      totWin: 0,
      product: "Pick 1",
      category: "Number Games",
      username: 256776843303,
      ID: 16664,
      Date: "02/08/2021 12:58:37",
      channel: "Online",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 500,
      totWin: 0,
      product: "Pick 2",
      category: "Number Games",
      username: 256776843303,
      ID: 16663,
      Date: "02/08/2021 12:54:18",
      channel: "Online",
      tax: 0,
      Status: "Won",
    },
    {
      totAmount: 7500,
      totWin: 0,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256773044210,
      ID: 16662,
      Date: "01/08/2021 23:55:45",
      channel: "Mobile",
      tax: 0,
      Status: "Won",
    },
    {
      totAmount: 11750,
      totWin: 0,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256773044210,
      ID: 16661,
      Date: "01/08/2021 23:05:20",
      channel: "n/a",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 7530,
      totWin: 4355,
      product: "Virtual Europa",
      category: "Virtuals",
      username: 256784701859,
      ID: 16660,
      Date: "01/08/2021 22:13:18",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 6750,
      totWin: 6440,
      product: "Virtual Football Pro",
      category: "Virtuals",
      username: 256780850357,
      ID: 16659,
      Date: "01/08/2021 21:39:21",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 17340,
      totWin: 15390,
      product: "Virtual Football Pro",
      category: "Virtuals",
      username: 256780850357,
      ID: 16658,
      Date: "01/08/2021 20:40:43",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 3250,
      totWin: 0,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256773044210,
      ID: 16657,
      Date: "01/08/2021 20:16:20",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 16656,
      Date: "01/08/2021 17:14:54",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 16655,
      Date: "01/08/2021 17:14:05",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 1250,
      totWin: 0,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256773044210,
      ID: 16654,
      Date: "01/08/2021 20:11:50",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 1250,
      totWin: 7500,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256773044210,
      ID: 16653,
      Date: "01/08/2021 20:10:21",
      channel: "Mobile",
      tax: 0,
      Status: "Won",
    },
    {
      totAmount: 1500,
      totWin: 0,
      product: "Virtual Euros",
      category: "Virtuals",
      username: 256756976045,
      ID: 16652,
      Date: "01/08/2021 18:44:08",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 16945,
      totWin: 16620,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256784701859,
      ID: 16651,
      Date: "01/08/2021 18:42:05",
      channel: "Mobile",
      tax: 0,
      Status: "Won",
    },
    {
      totAmount: 1950,
      totWin: 1450,
      product: "Virtual Europa",
      category: "Virtuals",
      username: 256784701859,
      ID: 16650,
      Date: "01/08/2021 18:05:08",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 3590,
      totWin: 3590,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256784701859,
      ID: 16649,
      Date: "01/08/2021 17:59:19",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 3300,
      totWin: 0,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256784701859,
      ID: 16648,
      Date: "01/08/2021 17:50:52",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 1250,
      totWin: 0,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256773044210,
      ID: 16647,
      Date: "01/08/2021 17:07:43",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 5000,
      totWin: 0,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256773044210,
      ID: 16646,
      Date: "01/08/2021 16:54:42",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 10000,
      totWin: 0,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256773044210,
      ID: 16645,
      Date: "01/08/2021 16:52:41",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 2500,
      totWin: 0,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256773044210,
      ID: 16644,
      Date: "01/08/2021 16:51:53",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 1250,
      totWin: 0,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256773044210,
      ID: 16643,
      Date: "01/08/2021 16:50:18",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 2500,
      totWin: 0,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256773044210,
      ID: 16642,
      Date: "01/08/2021 16:44:10",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 20000,
      totWin: 150000,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256773044210,
      ID: 16641,
      Date: "01/08/2021 16:42:24",
      channel: "Mobile",
      tax: 0,
      Status: "Won",
    },
    {
      totAmount: 5000,
      totWin: 0,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256773044210,
      ID: 16640,
      Date: "01/08/2021 16:38:33",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 10000,
      totWin: 0,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256773044210,
      ID: 16639,
      Date: "01/08/2021 16:36:49",
      channel: "Mobile",
      tax: 0,
      Status: "Won",
    },
    {
      totAmount: 2500,
      totWin: 0,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256773044210,
      ID: 16638,
      Date: "01/08/2021 16:34:06",
      channel: "Mobile",
      tax: 0,
      Status: "Won",
    },
    {
      totAmount: 18000,
      totWin: 0,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256773044210,
      ID: 16637,
      Date: "01/08/2021 16:30:31",
      channel: "Mobile",
      tax: 0,
      Status: "Won",
    },
    {
      totAmount: 10000,
      totWin: 0,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256773044210,
      ID: 16636,
      Date: "01/08/2021 16:22:24",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 4750,
      totWin: 5000,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256773044210,
      ID: 16635,
      Date: "01/08/2021 16:14:23",
      channel: "Mobile",
      tax: 0,
      Status: "Won",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 16634,
      Date: "01/08/2021 12:48:14",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 5000,
      totWin: 0,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256773044210,
      ID: 16633,
      Date: "01/08/2021 15:14:33",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 15000,
      totWin: 0,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256773044210,
      ID: 16632,
      Date: "01/08/2021 15:12:32",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 25000,
      totWin: 72500,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256773044210,
      ID: 16631,
      Date: "01/08/2021 15:10:18",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 30000,
      totWin: 0,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256773044210,
      ID: 16630,
      Date: "01/08/2021 15:02:47",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 10000,
      totWin: 0,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256773044210,
      ID: 16629,
      Date: "01/08/2021 14:52:05",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 15000,
      totWin: 0,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256773044210,
      ID: 16628,
      Date: "01/08/2021 14:40:15",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 10000,
      totWin: 0,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256773044210,
      ID: 16627,
      Date: "01/08/2021 14:34:24",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 10000,
      totWin: 25000,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256773044210,
      ID: 16626,
      Date: "01/08/2021 14:33:45",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 30000,
      totWin: 0,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256773044210,
      ID: 16625,
      Date: "01/08/2021 14:28:45",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 10000,
      totWin: 25000,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256773044210,
      ID: 16624,
      Date: "01/08/2021 14:26:15",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 15000,
      totWin: 0,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256773044210,
      ID: 16623,
      Date: "01/08/2021 14:20:12",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 22500,
      totWin: 7500,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256773044210,
      ID: 16622,
      Date: "01/08/2021 14:10:49",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 12500,
      totWin: 21650,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256773044210,
      ID: 16621,
      Date: "01/08/2021 13:45:59",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 1250,
      totWin: 0,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256773044210,
      ID: 16620,
      Date: "01/08/2021 13:34:42",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 7500,
      totWin: 0,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256773044210,
      ID: 16619,
      Date: "01/08/2021 13:34:15",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 6250,
      totWin: 0,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256773044210,
      ID: 16618,
      Date: "01/08/2021 13:31:37",
      channel: "Mobile",
      tax: 0,
      Status: "Won",
    },
    {
      totAmount: 21250,
      totWin: 22000,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256773044210,
      ID: 16617,
      Date: "01/08/2021 13:30:23",
      channel: "Mobile",
      tax: 0,
      Status: "Won",
    },
    {
      totAmount: 5000,
      totWin: 0,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256773044210,
      ID: 16616,
      Date: "01/08/2021 13:22:39",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 15000,
      totWin: 25000,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256773044210,
      ID: 16615,
      Date: "01/08/2021 13:10:45",
      channel: "Mobile",
      tax: 0,
      Status: "Won",
    },
    {
      totAmount: 20000,
      totWin: 41250,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256773044210,
      ID: 16614,
      Date: "01/08/2021 13:08:04",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 7500,
      totWin: 0,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256773044210,
      ID: 16613,
      Date: "01/08/2021 13:00:51",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 12500,
      totWin: 0,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256773044210,
      ID: 16612,
      Date: "01/08/2021 12:54:20",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 5000,
      totWin: 0,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256773044210,
      ID: 16611,
      Date: "01/08/2021 12:40:04",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 5000,
      totWin: 0,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256773044210,
      ID: 16610,
      Date: "01/08/2021 12:38:32",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 5000,
      totWin: 0,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256773044210,
      ID: 16609,
      Date: "01/08/2021 12:38:09",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 5000,
      totWin: 0,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256773044210,
      ID: 16608,
      Date: "01/08/2021 12:35:52",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 10000,
      totWin: 0,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256773044210,
      ID: 16607,
      Date: "01/08/2021 12:34:40",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 5000,
      totWin: 0,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256773044210,
      ID: 16606,
      Date: "01/08/2021 12:33:48",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 70000,
      totWin: 43300,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256773044210,
      ID: 16605,
      Date: "01/08/2021 12:26:34",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 1250,
      totWin: 13125,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256773044210,
      ID: 16604,
      Date: "01/08/2021 12:20:55",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 2500,
      totWin: 0,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256773044210,
      ID: 16603,
      Date: "01/08/2021 12:18:41",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 10000,
      totWin: 0,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256773044210,
      ID: 16602,
      Date: "01/08/2021 12:14:41",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 15000,
      totWin: 36000,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256773044210,
      ID: 16601,
      Date: "01/08/2021 12:13:04",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 5000,
      totWin: 0,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256773044210,
      ID: 16600,
      Date: "01/08/2021 11:57:41",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 500,
      totWin: 0,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256773044210,
      ID: 16599,
      Date: "01/08/2021 11:49:51",
      channel: "n/a",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 500,
      totWin: 0,
      product: "Virtual Football Pro",
      category: "Virtuals",
      username: 256785674484,
      ID: 16598,
      Date: "01/08/2021 11:23:29",
      channel: "Mobile",
      tax: 0,
      Status: "Won",
    },
    {
      totAmount: 500,
      totWin: 0,
      product: "Virtual Football Pro",
      category: "Virtuals",
      username: 256785674484,
      ID: 16597,
      Date: "01/08/2021 11:13:06",
      channel: "Mobile",
      tax: 0,
      Status: "Won",
    },
    {
      totAmount: 11250,
      totWin: 0,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256773044210,
      ID: 16596,
      Date: "01/08/2021 09:42:48",
      channel: "Mobile",
      tax: 0,
      Status: "Won",
    },
    {
      totAmount: 7500,
      totWin: 14400,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256773044210,
      ID: 16595,
      Date: "01/08/2021 09:32:51",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 1250,
      totWin: 0,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256773044210,
      ID: 16594,
      Date: "01/08/2021 09:10:21",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 2500,
      totWin: 0,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256773044210,
      ID: 16593,
      Date: "01/08/2021 09:08:43",
      channel: "Mobile",
      tax: 0,
      Status: "Won",
    },
    {
      totAmount: 2500,
      totWin: 0,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256773044210,
      ID: 16592,
      Date: "01/08/2021 09:08:17",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 5000,
      totWin: 0,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256773044210,
      ID: 16591,
      Date: "01/08/2021 09:06:31",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 1250,
      totWin: 0,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256773044210,
      ID: 16590,
      Date: "01/08/2021 08:59:41",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 1250,
      totWin: 0,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256773044210,
      ID: 16589,
      Date: "01/08/2021 08:56:34",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 3750,
      totWin: 5000,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256773044210,
      ID: 16588,
      Date: "01/08/2021 08:53:55",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 1250,
      totWin: 0,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256773044210,
      ID: 16587,
      Date: "01/08/2021 08:50:05",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 500,
      totWin: 0,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256773044210,
      ID: 16586,
      Date: "01/08/2021 08:37:42",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 900,
      totWin: 0,
      product: "Night At KTV",
      category: "Casino",
      username: 256775894712,
      ID: 16585,
      Date: "01/08/2021 07:43:46",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 10000,
      totWin: 0,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256773044210,
      ID: 16584,
      Date: "01/08/2021 04:22:45",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 7500,
      totWin: 0,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256773044210,
      ID: 16583,
      Date: "01/08/2021 04:20:31",
      channel: "Mobile",
      tax: 0,
      Status: "Won",
    },
    {
      totAmount: 1250,
      totWin: 0,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256773044210,
      ID: 16582,
      Date: "01/08/2021 04:12:23",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 5000,
      totWin: 12912.5,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256773044210,
      ID: 16581,
      Date: "01/08/2021 04:10:42",
      channel: "Mobile",
      tax: 0,
      Status: "Won",
    },
    {
      totAmount: 10000,
      totWin: 0,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256773044210,
      ID: 16580,
      Date: "01/08/2021 04:06:21",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 11250,
      totWin: 0,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256773044210,
      ID: 16579,
      Date: "01/08/2021 04:03:16",
      channel: "Mobile",
      tax: 0,
      Status: "Won",
    },
    {
      totAmount: 18750,
      totWin: 5412.5,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256773044210,
      ID: 16578,
      Date: "01/08/2021 03:52:37",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 7500,
      totWin: 20000,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256773044210,
      ID: 16577,
      Date: "01/08/2021 03:47:56",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 5000,
      totWin: 16250,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256773044210,
      ID: 16576,
      Date: "01/08/2021 03:46:19",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 26250,
      totWin: 24000,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256773044210,
      ID: 16575,
      Date: "01/08/2021 03:44:33",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 2500,
      totWin: 0,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256773044210,
      ID: 16574,
      Date: "01/08/2021 03:34:35",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 2500,
      totWin: 0,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256773044210,
      ID: 16573,
      Date: "01/08/2021 03:28:40",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 15500,
      totWin: 7250,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256773044210,
      ID: 16572,
      Date: "01/08/2021 03:24:43",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 22500,
      totWin: 0,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256773044210,
      ID: 16571,
      Date: "01/08/2021 03:16:35",
      channel: "Mobile",
      tax: 0,
      Status: "Won",
    },
    {
      totAmount: 5000,
      totWin: 0,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256773044210,
      ID: 16570,
      Date: "01/08/2021 03:10:33",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 30000,
      totWin: 0,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256773044210,
      ID: 16569,
      Date: "01/08/2021 03:08:33",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 6250,
      totWin: 15500,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256773044210,
      ID: 16568,
      Date: "01/08/2021 03:02:46",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 6250,
      totWin: 21650,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256773044210,
      ID: 16567,
      Date: "01/08/2021 02:58:06",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 18000,
      totWin: 31250,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256773044210,
      ID: 16566,
      Date: "01/08/2021 02:56:16",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 500,
      totWin: 0,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256773044210,
      ID: 16565,
      Date: "01/08/2021 02:51:35",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 1250,
      totWin: 6875,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256773044210,
      ID: 16564,
      Date: "01/08/2021 02:50:28",
      channel: "Mobile",
      tax: 0,
      Status: "Won",
    },
    {
      totAmount: 7500,
      totWin: 0,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256773044210,
      ID: 16563,
      Date: "01/08/2021 02:48:18",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 27500,
      totWin: 35825,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256773044210,
      ID: 16562,
      Date: "01/08/2021 02:38:39",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 2500,
      totWin: 0,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256773044210,
      ID: 16561,
      Date: "01/08/2021 02:26:39",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 1250,
      totWin: 0,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256773044210,
      ID: 16560,
      Date: "01/08/2021 02:25:47",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 1250,
      totWin: 0,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256773044210,
      ID: 16559,
      Date: "01/08/2021 02:24:28",
      channel: "Mobile",
      tax: 0,
      Status: "Won",
    },
    {
      totAmount: 8750,
      totWin: 11625,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256773044210,
      ID: 16558,
      Date: "01/08/2021 02:22:48",
      channel: "Mobile",
      tax: 0,
      Status: "Won",
    },
    {
      totAmount: 2500,
      totWin: 0,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256773044210,
      ID: 16557,
      Date: "01/08/2021 02:12:46",
      channel: "Mobile",
      tax: 0,
      Status: "Won",
    },
    {
      totAmount: 8750,
      totWin: 0,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256773044210,
      ID: 16556,
      Date: "01/08/2021 02:11:41",
      channel: "Mobile",
      tax: 0,
      Status: "Won",
    },
    {
      totAmount: 6250,
      totWin: 13125,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256773044210,
      ID: 16555,
      Date: "01/08/2021 01:58:36",
      channel: "Mobile",
      tax: 0,
      Status: "Won",
    },
    {
      totAmount: 2500,
      totWin: 12500,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256773044210,
      ID: 16554,
      Date: "01/08/2021 01:51:58",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 3000,
      totWin: 0,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256773044210,
      ID: 16553,
      Date: "01/08/2021 01:50:30",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 5000,
      totWin: 0,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256773044210,
      ID: 16552,
      Date: "01/08/2021 01:44:48",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 5000,
      totWin: 0,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256773044210,
      ID: 16551,
      Date: "01/08/2021 01:42:42",
      channel: "Mobile",
      tax: 0,
      Status: "Won",
    },
    {
      totAmount: 6500,
      totWin: 17125,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256773044210,
      ID: 16550,
      Date: "01/08/2021 01:40:40",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 6250,
      totWin: 11900,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256773044210,
      ID: 16549,
      Date: "01/08/2021 01:30:56",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 500,
      totWin: 0,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256773044210,
      ID: 16548,
      Date: "01/08/2021 01:22:42",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 7500,
      totWin: 6875,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256773044210,
      ID: 16547,
      Date: "01/08/2021 01:10:44",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 39750,
      totWin: 52500,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256773044210,
      ID: 16546,
      Date: "01/08/2021 01:06:18",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 2400,
      totWin: 200,
      product: "Ramses Treasure",
      category: "Casino",
      username: 256789156900,
      ID: 16545,
      Date: "01/08/2021 00:56:29",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 1250,
      totWin: 0,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256773044210,
      ID: 16544,
      Date: "01/08/2021 00:56:15",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 300,
      totWin: 0,
      product: "Joan Of Arc",
      category: "Casino",
      username: 256789156900,
      ID: 16543,
      Date: "01/08/2021 00:54:52",
      channel: "Mobile",
      tax: 0,
      Status: "Won",
    },
    {
      totAmount: 1250,
      totWin: 10000,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256773044210,
      ID: 16542,
      Date: "01/08/2021 00:54:32",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 4000,
      totWin: 0,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256773044210,
      ID: 16541,
      Date: "01/08/2021 00:53:47",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 1750,
      totWin: 0,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256773044210,
      ID: 16540,
      Date: "01/08/2021 00:49:29",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 2500,
      totWin: 0,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256773044210,
      ID: 16539,
      Date: "01/08/2021 00:43:53",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 3750,
      totWin: 0,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256773044210,
      ID: 16538,
      Date: "01/08/2021 00:34:34",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 1750,
      totWin: 0,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256773044210,
      ID: 16537,
      Date: "01/08/2021 00:28:47",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 4750,
      totWin: 26250,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256773044210,
      ID: 16536,
      Date: "01/08/2021 00:26:27",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 3000,
      totWin: 0,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256773044210,
      ID: 16535,
      Date: "01/08/2021 00:16:40",
      channel: "Mobile",
      tax: 0,
      Status: "Won",
    },
    {
      totAmount: 500,
      totWin: 0,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256773044210,
      ID: 16534,
      Date: "01/08/2021 00:12:25",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 1000,
      totWin: 0,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256773044210,
      ID: 16533,
      Date: "01/08/2021 00:11:35",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 500,
      totWin: 0,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256773044210,
      ID: 16532,
      Date: "01/08/2021 00:09:25",
      channel: "Mobile",
      tax: 0,
      Status: "Void",
    },
    {
      totAmount: 3200,
      totWin: 700,
      product: "Ramses Treasure",
      category: "Casino",
      username: 256789156900,
      ID: 16531,
      Date: "01/08/2021 00:07:22",
      channel: "Mobile",
      tax: 0,
      Status: "Won",
    },
    {
      totAmount: 1250,
      totWin: 0,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256773044210,
      ID: 16530,
      Date: "01/08/2021 00:07:22",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 5000,
      totWin: 0,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256773044210,
      ID: 16529,
      Date: "01/08/2021 00:01:36",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 2500,
      totWin: 0,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256773044210,
      ID: 16528,
      Date: "31/07/2021 23:54:47",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 3750,
      totWin: 5412.5,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256773044210,
      ID: 16527,
      Date: "31/07/2021 23:53:58",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 500,
      totWin: 0,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256773044210,
      ID: 16526,
      Date: "31/07/2021 23:50:48",
      channel: "Mobile",
      tax: 0,
      Status: "Won",
    },
    {
      totAmount: 10000,
      totWin: 16250,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256773044210,
      ID: 16525,
      Date: "31/07/2021 23:48:46",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 1250,
      totWin: 5412.5,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256773044210,
      ID: 16524,
      Date: "31/07/2021 23:44:40",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 14500,
      totWin: 23000,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256773044210,
      ID: 16523,
      Date: "31/07/2021 23:42:38",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 500,
      totWin: 0,
      product: "Virtual Football Pro",
      category: "Virtuals",
      username: 256780850357,
      ID: 16522,
      Date: "31/07/2021 23:37:08",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 3000,
      totWin: 9500,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256773044210,
      ID: 16521,
      Date: "31/07/2021 23:35:53",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 2000,
      totWin: 0,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256773044210,
      ID: 16520,
      Date: "31/07/2021 23:29:22",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 4000,
      totWin: 0,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256773044210,
      ID: 16519,
      Date: "31/07/2021 23:27:53",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 500,
      totWin: 0,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256773044210,
      ID: 16518,
      Date: "31/07/2021 23:13:50",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 500,
      totWin: 0,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256773044210,
      ID: 16517,
      Date: "31/07/2021 23:12:44",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 4000,
      totWin: 4330,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256773044210,
      ID: 16516,
      Date: "31/07/2021 23:10:35",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 3000,
      totWin: 5812.5,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256773044210,
      ID: 16515,
      Date: "31/07/2021 23:06:47",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 2750,
      totWin: 2500,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256773044210,
      ID: 16514,
      Date: "31/07/2021 23:02:45",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 1500,
      totWin: 0,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256773044210,
      ID: 16513,
      Date: "31/07/2021 22:58:15",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 2000,
      totWin: 0,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256773044210,
      ID: 16512,
      Date: "31/07/2021 22:56:03",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 2000,
      totWin: 0,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256773044210,
      ID: 16511,
      Date: "31/07/2021 22:51:30",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 500,
      totWin: 0,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256773044210,
      ID: 16510,
      Date: "31/07/2021 22:47:57",
      channel: "Mobile",
      tax: 0,
      Status: "Won",
    },
    {
      totAmount: 2000,
      totWin: 0,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256773044210,
      ID: 16509,
      Date: "31/07/2021 22:46:57",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 16508,
      Date: "31/07/2021 19:38:33",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 1000,
      totWin: 0,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256773044210,
      ID: 16507,
      Date: "31/07/2021 22:37:44",
      channel: "Mobile",
      tax: 0,
      Status: "Won",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 16506,
      Date: "31/07/2021 19:26:44",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 16505,
      Date: "31/07/2021 16:52:48",
      channel: "Mobile",
      tax: 0,
      Status: "Won",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 16504,
      Date: "31/07/2021 16:51:51",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 500,
      totWin: 0,
      product: "Virtual Football Pro",
      category: "Virtuals",
      username: 256785674484,
      ID: 16503,
      Date: "31/07/2021 17:25:18",
      channel: "Mobile",
      tax: 0,
      Status: "Won",
    },
    {
      totAmount: 1000,
      totWin: 0,
      product: "Virtual Football Pro",
      category: "Virtuals",
      username: 256785674484,
      ID: 16502,
      Date: "31/07/2021 17:20:54",
      channel: "Mobile",
      tax: 0,
      Status: "Won",
    },
    {
      totAmount: 7000,
      totWin: 2000,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256784701859,
      ID: 16501,
      Date: "31/07/2021 17:09:13",
      channel: "Mobile",
      tax: 0,
      Status: "Won",
    },
    {
      totAmount: 2000,
      totWin: 0,
      product: "Virtual Europa",
      category: "Virtuals",
      username: 256784701859,
      ID: 16500,
      Date: "31/07/2021 17:01:23",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 500,
      totWin: 0,
      product: "Pick 3",
      category: "Number Games",
      username: 256396866,
      ID: 16499,
      Date: "31/07/2021 16:51:10",
      channel: "Online",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 36497,
      totWin: 30600,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256784701859,
      ID: 16498,
      Date: "31/07/2021 16:42:29",
      channel: "Mobile",
      tax: 0,
      Status: "Won",
    },
    {
      totAmount: 500,
      totWin: 1050,
      product: "Virtual Football Pro",
      category: "Virtuals",
      username: 256785674484,
      ID: 16497,
      Date: "31/07/2021 16:18:09",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 5000,
      totWin: 0,
      product: "Virtual Europa",
      category: "Virtuals",
      username: 256784701859,
      ID: 16496,
      Date: "31/07/2021 16:09:49",
      channel: "Mobile",
      tax: 0,
      Status: "Won",
    },
    {
      totAmount: 5570,
      totWin: 11697,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256784701859,
      ID: 16495,
      Date: "31/07/2021 16:05:23",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 13000,
      totWin: 8110,
      product: "Virtual Europa",
      category: "Virtuals",
      username: 256784701859,
      ID: 16494,
      Date: "31/07/2021 15:59:46",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 2000,
      totWin: 4330,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256784701859,
      ID: 16493,
      Date: "31/07/2021 15:45:00",
      channel: "Mobile",
      tax: 0,
      Status: "Won",
    },
    {
      totAmount: 12000,
      totWin: 11030,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256784701859,
      ID: 16492,
      Date: "31/07/2021 15:37:15",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 9955,
      totWin: 10350,
      product: "Virtual Europa",
      category: "Virtuals",
      username: 256784701859,
      ID: 16491,
      Date: "31/07/2021 15:29:02",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 16490,
      Date: "31/07/2021 11:52:39",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 32000,
      totWin: 1400,
      product: "Peter's Universe",
      category: "Casino",
      username: 256775784921,
      ID: 16489,
      Date: "31/07/2021 14:43:08",
      channel: "Mobile",
      tax: 0,
      Status: "Won",
    },
    {
      totAmount: 124000,
      totWin: 65740,
      product: "Peter's Universe",
      category: "Casino",
      username: 256775784921,
      ID: 16488,
      Date: "31/07/2021 14:39:45",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 3750,
      totWin: 0,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256755717779,
      ID: 16487,
      Date: "31/07/2021 14:03:24",
      channel: "Mobile",
      tax: 0,
      Status: "Won",
    },
    {
      totAmount: 1000,
      totWin: 2205,
      product: "Virtual Football Pro",
      category: "Virtuals",
      username: 256785674484,
      ID: 16486,
      Date: "31/07/2021 13:41:20",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 500,
      totWin: 0,
      product: "Virtual Football Pro",
      category: "Virtuals",
      username: 256785674484,
      ID: 16485,
      Date: "31/07/2021 13:35:48",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 2000,
      totWin: 0,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256784701859,
      ID: 16484,
      Date: "31/07/2021 13:35:42",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 500,
      totWin: 0,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256773044210,
      ID: 16483,
      Date: "31/07/2021 13:34:25",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 1500,
      totWin: 0,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256773044210,
      ID: 16482,
      Date: "31/07/2021 13:34:04",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 10000,
      totWin: 6565,
      product: "Virtual Europa",
      category: "Virtuals",
      username: 256784701859,
      ID: 16481,
      Date: "31/07/2021 13:33:08",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 3000,
      totWin: 2165,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256773044210,
      ID: 16480,
      Date: "31/07/2021 13:31:57",
      channel: "Mobile",
      tax: 0,
      Status: "Won",
    },
    {
      totAmount: 5750,
      totWin: 5412.5,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256773044210,
      ID: 16479,
      Date: "31/07/2021 13:27:18",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 7500,
      totWin: 0,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256773044210,
      ID: 16478,
      Date: "31/07/2021 13:16:25",
      channel: "Mobile",
      tax: 0,
      Status: "Won",
    },
    {
      totAmount: 1000,
      totWin: 0,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256773044210,
      ID: 16477,
      Date: "31/07/2021 13:10:39",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 500,
      totWin: 0,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256773044210,
      ID: 16476,
      Date: "31/07/2021 13:07:33",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 16475,
      Date: "31/07/2021 09:40:00",
      channel: "Mobile",
      tax: 0,
      Status: "Won",
    },
    {
      totAmount: 500,
      totWin: 0,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256773601449,
      ID: 16474,
      Date: "31/07/2021 12:09:32",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 4000,
      totWin: 4430,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256773601449,
      ID: 16473,
      Date: "31/07/2021 12:07:19",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 1000,
      totWin: 1050,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256773601449,
      ID: 16472,
      Date: "31/07/2021 11:49:50",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 11115,
      totWin: 9115,
      product: "Virtual Football Pro",
      category: "Virtuals",
      username: 256780850357,
      ID: 16471,
      Date: "31/07/2021 11:15:26",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 779.71,
      totWin: 0,
      product: "Virtual Football Pro",
      category: "Virtuals",
      username: 256780850357,
      ID: 16470,
      Date: "31/07/2021 10:44:19",
      channel: "Mobile",
      tax: 0,
      Status: "Won",
    },
    {
      totAmount: 500,
      totWin: 0,
      product: "Virtual Football Pro",
      category: "Virtuals",
      username: 256780850357,
      ID: 16469,
      Date: "31/07/2021 09:14:00",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 21714.43,
      totWin: 25143.84,
      product: "Virtual Football Pro",
      category: "Virtuals",
      username: 256780850357,
      ID: 16468,
      Date: "31/07/2021 09:10:25",
      channel: "Mobile",
      tax: 0,
      Status: "Won",
    },
    {
      totAmount: 3500,
      totWin: 1550,
      product: "Virtual Football Pro",
      category: "Virtuals",
      username: 256780850357,
      ID: 16467,
      Date: "31/07/2021 08:17:31",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 4000,
      totWin: 0,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256773044210,
      ID: 16466,
      Date: "30/07/2021 23:08:48",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 1250,
      totWin: 0,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256773044210,
      ID: 16465,
      Date: "30/07/2021 20:34:21",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 1250,
      totWin: 0,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256773044210,
      ID: 16464,
      Date: "30/07/2021 20:30:46",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 1250,
      totWin: 0,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256773044210,
      ID: 16463,
      Date: "30/07/2021 20:28:31",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 10500,
      totWin: 11540,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256784701859,
      ID: 16462,
      Date: "30/07/2021 18:05:39",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 2500,
      totWin: 1450,
      product: "Virtual Europa",
      category: "Virtuals",
      username: 256784701859,
      ID: 16461,
      Date: "30/07/2021 17:35:05",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 500,
      totWin: 0,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256784701859,
      ID: 16460,
      Date: "30/07/2021 17:19:12",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 3000,
      totWin: 1150,
      product: "Virtual Europa",
      category: "Virtuals",
      username: 256784701859,
      ID: 16459,
      Date: "30/07/2021 17:17:31",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 5395,
      totWin: 5750,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256784701859,
      ID: 16458,
      Date: "30/07/2021 17:10:04",
      channel: "Mobile",
      tax: 0,
      Status: "Won",
    },
    {
      totAmount: 18500,
      totWin: 14655,
      product: "Virtual Europa",
      category: "Virtuals",
      username: 256784701859,
      ID: 16457,
      Date: "30/07/2021 17:01:45",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 4500,
      totWin: 8990,
      product: "Virtual Europa",
      category: "Virtuals",
      username: 256784701859,
      ID: 16456,
      Date: "30/07/2021 16:35:14",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 16455,
      Date: "30/07/2021 10:00:43",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 16454,
      Date: "30/07/2021 10:00:20",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 16453,
      Date: "30/07/2021 10:00:17",
      channel: "Mobile",
      tax: 0,
      Status: "Won",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 16452,
      Date: "30/07/2021 09:59:37",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 16451,
      Date: "30/07/2021 09:47:41",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 16450,
      Date: "30/07/2021 09:46:43",
      channel: "Mobile",
      tax: 0,
      Status: "Won",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 16449,
      Date: "30/07/2021 09:46:06",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 8750,
      totWin: 9375,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256700743115,
      ID: 16448,
      Date: "30/07/2021 12:36:41",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 2500,
      totWin: 0,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256755717779,
      ID: 16447,
      Date: "30/07/2021 12:30:48",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 2500,
      totWin: 6250,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256755717779,
      ID: 16446,
      Date: "30/07/2021 12:28:23",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 5000,
      totWin: 0,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256755717779,
      ID: 16445,
      Date: "30/07/2021 12:26:20",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 500,
      totWin: 0,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256755717779,
      ID: 16444,
      Date: "30/07/2021 11:58:10",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 2500,
      totWin: 5250,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256755717779,
      ID: 16443,
      Date: "30/07/2021 11:54:44",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 1250,
      totWin: 0,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256755717779,
      ID: 16442,
      Date: "30/07/2021 11:50:08",
      channel: "Mobile",
      tax: 0,
      Status: "Won",
    },
    {
      totAmount: 18000,
      totWin: 17000,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256755717779,
      ID: 16441,
      Date: "30/07/2021 11:44:15",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 5250,
      totWin: 24000,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256755717779,
      ID: 16440,
      Date: "30/07/2021 11:39:36",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 500,
      totWin: 0,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256755717779,
      ID: 16439,
      Date: "30/07/2021 11:32:34",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 1500,
      totWin: 2165,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256755717779,
      ID: 16438,
      Date: "30/07/2021 11:31:55",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 2500,
      totWin: 4000,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256755717779,
      ID: 16437,
      Date: "30/07/2021 11:29:45",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 1000,
      totWin: 0,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256773044210,
      ID: 16436,
      Date: "29/07/2021 23:08:27",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 500,
      totWin: 0,
      product: "Pick 1",
      category: "Number Games",
      username: 256396866,
      ID: 16435,
      Date: "29/07/2021 21:40:42",
      channel: "Online",
      tax: 0,
      Status: "Won",
    },
    {
      totAmount: 8750,
      totWin: 0,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256773044210,
      ID: 16434,
      Date: "29/07/2021 21:40:01",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 23250,
      totWin: 58350,
      product: "Chili Quest",
      category: "Casino",
      username: 256784600500,
      ID: 16433,
      Date: "29/07/2021 21:16:25",
      channel: "Mobile",
      tax: 0,
      Status: "Won",
    },
    {
      totAmount: 4000,
      totWin: 600,
      product: "3 Genie Wishes",
      category: "Casino",
      username: 256776843303,
      ID: 16432,
      Date: "29/07/2021 18:12:13",
      channel: "Online",
      tax: 0,
      Status: "Won",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 16431,
      Date: "29/07/2021 13:42:54",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 1000,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 16430,
      Date: "29/07/2021 13:42:00",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 1000,
      totWin: 0,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256773044210,
      ID: 16429,
      Date: "29/07/2021 15:49:22",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 7500,
      totWin: 0,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256773044210,
      ID: 16428,
      Date: "29/07/2021 12:58:25",
      channel: "Mobile",
      tax: 0,
      Status: "Won",
    },
    {
      totAmount: 6500,
      totWin: 7165,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256773044210,
      ID: 16427,
      Date: "29/07/2021 12:55:28",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 1250,
      totWin: 5000,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256773044210,
      ID: 16426,
      Date: "29/07/2021 12:06:33",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 1250,
      totWin: 0,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256773044210,
      ID: 16425,
      Date: "29/07/2021 11:58:06",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 1250,
      totWin: 0,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256773044210,
      ID: 16424,
      Date: "29/07/2021 11:56:35",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 3750,
      totWin: 10000,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256773044210,
      ID: 16423,
      Date: "29/07/2021 11:54:10",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 1250,
      totWin: 13125,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256773044210,
      ID: 16422,
      Date: "29/07/2021 11:50:15",
      channel: "Mobile",
      tax: 0,
      Status: "Won",
    },
    {
      totAmount: 1250,
      totWin: 0,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256773044210,
      ID: 16421,
      Date: "29/07/2021 11:46:19",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 18400,
      totWin: 20700,
      product: "Slot Of Money",
      category: "Casino",
      username: 256789156900,
      ID: 16420,
      Date: "29/07/2021 11:05:50",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 1250,
      totWin: 10000,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256773044210,
      ID: 16419,
      Date: "29/07/2021 10:56:02",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 3500,
      totWin: 4130.37,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256773044210,
      ID: 16418,
      Date: "29/07/2021 10:54:19",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 5000,
      totWin: 0,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256773044210,
      ID: 16417,
      Date: "29/07/2021 10:50:01",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 1250,
      totWin: 7500,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256773044210,
      ID: 16416,
      Date: "29/07/2021 10:48:21",
      channel: "Mobile",
      tax: 0,
      Status: "Won",
    },
    {
      totAmount: 1250,
      totWin: 5412.5,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256773044210,
      ID: 16415,
      Date: "29/07/2021 10:47:48",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 2500,
      totWin: 0,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256773044210,
      ID: 16414,
      Date: "29/07/2021 10:28:40",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 4250,
      totWin: 5412.5,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256773044210,
      ID: 16413,
      Date: "29/07/2021 10:27:51",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 5500,
      totWin: 13562.5,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256773044210,
      ID: 16412,
      Date: "29/07/2021 10:25:59",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 1250,
      totWin: 0,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256773044210,
      ID: 16411,
      Date: "29/07/2021 10:21:52",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 1000,
      totWin: 0,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256773044210,
      ID: 16410,
      Date: "29/07/2021 10:18:36",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 500,
      totWin: 0,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256773044210,
      ID: 16409,
      Date: "29/07/2021 10:17:49",
      channel: "Mobile",
      tax: 0,
      Status: "Won",
    },
    {
      totAmount: 1500,
      totWin: 0,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256773044210,
      ID: 16408,
      Date: "29/07/2021 10:16:15",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 5000,
      totWin: 3427.2,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256773044210,
      ID: 16407,
      Date: "29/07/2021 10:13:42",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 2500,
      totWin: 21088,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256773044210,
      ID: 16406,
      Date: "29/07/2021 10:01:11",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 2500,
      totWin: 0,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256773044210,
      ID: 16405,
      Date: "29/07/2021 09:56:24",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 16404,
      Date: "29/07/2021 06:27:46",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 16403,
      Date: "29/07/2021 06:27:19",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 13000,
      totWin: 7900,
      product: "Golden Dragon",
      category: "Casino",
      username: 256784600500,
      ID: 16402,
      Date: "29/07/2021 09:25:26",
      channel: "Mobile",
      tax: 0,
      Status: "Won",
    },
    {
      totAmount: 11500,
      totWin: 6100,
      product: "Golden Dragon",
      category: "Casino",
      username: 256784600500,
      ID: 16401,
      Date: "29/07/2021 09:22:27",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 12500,
      totWin: 32600,
      product: "Flaming Reels",
      category: "Casino",
      username: 256784600500,
      ID: 16400,
      Date: "29/07/2021 09:19:32",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 6250,
      totWin: 5412.5,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256773044210,
      ID: 16399,
      Date: "29/07/2021 08:32:16",
      channel: "Mobile",
      tax: 0,
      Status: "Won",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 16398,
      Date: "29/07/2021 05:23:19",
      channel: "Online",
      tax: 0,
      Status: "Won",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 16397,
      Date: "29/07/2021 05:22:50",
      channel: "Online",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 1750,
      totWin: 3250,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256773044210,
      ID: 16396,
      Date: "29/07/2021 08:22:46",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 2500,
      totWin: 0,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256773044210,
      ID: 16395,
      Date: "29/07/2021 08:21:58",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 16394,
      Date: "29/07/2021 05:19:43",
      channel: "Online",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 16393,
      Date: "29/07/2021 05:19:15",
      channel: "Online",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 1000,
      totWin: 0,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256773044210,
      ID: 16392,
      Date: "29/07/2021 08:18:48",
      channel: "Mobile",
      tax: 0,
      Status: "Won",
    },
    {
      totAmount: 3500,
      totWin: 0,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256773044210,
      ID: 16391,
      Date: "29/07/2021 08:17:37",
      channel: "Mobile",
      tax: 0,
      Status: "Void",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 16390,
      Date: "29/07/2021 05:14:51",
      channel: "Online",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 16389,
      Date: "29/07/2021 05:13:13",
      channel: "Online",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 16388,
      Date: "29/07/2021 05:10:02",
      channel: "Online",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 16387,
      Date: "29/07/2021 05:09:33",
      channel: "Online",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 16386,
      Date: "29/07/2021 05:09:02",
      channel: "Online",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 16385,
      Date: "29/07/2021 05:08:35",
      channel: "Online",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 16384,
      Date: "29/07/2021 05:02:19",
      channel: "Online",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 3500,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 16383,
      Date: "29/07/2021 05:01:42",
      channel: "Online",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 16382,
      Date: "29/07/2021 05:01:13",
      channel: "Online",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 16381,
      Date: "29/07/2021 05:00:45",
      channel: "Online",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 1250,
      totWin: 10000,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256773044210,
      ID: 16380,
      Date: "29/07/2021 07:53:52",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 3750,
      totWin: 6250,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256773044210,
      ID: 16379,
      Date: "29/07/2021 07:53:28",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 2500,
      totWin: 0,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256773044210,
      ID: 16378,
      Date: "29/07/2021 07:51:57",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 3750,
      totWin: 5412.5,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256773044210,
      ID: 16377,
      Date: "29/07/2021 07:50:48",
      channel: "Mobile",
      tax: 0,
      Status: "Won",
    },
    {
      totAmount: 5000,
      totWin: 6250,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256773044210,
      ID: 16376,
      Date: "29/07/2021 07:48:30",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 1250,
      totWin: 0,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256773044210,
      ID: 16375,
      Date: "29/07/2021 07:46:21",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 5000,
      totWin: 0,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256773044210,
      ID: 16374,
      Date: "29/07/2021 07:44:48",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 16373,
      Date: "29/07/2021 04:32:38",
      channel: "Online",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 16372,
      Date: "29/07/2021 04:30:06",
      channel: "Online",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 16371,
      Date: "29/07/2021 04:29:30",
      channel: "Online",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 16370,
      Date: "29/07/2021 04:28:54",
      channel: "Online",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 16369,
      Date: "29/07/2021 04:28:01",
      channel: "Online",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 16368,
      Date: "29/07/2021 04:27:05",
      channel: "Online",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 16367,
      Date: "29/07/2021 04:26:39",
      channel: "Online",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 4000,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 16366,
      Date: "29/07/2021 04:25:56",
      channel: "Online",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 1000,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 16365,
      Date: "29/07/2021 04:25:22",
      channel: "Online",
      tax: 0,
      Status: "Won",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 16364,
      Date: "29/07/2021 04:24:51",
      channel: "Online",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 4000,
      totWin: 1800,
      product: "Book Of Oziris",
      category: "Casino",
      username: 256776843303,
      ID: 16363,
      Date: "28/07/2021 22:51:04",
      channel: "Online",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 5000,
      totWin: 0,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256773044210,
      ID: 16362,
      Date: "28/07/2021 21:18:47",
      channel: "Online",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 1488,
      totWin: 0,
      product: "Virtual Football Pro",
      category: "Virtuals",
      username: 256780850357,
      ID: 16361,
      Date: "28/07/2021 21:17:34",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 1250,
      totWin: 0,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256773044210,
      ID: 16360,
      Date: "28/07/2021 21:06:09",
      channel: "Online",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 1750,
      totWin: 2165,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256773044210,
      ID: 16359,
      Date: "28/07/2021 21:04:42",
      channel: "Online",
      tax: 0,
      Status: "Won",
    },
    {
      totAmount: 1250,
      totWin: 0,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256773044210,
      ID: 16358,
      Date: "28/07/2021 21:02:05",
      channel: "Online",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 9750,
      totWin: 5250,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256773044210,
      ID: 16357,
      Date: "28/07/2021 20:59:56",
      channel: "Online",
      tax: 0,
      Status: "Won",
    },
    {
      totAmount: 2000,
      totWin: 0,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256773044210,
      ID: 16356,
      Date: "28/07/2021 20:52:34",
      channel: "Online",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 500,
      totWin: 0,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256773044210,
      ID: 16355,
      Date: "28/07/2021 20:49:52",
      channel: "Online",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 1000,
      totWin: 0,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256773044210,
      ID: 16354,
      Date: "28/07/2021 20:49:23",
      channel: "Online",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 11064,
      totWin: 11651.5,
      product: "Virtual Football Pro",
      category: "Virtuals",
      username: 256780850357,
      ID: 16353,
      Date: "28/07/2021 20:45:15",
      channel: "Mobile",
      tax: 0,
      Status: "Won",
    },
    {
      totAmount: 1500,
      totWin: 0,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256773044210,
      ID: 16352,
      Date: "28/07/2021 20:42:08",
      channel: "Online",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 6000,
      totWin: 9000,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256776843303,
      ID: 16351,
      Date: "28/07/2021 19:56:21",
      channel: "Online",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 2250,
      totWin: 2075,
      product: "Virtual World Cup",
      category: "Virtuals",
      username: 256786916636,
      ID: 16350,
      Date: "28/07/2021 19:55:47",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 1500,
      totWin: 1550,
      product: "Virtual World Cup",
      category: "Virtuals",
      username: 256786916636,
      ID: 16349,
      Date: "28/07/2021 19:48:35",
      channel: "Mobile",
      tax: 0,
      Status: "Won",
    },
    {
      totAmount: 5000,
      totWin: 0,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256773044210,
      ID: 16348,
      Date: "28/07/2021 19:16:44",
      channel: "Online",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 1250,
      totWin: 0,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256773044210,
      ID: 16347,
      Date: "28/07/2021 19:12:01",
      channel: "Online",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 8750,
      totWin: 16250,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256773044210,
      ID: 16346,
      Date: "28/07/2021 17:48:44",
      channel: "Online",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 1250,
      totWin: 6250,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256773044210,
      ID: 16345,
      Date: "28/07/2021 17:44:32",
      channel: "Online",
      tax: 0,
      Status: "Won",
    },
    {
      totAmount: 11250,
      totWin: 29125,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256773044210,
      ID: 16344,
      Date: "28/07/2021 17:43:49",
      channel: "Online",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 2500,
      totWin: 6250,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256773044210,
      ID: 16343,
      Date: "28/07/2021 17:40:31",
      channel: "Online",
      tax: 0,
      Status: "Won",
    },
    {
      totAmount: 2500,
      totWin: 0,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256773044210,
      ID: 16342,
      Date: "28/07/2021 17:38:38",
      channel: "Online",
      tax: 0,
      Status: "Won",
    },
    {
      totAmount: 6250,
      totWin: 0,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256773044210,
      ID: 16341,
      Date: "28/07/2021 17:34:14",
      channel: "Online",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 2500,
      totWin: 11000,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256773044210,
      ID: 16340,
      Date: "28/07/2021 17:22:20",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 2500,
      totWin: 0,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256773044210,
      ID: 16339,
      Date: "28/07/2021 17:18:44",
      channel: "Mobile",
      tax: 0,
      Status: "Won",
    },
    {
      totAmount: 1250,
      totWin: 8125,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256773044210,
      ID: 16338,
      Date: "28/07/2021 17:18:04",
      channel: "Mobile",
      tax: 0,
      Status: "Won",
    },
    {
      totAmount: 1250,
      totWin: 0,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256773044210,
      ID: 16337,
      Date: "28/07/2021 15:48:20",
      channel: "Mobile",
      tax: 0,
      Status: "Won",
    },
    {
      totAmount: 2500,
      totWin: 6875,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256773044210,
      ID: 16336,
      Date: "28/07/2021 15:47:46",
      channel: "Mobile",
      tax: 0,
      Status: "Won",
    },
    {
      totAmount: 2500,
      totWin: 0,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256773044210,
      ID: 16335,
      Date: "28/07/2021 15:46:47",
      channel: "Mobile",
      tax: 0,
      Status: "Won",
    },
    {
      totAmount: 2500,
      totWin: 0,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256773044210,
      ID: 16334,
      Date: "28/07/2021 15:24:14",
      channel: "Mobile",
      tax: 0,
      Status: "Won",
    },
    {
      totAmount: 2400,
      totWin: 700,
      product: "3 Kings",
      category: "Casino",
      username: 256773044210,
      ID: 16333,
      Date: "28/07/2021 15:21:27",
      channel: "Mobile",
      tax: 0,
      Status: "Won",
    },
    {
      totAmount: 8000,
      totWin: 5412.5,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256773044210,
      ID: 16332,
      Date: "28/07/2021 15:12:42",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 1750,
      totWin: 10000,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256773044210,
      ID: 16331,
      Date: "28/07/2021 15:06:48",
      channel: "Mobile",
      tax: 0,
      Status: "Won",
    },
    {
      totAmount: 6500,
      totWin: 5829.95,
      product: "Virtual Football Pro",
      category: "Virtuals",
      username: 256786916636,
      ID: 16330,
      Date: "28/07/2021 14:47:52",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 500,
      totWin: 0,
      product: "Virtual Football Pro",
      category: "Virtuals",
      username: 256786916636,
      ID: 16329,
      Date: "28/07/2021 14:32:16",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 1000,
      totWin: 1050,
      product: "Virtual World Cup",
      category: "Virtuals",
      username: 256786916636,
      ID: 16328,
      Date: "28/07/2021 14:19:33",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 2500,
      totWin: 2500,
      product: "Virtual World Cup",
      category: "Virtuals",
      username: 256786916636,
      ID: 16327,
      Date: "28/07/2021 14:14:30",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 2500,
      totWin: 0,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256773044210,
      ID: 16326,
      Date: "28/07/2021 14:02:23",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 1250,
      totWin: 0,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256773044210,
      ID: 16325,
      Date: "28/07/2021 14:00:40",
      channel: "Mobile",
      tax: 0,
      Status: "Won",
    },
    {
      totAmount: 5500,
      totWin: 8687.5,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256773044210,
      ID: 16324,
      Date: "28/07/2021 13:59:37",
      channel: "Mobile",
      tax: 0,
      Status: "Won",
    },
    {
      totAmount: 7500,
      totWin: 0,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256773044210,
      ID: 16323,
      Date: "28/07/2021 13:55:47",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 1250,
      totWin: 0,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256773044210,
      ID: 16322,
      Date: "28/07/2021 13:52:17",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 1250,
      totWin: 0,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256773044210,
      ID: 16321,
      Date: "28/07/2021 13:50:11",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 1000,
      totWin: 0,
      product: "Virtual World Cup",
      category: "Virtuals",
      username: 256786916636,
      ID: 16320,
      Date: "28/07/2021 13:49:38",
      channel: "Mobile",
      tax: 0,
      Status: "Won",
    },
    {
      totAmount: 5000,
      totWin: 9062.5,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256773044210,
      ID: 16319,
      Date: "28/07/2021 13:48:35",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 3750,
      totWin: 13750,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256773044210,
      ID: 16318,
      Date: "28/07/2021 13:46:08",
      channel: "Mobile",
      tax: 0,
      Status: "Won",
    },
    {
      totAmount: 1250,
      totWin: 0,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256773044210,
      ID: 16317,
      Date: "28/07/2021 13:42:30",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 2500,
      totWin: 4687.5,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256773044210,
      ID: 16316,
      Date: "28/07/2021 13:42:05",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 500,
      totWin: 0,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256773044210,
      ID: 16315,
      Date: "28/07/2021 13:40:09",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 500,
      totWin: 0,
      product: "Virtual World Cup",
      category: "Virtuals",
      username: 256786916636,
      ID: 16314,
      Date: "28/07/2021 13:38:52",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 1250,
      totWin: 0,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256773044210,
      ID: 16313,
      Date: "28/07/2021 13:38:41",
      channel: "Mobile",
      tax: 0,
      Status: "Won",
    },
    {
      totAmount: 1250,
      totWin: 0,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256773044210,
      ID: 16312,
      Date: "28/07/2021 13:38:18",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 4250,
      totWin: 0,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256773044210,
      ID: 16311,
      Date: "28/07/2021 13:36:43",
      channel: "Mobile",
      tax: 0,
      Status: "Won",
    },
    {
      totAmount: 500,
      totWin: 0,
      product: "Virtual World Cup",
      category: "Virtuals",
      username: 256786916636,
      ID: 16310,
      Date: "28/07/2021 13:31:41",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 9750,
      totWin: 8500,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256773044210,
      ID: 16309,
      Date: "28/07/2021 13:31:16",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 1500,
      totWin: 1020,
      product: "Virtual World Cup",
      category: "Virtuals",
      username: 256786916636,
      ID: 16308,
      Date: "28/07/2021 13:28:42",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 500,
      totWin: 0,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256788548795,
      ID: 16307,
      Date: "28/07/2021 13:15:51",
      channel: "Mobile",
      tax: 0,
      Status: "Won",
    },
    {
      totAmount: 500,
      totWin: 955,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256788548795,
      ID: 16306,
      Date: "28/07/2021 13:12:36",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 500,
      totWin: 0,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256788548795,
      ID: 16305,
      Date: "28/07/2021 13:08:30",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 500,
      totWin: 0,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256788548795,
      ID: 16304,
      Date: "28/07/2021 12:50:39",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 1000,
      totWin: 1050,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256788548795,
      ID: 16303,
      Date: "28/07/2021 12:44:18",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 16302,
      Date: "28/07/2021 08:57:08",
      channel: "Mobile",
      tax: 0,
      Status: "Won",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 16301,
      Date: "28/07/2021 08:56:21",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 16300,
      Date: "28/07/2021 08:55:35",
      channel: "Mobile",
      tax: 0,
      Status: "Won",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 16299,
      Date: "27/07/2021 19:33:39",
      channel: "Mobile",
      tax: 0,
      Status: "Won",
    },
    {
      totAmount: 7558,
      totWin: 5523.25,
      product: "Virtual Football Pro",
      category: "Virtuals",
      username: 256780850357,
      ID: 16298,
      Date: "27/07/2021 21:26:52",
      channel: "Mobile",
      tax: 0,
      Status: "Won",
    },
    {
      totAmount: 2500,
      totWin: 2535,
      product: "Virtual Football Pro",
      category: "Virtuals",
      username: 256780850357,
      ID: 16297,
      Date: "27/07/2021 21:08:13",
      channel: "Mobile",
      tax: 0,
      Status: "Won",
    },
    {
      totAmount: 11800,
      totWin: 6900,
      product: "Royal Gems",
      category: "Casino",
      username: 256705845097,
      ID: 16296,
      Date: "27/07/2021 21:08:02",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 1500,
      totWin: 0,
      product: "Virtual Football Pro",
      category: "Virtuals",
      username: 256780850357,
      ID: 16295,
      Date: "27/07/2021 21:00:59",
      channel: "Mobile",
      tax: 0,
      Status: "Won",
    },
    {
      totAmount: 7500,
      totWin: 4500,
      product: "Burning Flame",
      category: "Casino",
      username: 256705845097,
      ID: 16294,
      Date: "27/07/2021 20:37:23",
      channel: "Mobile",
      tax: 0,
      Status: "Void",
    },
    {
      totAmount: 5500,
      totWin: 400,
      product: "Golden Dragon",
      category: "Casino",
      username: 256705845097,
      ID: 16293,
      Date: "27/07/2021 20:31:58",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 17000,
      totWin: 23100,
      product: "Royal Gems",
      category: "Casino",
      username: 256705845097,
      ID: 16292,
      Date: "27/07/2021 20:28:13",
      channel: "Mobile",
      tax: 0,
      Status: "Won",
    },
    {
      totAmount: 7800,
      totWin: 1820,
      product: "88 Riches",
      category: "Casino",
      username: 256705845097,
      ID: 16291,
      Date: "27/07/2021 20:12:43",
      channel: "Mobile",
      tax: 0,
      Status: "Won",
    },
    {
      totAmount: 2000,
      totWin: 0,
      product: "Book Of Oziris",
      category: "Casino",
      username: 256705845097,
      ID: 16290,
      Date: "27/07/2021 20:01:58",
      channel: "Mobile",
      tax: 0,
      Status: "Won",
    },
    {
      totAmount: 500,
      totWin: 0,
      product: "Virtual World Cup",
      category: "Virtuals",
      username: 256786916636,
      ID: 16289,
      Date: "27/07/2021 19:12:36",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 1500,
      totWin: 3250,
      product: "Virtual World Cup",
      category: "Virtuals",
      username: 256786916636,
      ID: 16288,
      Date: "27/07/2021 19:07:25",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 16287,
      Date: "27/07/2021 15:53:55",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 16286,
      Date: "27/07/2021 15:53:12",
      channel: "Mobile",
      tax: 0,
      Status: "Won",
    },
    {
      totAmount: 1000,
      totWin: 0,
      product: "Virtual World Cup",
      category: "Virtuals",
      username: 256786916636,
      ID: 16285,
      Date: "27/07/2021 18:51:56",
      channel: "Mobile",
      tax: 0,
      Status: "Won",
    },
    {
      totAmount: 5000,
      totWin: 9000,
      product: "Virtual Europa",
      category: "Virtuals",
      username: 256778261972,
      ID: 16284,
      Date: "27/07/2021 17:58:33",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 500,
      totWin: 0,
      product: "Virtual Soccer",
      category: "Virtuals",
      username: 256750737621,
      ID: 16283,
      Date: "27/07/2021 17:21:09",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 500,
      totWin: 0,
      product: "Virtual Europa",
      category: "Virtuals",
      username: 256750737621,
      ID: 16282,
      Date: "27/07/2021 17:18:30",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 1000,
      totWin: 0,
      product: "Virtual Soccer",
      category: "Virtuals",
      username: 256750737621,
      ID: 16281,
      Date: "27/07/2021 17:07:50",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 1500,
      totWin: 2050,
      product: "Virtual World Cup",
      category: "Virtuals",
      username: 256786916636,
      ID: 16280,
      Date: "27/07/2021 15:08:37",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 500,
      totWin: 1100,
      product: "Virtual World Cup",
      category: "Virtuals",
      username: 256786916636,
      ID: 16279,
      Date: "27/07/2021 15:01:38",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 500,
      totWin: 955,
      product: "Virtual World Cup",
      category: "Virtuals",
      username: 256786916636,
      ID: 16278,
      Date: "27/07/2021 14:57:13",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 1250,
      totWin: 3403.12,
      product: "Virtual World Cup",
      category: "Virtuals",
      username: 256786916636,
      ID: 16277,
      Date: "27/07/2021 14:50:38",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 500,
      totWin: 1750,
      product: "Virtual World Cup",
      category: "Virtuals",
      username: 256786916636,
      ID: 16276,
      Date: "27/07/2021 14:46:23",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 2750,
      totWin: 5405,
      product: "Virtual World Cup",
      category: "Virtuals",
      username: 256786916636,
      ID: 16275,
      Date: "27/07/2021 14:38:25",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 1500,
      totWin: 1000,
      product: "Virtual World Cup",
      category: "Virtuals",
      username: 256786916636,
      ID: 16274,
      Date: "27/07/2021 14:09:26",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 3750,
      totWin: 3007.75,
      product: "Virtual World Cup",
      category: "Virtuals",
      username: 256786916636,
      ID: 16273,
      Date: "27/07/2021 13:53:31",
      channel: "Mobile",
      tax: 0,
      Status: "Won",
    },
    {
      totAmount: 4558,
      totWin: 1959.4,
      product: "Virtual Europa",
      category: "Virtuals",
      username: 256784701859,
      ID: 16272,
      Date: "27/07/2021 12:51:20",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 2600,
      totWin: 1050,
      product: "Virtual Europa",
      category: "Virtuals",
      username: 256784701859,
      ID: 16271,
      Date: "27/07/2021 12:39:31",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 500,
      totWin: 680,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256775478737,
      ID: 16270,
      Date: "27/07/2021 07:22:28",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 1000,
      totWin: 0,
      product: "Virtual Euros",
      category: "Virtuals",
      username: 256777654824,
      ID: 16269,
      Date: "27/07/2021 07:13:28",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 16268,
      Date: "26/07/2021 19:28:07",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 3750,
      totWin: 850,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256775478737,
      ID: 16267,
      Date: "26/07/2021 20:07:13",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 59750,
      totWin: 51350,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256775478737,
      ID: 16266,
      Date: "26/07/2021 19:59:04",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 41002,
      totWin: 11959.6,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256784701859,
      ID: 16265,
      Date: "26/07/2021 19:27:19",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 15000,
      totWin: 0,
      product: "Virtual Europa",
      category: "Virtuals",
      username: 256784701859,
      ID: 16264,
      Date: "26/07/2021 19:13:29",
      channel: "Mobile",
      tax: 0,
      Status: "Won",
    },
    {
      totAmount: 164750,
      totWin: 144150,
      product: "Virtual Europa",
      category: "Virtuals",
      username: 256784701859,
      ID: 16263,
      Date: "26/07/2021 19:07:58",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 20000,
      totWin: 24750,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256784701859,
      ID: 16262,
      Date: "26/07/2021 18:49:29",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 10000,
      totWin: 21500,
      product: "Virtual Europa",
      category: "Virtuals",
      username: 256784701859,
      ID: 16261,
      Date: "26/07/2021 18:44:13",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 158558,
      totWin: 187800,
      product: "Virtual Europa",
      category: "Virtuals",
      username: 256784701859,
      ID: 16260,
      Date: "26/07/2021 18:28:16",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 9665,
      totWin: 29558.5,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256784701859,
      ID: 16259,
      Date: "26/07/2021 17:31:57",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 9100,
      totWin: 8985,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256784701859,
      ID: 16258,
      Date: "26/07/2021 16:51:18",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 9500,
      totWin: 16103,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256775478737,
      ID: 16257,
      Date: "26/07/2021 10:47:18",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 15250,
      totWin: 18910.5,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256775478737,
      ID: 16256,
      Date: "26/07/2021 10:30:53",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 5923,
      totWin: 3200,
      product: "Virtual Football Pro",
      category: "Virtuals",
      username: 256780850357,
      ID: 16255,
      Date: "26/07/2021 10:02:50",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 5778,
      totWin: 3913,
      product: "Virtual Football Pro",
      category: "Virtuals",
      username: 256780850357,
      ID: 16254,
      Date: "26/07/2021 09:49:16",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 12042,
      totWin: 14630.35,
      product: "Virtual Football Pro",
      category: "Virtuals",
      username: 256780850357,
      ID: 16253,
      Date: "26/07/2021 08:57:24",
      channel: "Mobile",
      tax: 0,
      Status: "Won",
    },
    {
      totAmount: 500,
      totWin: 0,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256775478737,
      ID: 16252,
      Date: "26/07/2021 07:04:16",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 28000,
      totWin: 11250,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256773044210,
      ID: 16251,
      Date: "26/07/2021 01:19:02",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 1000,
      totWin: 11520,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256773044210,
      ID: 16250,
      Date: "26/07/2021 01:05:22",
      channel: "Mobile",
      tax: 0,
      Status: "Won",
    },
    {
      totAmount: 2500,
      totWin: 0,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256773044210,
      ID: 16249,
      Date: "26/07/2021 01:02:51",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 101000,
      totWin: 95043.75,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256773044210,
      ID: 16248,
      Date: "26/07/2021 00:05:54",
      channel: "Mobile",
      tax: 0,
      Status: "Won",
    },
    {
      totAmount: 61000,
      totWin: 57401.25,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256775478737,
      ID: 16247,
      Date: "25/07/2021 23:48:50",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 19500,
      totWin: 24873,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256773044210,
      ID: 16246,
      Date: "25/07/2021 23:07:31",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 16245,
      Date: "25/07/2021 18:58:13",
      channel: "Mobile",
      tax: 0,
      Status: "Won",
    },
    {
      totAmount: 1000,
      totWin: 1025,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256777654824,
      ID: 16244,
      Date: "25/07/2021 21:47:57",
      channel: "Mobile",
      tax: 0,
      Status: "Won",
    },
    {
      totAmount: 7768,
      totWin: 4865,
      product: "Virtual Football Pro",
      category: "Virtuals",
      username: 256780850357,
      ID: 16243,
      Date: "25/07/2021 21:44:52",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 1700,
      totWin: 2590,
      product: "Virtual Football Pro",
      category: "Virtuals",
      username: 256780850357,
      ID: 16242,
      Date: "25/07/2021 21:28:55",
      channel: "Mobile",
      tax: 0,
      Status: "Won",
    },
    {
      totAmount: 10750,
      totWin: 8156.25,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256773044210,
      ID: 16241,
      Date: "25/07/2021 20:47:34",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 19750,
      totWin: 20037.5,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256773044210,
      ID: 16240,
      Date: "25/07/2021 20:33:22",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 3750,
      totWin: 0,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256773044210,
      ID: 16239,
      Date: "25/07/2021 19:59:32",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 36750,
      totWin: 35180,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256773044210,
      ID: 16238,
      Date: "25/07/2021 19:57:41",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 1000,
      totWin: 1025,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256777654824,
      ID: 16237,
      Date: "25/07/2021 16:39:06",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 218400,
      totWin: 178400,
      product: "Battle for Atlantis",
      category: "Casino",
      username: 256775784921,
      ID: 16236,
      Date: "25/07/2021 13:03:13",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 112500,
      totWin: 62750,
      product: "Jumpin Pot",
      category: "Casino",
      username: 256775784921,
      ID: 16235,
      Date: "25/07/2021 10:09:09",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 9750,
      totWin: 4975,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256773044210,
      ID: 16234,
      Date: "25/07/2021 07:44:48",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 2500,
      totWin: 4000,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256773044210,
      ID: 16233,
      Date: "25/07/2021 07:34:58",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 2500,
      totWin: 4875,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256773044210,
      ID: 16232,
      Date: "25/07/2021 07:27:31",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 5000,
      totWin: 0,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256773044210,
      ID: 16231,
      Date: "25/07/2021 07:23:20",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 52750,
      totWin: 39737.5,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256775478737,
      ID: 16230,
      Date: "25/07/2021 03:04:02",
      channel: "Mobile",
      tax: 0,
      Status: "Won",
    },
    {
      totAmount: 16750,
      totWin: 17600,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256773044210,
      ID: 16229,
      Date: "25/07/2021 02:35:33",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 10000,
      totWin: 0,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256773044210,
      ID: 16228,
      Date: "25/07/2021 02:28:28",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 19750,
      totWin: 0,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256773044210,
      ID: 16227,
      Date: "25/07/2021 02:23:54",
      channel: "Mobile",
      tax: 0,
      Status: "Won",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 16226,
      Date: "24/07/2021 23:16:32",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 16225,
      Date: "24/07/2021 23:15:48",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 1000,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 16224,
      Date: "24/07/2021 23:15:09",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 16223,
      Date: "24/07/2021 23:14:17",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 28750,
      totWin: 32225,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256773044210,
      ID: 16222,
      Date: "25/07/2021 02:11:19",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 23750,
      totWin: 29862.5,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256773044210,
      ID: 16221,
      Date: "25/07/2021 01:57:46",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 43750,
      totWin: 55395.62,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256775478737,
      ID: 16220,
      Date: "25/07/2021 01:42:23",
      channel: "Mobile",
      tax: 0,
      Status: "Won",
    },
    {
      totAmount: 32250,
      totWin: 22662.5,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256773044210,
      ID: 16219,
      Date: "25/07/2021 01:42:04",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 28750,
      totWin: 27861.25,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256773044210,
      ID: 16218,
      Date: "25/07/2021 00:33:12",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 10000,
      totWin: 19000,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256773044210,
      ID: 16217,
      Date: "25/07/2021 00:18:19",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 5000,
      totWin: 6250,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256773044210,
      ID: 16216,
      Date: "25/07/2021 00:06:48",
      channel: "Mobile",
      tax: 0,
      Status: "Won",
    },
    {
      totAmount: 10000,
      totWin: 0,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256773044210,
      ID: 16215,
      Date: "25/07/2021 00:04:12",
      channel: "Mobile",
      tax: 0,
      Status: "Won",
    },
    {
      totAmount: 6750,
      totWin: 0,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256773044210,
      ID: 16214,
      Date: "24/07/2021 23:58:30",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 121000,
      totWin: 115275,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256773044210,
      ID: 16213,
      Date: "24/07/2021 23:48:18",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 16212,
      Date: "24/07/2021 20:04:47",
      channel: "Mobile",
      tax: 0,
      Status: "Won",
    },
    {
      totAmount: 15000,
      totWin: 23337.5,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256773044210,
      ID: 16211,
      Date: "24/07/2021 22:44:55",
      channel: "Mobile",
      tax: 0,
      Status: "Won",
    },
    {
      totAmount: 72500,
      totWin: 96612.5,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256773044210,
      ID: 16210,
      Date: "24/07/2021 22:36:34",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 21250,
      totWin: 0,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256773044210,
      ID: 16209,
      Date: "24/07/2021 22:07:02",
      channel: "Mobile",
      tax: 0,
      Status: "Won",
    },
    {
      totAmount: 8750,
      totWin: 6355.45,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256775478737,
      ID: 16208,
      Date: "24/07/2021 21:53:46",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 500,
      totWin: 0,
      product: "Virtual Soccer",
      category: "Virtuals",
      username: 256782345897,
      ID: 16207,
      Date: "24/07/2021 21:24:55",
      channel: "Online",
      tax: 0,
      Status: "Won",
    },
    {
      totAmount: 30500,
      totWin: 17549.5,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256775478737,
      ID: 16206,
      Date: "24/07/2021 21:13:45",
      channel: "Mobile",
      tax: 0,
      Status: "Won",
    },
    {
      totAmount: 8250,
      totWin: 5362.5,
      product: "Virtual Football Pro",
      category: "Virtuals",
      username: 256780850357,
      ID: 16205,
      Date: "24/07/2021 20:26:55",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 1500,
      totWin: 0,
      product: "Virtual Football Pro",
      category: "Virtuals",
      username: 256780850357,
      ID: 16204,
      Date: "24/07/2021 19:29:04",
      channel: "Mobile",
      tax: 0,
      Status: "Void",
    },
    {
      totAmount: 4500,
      totWin: 0,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256784701859,
      ID: 16203,
      Date: "24/07/2021 12:40:42",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 16202,
      Date: "24/07/2021 05:34:22",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 16201,
      Date: "24/07/2021 05:28:32",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 16200,
      Date: "24/07/2021 05:27:46",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 500,
      totWin: 0,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256777654824,
      ID: 16199,
      Date: "24/07/2021 07:55:39",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 16198,
      Date: "23/07/2021 21:16:25",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 16197,
      Date: "23/07/2021 21:15:58",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 16196,
      Date: "23/07/2021 21:15:25",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 16195,
      Date: "23/07/2021 21:13:57",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 16194,
      Date: "23/07/2021 21:13:13",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 16193,
      Date: "23/07/2021 21:11:05",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 16192,
      Date: "23/07/2021 19:33:49",
      channel: "Mobile",
      tax: 0,
      Status: "Won",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 16191,
      Date: "23/07/2021 19:22:52",
      channel: "Mobile",
      tax: 0,
      Status: "Void",
    },
    {
      totAmount: 0,
      totWin: 1060,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 16190,
      Date: "23/07/2021 19:22:07",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 16189,
      Date: "23/07/2021 19:21:26",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 1250,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 16188,
      Date: "23/07/2021 19:20:42",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 16187,
      Date: "23/07/2021 19:20:09",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 16186,
      Date: "23/07/2021 19:15:49",
      channel: "Mobile",
      tax: 0,
      Status: "Won",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 16185,
      Date: "23/07/2021 19:15:22",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 16184,
      Date: "23/07/2021 19:14:55",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 16183,
      Date: "23/07/2021 19:14:24",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 1000,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 16182,
      Date: "23/07/2021 19:13:54",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 16181,
      Date: "23/07/2021 19:13:19",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 16180,
      Date: "23/07/2021 19:12:41",
      channel: "Mobile",
      tax: 0,
      Status: "Won",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 16179,
      Date: "23/07/2021 19:12:13",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 16178,
      Date: "23/07/2021 19:11:26",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 16177,
      Date: "23/07/2021 19:10:37",
      channel: "Mobile",
      tax: 0,
      Status: "Won",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 16176,
      Date: "23/07/2021 19:10:08",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 16175,
      Date: "23/07/2021 19:08:55",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 16174,
      Date: "23/07/2021 19:08:26",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 16173,
      Date: "23/07/2021 19:07:55",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 2000,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 16172,
      Date: "23/07/2021 19:07:17",
      channel: "Mobile",
      tax: 0,
      Status: "Won",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 16171,
      Date: "23/07/2021 18:52:26",
      channel: "Mobile",
      tax: 0,
      Status: "Won",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 16170,
      Date: "23/07/2021 18:43:19",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 16169,
      Date: "23/07/2021 18:42:59",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 16168,
      Date: "23/07/2021 18:42:34",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 16167,
      Date: "23/07/2021 18:42:05",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 16166,
      Date: "23/07/2021 18:41:41",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 16165,
      Date: "23/07/2021 18:41:03",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 16164,
      Date: "23/07/2021 18:38:26",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 16163,
      Date: "23/07/2021 18:37:49",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 16162,
      Date: "23/07/2021 18:36:18",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 16161,
      Date: "23/07/2021 18:35:57",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 16160,
      Date: "23/07/2021 18:32:30",
      channel: "Mobile",
      tax: 0,
      Status: "Won",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 16159,
      Date: "23/07/2021 18:32:01",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 16158,
      Date: "23/07/2021 18:30:51",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 16157,
      Date: "23/07/2021 18:30:14",
      channel: "Mobile",
      tax: 0,
      Status: "Won",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 16156,
      Date: "23/07/2021 18:28:25",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 16155,
      Date: "23/07/2021 18:27:15",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 16154,
      Date: "23/07/2021 18:26:46",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 16153,
      Date: "23/07/2021 18:25:48",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 16152,
      Date: "23/07/2021 18:24:49",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 16151,
      Date: "23/07/2021 18:24:16",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 16150,
      Date: "23/07/2021 18:22:14",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 8750,
      totWin: 0,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256773044210,
      ID: 16149,
      Date: "23/07/2021 21:08:39",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 55500,
      totWin: 75827.5,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256773044210,
      ID: 16148,
      Date: "23/07/2021 20:35:05",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 500,
      totWin: 0,
      product: "Virtual Europa",
      category: "Virtuals",
      username: 256701052616,
      ID: 16147,
      Date: "23/07/2021 20:13:32",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 8500,
      totWin: 6505,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256701052616,
      ID: 16146,
      Date: "23/07/2021 20:11:18",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 32000,
      totWin: 20150,
      product: "Virtual Europa",
      category: "Virtuals",
      username: 256701052616,
      ID: 16145,
      Date: "23/07/2021 19:59:57",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 16144,
      Date: "23/07/2021 16:45:54",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 16143,
      Date: "23/07/2021 16:44:21",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 3000,
      totWin: 1910,
      product: "Virtual Europa",
      category: "Virtuals",
      username: 256701052616,
      ID: 16142,
      Date: "23/07/2021 19:37:34",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 1000,
      totWin: 0,
      product: "Virtual Europa",
      category: "Virtuals",
      username: 256701052616,
      ID: 16141,
      Date: "23/07/2021 19:32:48",
      channel: "Mobile",
      tax: 0,
      Status: "Won",
    },
    {
      totAmount: 19867,
      totWin: 24150,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256701052616,
      ID: 16140,
      Date: "23/07/2021 19:31:48",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 22000,
      totWin: 25480,
      product: "Virtual Europa",
      category: "Virtuals",
      username: 256701052616,
      ID: 16139,
      Date: "23/07/2021 19:18:48",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 10000,
      totWin: 13150,
      product: "Virtual Europa",
      category: "Virtuals",
      username: 256701052616,
      ID: 16138,
      Date: "23/07/2021 17:45:42",
      channel: "Mobile",
      tax: 0,
      Status: "Won",
    },
    {
      totAmount: 1946,
      totWin: 4086.6,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256701052616,
      ID: 16137,
      Date: "23/07/2021 17:33:57",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 3000,
      totWin: 0,
      product: "Virtual Europa",
      category: "Virtuals",
      username: 256701052616,
      ID: 16136,
      Date: "23/07/2021 17:31:49",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 14000,
      totWin: 3000,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256701052616,
      ID: 16135,
      Date: "23/07/2021 17:28:36",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 1000,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 16134,
      Date: "23/07/2021 14:28:20",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 2000,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 16133,
      Date: "23/07/2021 14:26:43",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 16132,
      Date: "23/07/2021 14:25:43",
      channel: "Mobile",
      tax: 0,
      Status: "Won",
    },
    {
      totAmount: 0,
      totWin: 2000,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 16131,
      Date: "23/07/2021 14:24:32",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 16130,
      Date: "23/07/2021 14:23:46",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 500,
      totWin: 0,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256773044210,
      ID: 16129,
      Date: "23/07/2021 17:23:06",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 16128,
      Date: "23/07/2021 14:21:38",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 16127,
      Date: "23/07/2021 14:20:51",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 16126,
      Date: "23/07/2021 14:16:04",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 73700,
      totWin: 71446,
      product: "Virtual Europa",
      category: "Virtuals",
      username: 256701052616,
      ID: 16125,
      Date: "23/07/2021 17:15:49",
      channel: "Mobile",
      tax: 0,
      Status: "Won",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 16124,
      Date: "23/07/2021 14:15:33",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 16123,
      Date: "23/07/2021 14:14:56",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 16122,
      Date: "23/07/2021 14:13:55",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 1000,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 16121,
      Date: "23/07/2021 14:13:22",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 16120,
      Date: "23/07/2021 14:12:54",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 1000,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 16119,
      Date: "23/07/2021 14:12:27",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 9750,
      totWin: 6000,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256773044210,
      ID: 16118,
      Date: "23/07/2021 17:12:05",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 16117,
      Date: "23/07/2021 14:12:02",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 1000,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 16116,
      Date: "23/07/2021 14:11:33",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 1000,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 16115,
      Date: "23/07/2021 14:11:05",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 1000,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 16114,
      Date: "23/07/2021 14:10:34",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 16113,
      Date: "23/07/2021 14:09:41",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 3250,
      totWin: 0,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256773044210,
      ID: 16112,
      Date: "23/07/2021 17:02:10",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 12750,
      totWin: 12625,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256773044210,
      ID: 16111,
      Date: "23/07/2021 16:56:57",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 16110,
      Date: "23/07/2021 13:54:04",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 16109,
      Date: "23/07/2021 13:51:42",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 16108,
      Date: "23/07/2021 13:50:51",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 16107,
      Date: "23/07/2021 13:50:30",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 1000,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 16106,
      Date: "23/07/2021 13:49:26",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 16105,
      Date: "23/07/2021 13:49:04",
      channel: "Mobile",
      tax: 0,
      Status: "Won",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 16104,
      Date: "23/07/2021 13:46:55",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 16103,
      Date: "23/07/2021 13:46:26",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 16102,
      Date: "23/07/2021 13:46:02",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 1000,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 16101,
      Date: "23/07/2021 13:45:33",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 16100,
      Date: "23/07/2021 13:45:09",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 16099,
      Date: "23/07/2021 13:45:00",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 16098,
      Date: "23/07/2021 13:44:35",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 1500,
      totWin: 0,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256773044210,
      ID: 16097,
      Date: "23/07/2021 16:44:26",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 16096,
      Date: "23/07/2021 13:44:14",
      channel: "Mobile",
      tax: 0,
      Status: "Won",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 16095,
      Date: "23/07/2021 13:44:04",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 2000,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 16094,
      Date: "23/07/2021 13:42:20",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 16093,
      Date: "23/07/2021 13:41:53",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 1000,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 16092,
      Date: "23/07/2021 13:40:28",
      channel: "Mobile",
      tax: 0,
      Status: "Won",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 16091,
      Date: "23/07/2021 13:40:05",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 1000,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 16090,
      Date: "23/07/2021 13:39:18",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 16089,
      Date: "23/07/2021 13:38:32",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 16088,
      Date: "23/07/2021 13:38:20",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 16087,
      Date: "23/07/2021 13:38:13",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 2000,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 16086,
      Date: "23/07/2021 13:37:41",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 16085,
      Date: "23/07/2021 13:36:49",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 16084,
      Date: "23/07/2021 13:36:01",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 1160,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 16083,
      Date: "23/07/2021 13:33:37",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 16082,
      Date: "23/07/2021 13:33:04",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 16081,
      Date: "23/07/2021 13:32:05",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 1000,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 16080,
      Date: "23/07/2021 13:31:37",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 1380,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 16079,
      Date: "23/07/2021 13:30:57",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 16078,
      Date: "23/07/2021 13:28:48",
      channel: "Mobile",
      tax: 0,
      Status: "Won",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 16077,
      Date: "23/07/2021 13:28:18",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 2000,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 16076,
      Date: "23/07/2021 13:26:05",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 16075,
      Date: "23/07/2021 13:24:34",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 16074,
      Date: "23/07/2021 13:22:32",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 1000,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 16073,
      Date: "23/07/2021 13:21:42",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 16072,
      Date: "23/07/2021 13:20:56",
      channel: "Mobile",
      tax: 0,
      Status: "Won",
    },
    {
      totAmount: 0,
      totWin: 2000,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 16071,
      Date: "23/07/2021 13:20:08",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 41250,
      totWin: 29615,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256773044210,
      ID: 16070,
      Date: "23/07/2021 15:22:07",
      channel: "Mobile",
      tax: 0,
      Status: "Won",
    },
    {
      totAmount: 2500,
      totWin: 1100,
      product: "Virtual Soccer",
      category: "Virtuals",
      username: 256789185090,
      ID: 16069,
      Date: "23/07/2021 15:19:25",
      channel: "Online",
      tax: 0,
      Status: "Won",
    },
    {
      totAmount: 2000,
      totWin: 0,
      product: "Virtual Soccer",
      category: "Virtuals",
      username: 256789185090,
      ID: 16068,
      Date: "23/07/2021 14:58:31",
      channel: "Online",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 3750,
      totWin: 0,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256773044210,
      ID: 16067,
      Date: "23/07/2021 14:54:28",
      channel: "Mobile",
      tax: 0,
      Status: "Won",
    },
    {
      totAmount: 3750,
      totWin: 0,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256773044210,
      ID: 16066,
      Date: "23/07/2021 14:50:13",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 9000,
      totWin: 7525,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256773044210,
      ID: 16065,
      Date: "23/07/2021 14:44:49",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 31000,
      totWin: 22712.5,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256773044210,
      ID: 16064,
      Date: "23/07/2021 14:35:57",
      channel: "Mobile",
      tax: 0,
      Status: "Won",
    },
    {
      totAmount: 5000,
      totWin: 0,
      product: "Virtual Euros",
      category: "Virtuals",
      username: 256777783352,
      ID: 16063,
      Date: "23/07/2021 12:54:46",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 114000,
      totWin: 140677.5,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256773044210,
      ID: 16062,
      Date: "23/07/2021 12:54:23",
      channel: "Mobile",
      tax: 0,
      Status: "Won",
    },
    {
      totAmount: 500,
      totWin: 0,
      product: "Virtual Europa",
      category: "Virtuals",
      username: 256777783352,
      ID: 16061,
      Date: "23/07/2021 12:43:51",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 1000,
      totWin: 2250,
      product: "Virtual Euros",
      category: "Virtuals",
      username: 256777783352,
      ID: 16060,
      Date: "23/07/2021 12:41:59",
      channel: "Mobile",
      tax: 0,
      Status: "Won",
    },
    {
      totAmount: 2000,
      totWin: 0,
      product: "Virtual Euros",
      category: "Virtuals",
      username: 256777783352,
      ID: 16059,
      Date: "23/07/2021 12:19:52",
      channel: "Mobile",
      tax: 0,
      Status: "Won",
    },
    {
      totAmount: 6000,
      totWin: 8627.25,
      product: "Virtual Euros",
      category: "Virtuals",
      username: 256777783352,
      ID: 16058,
      Date: "23/07/2021 12:11:49",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 18750,
      totWin: 10825,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256773044210,
      ID: 16057,
      Date: "23/07/2021 12:10:04",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 17500,
      totWin: 17000,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256773044210,
      ID: 16056,
      Date: "23/07/2021 11:51:14",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 3500,
      totWin: 9786.48,
      product: "Virtual Euros",
      category: "Virtuals",
      username: 256777783352,
      ID: 16055,
      Date: "23/07/2021 11:49:54",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 26750,
      totWin: 27075,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256773044210,
      ID: 16054,
      Date: "23/07/2021 11:47:20",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 2500,
      totWin: 1620,
      product: "Virtual Euros",
      category: "Virtuals",
      username: 256777783352,
      ID: 16053,
      Date: "23/07/2021 11:43:23",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 500,
      totWin: 0,
      product: "Virtual Euros",
      category: "Virtuals",
      username: 256777783352,
      ID: 16052,
      Date: "23/07/2021 11:39:08",
      channel: "Mobile",
      tax: 0,
      Status: "Won",
    },
    {
      totAmount: 20000,
      totWin: 23162.5,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256773044210,
      ID: 16051,
      Date: "23/07/2021 11:35:34",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 21250,
      totWin: 35700,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256773044210,
      ID: 16050,
      Date: "23/07/2021 11:19:03",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 7500,
      totWin: 11562.5,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256773044210,
      ID: 16049,
      Date: "23/07/2021 11:11:18",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 25000,
      totWin: 17957.5,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256773044210,
      ID: 16048,
      Date: "23/07/2021 11:04:43",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 143250,
      totWin: 164695,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256773044210,
      ID: 16047,
      Date: "23/07/2021 10:54:54",
      channel: "Mobile",
      tax: 0,
      Status: "Won",
    },
    {
      totAmount: 1000,
      totWin: 0,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256751851008,
      ID: 16046,
      Date: "23/07/2021 10:23:29",
      channel: "Mobile",
      tax: 0,
      Status: "Won",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 16045,
      Date: "23/07/2021 07:16:13",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 1825,
      totWin: 825,
      product: "Virtual Football Pro",
      category: "Virtuals",
      username: 256780850357,
      ID: 16044,
      Date: "23/07/2021 08:36:46",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 10036,
      totWin: 10031.15,
      product: "Virtual Football Pro",
      category: "Virtuals",
      username: 256780850357,
      ID: 16043,
      Date: "23/07/2021 08:23:23",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 120250,
      totWin: 79575,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256773044210,
      ID: 16042,
      Date: "23/07/2021 08:14:50",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 16041,
      Date: "23/07/2021 05:14:39",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 11750,
      totWin: 9675,
      product: "Virtual Football Pro",
      category: "Virtuals",
      username: 256780850357,
      ID: 16040,
      Date: "23/07/2021 07:57:49",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 13750,
      totWin: 17812.5,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256773044210,
      ID: 16039,
      Date: "23/07/2021 07:28:50",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 140000,
      totWin: 171707.5,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256773044210,
      ID: 16038,
      Date: "23/07/2021 07:21:40",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 5000,
      totWin: 0,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256773044210,
      ID: 16037,
      Date: "23/07/2021 06:19:56",
      channel: "Mobile",
      tax: 0,
      Status: "Won",
    },
    {
      totAmount: 5000,
      totWin: 0,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256773044210,
      ID: 16036,
      Date: "23/07/2021 06:17:44",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 26250,
      totWin: 16975,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256773044210,
      ID: 16035,
      Date: "23/07/2021 06:11:47",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 2800,
      totWin: 900,
      product: "Ramses Treasure",
      category: "Casino",
      username: 256789156900,
      ID: 16034,
      Date: "23/07/2021 04:02:51",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 400,
      totWin: 100,
      product: "Crystal Mystery",
      category: "Casino",
      username: 256789156900,
      ID: 16033,
      Date: "23/07/2021 03:21:13",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 10400,
      totWin: 1700,
      product: "Slot Of Money",
      category: "Casino",
      username: 256789156900,
      ID: 16032,
      Date: "23/07/2021 00:03:27",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 5400,
      totWin: 1400,
      product: "Ramses Treasure",
      category: "Casino",
      username: 256789156900,
      ID: 16031,
      Date: "22/07/2021 23:58:34",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 1250,
      totWin: 0,
      product: "Virtual Europa",
      category: "Virtuals",
      username: 256780850357,
      ID: 16030,
      Date: "22/07/2021 23:51:36",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 7000,
      totWin: 5530,
      product: "Virtual Football Pro",
      category: "Virtuals",
      username: 256780850357,
      ID: 16029,
      Date: "22/07/2021 23:11:23",
      channel: "Mobile",
      tax: 0,
      Status: "Won",
    },
    {
      totAmount: 11334,
      totWin: 7025,
      product: "Virtual Football Pro",
      category: "Virtuals",
      username: 256780850357,
      ID: 16028,
      Date: "22/07/2021 22:56:21",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 5000,
      totWin: 6585,
      product: "Virtual Football Pro",
      category: "Virtuals",
      username: 256780850357,
      ID: 16027,
      Date: "22/07/2021 22:31:20",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 1500,
      totWin: 0,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256773044210,
      ID: 16026,
      Date: "22/07/2021 21:57:32",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 500,
      totWin: 0,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256773044210,
      ID: 16025,
      Date: "22/07/2021 21:56:01",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 16750,
      totWin: 13850,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256773044210,
      ID: 16024,
      Date: "22/07/2021 21:54:52",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 49500,
      totWin: 45250,
      product: "Virtual Football Pro",
      category: "Virtuals",
      username: 256780850357,
      ID: 16023,
      Date: "22/07/2021 21:40:26",
      channel: "Mobile",
      tax: 0,
      Status: "Won",
    },
    {
      totAmount: 5000,
      totWin: 0,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256773044210,
      ID: 16022,
      Date: "22/07/2021 21:24:28",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 1500,
      totWin: 0,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256773044210,
      ID: 16021,
      Date: "22/07/2021 21:19:40",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 20250,
      totWin: 11975,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256773044210,
      ID: 16020,
      Date: "22/07/2021 21:15:52",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 5000,
      totWin: 6762.5,
      product: "Virtual Football Pro",
      category: "Virtuals",
      username: 256780850357,
      ID: 16019,
      Date: "22/07/2021 20:57:39",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 15750,
      totWin: 14517.5,
      product: "Virtual Football Pro",
      category: "Virtuals",
      username: 256780850357,
      ID: 16018,
      Date: "22/07/2021 20:45:20",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 25000,
      totWin: 17412.5,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256773044210,
      ID: 16017,
      Date: "22/07/2021 20:38:53",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 21760,
      totWin: 19728,
      product: "Virtual Football Pro",
      category: "Virtuals",
      username: 256780850357,
      ID: 16016,
      Date: "22/07/2021 20:15:40",
      channel: "Mobile",
      tax: 0,
      Status: "Won",
    },
    {
      totAmount: 7500,
      totWin: 23750,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256773044210,
      ID: 16015,
      Date: "22/07/2021 19:03:23",
      channel: "Mobile",
      tax: 0,
      Status: "Won",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 16014,
      Date: "22/07/2021 15:58:48",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 16013,
      Date: "22/07/2021 15:58:20",
      channel: "Mobile",
      tax: 0,
      Status: "Won",
    },
    {
      totAmount: 2000,
      totWin: 0,
      product: "Monkey Pirates",
      category: "Casino",
      username: 256773044210,
      ID: 16012,
      Date: "22/07/2021 18:54:13",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 3750,
      totWin: 5000,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256773044210,
      ID: 16011,
      Date: "22/07/2021 18:52:29",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 48750,
      totWin: 72612.5,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256773044210,
      ID: 16010,
      Date: "22/07/2021 18:49:06",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 8250,
      totWin: 3375,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256773044210,
      ID: 16009,
      Date: "22/07/2021 18:22:56",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 500,
      totWin: 979.2,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256700239092,
      ID: 16008,
      Date: "22/07/2021 16:44:34",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 500,
      totWin: 720,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256700239092,
      ID: 16007,
      Date: "22/07/2021 16:43:24",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 4750,
      totWin: 3345,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256700239092,
      ID: 16006,
      Date: "22/07/2021 16:41:21",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 13000,
      totWin: 16426.9,
      product: "Virtual Soccer",
      category: "Virtuals",
      username: 256789185090,
      ID: 16005,
      Date: "22/07/2021 15:37:39",
      channel: "Online",
      tax: 0,
      Status: "Won",
    },
    {
      totAmount: 129660,
      totWin: 141410,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256784701859,
      ID: 16004,
      Date: "22/07/2021 14:39:04",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 137900,
      totWin: 197800,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256784701859,
      ID: 16003,
      Date: "22/07/2021 14:13:36",
      channel: "Mobile",
      tax: 0,
      Status: "Won",
    },
    {
      totAmount: 15000,
      totWin: 21500,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256784701859,
      ID: 16002,
      Date: "22/07/2021 13:42:01",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 10500,
      totWin: 4690.8,
      product: "Virtual Soccer",
      category: "Virtuals",
      username: 256789185090,
      ID: 16001,
      Date: "22/07/2021 13:33:53",
      channel: "Online",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 7350,
      totWin: 11900,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256784701859,
      ID: 16000,
      Date: "22/07/2021 13:32:01",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 5000,
      totWin: 12500,
      product: "Virtual Europa",
      category: "Virtuals",
      username: 256784701859,
      ID: 15999,
      Date: "22/07/2021 13:28:18",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 86868,
      totWin: 84450,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256784701859,
      ID: 15998,
      Date: "22/07/2021 13:27:27",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 1500,
      totWin: 800,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256788548795,
      ID: 15997,
      Date: "22/07/2021 13:23:47",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 16147,
      totWin: 40867.5,
      product: "Virtual Europa",
      category: "Virtuals",
      username: 256784701859,
      ID: 15996,
      Date: "22/07/2021 13:13:42",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 132000,
      totWin: 123300,
      product: "Virtual Europa",
      category: "Virtuals",
      username: 256784701859,
      ID: 15995,
      Date: "22/07/2021 13:06:35",
      channel: "Mobile",
      tax: 0,
      Status: "Void",
    },
    {
      totAmount: 8000,
      totWin: 4308.3,
      product: "Virtual Soccer",
      category: "Virtuals",
      username: 256789185090,
      ID: 15994,
      Date: "22/07/2021 12:59:57",
      channel: "Online",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 196804,
      totWin: 162597.2,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256784701859,
      ID: 15993,
      Date: "22/07/2021 12:44:10",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 5000,
      totWin: 0,
      product: "Virtual Europa",
      category: "Virtuals",
      username: 256784701859,
      ID: 15992,
      Date: "22/07/2021 12:12:56",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 139620,
      totWin: 165554.6,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256784701859,
      ID: 15991,
      Date: "22/07/2021 12:12:19",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 15990,
      Date: "22/07/2021 07:31:38",
      channel: "Mobile",
      tax: 0,
      Status: "Won",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 15989,
      Date: "22/07/2021 07:30:54",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 15988,
      Date: "22/07/2021 07:30:18",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 1040,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 15987,
      Date: "22/07/2021 07:28:49",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 1060,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 15986,
      Date: "22/07/2021 07:28:01",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 15985,
      Date: "22/07/2021 07:26:59",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 15984,
      Date: "22/07/2021 07:25:36",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 15983,
      Date: "22/07/2021 07:25:04",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 15982,
      Date: "22/07/2021 07:24:17",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 15981,
      Date: "22/07/2021 07:23:18",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 1000,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 15980,
      Date: "22/07/2021 07:22:41",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 1000,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 15979,
      Date: "22/07/2021 07:22:03",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 15978,
      Date: "22/07/2021 07:21:24",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 1000,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 15977,
      Date: "22/07/2021 07:20:44",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 15976,
      Date: "22/07/2021 07:20:03",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 15975,
      Date: "22/07/2021 07:19:30",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 1000,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 15974,
      Date: "22/07/2021 07:18:41",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 1000,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 15973,
      Date: "22/07/2021 07:15:47",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 15972,
      Date: "22/07/2021 07:13:52",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 15971,
      Date: "22/07/2021 07:13:13",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 15970,
      Date: "22/07/2021 07:11:27",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 1200,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 15969,
      Date: "22/07/2021 06:11:44",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 15968,
      Date: "22/07/2021 06:10:18",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 15967,
      Date: "22/07/2021 06:09:46",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 15966,
      Date: "22/07/2021 06:09:16",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 15965,
      Date: "22/07/2021 06:08:41",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 15964,
      Date: "22/07/2021 06:08:08",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 2500,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 15963,
      Date: "22/07/2021 06:07:29",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 15962,
      Date: "22/07/2021 06:06:44",
      channel: "Mobile",
      tax: 0,
      Status: "Won",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 15961,
      Date: "22/07/2021 06:06:07",
      channel: "Mobile",
      tax: 0,
      Status: "Won",
    },
    {
      totAmount: 0,
      totWin: 1000,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 15960,
      Date: "22/07/2021 06:00:45",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 2400,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 15959,
      Date: "22/07/2021 06:00:07",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 15958,
      Date: "22/07/2021 05:58:38",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 1000,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 15957,
      Date: "22/07/2021 05:58:09",
      channel: "Mobile",
      tax: 0,
      Status: "Won",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 15956,
      Date: "22/07/2021 05:57:34",
      channel: "Mobile",
      tax: 0,
      Status: "Won",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 15955,
      Date: "22/07/2021 05:56:14",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 1000,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 15954,
      Date: "22/07/2021 05:55:07",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 15953,
      Date: "22/07/2021 05:54:25",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 1200,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 15952,
      Date: "22/07/2021 05:53:51",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 15951,
      Date: "22/07/2021 05:52:02",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 15950,
      Date: "22/07/2021 05:51:13",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 15949,
      Date: "22/07/2021 05:50:35",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 15948,
      Date: "22/07/2021 05:49:31",
      channel: "Mobile",
      tax: 0,
      Status: "Won",
    },
    {
      totAmount: 0,
      totWin: 1000,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 15947,
      Date: "22/07/2021 05:45:40",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 1000,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 15946,
      Date: "22/07/2021 05:45:11",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 1000,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 15945,
      Date: "22/07/2021 05:43:38",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 15944,
      Date: "22/07/2021 05:43:07",
      channel: "Mobile",
      tax: 0,
      Status: "Void",
    },
    {
      totAmount: 0,
      totWin: 1000,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 15943,
      Date: "22/07/2021 05:41:54",
      channel: "Mobile",
      tax: 0,
      Status: "Won",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 15942,
      Date: "22/07/2021 05:40:22",
      channel: "Mobile",
      tax: 0,
      Status: "Won",
    },
    {
      totAmount: 0,
      totWin: 1000,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 15941,
      Date: "22/07/2021 05:39:53",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 15940,
      Date: "22/07/2021 05:39:18",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 15939,
      Date: "22/07/2021 05:38:48",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 15938,
      Date: "22/07/2021 05:37:32",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 1000,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 15937,
      Date: "22/07/2021 05:36:18",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 1000,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 15936,
      Date: "22/07/2021 05:01:20",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 1000,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 15935,
      Date: "22/07/2021 05:00:36",
      channel: "Mobile",
      tax: 0,
      Status: "Won",
    },
    {
      totAmount: 0,
      totWin: 1000,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 15934,
      Date: "22/07/2021 04:59:31",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 1000,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 15933,
      Date: "22/07/2021 04:58:58",
      channel: "Mobile",
      tax: 0,
      Status: "Won",
    },
    {
      totAmount: 0,
      totWin: 1000,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 15932,
      Date: "22/07/2021 04:58:24",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 15931,
      Date: "22/07/2021 04:57:59",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 1000,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 15930,
      Date: "22/07/2021 04:57:30",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 15929,
      Date: "22/07/2021 04:57:03",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 15928,
      Date: "22/07/2021 04:54:14",
      channel: "Mobile",
      tax: 0,
      Status: "Won",
    },
    {
      totAmount: 0,
      totWin: 1000,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 15927,
      Date: "21/07/2021 21:33:09",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 15926,
      Date: "21/07/2021 21:31:53",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 15925,
      Date: "21/07/2021 21:31:21",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 15924,
      Date: "21/07/2021 21:30:35",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 1000,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 15923,
      Date: "21/07/2021 21:28:46",
      channel: "Mobile",
      tax: 0,
      Status: "Lost",
    },
    {
      totAmount: 0,
      totWin: 1000,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 15922,
      Date: "21/07/2021 21:27:15",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 1000,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 15921,
      Date: "21/07/2021 21:25:28",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 1000,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 15920,
      Date: "21/07/2021 21:24:52",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 15919,
      Date: "21/07/2021 21:24:01",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 1000,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 15918,
      Date: "21/07/2021 21:21:52",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 15917,
      Date: "21/07/2021 21:21:07",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 15916,
      Date: "21/07/2021 21:18:12",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 15915,
      Date: "21/07/2021 21:17:13",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 1000,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 15914,
      Date: "21/07/2021 21:16:08",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 1000,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 15913,
      Date: "21/07/2021 21:15:07",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 14820,
      totWin: 17446,
      product: "Virtual Football Pro",
      category: "Virtuals",
      username: 256780850357,
      ID: 15912,
      Date: "21/07/2021 22:42:57",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 15911,
      Date: "21/07/2021 14:06:34",
      channel: "Online",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 15910,
      Date: "21/07/2021 14:05:31",
      channel: "Online",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 13000,
      totWin: 9975,
      product: "Virtual Football Pro",
      category: "Virtuals",
      username: 256780850357,
      ID: 15909,
      Date: "21/07/2021 16:34:44",
      channel: "n/a",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 15908,
      Date: "21/07/2021 08:23:52",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 15907,
      Date: "21/07/2021 08:22:23",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 15906,
      Date: "21/07/2021 08:22:01",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 15905,
      Date: "21/07/2021 08:21:16",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 15904,
      Date: "21/07/2021 08:20:39",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 15903,
      Date: "21/07/2021 08:19:25",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 2000,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 15902,
      Date: "21/07/2021 08:18:36",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 15901,
      Date: "21/07/2021 08:17:43",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 15900,
      Date: "21/07/2021 08:17:16",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 15899,
      Date: "21/07/2021 07:59:28",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 15898,
      Date: "21/07/2021 07:58:55",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 15897,
      Date: "21/07/2021 07:56:26",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 15896,
      Date: "21/07/2021 07:53:38",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 15895,
      Date: "21/07/2021 07:53:20",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 15894,
      Date: "21/07/2021 07:52:58",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 15893,
      Date: "21/07/2021 07:52:41",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 15892,
      Date: "21/07/2021 07:52:23",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 15891,
      Date: "21/07/2021 07:48:43",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 15890,
      Date: "21/07/2021 07:48:18",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 2500,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 15889,
      Date: "21/07/2021 07:45:42",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 15888,
      Date: "21/07/2021 07:45:21",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 7000,
      totWin: 0,
      product: "Monkey Pirates",
      category: "Casino",
      username: 256704889151,
      ID: 15887,
      Date: "21/07/2021 09:30:40",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 15886,
      Date: "20/07/2021 20:57:16",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 15885,
      Date: "20/07/2021 20:56:32",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 15884,
      Date: "20/07/2021 20:55:46",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 15883,
      Date: "20/07/2021 20:53:31",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 15882,
      Date: "20/07/2021 20:51:58",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 15881,
      Date: "20/07/2021 20:51:19",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 15880,
      Date: "20/07/2021 20:50:36",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 7500,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 15879,
      Date: "20/07/2021 20:27:58",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 15878,
      Date: "20/07/2021 20:27:07",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 2500,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 15877,
      Date: "20/07/2021 20:25:09",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 6125,
      totWin: 3750,
      product: "Virtual Football Pro",
      category: "Virtuals",
      username: 256780850357,
      ID: 15876,
      Date: "20/07/2021 22:24:40",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 1295,
      totWin: 0,
      product: "Virtual Football Pro",
      category: "Virtuals",
      username: 256780850357,
      ID: 15875,
      Date: "20/07/2021 22:11:50",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 4500,
      totWin: 10395,
      product: "Virtual Football Pro",
      category: "Virtuals",
      username: 256780850357,
      ID: 15874,
      Date: "20/07/2021 21:49:39",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 15873,
      Date: "20/07/2021 11:39:48",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 15872,
      Date: "20/07/2021 11:39:26",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 15871,
      Date: "20/07/2021 11:38:54",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 15870,
      Date: "20/07/2021 11:37:20",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 1000,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 15869,
      Date: "20/07/2021 11:36:33",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 15868,
      Date: "20/07/2021 11:35:42",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 15867,
      Date: "20/07/2021 11:35:09",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 15866,
      Date: "20/07/2021 11:34:32",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 1000,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 15865,
      Date: "20/07/2021 11:33:12",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 1200,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 15864,
      Date: "20/07/2021 11:31:56",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 1080,
      totWin: 420,
      product: "Emperors Wealth",
      category: "Casino",
      username: 256789156900,
      ID: 15863,
      Date: "19/07/2021 22:28:28",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 15862,
      Date: "19/07/2021 17:41:38",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 25000,
      totWin: 17690.1,
      product: "Virtual Soccer",
      category: "Virtuals",
      username: 256754688249,
      ID: 15861,
      Date: "19/07/2021 19:18:41",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 15860,
      Date: "19/07/2021 13:48:42",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 15859,
      Date: "19/07/2021 13:48:18",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 15858,
      Date: "19/07/2021 13:47:26",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 1000,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 15857,
      Date: "19/07/2021 13:43:36",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 15856,
      Date: "19/07/2021 13:35:59",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 15855,
      Date: "19/07/2021 13:35:36",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 15854,
      Date: "19/07/2021 13:34:36",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 15853,
      Date: "19/07/2021 13:33:55",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 15852,
      Date: "19/07/2021 13:33:34",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 15851,
      Date: "19/07/2021 13:32:44",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 2500,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 15850,
      Date: "19/07/2021 13:32:04",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 15849,
      Date: "19/07/2021 13:31:46",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 1000,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 15848,
      Date: "19/07/2021 13:31:19",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 15847,
      Date: "19/07/2021 13:30:55",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 15846,
      Date: "19/07/2021 13:30:33",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 5500,
      totWin: 4205,
      product: "Virtual Europa",
      category: "Virtuals",
      username: 256784701859,
      ID: 15845,
      Date: "19/07/2021 15:43:43",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 2000,
      totWin: 0,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256784701859,
      ID: 15844,
      Date: "19/07/2021 15:34:02",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 5500,
      totWin: 7885,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256784701859,
      ID: 15843,
      Date: "19/07/2021 15:28:50",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 1750,
      totWin: 2030,
      product: "Virtual Europa",
      category: "Virtuals",
      username: 256784701859,
      ID: 15842,
      Date: "19/07/2021 15:19:37",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 6000,
      totWin: 2750,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256784701859,
      ID: 15841,
      Date: "19/07/2021 15:12:00",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 4500,
      totWin: 0,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256784701859,
      ID: 15840,
      Date: "19/07/2021 14:59:47",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 2500,
      totWin: 1555,
      product: "Virtual Soccer",
      category: "Virtuals",
      username: 256754688249,
      ID: 15839,
      Date: "19/07/2021 09:50:43",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 15838,
      Date: "19/07/2021 03:18:12",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 15837,
      Date: "19/07/2021 03:17:43",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 15836,
      Date: "19/07/2021 03:17:19",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 1000,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 15835,
      Date: "19/07/2021 03:16:20",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 1000,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 15834,
      Date: "19/07/2021 03:10:19",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 15833,
      Date: "19/07/2021 03:09:39",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 15832,
      Date: "19/07/2021 03:08:40",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 1000,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 15831,
      Date: "19/07/2021 03:07:31",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 15830,
      Date: "19/07/2021 03:06:26",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 15829,
      Date: "19/07/2021 03:05:46",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 15828,
      Date: "19/07/2021 02:57:30",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 15827,
      Date: "19/07/2021 02:57:04",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 4000,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 15826,
      Date: "19/07/2021 02:55:48",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 15825,
      Date: "19/07/2021 02:54:25",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 4000,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 15824,
      Date: "19/07/2021 02:53:29",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 15823,
      Date: "19/07/2021 02:52:54",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 15822,
      Date: "19/07/2021 02:52:20",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 1000,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 15821,
      Date: "19/07/2021 02:49:26",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 2700,
      totWin: 700,
      product: "Night At KTV",
      category: "Casino",
      username: 256789156900,
      ID: 15820,
      Date: "19/07/2021 00:10:20",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 2600,
      totWin: 700,
      product: "Ramses Treasure",
      category: "Casino",
      username: 256789156900,
      ID: 15819,
      Date: "19/07/2021 00:06:34",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 15818,
      Date: "18/07/2021 19:59:59",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 11785,
      totWin: 8875,
      product: "Virtual Football Pro",
      category: "Virtuals",
      username: 256780850357,
      ID: 15817,
      Date: "18/07/2021 22:57:02",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 15816,
      Date: "18/07/2021 19:50:49",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 2000,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 15815,
      Date: "18/07/2021 19:49:44",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 15814,
      Date: "18/07/2021 19:48:45",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 2000,
      totWin: 0,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256705391480,
      ID: 15813,
      Date: "18/07/2021 22:10:18",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 1499,
      totWin: 0,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256705391480,
      ID: 15812,
      Date: "18/07/2021 22:08:20",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 1000,
      totWin: 0,
      product: "Monkey Pirates",
      category: "Casino",
      username: 256772617998,
      ID: 15811,
      Date: "18/07/2021 20:03:33",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 1000,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 15810,
      Date: "18/07/2021 17:00:21",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 15809,
      Date: "18/07/2021 16:58:42",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 15808,
      Date: "18/07/2021 16:58:16",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 3500,
      totWin: 0,
      product: "Virtual Soccer",
      category: "Virtuals",
      username: 256770845346,
      ID: 15807,
      Date: "18/07/2021 19:50:27",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 15806,
      Date: "18/07/2021 15:31:59",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 1000,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 15805,
      Date: "18/07/2021 15:11:59",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 1000,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 15804,
      Date: "18/07/2021 15:11:17",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 15803,
      Date: "18/07/2021 15:09:49",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 1500,
      totWin: 0,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256752016916,
      ID: 15802,
      Date: "18/07/2021 14:28:46",
      channel: "Online",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 15801,
      Date: "18/07/2021 08:10:20",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 15800,
      Date: "18/07/2021 08:09:54",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 15799,
      Date: "18/07/2021 08:09:31",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 15798,
      Date: "18/07/2021 08:08:59",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 15797,
      Date: "18/07/2021 05:40:50",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 15796,
      Date: "18/07/2021 05:39:22",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 16000,
      totWin: 5412.5,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256773044210,
      ID: 15795,
      Date: "18/07/2021 08:06:18",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 2250,
      totWin: 1000,
      product: "Virtual World Cup",
      category: "Virtuals",
      username: 256786916636,
      ID: 15794,
      Date: "18/07/2021 07:24:05",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 2000,
      totWin: 3570,
      product: "Virtual World Cup",
      category: "Virtuals",
      username: 256786916636,
      ID: 15793,
      Date: "18/07/2021 07:14:16",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 1000,
      totWin: 0,
      product: "Virtual World Cup",
      category: "Virtuals",
      username: 256786916636,
      ID: 15792,
      Date: "18/07/2021 07:05:54",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 15791,
      Date: "17/07/2021 19:34:39",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 15790,
      Date: "17/07/2021 19:33:47",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 15789,
      Date: "17/07/2021 19:03:44",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 15788,
      Date: "17/07/2021 19:01:48",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 15787,
      Date: "17/07/2021 19:00:56",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 15786,
      Date: "17/07/2021 19:00:43",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 15785,
      Date: "17/07/2021 19:00:35",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 15784,
      Date: "17/07/2021 19:00:17",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 15783,
      Date: "17/07/2021 19:00:14",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 15782,
      Date: "17/07/2021 18:59:32",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 15781,
      Date: "17/07/2021 18:59:22",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 15780,
      Date: "17/07/2021 18:59:10",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 15779,
      Date: "17/07/2021 18:58:47",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 15778,
      Date: "17/07/2021 18:58:40",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 15777,
      Date: "17/07/2021 18:58:24",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 15776,
      Date: "17/07/2021 18:58:12",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 15775,
      Date: "17/07/2021 18:57:51",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 15774,
      Date: "17/07/2021 18:57:47",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 15773,
      Date: "17/07/2021 18:57:06",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 2000,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 15772,
      Date: "17/07/2021 18:56:38",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 15771,
      Date: "17/07/2021 18:55:53",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 2000,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 15770,
      Date: "17/07/2021 18:55:40",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 15769,
      Date: "17/07/2021 18:55:03",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 15768,
      Date: "17/07/2021 18:54:57",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 15767,
      Date: "17/07/2021 18:54:32",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 10420,
      totWin: 7920,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256773127847,
      ID: 15766,
      Date: "17/07/2021 21:33:27",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 2500,
      totWin: 0,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256773127847,
      ID: 15765,
      Date: "17/07/2021 21:20:45",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 15764,
      Date: "17/07/2021 17:55:31",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 15763,
      Date: "17/07/2021 17:55:12",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 2000,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 15762,
      Date: "17/07/2021 17:54:29",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 15761,
      Date: "17/07/2021 17:53:56",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 15760,
      Date: "17/07/2021 17:53:01",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 15759,
      Date: "17/07/2021 17:52:40",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 15758,
      Date: "17/07/2021 17:52:12",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 5000,
      totWin: 3025,
      product: "Virtual Football Pro",
      category: "Virtuals",
      username: 256780850357,
      ID: 15757,
      Date: "17/07/2021 20:51:27",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 599.9,
      totWin: 0,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256773127847,
      ID: 15756,
      Date: "17/07/2021 20:44:42",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 19250,
      totWin: 6250,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256773044210,
      ID: 15755,
      Date: "17/07/2021 20:40:37",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 3000,
      totWin: 2000,
      product: "Virtual Football Pro",
      category: "Virtuals",
      username: 256780850357,
      ID: 15754,
      Date: "17/07/2021 20:22:52",
      channel: "n/a",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 172000,
      totWin: 211860,
      product: "Peter's Universe",
      category: "Casino",
      username: 256775784921,
      ID: 15753,
      Date: "17/07/2021 20:11:43",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 43750,
      totWin: 13250,
      product: "Chili Quest",
      category: "Casino",
      username: 256775784921,
      ID: 15752,
      Date: "17/07/2021 19:53:19",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 13000,
      totWin: 3480,
      product: "Monkey Pirates",
      category: "Casino",
      username: 256775784921,
      ID: 15751,
      Date: "17/07/2021 19:46:16",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 1000,
      totWin: 0,
      product: "Virtual Europa",
      category: "Virtuals",
      username: 256773044210,
      ID: 15750,
      Date: "17/07/2021 18:55:21",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 15749,
      Date: "17/07/2021 15:53:47",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 17000,
      totWin: 12883.15,
      product: "Virtual Soccer",
      category: "Virtuals",
      username: 256754740716,
      ID: 15748,
      Date: "17/07/2021 18:13:06",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 29500,
      totWin: 28545.2,
      product: "Virtual Soccer",
      category: "Virtuals",
      username: 256754740716,
      ID: 15747,
      Date: "17/07/2021 17:46:44",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 2500,
      totWin: 0,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256773044210,
      ID: 15746,
      Date: "17/07/2021 17:40:18",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 11250,
      totWin: 3600,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256773044210,
      ID: 15745,
      Date: "17/07/2021 17:37:47",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 15744,
      Date: "17/07/2021 14:35:08",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 2000,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 15743,
      Date: "17/07/2021 14:34:36",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 15742,
      Date: "17/07/2021 14:34:06",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 15741,
      Date: "17/07/2021 14:33:53",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 10500,
      totWin: 30750,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256773044210,
      ID: 15740,
      Date: "17/07/2021 17:26:47",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 2000,
      totWin: 0,
      product: "Chili Quest",
      category: "Casino",
      username: 256773308690,
      ID: 15739,
      Date: "17/07/2021 16:01:57",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 500,
      totWin: 0,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256773630488,
      ID: 15738,
      Date: "17/07/2021 13:58:13",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 500,
      totWin: 0,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256773630488,
      ID: 15737,
      Date: "17/07/2021 13:52:51",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 15736,
      Date: "17/07/2021 10:17:59",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 15735,
      Date: "17/07/2021 10:17:35",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 15734,
      Date: "17/07/2021 08:40:22",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 15733,
      Date: "17/07/2021 08:38:27",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 15732,
      Date: "17/07/2021 05:04:04",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 15731,
      Date: "17/07/2021 04:45:42",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 15730,
      Date: "17/07/2021 04:45:18",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 15729,
      Date: "17/07/2021 04:43:55",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 15728,
      Date: "17/07/2021 04:43:34",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 4500,
      totWin: 8535,
      product: "Virtual Football Pro",
      category: "Virtuals",
      username: 256780850357,
      ID: 15727,
      Date: "17/07/2021 05:55:29",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 1000,
      totWin: 0,
      product: "Virtual Football Pro",
      category: "Virtuals",
      username: 256780850357,
      ID: 15726,
      Date: "17/07/2021 05:46:26",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 5106,
      totWin: 3054,
      product: "Virtual Football Pro",
      category: "Virtuals",
      username: 256780850357,
      ID: 15725,
      Date: "17/07/2021 05:43:51",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 6400,
      totWin: 2700,
      product: "Slot Of Money",
      category: "Casino",
      username: 256756548434,
      ID: 15724,
      Date: "17/07/2021 03:02:50",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 6600,
      totWin: 1700,
      product: "Night At KTV",
      category: "Casino",
      username: 256756548434,
      ID: 15723,
      Date: "17/07/2021 03:00:23",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 2000,
      totWin: 3900,
      product: "El Toreo",
      category: "Casino",
      username: 256756548434,
      ID: 15722,
      Date: "17/07/2021 02:57:11",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 9400,
      totWin: 2300,
      product: "Ramses Treasure",
      category: "Casino",
      username: 256756548434,
      ID: 15721,
      Date: "17/07/2021 02:55:07",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 50400,
      totWin: 60400,
      product: "Slot Of Money",
      category: "Casino",
      username: 256756548434,
      ID: 15720,
      Date: "17/07/2021 02:51:10",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 4500,
      totWin: 500,
      product: "More Cash",
      category: "Casino",
      username: 256756548434,
      ID: 15719,
      Date: "17/07/2021 02:31:50",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 9200,
      totWin: 1300,
      product: "Slot Of Money",
      category: "Casino",
      username: 256756548434,
      ID: 15718,
      Date: "17/07/2021 02:28:17",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 2200,
      totWin: 200,
      product: "Ramses Treasure",
      category: "Casino",
      username: 256756548434,
      ID: 15717,
      Date: "17/07/2021 02:23:37",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 25250,
      totWin: 5875,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256773044210,
      ID: 15716,
      Date: "17/07/2021 01:07:26",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 15715,
      Date: "16/07/2021 21:01:44",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 15714,
      Date: "16/07/2021 21:01:01",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 1000,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 15713,
      Date: "16/07/2021 21:00:27",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 15712,
      Date: "16/07/2021 20:59:35",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 1000,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 15711,
      Date: "16/07/2021 20:58:47",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 15710,
      Date: "16/07/2021 20:58:47",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 15709,
      Date: "16/07/2021 20:57:49",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 15708,
      Date: "16/07/2021 20:55:56",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 15707,
      Date: "16/07/2021 20:55:22",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 1000,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 15706,
      Date: "16/07/2021 20:54:53",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 1000,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 15705,
      Date: "16/07/2021 20:54:28",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 1000,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 15704,
      Date: "16/07/2021 20:53:42",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 15703,
      Date: "16/07/2021 20:52:54",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 15702,
      Date: "16/07/2021 20:51:38",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 15701,
      Date: "16/07/2021 20:51:11",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 1000,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 15700,
      Date: "16/07/2021 20:50:40",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 15699,
      Date: "16/07/2021 20:49:04",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 15698,
      Date: "16/07/2021 20:48:25",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 1000,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 15697,
      Date: "16/07/2021 20:47:46",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 15696,
      Date: "16/07/2021 20:47:45",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 1000,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 15695,
      Date: "16/07/2021 20:47:05",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 1000,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 15694,
      Date: "16/07/2021 20:46:29",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 1000,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 15693,
      Date: "16/07/2021 20:44:27",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 15692,
      Date: "16/07/2021 20:44:06",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 15691,
      Date: "16/07/2021 20:43:33",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 15690,
      Date: "16/07/2021 20:43:13",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 15689,
      Date: "16/07/2021 20:42:12",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 2000,
      totWin: 2677.5,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256773127847,
      ID: 15688,
      Date: "16/07/2021 23:24:16",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 39746,
      totWin: 43797,
      product: "Virtual Football Pro",
      category: "Virtuals",
      username: 256780850357,
      ID: 15687,
      Date: "16/07/2021 23:12:29",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 42500,
      totWin: 53712.5,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256773044210,
      ID: 15686,
      Date: "16/07/2021 22:17:39",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 4750,
      totWin: 2750,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256773044210,
      ID: 15685,
      Date: "16/07/2021 21:59:47",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 28250,
      totWin: 22525,
      product: "Virtual Football Pro",
      category: "Virtuals",
      username: 256780850357,
      ID: 15684,
      Date: "16/07/2021 21:51:24",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 1000,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 15683,
      Date: "16/07/2021 18:39:07",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 1000,
      totWin: 0,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256773044210,
      ID: 15682,
      Date: "16/07/2021 21:31:26",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 5000,
      totWin: 10500,
      product: "Virtual Football Pro",
      category: "Virtuals",
      username: 256780850357,
      ID: 15681,
      Date: "16/07/2021 21:09:44",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 20000,
      totWin: 26602.5,
      product: "Virtual Football Pro",
      category: "Virtuals",
      username: 256780850357,
      ID: 15680,
      Date: "16/07/2021 21:01:54",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 1250,
      totWin: 0,
      product: "Virtual Europa",
      category: "Virtuals",
      username: 256773044210,
      ID: 15679,
      Date: "16/07/2021 20:55:30",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 36250,
      totWin: 28750,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256773044210,
      ID: 15678,
      Date: "16/07/2021 20:54:15",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 15250,
      totWin: 15205,
      product: "Virtual Football Pro",
      category: "Virtuals",
      username: 256780850357,
      ID: 15677,
      Date: "16/07/2021 20:13:39",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 2242,
      totWin: 1068.48,
      product: "Virtual Football Pro",
      category: "Virtuals",
      username: 256780850357,
      ID: 15676,
      Date: "16/07/2021 18:26:22",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 15675,
      Date: "16/07/2021 15:10:29",
      channel: "Online",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 15674,
      Date: "16/07/2021 15:09:51",
      channel: "Online",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 3000,
      totWin: 0,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256773127847,
      ID: 15673,
      Date: "16/07/2021 17:30:40",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 6000,
      totWin: 4123.4,
      product: "Virtual Soccer",
      category: "Virtuals",
      username: 256754688249,
      ID: 15672,
      Date: "16/07/2021 16:59:09",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 29000,
      totWin: 26976.65,
      product: "Virtual Soccer",
      category: "Virtuals",
      username: 256754688249,
      ID: 15671,
      Date: "16/07/2021 16:34:49",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 1233.5,
      totWin: 0,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256773127847,
      ID: 15670,
      Date: "16/07/2021 10:30:46",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 15669,
      Date: "16/07/2021 07:24:46",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 15668,
      Date: "16/07/2021 07:22:39",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 15667,
      Date: "16/07/2021 07:21:50",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 15666,
      Date: "16/07/2021 07:21:11",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 15750,
      totWin: 0,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256773127847,
      ID: 15665,
      Date: "16/07/2021 10:18:46",
      channel: "n/a",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 1500,
      totWin: 0,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256773127847,
      ID: 15664,
      Date: "16/07/2021 08:51:19",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 8500,
      totWin: 4165,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256773127847,
      ID: 15663,
      Date: "16/07/2021 08:49:30",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 500,
      totWin: 0,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256773127847,
      ID: 15662,
      Date: "16/07/2021 08:35:03",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 500,
      totWin: 1946.25,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256773127847,
      ID: 15661,
      Date: "16/07/2021 08:34:01",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 30500,
      totWin: 33368.25,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256773127847,
      ID: 15660,
      Date: "16/07/2021 08:29:45",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 15659,
      Date: "16/07/2021 03:30:47",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 15658,
      Date: "16/07/2021 03:30:26",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 15657,
      Date: "16/07/2021 03:30:05",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 15656,
      Date: "16/07/2021 03:29:45",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 15655,
      Date: "16/07/2021 03:29:14",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 15654,
      Date: "16/07/2021 03:28:47",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 15653,
      Date: "16/07/2021 03:28:11",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 122500,
      totWin: 22750,
      product: "Jumpin Pot",
      category: "Casino",
      username: 256775784921,
      ID: 15652,
      Date: "16/07/2021 01:26:45",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 213500,
      totWin: 111750,
      product: "Chili Quest",
      category: "Casino",
      username: 256775784921,
      ID: 15651,
      Date: "16/07/2021 01:16:22",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 654600,
      totWin: 556100,
      product: "Battle for Atlantis",
      category: "Casino",
      username: 256775784921,
      ID: 15650,
      Date: "16/07/2021 01:08:26",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 158400,
      totWin: 108460,
      product: "Lady Luck",
      category: "Casino",
      username: 256775784921,
      ID: 15649,
      Date: "16/07/2021 00:33:33",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 15648,
      Date: "15/07/2021 21:11:17",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 15647,
      Date: "15/07/2021 21:07:42",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 15646,
      Date: "15/07/2021 21:04:24",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 15645,
      Date: "15/07/2021 21:03:15",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 15644,
      Date: "15/07/2021 21:02:42",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 1000,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 15643,
      Date: "15/07/2021 20:31:01",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 4000,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 15642,
      Date: "15/07/2021 20:26:35",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 15641,
      Date: "15/07/2021 20:24:27",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 15000,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 15640,
      Date: "15/07/2021 19:35:13",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 15639,
      Date: "15/07/2021 19:34:14",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 72500,
      totWin: 22300,
      product: "Chili Quest",
      category: "Casino",
      username: 256775784921,
      ID: 15638,
      Date: "15/07/2021 21:54:22",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 317000,
      totWin: 327100,
      product: "Jumpin Pot",
      category: "Casino",
      username: 256775784921,
      ID: 15637,
      Date: "15/07/2021 21:48:38",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 3000,
      totWin: 0,
      product: "Virtual Football Pro",
      category: "Virtuals",
      username: 256754740716,
      ID: 15636,
      Date: "15/07/2021 19:16:44",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 2500,
      totWin: 2196.5,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256754740716,
      ID: 15635,
      Date: "15/07/2021 19:06:13",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 9550,
      totWin: 3660,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256701052616,
      ID: 15634,
      Date: "15/07/2021 18:38:06",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 2000,
      totWin: 0,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256773044210,
      ID: 15633,
      Date: "15/07/2021 17:53:43",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 5750,
      totWin: 2750,
      product: "Virtual Europa",
      category: "Virtuals",
      username: 256770857444,
      ID: 15632,
      Date: "15/07/2021 14:49:29",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 4250,
      totWin: 3250,
      product: "Virtual Europa",
      category: "Virtuals",
      username: 256770857444,
      ID: 15631,
      Date: "15/07/2021 14:40:03",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 5000,
      totWin: 0,
      product: "Virtual Euros",
      category: "Virtuals",
      username: 256777783352,
      ID: 15630,
      Date: "15/07/2021 14:17:27",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 2500,
      totWin: 0,
      product: "Virtual Euros",
      category: "Virtuals",
      username: 256777783352,
      ID: 15629,
      Date: "15/07/2021 14:08:43",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 25500,
      totWin: 36080,
      product: "Virtual Euros",
      category: "Virtuals",
      username: 256777783352,
      ID: 15628,
      Date: "15/07/2021 14:03:27",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 2000,
      totWin: 400,
      product: "Chili Quest",
      category: "Casino",
      username: 256777783352,
      ID: 15627,
      Date: "15/07/2021 13:45:23",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 15626,
      Date: "15/07/2021 10:41:47",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 2500,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 15625,
      Date: "15/07/2021 10:41:03",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 15624,
      Date: "15/07/2021 10:40:22",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 15623,
      Date: "15/07/2021 10:39:41",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 12500,
      totWin: 11676,
      product: "Virtual Euros",
      category: "Virtuals",
      username: 256777783352,
      ID: 15622,
      Date: "15/07/2021 13:37:34",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 1250,
      totWin: 0,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256777783352,
      ID: 15621,
      Date: "15/07/2021 13:21:18",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 1000,
      totWin: 0,
      product: "Virtual Euros",
      category: "Virtuals",
      username: 256777783352,
      ID: 15620,
      Date: "15/07/2021 13:17:06",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 5500,
      totWin: 4960,
      product: "Virtual Euros",
      category: "Virtuals",
      username: 256777783352,
      ID: 15619,
      Date: "15/07/2021 13:15:43",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 3500,
      totWin: 3893,
      product: "Virtual Soccer",
      category: "Virtuals",
      username: 256754688249,
      ID: 15618,
      Date: "15/07/2021 13:09:03",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 9000,
      totWin: 18490,
      product: "Virtual Euros",
      category: "Virtuals",
      username: 256777783352,
      ID: 15617,
      Date: "15/07/2021 13:08:55",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 500,
      totWin: 0,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256770857444,
      ID: 15616,
      Date: "15/07/2021 12:59:56",
      channel: "Online",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 1000,
      totWin: 0,
      product: "Virtual Europa",
      category: "Virtuals",
      username: 256770857444,
      ID: 15615,
      Date: "15/07/2021 12:58:15",
      channel: "Online",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 6500,
      totWin: 6560,
      product: "Virtual Soccer",
      category: "Virtuals",
      username: 256754688249,
      ID: 15614,
      Date: "15/07/2021 12:51:23",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 500,
      totWin: 0,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256777783352,
      ID: 15613,
      Date: "15/07/2021 12:43:22",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 15612,
      Date: "15/07/2021 09:41:09",
      channel: "Online",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 15611,
      Date: "15/07/2021 09:38:46",
      channel: "Online",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 38500,
      totWin: 24273.3,
      product: "Virtual Soccer",
      category: "Virtuals",
      username: 256754688249,
      ID: 15610,
      Date: "15/07/2021 12:30:26",
      channel: "n/a",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 3750,
      totWin: 1750,
      product: "Storming Flame",
      category: "Casino",
      username: 256789156900,
      ID: 15609,
      Date: "15/07/2021 12:09:52",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 4890.05,
      totWin: 1870,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256773127847,
      ID: 15608,
      Date: "15/07/2021 08:31:54",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 8750,
      totWin: 0,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256773127847,
      ID: 15607,
      Date: "15/07/2021 06:33:13",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 15606,
      Date: "14/07/2021 21:05:58",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 250,
      totWin: 0,
      product: "Ancient Gong",
      category: "Casino",
      username: 256789156900,
      ID: 15605,
      Date: "14/07/2021 23:58:55",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 5600,
      totWin: 1000,
      product: "Slot Of Money",
      category: "Casino",
      username: 256789156900,
      ID: 15604,
      Date: "14/07/2021 23:57:28",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 26250,
      totWin: 28000,
      product: "Storming Flame",
      category: "Casino",
      username: 256789156900,
      ID: 15603,
      Date: "14/07/2021 23:55:17",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 500,
      totWin: 3892.5,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256773127847,
      ID: 15602,
      Date: "14/07/2021 23:46:54",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 3250,
      totWin: 350,
      product: "King Of Wealth",
      category: "Casino",
      username: 256789156900,
      ID: 15601,
      Date: "14/07/2021 23:45:07",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 7200,
      totWin: 1400,
      product: "Slot Of Money",
      category: "Casino",
      username: 256789156900,
      ID: 15600,
      Date: "14/07/2021 22:52:02",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 4400,
      totWin: 14100,
      product: "Ramses Treasure",
      category: "Casino",
      username: 256789156900,
      ID: 15599,
      Date: "14/07/2021 22:49:11",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 58500,
      totWin: 49672.65,
      product: "Virtual Soccer",
      category: "Virtuals",
      username: 256754688249,
      ID: 15598,
      Date: "14/07/2021 22:40:08",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 15597,
      Date: "14/07/2021 19:31:31",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 122500,
      totWin: 144138.6,
      product: "Virtual Soccer",
      category: "Virtuals",
      username: 256754688249,
      ID: 15596,
      Date: "14/07/2021 22:07:13",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 15595,
      Date: "14/07/2021 18:36:06",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 15594,
      Date: "14/07/2021 18:34:57",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 1500,
      totWin: 0,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256773127847,
      ID: 15593,
      Date: "14/07/2021 21:27:50",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 1750,
      totWin: 6324.05,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256773127847,
      ID: 15592,
      Date: "14/07/2021 21:23:15",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 11854,
      totWin: 11930.7,
      product: "Virtual Football Pro",
      category: "Virtuals",
      username: 256780850357,
      ID: 15591,
      Date: "14/07/2021 21:22:11",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 1000,
      totWin: 2300,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256773127847,
      ID: 15590,
      Date: "14/07/2021 21:21:18",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 15589,
      Date: "14/07/2021 18:20:12",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 18500,
      totWin: 15837.5,
      product: "Virtual Soccer",
      category: "Virtuals",
      username: 256754688249,
      ID: 15588,
      Date: "14/07/2021 21:07:30",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 500,
      totWin: 0,
      product: "Virtual Football Pro",
      category: "Virtuals",
      username: 256780850357,
      ID: 15587,
      Date: "14/07/2021 21:05:41",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 7850,
      totWin: 6428,
      product: "Virtual Football Pro",
      category: "Virtuals",
      username: 256780850357,
      ID: 15586,
      Date: "14/07/2021 21:01:11",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 15585,
      Date: "14/07/2021 17:50:13",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 15584,
      Date: "14/07/2021 17:49:31",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 34000,
      totWin: 28216.2,
      product: "Virtual Soccer",
      category: "Virtuals",
      username: 256754688249,
      ID: 15583,
      Date: "14/07/2021 20:47:51",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 595,
      totWin: 0,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256770857444,
      ID: 15582,
      Date: "14/07/2021 18:25:36",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 1692,
      totWin: 2595,
      product: "Virtual Europa",
      category: "Virtuals",
      username: 256770857444,
      ID: 15581,
      Date: "14/07/2021 18:22:14",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 2000,
      totWin: 2600,
      product: "Chili Quest",
      category: "Casino",
      username: 256773308690,
      ID: 15580,
      Date: "14/07/2021 18:18:10",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 500,
      totWin: 0,
      product: "Chili Quest",
      category: "Casino",
      username: 256773308690,
      ID: 15579,
      Date: "14/07/2021 18:15:02",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 940,
      totWin: 1692,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256770857444,
      ID: 15578,
      Date: "14/07/2021 18:12:39",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 500,
      totWin: 0,
      product: "Virtual Europa",
      category: "Virtuals",
      username: 256770857444,
      ID: 15577,
      Date: "14/07/2021 18:11:34",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 1000,
      totWin: 1440,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256770857444,
      ID: 15576,
      Date: "14/07/2021 17:41:51",
      channel: "Online",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 2000,
      totWin: 0,
      product: "Virtual Europa",
      category: "Virtuals",
      username: 256770857444,
      ID: 15575,
      Date: "14/07/2021 17:40:57",
      channel: "Online",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 1250,
      totWin: 0,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256770857444,
      ID: 15574,
      Date: "14/07/2021 17:17:08",
      channel: "Online",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 4000,
      totWin: 3250,
      product: "Virtual Europa",
      category: "Virtuals",
      username: 256770857444,
      ID: 15573,
      Date: "14/07/2021 17:01:52",
      channel: "Online",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 1000,
      totWin: 0,
      product: "Virtual Europa",
      category: "Virtuals",
      username: 256770857444,
      ID: 15572,
      Date: "14/07/2021 16:10:23",
      channel: "Online",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 1000,
      totWin: 0,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256770857444,
      ID: 15571,
      Date: "14/07/2021 16:05:48",
      channel: "Online",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 2250,
      totWin: 3250,
      product: "Virtual Europa",
      category: "Virtuals",
      username: 256770857444,
      ID: 15570,
      Date: "14/07/2021 16:04:14",
      channel: "Online",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 3250,
      totWin: 3250,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256770857444,
      ID: 15569,
      Date: "14/07/2021 15:59:50",
      channel: "Online",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 500,
      totWin: 0,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256770857444,
      ID: 15568,
      Date: "14/07/2021 15:55:18",
      channel: "Online",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 1593.75,
      totWin: 6093.75,
      product: "Virtual Europa",
      category: "Virtuals",
      username: 256770857444,
      ID: 15567,
      Date: "14/07/2021 12:20:46",
      channel: "Online",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 500,
      totWin: 0,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256770857444,
      ID: 15566,
      Date: "14/07/2021 12:10:14",
      channel: "Online",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 500,
      totWin: 0,
      product: "Virtual Europa",
      category: "Virtuals",
      username: 256770857444,
      ID: 15565,
      Date: "14/07/2021 12:09:38",
      channel: "Online",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 1000,
      totWin: 0,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256770857444,
      ID: 15564,
      Date: "14/07/2021 12:08:35",
      channel: "Online",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 3000,
      totWin: 0,
      product: "Virtual Europa",
      category: "Virtuals",
      username: 256770857444,
      ID: 15563,
      Date: "14/07/2021 12:07:57",
      channel: "Online",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 6312.5,
      totWin: 7312.5,
      product: "Virtual Europa",
      category: "Virtuals",
      username: 256770857444,
      ID: 15562,
      Date: "14/07/2021 11:34:04",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 500,
      totWin: 0,
      product: "Virtual Europa",
      category: "Virtuals",
      username: 256770857444,
      ID: 15561,
      Date: "14/07/2021 11:04:24",
      channel: "Online",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 15560,
      Date: "14/07/2021 07:56:17",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 15559,
      Date: "14/07/2021 07:55:40",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 15558,
      Date: "14/07/2021 07:54:02",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 9500,
      totWin: 5937.5,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256773127847,
      ID: 15557,
      Date: "14/07/2021 10:44:31",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 500,
      totWin: 0,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256770857444,
      ID: 15556,
      Date: "14/07/2021 10:31:55",
      channel: "Online",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 500,
      totWin: 0,
      product: "Virtual Europa",
      category: "Virtuals",
      username: 256770857444,
      ID: 15555,
      Date: "14/07/2021 10:29:26",
      channel: "Online",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 500,
      totWin: 0,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256770857444,
      ID: 15554,
      Date: "14/07/2021 10:28:19",
      channel: "Online",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 500,
      totWin: 0,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256770857444,
      ID: 15553,
      Date: "14/07/2021 10:25:55",
      channel: "Online",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 500,
      totWin: 0,
      product: "Virtual Europa",
      category: "Virtuals",
      username: 256770857444,
      ID: 15552,
      Date: "14/07/2021 10:04:16",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 15551,
      Date: "14/07/2021 07:02:36",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 15550,
      Date: "14/07/2021 07:02:09",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 15549,
      Date: "14/07/2021 07:01:44",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 15548,
      Date: "14/07/2021 07:01:06",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 15547,
      Date: "14/07/2021 07:00:19",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 15546,
      Date: "14/07/2021 06:59:16",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 15545,
      Date: "14/07/2021 06:58:56",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 15544,
      Date: "14/07/2021 06:58:07",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 15543,
      Date: "14/07/2021 06:57:44",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 15542,
      Date: "14/07/2021 06:57:23",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 2000,
      totWin: 0,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256770857444,
      ID: 15541,
      Date: "14/07/2021 09:57:02",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 15540,
      Date: "14/07/2021 06:56:54",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 15539,
      Date: "14/07/2021 06:56:32",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 15538,
      Date: "14/07/2021 06:55:56",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 15537,
      Date: "14/07/2021 06:55:17",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 15536,
      Date: "14/07/2021 06:54:49",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 1781.25,
      totWin: 0,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256770857444,
      ID: 15535,
      Date: "14/07/2021 09:54:23",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 15534,
      Date: "14/07/2021 06:53:39",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 15533,
      Date: "14/07/2021 06:51:32",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 500,
      totWin: 5281.25,
      product: "Virtual Europa",
      category: "Virtuals",
      username: 256770857444,
      ID: 15532,
      Date: "14/07/2021 09:50:49",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 15531,
      Date: "14/07/2021 06:50:46",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 15530,
      Date: "14/07/2021 06:50:20",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 15529,
      Date: "14/07/2021 06:49:26",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 1500,
      totWin: 0,
      product: "Virtual Europa",
      category: "Virtuals",
      username: 256770857444,
      ID: 15528,
      Date: "14/07/2021 09:49:24",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 15527,
      Date: "14/07/2021 06:48:36",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 15526,
      Date: "14/07/2021 06:47:48",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 500,
      totWin: 0,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256770857444,
      ID: 15525,
      Date: "14/07/2021 09:47:38",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 1000,
      totWin: 0,
      product: "Virtual Europa",
      category: "Virtuals",
      username: 256770857444,
      ID: 15524,
      Date: "14/07/2021 09:46:36",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 15523,
      Date: "14/07/2021 06:46:04",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 500,
      totWin: 0,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256770857444,
      ID: 15522,
      Date: "14/07/2021 09:45:56",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 15521,
      Date: "14/07/2021 06:45:39",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 500,
      totWin: 0,
      product: "Virtual Europa",
      category: "Virtuals",
      username: 256770857444,
      ID: 15520,
      Date: "14/07/2021 09:44:32",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 7500,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 15519,
      Date: "14/07/2021 06:44:08",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 15518,
      Date: "14/07/2021 06:43:47",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 3000,
      totWin: 0,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256770857444,
      ID: 15517,
      Date: "14/07/2021 09:43:38",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 15516,
      Date: "14/07/2021 06:42:40",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 1000,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 15515,
      Date: "14/07/2021 06:41:32",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 500,
      totWin: 0,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256788956588,
      ID: 15514,
      Date: "14/07/2021 09:40:53",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 15513,
      Date: "14/07/2021 06:40:43",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 15512,
      Date: "14/07/2021 06:40:19",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 15511,
      Date: "14/07/2021 06:39:46",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 15510,
      Date: "14/07/2021 06:38:29",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 15509,
      Date: "14/07/2021 06:38:07",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 15508,
      Date: "14/07/2021 06:37:41",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 15507,
      Date: "14/07/2021 06:35:52",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 15506,
      Date: "14/07/2021 06:34:43",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 15505,
      Date: "14/07/2021 06:34:22",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 1400,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 15504,
      Date: "14/07/2021 06:33:02",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 7500,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 15503,
      Date: "14/07/2021 06:29:58",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 15502,
      Date: "14/07/2021 06:29:22",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 15501,
      Date: "14/07/2021 06:28:29",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 1000,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 15500,
      Date: "14/07/2021 06:27:11",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 4300,
      totWin: 0,
      product: "Virtual Europa",
      category: "Virtuals",
      username: 256770857444,
      ID: 15499,
      Date: "14/07/2021 08:56:43",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 3000,
      totWin: 2300,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256770857444,
      ID: 15498,
      Date: "14/07/2021 08:53:12",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 2000,
      totWin: 0,
      product: "Virtual Europa",
      category: "Virtuals",
      username: 256770857444,
      ID: 15497,
      Date: "14/07/2021 08:50:42",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 11075,
      totWin: 10075,
      product: "Virtual Europa",
      category: "Virtuals",
      username: 256770857444,
      ID: 15496,
      Date: "14/07/2021 08:48:02",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 22750,
      totWin: 20750,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256770857444,
      ID: 15495,
      Date: "14/07/2021 08:43:34",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 1000,
      totWin: 0,
      product: "Virtual Europa",
      category: "Virtuals",
      username: 256770857444,
      ID: 15494,
      Date: "14/07/2021 08:30:24",
      channel: "n/a",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 7200,
      totWin: 1000,
      product: "Slot Of Money",
      category: "Casino",
      username: 256789156900,
      ID: 15493,
      Date: "14/07/2021 01:07:19",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 5200,
      totWin: 2900,
      product: "Ramses Treasure",
      category: "Casino",
      username: 256789156900,
      ID: 15492,
      Date: "14/07/2021 01:02:23",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 2500,
      totWin: 2800,
      product: "Ancient Gong",
      category: "Casino",
      username: 256789156900,
      ID: 15491,
      Date: "14/07/2021 00:59:45",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 6750,
      totWin: 3500,
      product: "5 Star Luxury",
      category: "Casino",
      username: 256789156900,
      ID: 15490,
      Date: "14/07/2021 00:56:48",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 2400,
      totWin: 600,
      product: "Slot Of Money",
      category: "Casino",
      username: 256789156900,
      ID: 15489,
      Date: "14/07/2021 00:04:43",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 15488,
      Date: "13/07/2021 19:40:22",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 15487,
      Date: "13/07/2021 19:39:58",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 15486,
      Date: "13/07/2021 19:39:20",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 15485,
      Date: "13/07/2021 19:38:27",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 2000,
      totWin: 0,
      product: "Virtual Football Pro",
      category: "Virtuals",
      username: 256780850357,
      ID: 15484,
      Date: "13/07/2021 22:29:24",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 15483,
      Date: "13/07/2021 19:23:20",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 15482,
      Date: "13/07/2021 19:22:58",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 15481,
      Date: "13/07/2021 19:22:18",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 15480,
      Date: "13/07/2021 19:21:58",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 15479,
      Date: "13/07/2021 19:21:10",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 1000,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 15478,
      Date: "13/07/2021 19:20:26",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 2000,
      totWin: 1125,
      product: "Virtual Football Pro",
      category: "Virtuals",
      username: 256780850357,
      ID: 15477,
      Date: "13/07/2021 22:18:32",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 7500,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 15476,
      Date: "13/07/2021 19:18:26",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 15475,
      Date: "13/07/2021 19:17:58",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 15474,
      Date: "13/07/2021 19:17:04",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 15473,
      Date: "13/07/2021 19:16:43",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 15472,
      Date: "13/07/2021 19:15:51",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 1000,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 15471,
      Date: "13/07/2021 19:14:57",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 1000,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 15470,
      Date: "13/07/2021 19:14:23",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 15469,
      Date: "13/07/2021 19:13:58",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 15468,
      Date: "13/07/2021 19:13:36",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 15467,
      Date: "13/07/2021 19:13:12",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 15466,
      Date: "13/07/2021 19:12:43",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 15465,
      Date: "13/07/2021 19:12:17",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 15464,
      Date: "13/07/2021 19:11:53",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 15463,
      Date: "13/07/2021 19:11:28",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 15462,
      Date: "13/07/2021 19:11:06",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 15461,
      Date: "13/07/2021 19:10:23",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 15460,
      Date: "13/07/2021 19:09:55",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 7500,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 15459,
      Date: "13/07/2021 18:55:36",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 4250,
      totWin: 2250,
      product: "Burning Flame",
      category: "Casino",
      username: 256789156900,
      ID: 15458,
      Date: "13/07/2021 21:39:55",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 6750,
      totWin: 4050,
      product: "Virtual Football Pro",
      category: "Virtuals",
      username: 256780850357,
      ID: 15457,
      Date: "13/07/2021 18:51:56",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 13750,
      totWin: 19840,
      product: "Virtual Football Pro",
      category: "Virtuals",
      username: 256780850357,
      ID: 15456,
      Date: "13/07/2021 18:12:37",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 13180,
      totWin: 15070,
      product: "Virtual Football Pro",
      category: "Virtuals",
      username: 256780850357,
      ID: 15455,
      Date: "13/07/2021 17:39:47",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 15454,
      Date: "13/07/2021 14:17:21",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 15453,
      Date: "13/07/2021 14:16:35",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 14750,
      totWin: 11052.5,
      product: "Virtual Football Pro",
      category: "Virtuals",
      username: 256780850357,
      ID: 15452,
      Date: "13/07/2021 16:26:46",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 34800,
      totWin: 34184,
      product: "Virtual Football Pro",
      category: "Virtuals",
      username: 256780850357,
      ID: 15451,
      Date: "13/07/2021 15:38:08",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 500,
      totWin: 1800,
      product: "Virtual Football Pro",
      category: "Virtuals",
      username: 256780850357,
      ID: 15450,
      Date: "13/07/2021 14:44:14",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 15449,
      Date: "13/07/2021 11:12:55",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 15448,
      Date: "13/07/2021 11:12:37",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 15447,
      Date: "13/07/2021 11:11:13",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 15446,
      Date: "13/07/2021 11:10:54",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 15445,
      Date: "13/07/2021 11:10:34",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 1000,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 15444,
      Date: "13/07/2021 11:09:38",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 15443,
      Date: "13/07/2021 11:07:47",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 15442,
      Date: "13/07/2021 11:07:25",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 15441,
      Date: "13/07/2021 11:07:03",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 500,
      totWin: 1100,
      product: "Virtual Football Pro",
      category: "Virtuals",
      username: 256780850357,
      ID: 15440,
      Date: "13/07/2021 14:02:59",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 15439,
      Date: "13/07/2021 10:46:33",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 15438,
      Date: "13/07/2021 10:46:16",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 15437,
      Date: "13/07/2021 10:44:55",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 15436,
      Date: "13/07/2021 10:44:10",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 15435,
      Date: "13/07/2021 10:43:43",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 15434,
      Date: "13/07/2021 10:43:18",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 15433,
      Date: "13/07/2021 10:42:58",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 15432,
      Date: "13/07/2021 10:42:18",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 15431,
      Date: "13/07/2021 10:42:01",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 15430,
      Date: "13/07/2021 10:41:32",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 15429,
      Date: "13/07/2021 10:40:41",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 15428,
      Date: "13/07/2021 10:39:04",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 15427,
      Date: "13/07/2021 10:38:47",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 15426,
      Date: "13/07/2021 10:37:42",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 15425,
      Date: "13/07/2021 10:36:15",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 15424,
      Date: "13/07/2021 10:35:53",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 15423,
      Date: "13/07/2021 10:35:34",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 15422,
      Date: "13/07/2021 10:25:34",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 15421,
      Date: "13/07/2021 10:25:13",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 15420,
      Date: "13/07/2021 10:24:34",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 15419,
      Date: "13/07/2021 10:24:12",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 15418,
      Date: "13/07/2021 10:22:36",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 15417,
      Date: "13/07/2021 10:22:17",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 15416,
      Date: "13/07/2021 10:21:59",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 15415,
      Date: "13/07/2021 10:21:38",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 2000,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 15414,
      Date: "13/07/2021 10:19:10",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 15413,
      Date: "13/07/2021 10:18:17",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 15412,
      Date: "13/07/2021 10:17:12",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 15411,
      Date: "13/07/2021 10:16:53",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 15410,
      Date: "13/07/2021 10:16:35",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 15409,
      Date: "13/07/2021 10:15:53",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 4000,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 15408,
      Date: "13/07/2021 10:10:51",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 15407,
      Date: "13/07/2021 10:10:34",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 15406,
      Date: "13/07/2021 10:10:09",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 15405,
      Date: "13/07/2021 10:09:47",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 15404,
      Date: "13/07/2021 10:09:09",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 1000,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 15403,
      Date: "13/07/2021 10:08:49",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 2500,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 15402,
      Date: "13/07/2021 10:07:39",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 15401,
      Date: "13/07/2021 10:07:23",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 15400,
      Date: "13/07/2021 10:06:59",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 15399,
      Date: "13/07/2021 10:06:42",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 15398,
      Date: "13/07/2021 10:06:06",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 15397,
      Date: "13/07/2021 10:05:50",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 1000,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 15396,
      Date: "13/07/2021 10:05:30",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 15395,
      Date: "13/07/2021 10:05:11",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 15394,
      Date: "13/07/2021 10:04:39",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 15393,
      Date: "13/07/2021 10:03:23",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 15392,
      Date: "13/07/2021 10:02:49",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 15391,
      Date: "13/07/2021 10:02:30",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 15390,
      Date: "13/07/2021 10:02:10",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 15389,
      Date: "13/07/2021 10:01:53",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 15388,
      Date: "13/07/2021 10:01:36",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 1000,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 15387,
      Date: "13/07/2021 10:01:06",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 2000,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 15386,
      Date: "13/07/2021 10:00:39",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 15385,
      Date: "13/07/2021 10:00:16",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 15384,
      Date: "13/07/2021 09:59:59",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 15383,
      Date: "13/07/2021 09:59:41",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 2000,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 15382,
      Date: "13/07/2021 09:59:07",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 15381,
      Date: "13/07/2021 09:58:43",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 15380,
      Date: "13/07/2021 09:58:26",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 2500,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 15379,
      Date: "13/07/2021 09:57:21",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 3700,
      totWin: 4146,
      product: "Virtual Football Pro",
      category: "Virtuals",
      username: 256780850357,
      ID: 15378,
      Date: "13/07/2021 12:56:45",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 4000,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 15377,
      Date: "13/07/2021 09:53:58",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 15376,
      Date: "13/07/2021 09:53:27",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 2000,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 15375,
      Date: "13/07/2021 09:52:32",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 15374,
      Date: "13/07/2021 09:51:34",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 15373,
      Date: "13/07/2021 09:51:11",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 7500,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 15372,
      Date: "13/07/2021 09:50:17",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 15371,
      Date: "13/07/2021 09:49:48",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 15370,
      Date: "13/07/2021 09:49:28",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 15369,
      Date: "13/07/2021 09:49:10",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 2000,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 15368,
      Date: "13/07/2021 09:48:33",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 15367,
      Date: "13/07/2021 09:48:21",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 15366,
      Date: "13/07/2021 09:47:36",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 15365,
      Date: "13/07/2021 09:46:29",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 15364,
      Date: "13/07/2021 09:43:31",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 15363,
      Date: "13/07/2021 09:43:15",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 15362,
      Date: "13/07/2021 09:42:57",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 15361,
      Date: "13/07/2021 09:42:38",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 2000,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 15360,
      Date: "13/07/2021 09:42:10",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 15359,
      Date: "13/07/2021 09:41:32",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 15358,
      Date: "13/07/2021 09:41:14",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 15357,
      Date: "13/07/2021 09:39:10",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 4250,
      totWin: 3600,
      product: "Virtual Football Pro",
      category: "Virtuals",
      username: 256780850357,
      ID: 15356,
      Date: "13/07/2021 12:14:17",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 1500,
      totWin: 2800,
      product: "Virtual Football Pro",
      category: "Virtuals",
      username: 256780850357,
      ID: 15355,
      Date: "13/07/2021 11:49:00",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 15354,
      Date: "13/07/2021 08:42:36",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 15353,
      Date: "13/07/2021 08:42:19",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 15352,
      Date: "13/07/2021 08:41:45",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 15351,
      Date: "13/07/2021 08:41:26",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 15350,
      Date: "13/07/2021 08:40:51",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 1000,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 15349,
      Date: "13/07/2021 08:40:26",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 15348,
      Date: "13/07/2021 08:40:06",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 15347,
      Date: "13/07/2021 08:39:17",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 15346,
      Date: "13/07/2021 08:38:59",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 15345,
      Date: "13/07/2021 08:38:45",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 15344,
      Date: "13/07/2021 08:38:24",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 15343,
      Date: "13/07/2021 08:38:06",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 2000,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 15342,
      Date: "13/07/2021 08:37:06",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 15341,
      Date: "13/07/2021 08:36:48",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 1000,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 15340,
      Date: "13/07/2021 08:36:17",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 2000,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 15339,
      Date: "13/07/2021 08:35:49",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 15338,
      Date: "13/07/2021 08:35:14",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 15337,
      Date: "13/07/2021 08:34:54",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 15336,
      Date: "13/07/2021 08:34:32",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 15335,
      Date: "13/07/2021 08:32:45",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 15334,
      Date: "13/07/2021 08:32:16",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 1000,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 15333,
      Date: "13/07/2021 08:31:46",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 2000,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 15332,
      Date: "13/07/2021 08:26:20",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 2000,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 15331,
      Date: "13/07/2021 08:25:48",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 1000,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 15330,
      Date: "13/07/2021 08:25:20",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 2000,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 15329,
      Date: "13/07/2021 08:24:12",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 15328,
      Date: "13/07/2021 08:24:11",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 15327,
      Date: "13/07/2021 08:23:31",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 15326,
      Date: "13/07/2021 08:23:25",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 7500,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 15325,
      Date: "13/07/2021 08:14:46",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 1000,
      totWin: 0,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256770857444,
      ID: 15324,
      Date: "13/07/2021 10:37:38",
      channel: "Online",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 2000,
      totWin: 0,
      product: "Virtual Europa",
      category: "Virtuals",
      username: 256770857444,
      ID: 15323,
      Date: "13/07/2021 10:36:38",
      channel: "Online",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 13750,
      totWin: 10750,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256770857444,
      ID: 15322,
      Date: "13/07/2021 10:36:12",
      channel: "Online",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 15321,
      Date: "13/07/2021 07:33:02",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 15320,
      Date: "13/07/2021 07:31:35",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 26750,
      totWin: 21600,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256750622095,
      ID: 15319,
      Date: "13/07/2021 10:30:03",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 2000,
      totWin: 0,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256770857444,
      ID: 15318,
      Date: "13/07/2021 10:29:33",
      channel: "Online",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 1000,
      totWin: 0,
      product: "Virtual Europa",
      category: "Virtuals",
      username: 256770857444,
      ID: 15317,
      Date: "13/07/2021 10:27:24",
      channel: "Online",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 1000,
      totWin: 0,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256770857444,
      ID: 15316,
      Date: "13/07/2021 10:25:37",
      channel: "Online",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 1000,
      totWin: 0,
      product: "Virtual Europa",
      category: "Virtuals",
      username: 256770857444,
      ID: 15315,
      Date: "13/07/2021 10:24:42",
      channel: "Online",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 836.96,
      totWin: 0,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256770857444,
      ID: 15314,
      Date: "13/07/2021 10:23:53",
      channel: "Online",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 2359.38,
      totWin: 0,
      product: "Virtual Europa",
      category: "Virtuals",
      username: 256770857444,
      ID: 15313,
      Date: "13/07/2021 10:22:07",
      channel: "Online",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 500,
      totWin: 5836.96,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256770857444,
      ID: 15312,
      Date: "13/07/2021 10:19:45",
      channel: "Online",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 4187.5,
      totWin: 16046.88,
      product: "Virtual Europa",
      category: "Virtuals",
      username: 256770857444,
      ID: 15311,
      Date: "13/07/2021 10:18:35",
      channel: "Online",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 3000,
      totWin: 0,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256770857444,
      ID: 15310,
      Date: "13/07/2021 10:16:20",
      channel: "Online",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 500,
      totWin: 0,
      product: "Virtual Europa",
      category: "Virtuals",
      username: 256770857444,
      ID: 15309,
      Date: "13/07/2021 10:15:15",
      channel: "Online",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 15308,
      Date: "13/07/2021 07:13:26",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 15307,
      Date: "13/07/2021 07:04:42",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 15306,
      Date: "13/07/2021 07:03:52",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 500,
      totWin: 0,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256770857444,
      ID: 15305,
      Date: "13/07/2021 10:03:12",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 2000,
      totWin: 0,
      product: "Virtual Europa",
      category: "Virtuals",
      username: 256770857444,
      ID: 15304,
      Date: "13/07/2021 10:02:07",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 15303,
      Date: "13/07/2021 07:00:34",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 15302,
      Date: "13/07/2021 06:58:32",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 2000,
      totWin: 0,
      product: "Virtual Europa",
      category: "Virtuals",
      username: 256770857444,
      ID: 15301,
      Date: "13/07/2021 09:58:12",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 15300,
      Date: "13/07/2021 06:57:57",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 2000,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 15299,
      Date: "13/07/2021 06:57:31",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 1000,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 15298,
      Date: "13/07/2021 06:56:47",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 1500,
      totWin: 0,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256770857444,
      ID: 15297,
      Date: "13/07/2021 09:55:52",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 18500,
      totWin: 15000,
      product: "Virtual Europa",
      category: "Virtuals",
      username: 256770857444,
      ID: 15296,
      Date: "13/07/2021 09:54:16",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 15295,
      Date: "13/07/2021 06:46:14",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 15294,
      Date: "13/07/2021 06:45:50",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 3000,
      totWin: 4000,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256770857444,
      ID: 15293,
      Date: "13/07/2021 09:45:39",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 15292,
      Date: "13/07/2021 06:45:29",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 15291,
      Date: "13/07/2021 06:45:01",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 1000,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 15290,
      Date: "13/07/2021 06:42:40",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 15289,
      Date: "13/07/2021 06:42:30",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 15288,
      Date: "13/07/2021 06:42:01",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 15287,
      Date: "13/07/2021 06:41:41",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 1000,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 15286,
      Date: "13/07/2021 06:41:09",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 2000,
      totWin: 0,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256770857444,
      ID: 15285,
      Date: "13/07/2021 09:41:09",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 2000,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 15284,
      Date: "13/07/2021 06:40:18",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 15283,
      Date: "13/07/2021 06:38:24",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 15282,
      Date: "13/07/2021 06:37:31",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 4000,
      totWin: 0,
      product: "Virtual Europa",
      category: "Virtuals",
      username: 256770857444,
      ID: 15281,
      Date: "13/07/2021 09:37:27",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 15280,
      Date: "13/07/2021 06:36:52",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 15279,
      Date: "13/07/2021 06:36:18",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 1000,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 15278,
      Date: "13/07/2021 06:35:51",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 15277,
      Date: "13/07/2021 06:35:28",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 15276,
      Date: "13/07/2021 06:35:01",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 15275,
      Date: "13/07/2021 06:34:33",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 2000,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 15274,
      Date: "13/07/2021 06:34:08",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 15273,
      Date: "13/07/2021 06:33:11",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 2000,
      totWin: 0,
      product: "Virtual Europa",
      category: "Virtuals",
      username: 256770857444,
      ID: 15272,
      Date: "13/07/2021 09:32:19",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 1000,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 15271,
      Date: "13/07/2021 06:32:04",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 15270,
      Date: "13/07/2021 06:31:42",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 1000,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 15269,
      Date: "13/07/2021 06:30:33",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 2000,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 15268,
      Date: "13/07/2021 06:29:06",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 15267,
      Date: "13/07/2021 06:28:35",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 1000,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 15266,
      Date: "13/07/2021 06:27:31",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 1000,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 15265,
      Date: "13/07/2021 06:24:43",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 4250,
      totWin: 2250,
      product: "Storming Flame",
      category: "Casino",
      username: 256789156900,
      ID: 15264,
      Date: "13/07/2021 01:13:12",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 2600,
      totWin: 200,
      product: "Ramses Treasure",
      category: "Casino",
      username: 256789156900,
      ID: 15263,
      Date: "13/07/2021 00:20:20",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 11200,
      totWin: 4200,
      product: "Slot Of Money",
      category: "Casino",
      username: 256789156900,
      ID: 15262,
      Date: "13/07/2021 00:18:36",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 2000,
      totWin: 0,
      product: "Ramses Treasure",
      category: "Casino",
      username: 256789156900,
      ID: 15261,
      Date: "12/07/2021 23:34:52",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 2500,
      totWin: 0,
      product: "Storming Flame",
      category: "Casino",
      username: 256789156900,
      ID: 15260,
      Date: "12/07/2021 23:32:55",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 5000,
      totWin: 5875,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256750622095,
      ID: 15259,
      Date: "12/07/2021 22:43:30",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 3300,
      totWin: 3300,
      product: "3 Kings",
      category: "Casino",
      username: 256789156900,
      ID: 15258,
      Date: "12/07/2021 21:27:51",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 2600,
      totWin: 500,
      product: "Ramses Treasure",
      category: "Casino",
      username: 256789156900,
      ID: 15257,
      Date: "12/07/2021 21:19:42",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 750,
      totWin: 2812.5,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256770857444,
      ID: 15256,
      Date: "12/07/2021 21:18:05",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 2000,
      totWin: 0,
      product: "Ramses Treasure",
      category: "Casino",
      username: 256789156900,
      ID: 15255,
      Date: "12/07/2021 21:17:46",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 1000,
      totWin: 0,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256770857444,
      ID: 15254,
      Date: "12/07/2021 21:16:15",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 3256.18,
      totWin: 1750,
      product: "Virtual Europa",
      category: "Virtuals",
      username: 256770857444,
      ID: 15253,
      Date: "12/07/2021 21:12:07",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 1220,
      totWin: 3256.18,
      product: "Virtual Europa",
      category: "Virtuals",
      username: 256770857444,
      ID: 15252,
      Date: "12/07/2021 21:08:05",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 1000,
      totWin: 5220,
      product: "Virtual Europa",
      category: "Virtuals",
      username: 256770857444,
      ID: 15251,
      Date: "12/07/2021 21:06:10",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 5375,
      totWin: 9375,
      product: "Virtual Europa",
      category: "Virtuals",
      username: 256770857444,
      ID: 15250,
      Date: "12/07/2021 21:04:13",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 1500,
      totWin: 0,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256770857444,
      ID: 15249,
      Date: "12/07/2021 20:53:00",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 2000,
      totWin: 0,
      product: "Virtual Europa",
      category: "Virtuals",
      username: 256770857444,
      ID: 15248,
      Date: "12/07/2021 20:52:00",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 500,
      totWin: 0,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256770857444,
      ID: 15247,
      Date: "12/07/2021 20:49:30",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 2536,
      totWin: 5536,
      product: "Virtual Europa",
      category: "Virtuals",
      username: 256770857444,
      ID: 15246,
      Date: "12/07/2021 20:48:18",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 500,
      totWin: 0,
      product: "Virtual Europa",
      category: "Virtuals",
      username: 256770857444,
      ID: 15245,
      Date: "12/07/2021 20:44:32",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 19347.5,
      totWin: 29847.5,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256770857444,
      ID: 15244,
      Date: "12/07/2021 20:43:49",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 5470,
      totWin: 5800,
      product: "Virtual Europa",
      category: "Virtuals",
      username: 256770857444,
      ID: 15243,
      Date: "12/07/2021 20:25:59",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 7000,
      totWin: 9520,
      product: "Virtual Europa",
      category: "Virtuals",
      username: 256770857444,
      ID: 15242,
      Date: "12/07/2021 20:12:57",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 2440,
      totWin: 3150,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256770857444,
      ID: 15241,
      Date: "12/07/2021 20:12:00",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 1000,
      totWin: 5440,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256770857444,
      ID: 15240,
      Date: "12/07/2021 20:08:37",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 1000,
      totWin: 0,
      product: "Virtual Europa",
      category: "Virtuals",
      username: 256770857444,
      ID: 15239,
      Date: "12/07/2021 20:07:20",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 324750,
      totWin: 315396.9,
      product: "Virtual Soccer",
      category: "Virtuals",
      username: 256754688249,
      ID: 15238,
      Date: "12/07/2021 20:06:34",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 1000,
      totWin: 0,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256770857444,
      ID: 15237,
      Date: "12/07/2021 20:05:36",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 1000,
      totWin: 0,
      product: "Virtual Europa",
      category: "Virtuals",
      username: 256770857444,
      ID: 15236,
      Date: "12/07/2021 20:04:31",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 2000,
      totWin: 0,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256770857444,
      ID: 15235,
      Date: "12/07/2021 20:03:14",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 2000,
      totWin: 0,
      product: "Virtual Europa",
      category: "Virtuals",
      username: 256770857444,
      ID: 15234,
      Date: "12/07/2021 20:00:09",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 3000,
      totWin: 0,
      product: "Virtual Europa",
      category: "Virtuals",
      username: 256770857444,
      ID: 15233,
      Date: "12/07/2021 19:53:35",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 500,
      totWin: 0,
      product: "Virtual Europa",
      category: "Virtuals",
      username: 256770857444,
      ID: 15232,
      Date: "12/07/2021 19:47:25",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 2000,
      totWin: 0,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256770857444,
      ID: 15231,
      Date: "12/07/2021 19:45:58",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 500,
      totWin: 1000,
      product: "Virtual Football Pro",
      category: "Virtuals",
      username: 256780850357,
      ID: 15230,
      Date: "12/07/2021 19:42:58",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 2000,
      totWin: 6500,
      product: "Virtual Europa",
      category: "Virtuals",
      username: 256770857444,
      ID: 15229,
      Date: "12/07/2021 19:41:58",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 6817,
      totWin: 2775,
      product: "Virtual Football Pro",
      category: "Virtuals",
      username: 256780850357,
      ID: 15228,
      Date: "12/07/2021 19:40:15",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 1000,
      totWin: 0,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256770857444,
      ID: 15227,
      Date: "12/07/2021 19:27:29",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 1000,
      totWin: 0,
      product: "Virtual Europa",
      category: "Virtuals",
      username: 256770857444,
      ID: 15226,
      Date: "12/07/2021 19:26:45",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 1000,
      totWin: 0,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256770857444,
      ID: 15225,
      Date: "12/07/2021 19:17:43",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 1000,
      totWin: 0,
      product: "Virtual Europa",
      category: "Virtuals",
      username: 256770857444,
      ID: 15224,
      Date: "12/07/2021 19:16:11",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 1000,
      totWin: 0,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256770857444,
      ID: 15223,
      Date: "12/07/2021 19:04:09",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 500,
      totWin: 0,
      product: "Virtual Europa",
      category: "Virtuals",
      username: 256770857444,
      ID: 15222,
      Date: "12/07/2021 19:02:11",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 500,
      totWin: 0,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256770857444,
      ID: 15221,
      Date: "12/07/2021 19:00:14",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 4250,
      totWin: 5330,
      product: "Virtual Football Pro",
      category: "Virtuals",
      username: 256780850357,
      ID: 15220,
      Date: "12/07/2021 18:59:35",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 2000,
      totWin: 0,
      product: "Virtual Europa",
      category: "Virtuals",
      username: 256770857444,
      ID: 15219,
      Date: "12/07/2021 18:58:25",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 2000,
      totWin: 0,
      product: "Virtual Europa",
      category: "Virtuals",
      username: 256770857444,
      ID: 15218,
      Date: "12/07/2021 18:53:43",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 2000,
      totWin: 3000,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256770857444,
      ID: 15217,
      Date: "12/07/2021 18:51:43",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 500,
      totWin: 0,
      product: "Virtual Europa",
      category: "Virtuals",
      username: 256770857444,
      ID: 15216,
      Date: "12/07/2021 18:50:29",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 1000,
      totWin: 0,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256770857444,
      ID: 15215,
      Date: "12/07/2021 18:49:41",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 500,
      totWin: 0,
      product: "Virtual Europa",
      category: "Virtuals",
      username: 256770857444,
      ID: 15214,
      Date: "12/07/2021 18:47:24",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 1000,
      totWin: 0,
      product: "Virtual Europa",
      category: "Virtuals",
      username: 256770857444,
      ID: 15213,
      Date: "12/07/2021 18:45:33",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 5781.35,
      totWin: 13181.35,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256770857444,
      ID: 15212,
      Date: "12/07/2021 18:43:48",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 2000,
      totWin: 1600,
      product: "Virtual Europa",
      category: "Virtuals",
      username: 256770857444,
      ID: 15211,
      Date: "12/07/2021 18:34:10",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 1000,
      totWin: 0,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256770857444,
      ID: 15210,
      Date: "12/07/2021 18:31:56",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 3075,
      totWin: 10075,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256770857444,
      ID: 15209,
      Date: "12/07/2021 18:30:47",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 9683,
      totWin: 8668.88,
      product: "Virtual Football Pro",
      category: "Virtuals",
      username: 256780850357,
      ID: 15208,
      Date: "12/07/2021 17:44:46",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 1000,
      totWin: 0,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256770857444,
      ID: 15207,
      Date: "12/07/2021 17:13:07",
      channel: "Online",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 6264,
      totWin: 0,
      product: "Virtual Europa",
      category: "Virtuals",
      username: 256770857444,
      ID: 15206,
      Date: "12/07/2021 17:11:54",
      channel: "Online",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 4000,
      totWin: 0,
      product: "Virtual World Cup",
      category: "Virtuals",
      username: 256770857444,
      ID: 15205,
      Date: "12/07/2021 17:04:40",
      channel: "Online",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 3750,
      totWin: 10014,
      product: "Virtual Europa",
      category: "Virtuals",
      username: 256770857444,
      ID: 15204,
      Date: "12/07/2021 17:02:33",
      channel: "Online",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 3225,
      totWin: 2020,
      product: "Virtual Europa",
      category: "Virtuals",
      username: 256770857444,
      ID: 15203,
      Date: "12/07/2021 16:58:17",
      channel: "Online",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 6000,
      totWin: 4205,
      product: "Virtual Europa",
      category: "Virtuals",
      username: 256770857444,
      ID: 15202,
      Date: "12/07/2021 16:52:44",
      channel: "Online",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 6750,
      totWin: 3250,
      product: "Virtual Europa",
      category: "Virtuals",
      username: 256770857444,
      ID: 15201,
      Date: "12/07/2021 16:46:24",
      channel: "Online",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 500,
      totWin: 0,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256770857444,
      ID: 15200,
      Date: "12/07/2021 16:42:02",
      channel: "Online",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 1305,
      totWin: 0,
      product: "Virtual Europa",
      category: "Virtuals",
      username: 256770857444,
      ID: 15199,
      Date: "12/07/2021 16:40:36",
      channel: "Online",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 3500,
      totWin: 4805,
      product: "Virtual Europa",
      category: "Virtuals",
      username: 256770857444,
      ID: 15198,
      Date: "12/07/2021 16:38:41",
      channel: "Online",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 500,
      totWin: 0,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256770857444,
      ID: 15197,
      Date: "12/07/2021 16:05:52",
      channel: "Online",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 3350,
      totWin: 4350,
      product: "Virtual Europa",
      category: "Virtuals",
      username: 256770857444,
      ID: 15196,
      Date: "12/07/2021 16:04:10",
      channel: "Online",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 500,
      totWin: 2500,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256770857444,
      ID: 15195,
      Date: "12/07/2021 16:01:40",
      channel: "Online",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 500,
      totWin: 0,
      product: "Virtual Europa",
      category: "Virtuals",
      username: 256770857444,
      ID: 15194,
      Date: "12/07/2021 16:00:40",
      channel: "Online",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 1000,
      totWin: 0,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256770857444,
      ID: 15193,
      Date: "12/07/2021 15:58:32",
      channel: "Online",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 562.5,
      totWin: 0,
      product: "Virtual Europa",
      category: "Virtuals",
      username: 256770857444,
      ID: 15192,
      Date: "12/07/2021 15:54:29",
      channel: "Online",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 1000,
      totWin: 0,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256770857444,
      ID: 15191,
      Date: "12/07/2021 15:51:31",
      channel: "Online",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 9000,
      totWin: 23562.5,
      product: "Virtual Europa",
      category: "Virtuals",
      username: 256770857444,
      ID: 15190,
      Date: "12/07/2021 15:50:41",
      channel: "Online",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 2000,
      totWin: 0,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256770857444,
      ID: 15189,
      Date: "12/07/2021 15:41:54",
      channel: "Online",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 2000,
      totWin: 0,
      product: "Virtual Europa",
      category: "Virtuals",
      username: 256770857444,
      ID: 15188,
      Date: "12/07/2021 15:38:32",
      channel: "Online",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 1300,
      totWin: 0,
      product: "Virtual Europa",
      category: "Virtuals",
      username: 256770857444,
      ID: 15187,
      Date: "12/07/2021 15:34:21",
      channel: "Online",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 4000,
      totWin: 5800,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256770857444,
      ID: 15186,
      Date: "12/07/2021 15:33:07",
      channel: "Online",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 3000,
      totWin: 6500,
      product: "Virtual Europa",
      category: "Virtuals",
      username: 256770857444,
      ID: 15185,
      Date: "12/07/2021 15:32:15",
      channel: "Online",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 1000,
      totWin: 0,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256770857444,
      ID: 15184,
      Date: "12/07/2021 15:30:33",
      channel: "Online",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 3000,
      totWin: 0,
      product: "Virtual Europa",
      category: "Virtuals",
      username: 256770857444,
      ID: 15183,
      Date: "12/07/2021 15:30:03",
      channel: "Online",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 2000,
      totWin: 0,
      product: "Virtual Europa",
      category: "Virtuals",
      username: 256770857444,
      ID: 15182,
      Date: "12/07/2021 15:24:19",
      channel: "Online",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 1852,
      totWin: 0,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256770857444,
      ID: 15181,
      Date: "12/07/2021 15:21:47",
      channel: "Online",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 2000,
      totWin: 6500,
      product: "Virtual Europa",
      category: "Virtuals",
      username: 256770857444,
      ID: 15180,
      Date: "12/07/2021 15:19:32",
      channel: "Online",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 4000,
      totWin: 8352,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256770857444,
      ID: 15179,
      Date: "12/07/2021 15:18:21",
      channel: "Online",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 1000,
      totWin: 0,
      product: "Virtual Europa",
      category: "Virtuals",
      username: 256770857444,
      ID: 15178,
      Date: "12/07/2021 15:14:27",
      channel: "Online",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 4624,
      totWin: 8624,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256770857444,
      ID: 15177,
      Date: "12/07/2021 13:59:08",
      channel: "Online",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 1000,
      totWin: 0,
      product: "Virtual Europa",
      category: "Virtuals",
      username: 256770857444,
      ID: 15176,
      Date: "12/07/2021 13:53:30",
      channel: "Online",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 2905,
      totWin: 0,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256770857444,
      ID: 15175,
      Date: "12/07/2021 13:52:05",
      channel: "Online",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 1000,
      totWin: 0,
      product: "Virtual Europa",
      category: "Virtuals",
      username: 256770857444,
      ID: 15174,
      Date: "12/07/2021 13:49:24",
      channel: "Online",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 3500,
      totWin: 7905,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256770857444,
      ID: 15173,
      Date: "12/07/2021 13:48:01",
      channel: "Online",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 500,
      totWin: 0,
      product: "Virtual Europa",
      category: "Virtuals",
      username: 256770857444,
      ID: 15172,
      Date: "12/07/2021 13:46:47",
      channel: "Online",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 1000,
      totWin: 0,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256770857444,
      ID: 15171,
      Date: "12/07/2021 13:45:02",
      channel: "Online",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 3750,
      totWin: 9750,
      product: "Virtual Europa",
      category: "Virtuals",
      username: 256770857444,
      ID: 15170,
      Date: "12/07/2021 13:44:10",
      channel: "Online",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 500,
      totWin: 0,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256770857444,
      ID: 15169,
      Date: "12/07/2021 13:41:34",
      channel: "Online",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 500,
      totWin: 0,
      product: "Virtual Europa",
      category: "Virtuals",
      username: 256770857444,
      ID: 15168,
      Date: "12/07/2021 13:40:41",
      channel: "Online",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 1000,
      totWin: 0,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256770857444,
      ID: 15167,
      Date: "12/07/2021 13:39:55",
      channel: "Online",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 2000,
      totWin: 0,
      product: "Virtual Europa",
      category: "Virtuals",
      username: 256770857444,
      ID: 15166,
      Date: "12/07/2021 13:38:26",
      channel: "Online",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 1200,
      totWin: 0,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256770857444,
      ID: 15165,
      Date: "12/07/2021 13:36:14",
      channel: "Online",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 1303.52,
      totWin: 0,
      product: "Virtual Europa",
      category: "Virtuals",
      username: 256770857444,
      ID: 15164,
      Date: "12/07/2021 13:32:57",
      channel: "Online",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 2000,
      totWin: 2200,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256770857444,
      ID: 15163,
      Date: "12/07/2021 13:31:38",
      channel: "Online",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 9384,
      totWin: 16303.52,
      product: "Virtual Europa",
      category: "Virtuals",
      username: 256770857444,
      ID: 15162,
      Date: "12/07/2021 13:30:29",
      channel: "Online",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 1000,
      totWin: 0,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256770857444,
      ID: 15161,
      Date: "12/07/2021 13:29:21",
      channel: "Online",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 1960,
      totWin: 20384,
      product: "Virtual Europa",
      category: "Virtuals",
      username: 256770857444,
      ID: 15160,
      Date: "12/07/2021 13:28:35",
      channel: "Online",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 1000,
      totWin: 0,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256770857444,
      ID: 15159,
      Date: "12/07/2021 13:27:32",
      channel: "Online",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 10000,
      totWin: 12960,
      product: "Virtual Europa",
      category: "Virtuals",
      username: 256770857444,
      ID: 15158,
      Date: "12/07/2021 13:26:29",
      channel: "Online",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 9750,
      totWin: 29750,
      product: "Virtual Europa",
      category: "Virtuals",
      username: 256770857444,
      ID: 15157,
      Date: "12/07/2021 13:22:27",
      channel: "Online",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 11500,
      totWin: 0,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256770857444,
      ID: 15156,
      Date: "12/07/2021 13:17:28",
      channel: "Online",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 1000,
      totWin: 0,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256770857444,
      ID: 15155,
      Date: "12/07/2021 13:12:44",
      channel: "Online",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 13000,
      totWin: 12500,
      product: "Virtual Europa",
      category: "Virtuals",
      username: 256770857444,
      ID: 15154,
      Date: "12/07/2021 13:11:47",
      channel: "Online",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 1200,
      totWin: 0,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256770857444,
      ID: 15153,
      Date: "12/07/2021 13:10:31",
      channel: "Online",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 1000,
      totWin: 0,
      product: "Virtual Europa",
      category: "Virtuals",
      username: 256770857444,
      ID: 15152,
      Date: "12/07/2021 13:09:18",
      channel: "Online",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 11000,
      totWin: 7200,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256770857444,
      ID: 15151,
      Date: "12/07/2021 13:08:37",
      channel: "Online",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 13500,
      totWin: 0,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256770857444,
      ID: 15150,
      Date: "12/07/2021 13:05:56",
      channel: "Online",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 500,
      totWin: 0,
      product: "Virtual Europa",
      category: "Virtuals",
      username: 256770857444,
      ID: 15149,
      Date: "12/07/2021 13:03:28",
      channel: "Online",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 1000,
      totWin: 0,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256770857444,
      ID: 15148,
      Date: "12/07/2021 13:01:05",
      channel: "Online",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 500,
      totWin: 0,
      product: "Virtual Europa",
      category: "Virtuals",
      username: 256770857444,
      ID: 15147,
      Date: "12/07/2021 12:58:49",
      channel: "Online",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 500,
      totWin: 0,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256770857444,
      ID: 15146,
      Date: "12/07/2021 12:57:48",
      channel: "Online",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 1750,
      totWin: 0,
      product: "Virtual Europa",
      category: "Virtuals",
      username: 256770857444,
      ID: 15145,
      Date: "12/07/2021 12:56:43",
      channel: "Online",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 550,
      totWin: 0,
      product: "Virtual Europa",
      category: "Virtuals",
      username: 256770857444,
      ID: 15144,
      Date: "12/07/2021 12:52:53",
      channel: "Online",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 2000,
      totWin: 3250,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256770857444,
      ID: 15143,
      Date: "12/07/2021 12:51:46",
      channel: "Online",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 1600,
      totWin: 11050,
      product: "Virtual Europa",
      category: "Virtuals",
      username: 256770857444,
      ID: 15142,
      Date: "12/07/2021 12:50:20",
      channel: "Online",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 500,
      totWin: 0,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256770857444,
      ID: 15141,
      Date: "12/07/2021 12:49:31",
      channel: "Online",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 500,
      totWin: 5600,
      product: "Virtual Europa",
      category: "Virtuals",
      username: 256770857444,
      ID: 15140,
      Date: "12/07/2021 12:48:29",
      channel: "Online",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 2675,
      totWin: 2175,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256770857444,
      ID: 15139,
      Date: "12/07/2021 12:47:37",
      channel: "Online",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 2000,
      totWin: 0,
      product: "Virtual Europa",
      category: "Virtuals",
      username: 256770857444,
      ID: 15138,
      Date: "12/07/2021 12:44:00",
      channel: "Online",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 500,
      totWin: 0,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256770857444,
      ID: 15137,
      Date: "12/07/2021 12:40:07",
      channel: "Online",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 2000,
      totWin: 0,
      product: "Virtual Europa",
      category: "Virtuals",
      username: 256770857444,
      ID: 15136,
      Date: "12/07/2021 12:34:01",
      channel: "Online",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 3000,
      totWin: 0,
      product: "Virtual Europa",
      category: "Virtuals",
      username: 256770857444,
      ID: 15135,
      Date: "12/07/2021 12:28:42",
      channel: "Online",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 7510,
      totWin: 4000,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256770857444,
      ID: 15134,
      Date: "12/07/2021 12:26:11",
      channel: "Online",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 3500,
      totWin: 3510,
      product: "Virtual World Cup",
      category: "Virtuals",
      username: 256770857444,
      ID: 15133,
      Date: "12/07/2021 12:17:22",
      channel: "Online",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 3000,
      totWin: 0,
      product: "Virtual Europa",
      category: "Virtuals",
      username: 256770857444,
      ID: 15132,
      Date: "12/07/2021 12:12:55",
      channel: "Online",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 2000,
      totWin: 3500,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256770857444,
      ID: 15131,
      Date: "12/07/2021 12:11:45",
      channel: "Online",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 500,
      totWin: 0,
      product: "Virtual Europa",
      category: "Virtuals",
      username: 256770857444,
      ID: 15130,
      Date: "12/07/2021 12:10:08",
      channel: "Online",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 1000,
      totWin: 0,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256770857444,
      ID: 15129,
      Date: "12/07/2021 12:09:32",
      channel: "Online",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 2000,
      totWin: 6500,
      product: "Virtual Europa",
      category: "Virtuals",
      username: 256770857444,
      ID: 15128,
      Date: "12/07/2021 12:08:39",
      channel: "Online",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 1000,
      totWin: 0,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256770857444,
      ID: 15127,
      Date: "12/07/2021 12:08:00",
      channel: "Online",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 5000,
      totWin: 0,
      product: "Virtual Europa",
      category: "Virtuals",
      username: 256770857444,
      ID: 15126,
      Date: "12/07/2021 12:07:23",
      channel: "Online",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 1000,
      totWin: 0,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256770857444,
      ID: 15125,
      Date: "12/07/2021 12:05:33",
      channel: "Online",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 1000,
      totWin: 0,
      product: "Virtual Europa",
      category: "Virtuals",
      username: 256770857444,
      ID: 15124,
      Date: "12/07/2021 12:04:16",
      channel: "Online",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 7000,
      totWin: 0,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256770857444,
      ID: 15123,
      Date: "12/07/2021 12:03:36",
      channel: "Online",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 1000,
      totWin: 0,
      product: "Virtual Europa",
      category: "Virtuals",
      username: 256770857444,
      ID: 15122,
      Date: "12/07/2021 12:01:20",
      channel: "Online",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 1000,
      totWin: 0,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256770857444,
      ID: 15121,
      Date: "12/07/2021 12:00:11",
      channel: "Online",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 1000,
      totWin: 0,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256770857444,
      ID: 15120,
      Date: "12/07/2021 11:58:20",
      channel: "Online",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 2750,
      totWin: 3750,
      product: "Virtual Europa",
      category: "Virtuals",
      username: 256770857444,
      ID: 15119,
      Date: "12/07/2021 11:56:28",
      channel: "Online",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 1000,
      totWin: 0,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256770857444,
      ID: 15118,
      Date: "12/07/2021 11:53:49",
      channel: "Online",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 3250,
      totWin: 3250,
      product: "Virtual Europa",
      category: "Virtuals",
      username: 256770857444,
      ID: 15117,
      Date: "12/07/2021 11:52:28",
      channel: "Online",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 1168,
      totWin: 0,
      product: "Virtual Europa",
      category: "Virtuals",
      username: 256770857444,
      ID: 15116,
      Date: "12/07/2021 11:48:47",
      channel: "Online",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 2000,
      totWin: 3168,
      product: "Virtual Europa",
      category: "Virtuals",
      username: 256770857444,
      ID: 15115,
      Date: "12/07/2021 11:45:53",
      channel: "Online",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 1000,
      totWin: 0,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256770857444,
      ID: 15114,
      Date: "12/07/2021 11:43:46",
      channel: "Online",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 6000,
      totWin: 0,
      product: "Virtual Europa",
      category: "Virtuals",
      username: 256770857444,
      ID: 15113,
      Date: "12/07/2021 11:42:16",
      channel: "Online",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 1000,
      totWin: 0,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256770857444,
      ID: 15112,
      Date: "12/07/2021 11:39:59",
      channel: "Online",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 1000,
      totWin: 0,
      product: "Virtual Europa",
      category: "Virtuals",
      username: 256770857444,
      ID: 15111,
      Date: "12/07/2021 11:38:15",
      channel: "Online",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 1000,
      totWin: 0,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256770857444,
      ID: 15110,
      Date: "12/07/2021 11:35:27",
      channel: "Online",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 500,
      totWin: 0,
      product: "Virtual Europa",
      category: "Virtuals",
      username: 256770857444,
      ID: 15109,
      Date: "12/07/2021 11:34:21",
      channel: "Online",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 500,
      totWin: 0,
      product: "Virtual Europa",
      category: "Virtuals",
      username: 256770857444,
      ID: 15108,
      Date: "12/07/2021 11:32:55",
      channel: "Online",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 4000,
      totWin: 5000,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256770857444,
      ID: 15107,
      Date: "12/07/2021 11:31:43",
      channel: "Online",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 3000,
      totWin: 0,
      product: "Virtual Europa",
      category: "Virtuals",
      username: 256770857444,
      ID: 15106,
      Date: "12/07/2021 11:30:34",
      channel: "Online",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 1525,
      totWin: 5525,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256770857444,
      ID: 15105,
      Date: "12/07/2021 11:27:42",
      channel: "Online",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 1800,
      totWin: 0,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256770857444,
      ID: 15104,
      Date: "12/07/2021 11:24:29",
      channel: "Online",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 1000,
      totWin: 0,
      product: "Virtual Europa",
      category: "Virtuals",
      username: 256770857444,
      ID: 15103,
      Date: "12/07/2021 11:20:27",
      channel: "Online",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 4000,
      totWin: 10800,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256770857444,
      ID: 15102,
      Date: "12/07/2021 11:18:16",
      channel: "Online",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 2635,
      totWin: 2635,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256770857444,
      ID: 15101,
      Date: "12/07/2021 11:14:14",
      channel: "Online",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 2000,
      totWin: 0,
      product: "Virtual Europa",
      category: "Virtuals",
      username: 256770857444,
      ID: 15100,
      Date: "12/07/2021 11:02:20",
      channel: "Online",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 1000,
      totWin: 0,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256770857444,
      ID: 15099,
      Date: "12/07/2021 10:59:39",
      channel: "Online",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 3000,
      totWin: 0,
      product: "Virtual Europa",
      category: "Virtuals",
      username: 256770857444,
      ID: 15098,
      Date: "12/07/2021 10:58:40",
      channel: "Online",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 5000,
      totWin: 0,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256770857444,
      ID: 15097,
      Date: "12/07/2021 10:53:09",
      channel: "Online",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 2360,
      totWin: 0,
      product: "Virtual Europa",
      category: "Virtuals",
      username: 256770857444,
      ID: 15096,
      Date: "12/07/2021 10:50:21",
      channel: "Online",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 2000,
      totWin: 0,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256770857444,
      ID: 15095,
      Date: "12/07/2021 10:47:48",
      channel: "Online",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 2000,
      totWin: 9360,
      product: "Virtual Europa",
      category: "Virtuals",
      username: 256770857444,
      ID: 15094,
      Date: "12/07/2021 10:44:48",
      channel: "Online",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 500,
      totWin: 0,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256770857444,
      ID: 15093,
      Date: "12/07/2021 10:42:13",
      channel: "Online",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 15092,
      Date: "12/07/2021 06:08:21",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 15091,
      Date: "12/07/2021 06:07:57",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 15090,
      Date: "12/07/2021 06:07:36",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 15089,
      Date: "12/07/2021 06:07:13",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 9500,
      totWin: 6950,
      product: "Virtual Football Pro",
      category: "Virtuals",
      username: 256780850357,
      ID: 15088,
      Date: "12/07/2021 08:18:20",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 2500,
      totWin: 0,
      product: "Virtual Football Pro",
      category: "Virtuals",
      username: 256780850357,
      ID: 15087,
      Date: "12/07/2021 07:52:07",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 13750,
      totWin: 11750,
      product: "Storming Flame",
      category: "Casino",
      username: 256789156900,
      ID: 15086,
      Date: "11/07/2021 23:55:22",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 4000,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 15085,
      Date: "11/07/2021 20:11:50",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 4000,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 15084,
      Date: "11/07/2021 20:10:48",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 15083,
      Date: "11/07/2021 20:10:02",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 15082,
      Date: "11/07/2021 20:09:38",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 15081,
      Date: "11/07/2021 20:09:17",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 15080,
      Date: "11/07/2021 20:08:53",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 15079,
      Date: "11/07/2021 20:08:29",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 15078,
      Date: "11/07/2021 20:06:57",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 15077,
      Date: "11/07/2021 20:06:36",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 15076,
      Date: "11/07/2021 20:04:56",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 15075,
      Date: "11/07/2021 20:03:33",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 2000,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 15074,
      Date: "11/07/2021 20:02:50",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 15073,
      Date: "11/07/2021 19:16:10",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 15072,
      Date: "11/07/2021 19:15:40",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 15071,
      Date: "11/07/2021 19:14:49",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 7500,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 15070,
      Date: "11/07/2021 19:14:03",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 15069,
      Date: "11/07/2021 19:13:31",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 15068,
      Date: "11/07/2021 19:13:07",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 15067,
      Date: "11/07/2021 19:11:38",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 7500,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 15066,
      Date: "11/07/2021 19:10:07",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 15065,
      Date: "11/07/2021 18:58:05",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 15064,
      Date: "11/07/2021 18:56:06",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 2500,
      totWin: 5477.5,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256775478737,
      ID: 15063,
      Date: "11/07/2021 21:02:41",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 200,
      totWin: 0,
      product: "Star Cash",
      category: "Casino",
      username: 256788081037,
      ID: 15062,
      Date: "11/07/2021 20:38:40",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 500,
      totWin: 0,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256775478737,
      ID: 15061,
      Date: "11/07/2021 20:37:42",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 54750,
      totWin: 54930,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256775478737,
      ID: 15060,
      Date: "11/07/2021 20:30:11",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 10000,
      totWin: 6199.5,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256775478737,
      ID: 15059,
      Date: "11/07/2021 18:22:07",
      channel: "n/a",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 1000,
      totWin: 3500,
      product: "Virtual Europa",
      category: "Virtuals",
      username: 256770857444,
      ID: 15058,
      Date: "11/07/2021 18:08:05",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 1000,
      totWin: 0,
      product: "Virtual Europa",
      category: "Virtuals",
      username: 256770857444,
      ID: 15057,
      Date: "11/07/2021 18:06:09",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 720,
      totWin: 0,
      product: "Virtual Europa",
      category: "Virtuals",
      username: 256770857444,
      ID: 15056,
      Date: "11/07/2021 17:58:37",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 3000,
      totWin: 2720,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256770857444,
      ID: 15055,
      Date: "11/07/2021 17:57:10",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 1000,
      totWin: 0,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256770857444,
      ID: 15054,
      Date: "11/07/2021 17:54:19",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 1400,
      totWin: 0,
      product: "Virtual Europa",
      category: "Virtuals",
      username: 256770857444,
      ID: 15053,
      Date: "11/07/2021 17:53:08",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 1000,
      totWin: 5400,
      product: "Virtual Europa",
      category: "Virtuals",
      username: 256770857444,
      ID: 15052,
      Date: "11/07/2021 17:49:34",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 1750,
      totWin: 3750,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256770857444,
      ID: 15051,
      Date: "11/07/2021 17:45:13",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 1000,
      totWin: 0,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256770857444,
      ID: 15050,
      Date: "11/07/2021 17:40:18",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 5000,
      totWin: 0,
      product: "Virtual Europa",
      category: "Virtuals",
      username: 256770857444,
      ID: 15049,
      Date: "11/07/2021 17:30:57",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 1000,
      totWin: 0,
      product: "Virtual Europa",
      category: "Virtuals",
      username: 256770857444,
      ID: 15048,
      Date: "11/07/2021 17:28:14",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 500,
      totWin: 0,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256770857444,
      ID: 15047,
      Date: "11/07/2021 17:26:45",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 500,
      totWin: 0,
      product: "Virtual Europa",
      category: "Virtuals",
      username: 256770857444,
      ID: 15046,
      Date: "11/07/2021 17:23:48",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 5000,
      totWin: 0,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256770857444,
      ID: 15045,
      Date: "11/07/2021 17:20:29",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 500,
      totWin: 0,
      product: "Virtual Europa",
      category: "Virtuals",
      username: 256770857444,
      ID: 15044,
      Date: "11/07/2021 17:09:59",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 1740,
      totWin: 10240,
      product: "Virtual Europa",
      category: "Virtuals",
      username: 256770857444,
      ID: 15043,
      Date: "11/07/2021 16:50:46",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 1000,
      totWin: 0,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256770857444,
      ID: 15042,
      Date: "11/07/2021 16:47:27",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 1000,
      totWin: 0,
      product: "Virtual Europa",
      category: "Virtuals",
      username: 256770857444,
      ID: 15041,
      Date: "11/07/2021 16:46:47",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 1000,
      totWin: 0,
      product: "Virtual Europa",
      category: "Virtuals",
      username: 256770857444,
      ID: 15040,
      Date: "11/07/2021 16:44:55",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 1000,
      totWin: 0,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256770857444,
      ID: 15039,
      Date: "11/07/2021 16:43:43",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 1000,
      totWin: 0,
      product: "Virtual Europa",
      category: "Virtuals",
      username: 256770857444,
      ID: 15038,
      Date: "11/07/2021 16:42:13",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 2507.6,
      totWin: 6507.6,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256770857444,
      ID: 15037,
      Date: "11/07/2021 16:40:40",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 1887.5,
      totWin: 4387.5,
      product: "Virtual Europa",
      category: "Virtuals",
      username: 256770857444,
      ID: 15036,
      Date: "11/07/2021 16:30:34",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 500,
      totWin: 0,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256770857444,
      ID: 15035,
      Date: "11/07/2021 16:27:56",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 1000,
      totWin: 0,
      product: "Virtual Europa",
      category: "Virtuals",
      username: 256770857444,
      ID: 15034,
      Date: "11/07/2021 16:26:13",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 1000,
      totWin: 0,
      product: "Virtual Europa",
      category: "Virtuals",
      username: 256770857444,
      ID: 15033,
      Date: "11/07/2021 16:25:07",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 1227.59,
      totWin: 0,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256770857444,
      ID: 15032,
      Date: "11/07/2021 16:23:26",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 2304.3,
      totWin: 18227.59,
      product: "Virtual Europa",
      category: "Virtuals",
      username: 256770857444,
      ID: 15031,
      Date: "11/07/2021 15:44:50",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 1000,
      totWin: 0,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256770857444,
      ID: 15030,
      Date: "11/07/2021 15:42:15",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 4700,
      totWin: 6004.3,
      product: "Virtual Europa",
      category: "Virtuals",
      username: 256770857444,
      ID: 15029,
      Date: "11/07/2021 15:40:37",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 2000,
      totWin: 0,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256770857444,
      ID: 15028,
      Date: "11/07/2021 15:31:28",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 1000,
      totWin: 0,
      product: "Virtual Europa",
      category: "Virtuals",
      username: 256770857444,
      ID: 15027,
      Date: "11/07/2021 15:30:14",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 2375,
      totWin: 0,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256770857444,
      ID: 15026,
      Date: "11/07/2021 15:29:24",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 3000,
      totWin: 0,
      product: "Virtual Europa",
      category: "Virtuals",
      username: 256770857444,
      ID: 15025,
      Date: "11/07/2021 15:27:29",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 2000,
      totWin: 11375,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256770857444,
      ID: 15024,
      Date: "11/07/2021 15:25:50",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 1000,
      totWin: 0,
      product: "Virtual Europa",
      category: "Virtuals",
      username: 256770857444,
      ID: 15023,
      Date: "11/07/2021 15:24:01",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 5000,
      totWin: 0,
      product: "Virtual Europa",
      category: "Virtuals",
      username: 256770857444,
      ID: 15022,
      Date: "11/07/2021 15:21:20",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 1000,
      totWin: 0,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256770857444,
      ID: 15021,
      Date: "11/07/2021 15:20:20",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 3280,
      totWin: 2900,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256770857444,
      ID: 15020,
      Date: "11/07/2021 15:18:31",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 2330,
      totWin: 2380,
      product: "Virtual Europa",
      category: "Virtuals",
      username: 256770857444,
      ID: 15019,
      Date: "11/07/2021 15:13:26",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 1000,
      totWin: 8330,
      product: "Virtual Europa",
      category: "Virtuals",
      username: 256770857444,
      ID: 15018,
      Date: "11/07/2021 15:11:42",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 750,
      totWin: 0,
      product: "Virtual Europa",
      category: "Virtuals",
      username: 256770857444,
      ID: 15017,
      Date: "11/07/2021 15:08:02",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 1000,
      totWin: 0,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256770857444,
      ID: 15016,
      Date: "11/07/2021 15:06:01",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 2000,
      totWin: 1750,
      product: "Virtual Europa",
      category: "Virtuals",
      username: 256770857444,
      ID: 15015,
      Date: "11/07/2021 15:04:34",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 2040.8,
      totWin: 0,
      product: "Virtual Europa",
      category: "Virtuals",
      username: 256770857444,
      ID: 15014,
      Date: "11/07/2021 14:58:50",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 3448,
      totWin: 3040.8,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256770857444,
      ID: 15013,
      Date: "11/07/2021 14:52:10",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 1000,
      totWin: 0,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256770857444,
      ID: 15012,
      Date: "11/07/2021 14:49:52",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 1000,
      totWin: 2448,
      product: "Virtual Europa",
      category: "Virtuals",
      username: 256770857444,
      ID: 15011,
      Date: "11/07/2021 14:48:54",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 2300,
      totWin: 0,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256770857444,
      ID: 15010,
      Date: "11/07/2021 14:47:36",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 1000,
      totWin: 6300,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256770857444,
      ID: 15009,
      Date: "11/07/2021 14:44:24",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 500,
      totWin: 0,
      product: "Virtual Europa",
      category: "Virtuals",
      username: 256770857444,
      ID: 15008,
      Date: "11/07/2021 14:43:16",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 500,
      totWin: 0,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256770857444,
      ID: 15007,
      Date: "11/07/2021 14:42:15",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 6000,
      totWin: 7000,
      product: "Virtual Europa",
      category: "Virtuals",
      username: 256770857444,
      ID: 15006,
      Date: "11/07/2021 14:41:22",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 2020,
      totWin: 0,
      product: "Virtual Europa",
      category: "Virtuals",
      username: 256770857444,
      ID: 15005,
      Date: "11/07/2021 14:34:48",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 4000,
      totWin: 11520,
      product: "Virtual Europa",
      category: "Virtuals",
      username: 256770857444,
      ID: 15004,
      Date: "11/07/2021 14:32:36",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 4000,
      totWin: 10500,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256770857444,
      ID: 15003,
      Date: "11/07/2021 14:31:52",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 1000,
      totWin: 0,
      product: "Virtual Europa",
      category: "Virtuals",
      username: 256770857444,
      ID: 15002,
      Date: "11/07/2021 14:30:46",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 685,
      totWin: 0,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256770857444,
      ID: 15001,
      Date: "11/07/2021 14:30:02",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 1000,
      totWin: 0,
      product: "Virtual Europa",
      category: "Virtuals",
      username: 256770857444,
      ID: 15000,
      Date: "11/07/2021 14:28:19",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 1000,
      totWin: 6685,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256770857444,
      ID: 14999,
      Date: "11/07/2021 14:26:27",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 2665,
      totWin: 4165,
      product: "Virtual Europa",
      category: "Virtuals",
      username: 256770857444,
      ID: 14998,
      Date: "11/07/2021 14:24:27",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 500,
      totWin: 0,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256770857444,
      ID: 14997,
      Date: "11/07/2021 14:20:06",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 1300,
      totWin: 0,
      product: "Virtual World Cup",
      category: "Virtuals",
      username: 256770857444,
      ID: 14996,
      Date: "11/07/2021 14:18:21",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 2000,
      totWin: 3800,
      product: "Virtual Europa",
      category: "Virtuals",
      username: 256770857444,
      ID: 14995,
      Date: "11/07/2021 14:12:45",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 1750.4,
      totWin: 3500,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256770857444,
      ID: 14994,
      Date: "11/07/2021 14:11:56",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 1000,
      totWin: 0,
      product: "Virtual Europa",
      category: "Virtuals",
      username: 256770857444,
      ID: 14993,
      Date: "11/07/2021 14:10:22",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 500,
      totWin: 2750.4,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256770857444,
      ID: 14992,
      Date: "11/07/2021 14:09:28",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 500,
      totWin: 0,
      product: "Virtual Europa",
      category: "Virtuals",
      username: 256770857444,
      ID: 14991,
      Date: "11/07/2021 14:08:52",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 819,
      totWin: 0,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256770857444,
      ID: 14990,
      Date: "11/07/2021 14:07:38",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 5756,
      totWin: 0,
      product: "Virtual Europa",
      category: "Virtuals",
      username: 256770857444,
      ID: 14989,
      Date: "11/07/2021 14:06:16",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 1000,
      totWin: 0,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256770857444,
      ID: 14988,
      Date: "11/07/2021 14:04:06",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 2100,
      totWin: 3575,
      product: "Virtual Europa",
      category: "Virtuals",
      username: 256770857444,
      ID: 14987,
      Date: "11/07/2021 14:02:24",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 1000,
      totWin: 0,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256770857444,
      ID: 14986,
      Date: "11/07/2021 14:00:14",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 1500,
      totWin: 3100,
      product: "Virtual Europa",
      category: "Virtuals",
      username: 256770857444,
      ID: 14985,
      Date: "11/07/2021 13:58:29",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 1500,
      totWin: 0,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256770857444,
      ID: 14984,
      Date: "11/07/2021 13:57:09",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 1000,
      totWin: 0,
      product: "Virtual Europa",
      category: "Virtuals",
      username: 256770857444,
      ID: 14983,
      Date: "11/07/2021 13:52:14",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 500,
      totWin: 0,
      product: "Virtual World Cup",
      category: "Virtuals",
      username: 256770857444,
      ID: 14982,
      Date: "11/07/2021 13:51:18",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 500,
      totWin: 0,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256770857444,
      ID: 14981,
      Date: "11/07/2021 13:50:07",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 500,
      totWin: 0,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256770857444,
      ID: 14980,
      Date: "11/07/2021 13:42:03",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 4250,
      totWin: 3500,
      product: "Virtual Europa",
      category: "Virtuals",
      username: 256770857444,
      ID: 14979,
      Date: "11/07/2021 13:40:18",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 1000,
      totWin: 0,
      product: "Virtual Europa",
      category: "Virtuals",
      username: 256770857444,
      ID: 14978,
      Date: "11/07/2021 13:32:51",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 3000,
      totWin: 2250,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256770857444,
      ID: 14977,
      Date: "11/07/2021 13:32:15",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 1000,
      totWin: 0,
      product: "Virtual Europa",
      category: "Virtuals",
      username: 256770857444,
      ID: 14976,
      Date: "11/07/2021 13:28:29",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 2284,
      totWin: 4284,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256770857444,
      ID: 14975,
      Date: "11/07/2021 13:23:27",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 1000,
      totWin: 0,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256770857444,
      ID: 14974,
      Date: "11/07/2021 13:18:20",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 500,
      totWin: 0,
      product: "Virtual Europa",
      category: "Virtuals",
      username: 256770857444,
      ID: 14973,
      Date: "11/07/2021 13:16:59",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 1380,
      totWin: 0,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256770857444,
      ID: 14972,
      Date: "11/07/2021 13:16:29",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 2000,
      totWin: 2880,
      product: "Virtual Europa",
      category: "Virtuals",
      username: 256770857444,
      ID: 14971,
      Date: "11/07/2021 13:12:08",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 1125,
      totWin: 0,
      product: "Virtual Europa",
      category: "Virtuals",
      username: 256770857444,
      ID: 14970,
      Date: "11/07/2021 13:09:52",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 500,
      totWin: 0,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256770857444,
      ID: 14969,
      Date: "11/07/2021 13:08:58",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 500,
      totWin: 6125,
      product: "Virtual Europa",
      category: "Virtuals",
      username: 256770857444,
      ID: 14968,
      Date: "11/07/2021 13:07:48",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 1000,
      totWin: 0,
      product: "Virtual Europa",
      category: "Virtuals",
      username: 256770857444,
      ID: 14967,
      Date: "11/07/2021 13:06:33",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 1000,
      totWin: 0,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256770857444,
      ID: 14966,
      Date: "11/07/2021 13:03:51",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 500,
      totWin: 0,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256770857444,
      ID: 14965,
      Date: "11/07/2021 13:00:08",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 700,
      totWin: 0,
      product: "Virtual Europa",
      category: "Virtuals",
      username: 256770857444,
      ID: 14964,
      Date: "11/07/2021 12:58:40",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 5200,
      totWin: 16900,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256770857444,
      ID: 14963,
      Date: "11/07/2021 12:52:42",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 500,
      totWin: 0,
      product: "Virtual Europa",
      category: "Virtuals",
      username: 256770857444,
      ID: 14962,
      Date: "11/07/2021 12:51:47",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 880,
      totWin: 0,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256770857444,
      ID: 14961,
      Date: "11/07/2021 12:50:30",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 1000,
      totWin: 0,
      product: "Virtual World Cup",
      category: "Virtuals",
      username: 256770857444,
      ID: 14960,
      Date: "11/07/2021 12:49:09",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 1000,
      totWin: 2880,
      product: "Virtual Europa",
      category: "Virtuals",
      username: 256770857444,
      ID: 14959,
      Date: "11/07/2021 12:48:21",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 1000,
      totWin: 0,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256770857444,
      ID: 14958,
      Date: "11/07/2021 12:47:30",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 1000,
      totWin: 0,
      product: "Virtual World Cup",
      category: "Virtuals",
      username: 256770857444,
      ID: 14957,
      Date: "11/07/2021 12:46:50",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 1000,
      totWin: 0,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256770857444,
      ID: 14956,
      Date: "11/07/2021 12:45:43",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 1018.2,
      totWin: 14018.2,
      product: "Virtual Europa",
      category: "Virtuals",
      username: 256770857444,
      ID: 14955,
      Date: "11/07/2021 12:44:50",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 14954,
      Date: "11/07/2021 09:37:43",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 14953,
      Date: "11/07/2021 09:37:07",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 1000,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 14952,
      Date: "11/07/2021 09:36:46",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 14951,
      Date: "11/07/2021 09:36:27",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 14950,
      Date: "11/07/2021 09:36:09",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 14949,
      Date: "11/07/2021 09:35:55",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 1000,
      totWin: 0,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256770857444,
      ID: 14948,
      Date: "11/07/2021 12:35:42",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 1000,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 14947,
      Date: "11/07/2021 09:35:33",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 14946,
      Date: "11/07/2021 09:35:00",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 14945,
      Date: "11/07/2021 09:34:43",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 14944,
      Date: "11/07/2021 09:34:27",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 1854.4,
      totWin: 6854.4,
      product: "Virtual Europa",
      category: "Virtuals",
      username: 256770857444,
      ID: 14943,
      Date: "11/07/2021 12:34:21",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 14942,
      Date: "11/07/2021 09:34:08",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 14941,
      Date: "11/07/2021 09:33:52",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 1000,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 14940,
      Date: "11/07/2021 09:33:02",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 1000,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 14939,
      Date: "11/07/2021 09:32:25",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 14938,
      Date: "11/07/2021 09:32:08",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 14937,
      Date: "11/07/2021 09:31:53",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 500,
      totWin: 0,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256770857444,
      ID: 14936,
      Date: "11/07/2021 12:31:51",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 14935,
      Date: "11/07/2021 09:31:37",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 14934,
      Date: "11/07/2021 09:31:21",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 14933,
      Date: "11/07/2021 09:31:03",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 14932,
      Date: "11/07/2021 09:30:47",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 837.2,
      totWin: 0,
      product: "Virtual Europa",
      category: "Virtuals",
      username: 256770857444,
      ID: 14931,
      Date: "11/07/2021 12:30:46",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 14930,
      Date: "11/07/2021 09:30:32",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 14929,
      Date: "11/07/2021 09:30:14",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 2500,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 14928,
      Date: "11/07/2021 09:29:55",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 14927,
      Date: "11/07/2021 09:29:37",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 14926,
      Date: "11/07/2021 09:28:44",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 1000,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 14925,
      Date: "11/07/2021 09:28:25",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 14924,
      Date: "11/07/2021 09:28:10",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 14923,
      Date: "11/07/2021 09:27:50",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 4000,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 14922,
      Date: "11/07/2021 09:27:21",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 14921,
      Date: "11/07/2021 09:27:02",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 1000,
      totWin: 4147.2,
      product: "Virtual Europa",
      category: "Virtuals",
      username: 256770857444,
      ID: 14920,
      Date: "11/07/2021 12:26:35",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 1000,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 14919,
      Date: "11/07/2021 09:26:22",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 2000,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 14918,
      Date: "11/07/2021 09:26:04",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 2500,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 14917,
      Date: "11/07/2021 09:25:42",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 2188,
      totWin: 1190,
      product: "Virtual World Cup",
      category: "Virtuals",
      username: 256770857444,
      ID: 14916,
      Date: "11/07/2021 12:25:37",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 3100,
      totWin: 3744,
      product: "Virtual World Cup",
      category: "Virtuals",
      username: 256770857444,
      ID: 14915,
      Date: "11/07/2021 12:23:30",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 14914,
      Date: "11/07/2021 09:23:20",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 14913,
      Date: "11/07/2021 09:23:04",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 14912,
      Date: "11/07/2021 09:22:44",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 14911,
      Date: "11/07/2021 09:22:06",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 1000,
      totWin: 10944,
      product: "Virtual Europa",
      category: "Virtuals",
      username: 256770857444,
      ID: 14910,
      Date: "11/07/2021 12:21:49",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 14909,
      Date: "11/07/2021 09:21:47",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 14908,
      Date: "11/07/2021 09:21:30",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 14907,
      Date: "11/07/2021 09:21:13",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 2000,
      totWin: 1600,
      product: "Virtual World Cup",
      category: "Virtuals",
      username: 256770857444,
      ID: 14906,
      Date: "11/07/2021 12:21:12",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 14905,
      Date: "11/07/2021 09:20:55",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 14904,
      Date: "11/07/2021 09:20:35",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 4000,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 14903,
      Date: "11/07/2021 09:20:08",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 14902,
      Date: "11/07/2021 09:19:33",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 14901,
      Date: "11/07/2021 09:18:59",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 1000,
      totWin: 0,
      product: "Virtual Europa",
      category: "Virtuals",
      username: 256770857444,
      ID: 14900,
      Date: "11/07/2021 12:18:41",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 14899,
      Date: "11/07/2021 09:18:37",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 1000,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 14898,
      Date: "11/07/2021 09:18:14",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 500,
      totWin: 0,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256770857444,
      ID: 14897,
      Date: "11/07/2021 12:17:52",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 14896,
      Date: "11/07/2021 09:17:35",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 14895,
      Date: "11/07/2021 09:17:19",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 14894,
      Date: "11/07/2021 09:16:46",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 14893,
      Date: "11/07/2021 09:16:29",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 500,
      totWin: 0,
      product: "Virtual Europa",
      category: "Virtuals",
      username: 256770857444,
      ID: 14892,
      Date: "11/07/2021 12:16:26",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 14891,
      Date: "11/07/2021 09:15:53",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 500,
      totWin: 0,
      product: "Virtual World Cup",
      category: "Virtuals",
      username: 256770857444,
      ID: 14890,
      Date: "11/07/2021 12:15:50",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 14889,
      Date: "11/07/2021 09:15:34",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 14888,
      Date: "11/07/2021 09:14:58",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 1000,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 14887,
      Date: "11/07/2021 09:14:39",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 2500,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 14886,
      Date: "11/07/2021 09:14:21",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 1000,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 14885,
      Date: "11/07/2021 09:13:44",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 1000,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 14884,
      Date: "11/07/2021 09:13:27",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 14883,
      Date: "11/07/2021 09:13:12",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 14882,
      Date: "11/07/2021 09:12:52",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 14881,
      Date: "11/07/2021 09:12:35",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 14880,
      Date: "11/07/2021 09:12:15",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 14879,
      Date: "11/07/2021 09:11:52",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 2000,
      totWin: 3500,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256770857444,
      ID: 14878,
      Date: "11/07/2021 12:11:49",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 14877,
      Date: "11/07/2021 09:11:34",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 14876,
      Date: "11/07/2021 09:11:17",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 500,
      totWin: 0,
      product: "Virtual Europa",
      category: "Virtuals",
      username: 256770857444,
      ID: 14875,
      Date: "11/07/2021 12:10:34",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 2500,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 14874,
      Date: "11/07/2021 09:10:33",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 500,
      totWin: 0,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256770857444,
      ID: 14873,
      Date: "11/07/2021 12:09:42",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 1350,
      totWin: 0,
      product: "Virtual Europa",
      category: "Virtuals",
      username: 256770857444,
      ID: 14872,
      Date: "11/07/2021 12:08:34",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 500,
      totWin: 0,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256770857444,
      ID: 14871,
      Date: "11/07/2021 12:07:53",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 2500,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 14870,
      Date: "11/07/2021 09:07:25",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 500,
      totWin: 2850,
      product: "Virtual Europa",
      category: "Virtuals",
      username: 256770857444,
      ID: 14869,
      Date: "11/07/2021 12:06:39",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 500,
      totWin: 0,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256770857444,
      ID: 14868,
      Date: "11/07/2021 12:05:54",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 1000,
      totWin: 0,
      product: "Virtual Europa",
      category: "Virtuals",
      username: 256770857444,
      ID: 14867,
      Date: "11/07/2021 12:04:03",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 500,
      totWin: 0,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256770857444,
      ID: 14866,
      Date: "11/07/2021 12:01:51",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 14865,
      Date: "11/07/2021 09:01:29",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 14864,
      Date: "11/07/2021 09:01:09",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 14863,
      Date: "11/07/2021 09:01:04",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 14862,
      Date: "11/07/2021 09:00:44",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 1500,
      totWin: 0,
      product: "Virtual Europa",
      category: "Virtuals",
      username: 256770857444,
      ID: 14861,
      Date: "11/07/2021 12:00:31",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 14860,
      Date: "11/07/2021 09:00:22",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 14859,
      Date: "11/07/2021 09:00:05",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 14858,
      Date: "11/07/2021 08:59:45",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 14857,
      Date: "11/07/2021 08:59:06",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 14856,
      Date: "11/07/2021 08:58:44",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 14855,
      Date: "11/07/2021 08:58:28",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 3050,
      totWin: 1550,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256770857444,
      ID: 14854,
      Date: "11/07/2021 11:57:58",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 14853,
      Date: "11/07/2021 08:57:24",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 14852,
      Date: "11/07/2021 08:57:08",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 14851,
      Date: "11/07/2021 08:56:09",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 14850,
      Date: "11/07/2021 08:55:49",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 500,
      totWin: 0,
      product: "Virtual Europa",
      category: "Virtuals",
      username: 256770857444,
      ID: 14849,
      Date: "11/07/2021 11:52:38",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 14848,
      Date: "11/07/2021 08:52:37",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 14847,
      Date: "11/07/2021 08:52:01",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 1125,
      totWin: 0,
      product: "Virtual Europa",
      category: "Virtuals",
      username: 256770857444,
      ID: 14846,
      Date: "11/07/2021 11:51:55",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 14845,
      Date: "11/07/2021 08:51:39",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 14844,
      Date: "11/07/2021 08:51:19",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 1000,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 14843,
      Date: "11/07/2021 08:50:55",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 14842,
      Date: "11/07/2021 08:50:38",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 14841,
      Date: "11/07/2021 08:49:55",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 14840,
      Date: "11/07/2021 08:49:39",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 14839,
      Date: "11/07/2021 08:48:54",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 1000,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 14838,
      Date: "11/07/2021 08:48:34",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 14837,
      Date: "11/07/2021 08:48:11",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 2500,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 14836,
      Date: "11/07/2021 08:47:48",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 14835,
      Date: "11/07/2021 08:47:08",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 14834,
      Date: "11/07/2021 08:46:49",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 14833,
      Date: "11/07/2021 08:43:54",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 2500,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 14832,
      Date: "11/07/2021 08:42:11",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 14831,
      Date: "11/07/2021 08:41:29",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 14830,
      Date: "11/07/2021 08:40:47",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 14829,
      Date: "11/07/2021 08:40:27",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 14828,
      Date: "11/07/2021 08:40:02",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 14827,
      Date: "11/07/2021 08:21:56",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 17530,
      totWin: 14276,
      product: "Virtual Football Pro",
      category: "Virtuals",
      username: 256780850357,
      ID: 14826,
      Date: "11/07/2021 11:21:39",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 14825,
      Date: "11/07/2021 08:21:25",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 14824,
      Date: "11/07/2021 08:20:50",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 14823,
      Date: "11/07/2021 08:19:29",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 14822,
      Date: "11/07/2021 08:19:09",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 14821,
      Date: "11/07/2021 08:18:42",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 14820,
      Date: "11/07/2021 08:18:16",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 1000,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 14819,
      Date: "11/07/2021 08:17:54",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 14818,
      Date: "11/07/2021 08:17:06",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 14817,
      Date: "11/07/2021 08:16:41",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 2500,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 14816,
      Date: "11/07/2021 08:15:55",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 14815,
      Date: "11/07/2021 08:15:05",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 2500,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 14814,
      Date: "11/07/2021 08:13:46",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 14813,
      Date: "11/07/2021 08:13:15",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 14812,
      Date: "11/07/2021 08:12:57",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 14811,
      Date: "11/07/2021 08:12:06",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 14810,
      Date: "11/07/2021 08:11:48",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 14809,
      Date: "11/07/2021 08:11:30",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 14808,
      Date: "11/07/2021 08:11:10",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 2000,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 14807,
      Date: "11/07/2021 08:10:47",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 14806,
      Date: "11/07/2021 08:10:12",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 14805,
      Date: "11/07/2021 08:09:54",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 14804,
      Date: "11/07/2021 08:09:35",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 14803,
      Date: "11/07/2021 08:09:18",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 14802,
      Date: "11/07/2021 08:08:59",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 14801,
      Date: "11/07/2021 08:08:16",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 2000,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 14800,
      Date: "11/07/2021 08:07:51",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 14799,
      Date: "11/07/2021 08:07:33",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 14798,
      Date: "11/07/2021 08:07:12",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 14797,
      Date: "11/07/2021 08:06:54",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 14796,
      Date: "11/07/2021 08:06:15",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 2000,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 14795,
      Date: "11/07/2021 08:05:42",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 14794,
      Date: "11/07/2021 08:05:22",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 14793,
      Date: "11/07/2021 08:05:00",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 14792,
      Date: "11/07/2021 08:03:57",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 14791,
      Date: "11/07/2021 08:03:40",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 14790,
      Date: "11/07/2021 08:03:18",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 14789,
      Date: "11/07/2021 08:02:40",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 14788,
      Date: "11/07/2021 08:02:16",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 2000,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 14787,
      Date: "11/07/2021 08:01:41",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 2500,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 14786,
      Date: "11/07/2021 08:00:55",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 14785,
      Date: "11/07/2021 08:00:34",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 2000,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 14784,
      Date: "11/07/2021 07:59:58",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 14783,
      Date: "11/07/2021 07:59:35",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 14782,
      Date: "11/07/2021 07:59:15",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 14781,
      Date: "11/07/2021 07:58:52",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 14780,
      Date: "11/07/2021 07:56:24",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 14779,
      Date: "11/07/2021 07:55:21",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 14778,
      Date: "11/07/2021 07:55:02",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 14777,
      Date: "11/07/2021 07:53:22",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 1000,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 14776,
      Date: "11/07/2021 07:52:55",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 2500,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 14775,
      Date: "11/07/2021 07:52:08",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 14774,
      Date: "11/07/2021 07:51:04",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 2500,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 14773,
      Date: "11/07/2021 07:50:16",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 14772,
      Date: "11/07/2021 07:49:30",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 14771,
      Date: "11/07/2021 07:48:34",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 7000,
      totWin: 6180,
      product: "Virtual Football Pro",
      category: "Virtuals",
      username: 256780850357,
      ID: 14770,
      Date: "11/07/2021 10:43:11",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 2000,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 14769,
      Date: "11/07/2021 07:18:25",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 14768,
      Date: "11/07/2021 07:13:40",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 14767,
      Date: "11/07/2021 07:13:14",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 14766,
      Date: "11/07/2021 07:12:56",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 14765,
      Date: "11/07/2021 07:12:01",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 14764,
      Date: "11/07/2021 07:09:43",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 14763,
      Date: "11/07/2021 07:08:54",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 14762,
      Date: "11/07/2021 07:08:26",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 14761,
      Date: "11/07/2021 07:07:43",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 14760,
      Date: "11/07/2021 07:06:49",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 14759,
      Date: "11/07/2021 07:06:13",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 2980,
      totWin: 1025,
      product: "Virtual Football Pro",
      category: "Virtuals",
      username: 256780850357,
      ID: 14758,
      Date: "11/07/2021 09:34:35",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 1000,
      totWin: 1100,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256780850357,
      ID: 14757,
      Date: "11/07/2021 08:53:23",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 25254,
      totWin: 28369,
      product: "Virtual Football Pro",
      category: "Virtuals",
      username: 256780850357,
      ID: 14756,
      Date: "11/07/2021 08:44:59",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 500,
      totWin: 0,
      product: "Virtual Football Pro",
      category: "Virtuals",
      username: 256780850357,
      ID: 14755,
      Date: "11/07/2021 08:11:24",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 8154,
      totWin: 7894,
      product: "Virtual Football Pro",
      category: "Virtuals",
      username: 256780850357,
      ID: 14754,
      Date: "11/07/2021 07:55:23",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 500,
      totWin: 0,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256775478737,
      ID: 14753,
      Date: "11/07/2021 05:37:32",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 88000,
      totWin: 62000,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256775478737,
      ID: 14752,
      Date: "11/07/2021 05:32:44",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 7500,
      totWin: 9500,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256775478737,
      ID: 14751,
      Date: "11/07/2021 04:06:17",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 48000,
      totWin: 67652,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256775478737,
      ID: 14750,
      Date: "11/07/2021 04:03:12",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 36250,
      totWin: 24061.43,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256775478737,
      ID: 14749,
      Date: "11/07/2021 03:25:08",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 500,
      totWin: 720,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256775478737,
      ID: 14748,
      Date: "11/07/2021 02:55:55",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 79750,
      totWin: 95727.5,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256775478737,
      ID: 14747,
      Date: "11/07/2021 02:45:04",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 2000,
      totWin: 0,
      product: "Storming Flame",
      category: "Casino",
      username: 256789156900,
      ID: 14746,
      Date: "11/07/2021 01:40:58",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 9200,
      totWin: 3700,
      product: "Slot Of Money",
      category: "Casino",
      username: 256789156900,
      ID: 14745,
      Date: "11/07/2021 01:06:22",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 4400,
      totWin: 2000,
      product: "Texas Rangers Reward",
      category: "Casino",
      username: 256789156900,
      ID: 14744,
      Date: "11/07/2021 01:03:03",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 33250,
      totWin: 28595.12,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256775478737,
      ID: 14743,
      Date: "11/07/2021 01:01:44",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 500,
      totWin: 0,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256775478737,
      ID: 14742,
      Date: "10/07/2021 23:30:56",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 2500,
      totWin: 1690,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256775478737,
      ID: 14741,
      Date: "10/07/2021 23:27:17",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 200,
      totWin: 0,
      product: "Ramses Treasure",
      category: "Casino",
      username: 256789156900,
      ID: 14740,
      Date: "10/07/2021 22:58:00",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 3300,
      totWin: 1360,
      product: "3 Kings",
      category: "Casino",
      username: 256789156900,
      ID: 14739,
      Date: "10/07/2021 22:57:06",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 3500,
      totWin: 1500,
      product: "Storming Flame",
      category: "Casino",
      username: 256789156900,
      ID: 14738,
      Date: "10/07/2021 22:53:13",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 4400,
      totWin: 1500,
      product: "Ramses Treasure",
      category: "Casino",
      username: 256789156900,
      ID: 14737,
      Date: "10/07/2021 22:48:15",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 3600,
      totWin: 400,
      product: "Slot Of Money",
      category: "Casino",
      username: 256789156900,
      ID: 14736,
      Date: "10/07/2021 22:43:47",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 8800,
      totWin: 8900,
      product: "Lady Luck",
      category: "Casino",
      username: 256789156900,
      ID: 14735,
      Date: "10/07/2021 22:41:58",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 600,
      totWin: 500,
      product: "El Toreo",
      category: "Casino",
      username: 256789156900,
      ID: 14734,
      Date: "10/07/2021 22:38:44",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 5046,
      totWin: 3046,
      product: "Virtual Football Pro",
      category: "Virtuals",
      username: 256780850357,
      ID: 14733,
      Date: "10/07/2021 21:40:18",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 500,
      totWin: 0,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256770857444,
      ID: 14732,
      Date: "10/07/2021 21:03:44",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 500,
      totWin: 7125,
      product: "Virtual Europa",
      category: "Virtuals",
      username: 256770857444,
      ID: 14731,
      Date: "10/07/2021 21:02:21",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 1000,
      totWin: 0,
      product: "Virtual Europa",
      category: "Virtuals",
      username: 256770857444,
      ID: 14730,
      Date: "10/07/2021 21:00:11",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 500,
      totWin: 0,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256770857444,
      ID: 14729,
      Date: "10/07/2021 20:59:05",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 970.84,
      totWin: 0,
      product: "Virtual Europa",
      category: "Virtuals",
      username: 256770857444,
      ID: 14728,
      Date: "10/07/2021 20:57:23",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 1000,
      totWin: 0,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256770857444,
      ID: 14727,
      Date: "10/07/2021 20:55:51",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 618,
      totWin: 1470.84,
      product: "Virtual Europa",
      category: "Virtuals",
      username: 256770857444,
      ID: 14726,
      Date: "10/07/2021 20:54:28",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 1540,
      totWin: 0,
      product: "Virtual Europa",
      category: "Virtuals",
      username: 256770857444,
      ID: 14725,
      Date: "10/07/2021 20:52:20",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 500,
      totWin: 2618,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256770857444,
      ID: 14724,
      Date: "10/07/2021 20:49:41",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 1750,
      totWin: 5040,
      product: "Virtual Europa",
      category: "Virtuals",
      username: 256770857444,
      ID: 14723,
      Date: "10/07/2021 20:48:16",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 500,
      totWin: 0,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256770857444,
      ID: 14722,
      Date: "10/07/2021 20:47:23",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 22890,
      totWin: 21884,
      product: "Virtual Football Pro",
      category: "Virtuals",
      username: 256780850357,
      ID: 14721,
      Date: "10/07/2021 20:46:50",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 500,
      totWin: 1750,
      product: "Virtual Europa",
      category: "Virtuals",
      username: 256770857444,
      ID: 14720,
      Date: "10/07/2021 20:46:47",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 1000,
      totWin: 0,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256770857444,
      ID: 14719,
      Date: "10/07/2021 20:45:55",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 1249.6,
      totWin: 0,
      product: "Virtual Europa",
      category: "Virtuals",
      username: 256770857444,
      ID: 14718,
      Date: "10/07/2021 20:44:57",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 1474.4,
      totWin: 0,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256770857444,
      ID: 14717,
      Date: "10/07/2021 20:43:48",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 592,
      totWin: 2249.6,
      product: "Virtual Europa",
      category: "Virtuals",
      username: 256770857444,
      ID: 14716,
      Date: "10/07/2021 20:42:54",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 1880,
      totWin: 4474.4,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256770857444,
      ID: 14715,
      Date: "10/07/2021 20:41:50",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 900,
      totWin: 2592,
      product: "Virtual Europa",
      category: "Virtuals",
      username: 256770857444,
      ID: 14714,
      Date: "10/07/2021 20:40:26",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 1000,
      totWin: 2880,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256770857444,
      ID: 14713,
      Date: "10/07/2021 20:39:33",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 500,
      totWin: 1900,
      product: "Virtual Europa",
      category: "Virtuals",
      username: 256770857444,
      ID: 14712,
      Date: "10/07/2021 20:38:49",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 500,
      totWin: 0,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256770857444,
      ID: 14711,
      Date: "10/07/2021 20:38:02",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 1000.8,
      totWin: 0,
      product: "Virtual Europa",
      category: "Virtuals",
      username: 256770857444,
      ID: 14710,
      Date: "10/07/2021 20:37:18",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 1000,
      totWin: 0,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256770857444,
      ID: 14709,
      Date: "10/07/2021 20:36:09",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 500,
      totWin: 0,
      product: "Virtual Europa",
      category: "Virtuals",
      username: 256770857444,
      ID: 14708,
      Date: "10/07/2021 20:34:37",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 1000,
      totWin: 5500.8,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256770857444,
      ID: 14707,
      Date: "10/07/2021 20:33:50",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 1000,
      totWin: 0,
      product: "Virtual Europa",
      category: "Virtuals",
      username: 256770857444,
      ID: 14706,
      Date: "10/07/2021 20:33:16",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 1900.67,
      totWin: 0,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256770857444,
      ID: 14705,
      Date: "10/07/2021 20:31:41",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 1354.4,
      totWin: 3900.67,
      product: "Virtual Europa",
      category: "Virtuals",
      username: 256770857444,
      ID: 14704,
      Date: "10/07/2021 20:29:21",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 500,
      totWin: 0,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256770857444,
      ID: 14703,
      Date: "10/07/2021 20:26:19",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 1500,
      totWin: 6854.4,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256770857444,
      ID: 14702,
      Date: "10/07/2021 20:24:28",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 1000,
      totWin: 0,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256770857444,
      ID: 14701,
      Date: "10/07/2021 20:20:38",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 500,
      totWin: 0,
      product: "Virtual Europa",
      category: "Virtuals",
      username: 256770857444,
      ID: 14700,
      Date: "10/07/2021 20:15:55",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 1000,
      totWin: 0,
      product: "Virtual Europa",
      category: "Virtuals",
      username: 256770857444,
      ID: 14699,
      Date: "10/07/2021 20:12:09",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 1498,
      totWin: 0,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256770857444,
      ID: 14698,
      Date: "10/07/2021 20:11:31",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 500,
      totWin: 0,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256770857444,
      ID: 14697,
      Date: "10/07/2021 20:09:34",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 1000,
      totWin: 0,
      product: "Virtual Europa",
      category: "Virtuals",
      username: 256770857444,
      ID: 14696,
      Date: "10/07/2021 20:08:39",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 1000,
      totWin: 4998,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256770857444,
      ID: 14695,
      Date: "10/07/2021 20:07:33",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 1000,
      totWin: 0,
      product: "Virtual Europa",
      category: "Virtuals",
      username: 256770857444,
      ID: 14694,
      Date: "10/07/2021 20:06:03",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 1258,
      totWin: 0,
      product: "Virtual Europa",
      category: "Virtuals",
      username: 256770857444,
      ID: 14693,
      Date: "10/07/2021 19:48:19",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 1000,
      totWin: 7258,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256770857444,
      ID: 14692,
      Date: "10/07/2021 19:46:42",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 500,
      totWin: 0,
      product: "Virtual Europa",
      category: "Virtuals",
      username: 256770857444,
      ID: 14691,
      Date: "10/07/2021 19:45:59",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 500,
      totWin: 0,
      product: "Virtual Europa",
      category: "Virtuals",
      username: 256770857444,
      ID: 14690,
      Date: "10/07/2021 19:44:10",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 500,
      totWin: 0,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256770857444,
      ID: 14689,
      Date: "10/07/2021 19:43:31",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 500,
      totWin: 0,
      product: "Virtual Europa",
      category: "Virtuals",
      username: 256770857444,
      ID: 14688,
      Date: "10/07/2021 19:42:08",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 500,
      totWin: 0,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256770857444,
      ID: 14687,
      Date: "10/07/2021 19:40:44",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 500,
      totWin: 0,
      product: "Virtual Europa",
      category: "Virtuals",
      username: 256770857444,
      ID: 14686,
      Date: "10/07/2021 19:39:55",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 1900,
      totWin: 0,
      product: "Virtual Europa",
      category: "Virtuals",
      username: 256770857444,
      ID: 14685,
      Date: "10/07/2021 19:38:10",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 5000,
      totWin: 14400,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256770857444,
      ID: 14684,
      Date: "10/07/2021 19:33:24",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 500,
      totWin: 0,
      product: "Virtual Europa",
      category: "Virtuals",
      username: 256770857444,
      ID: 14683,
      Date: "10/07/2021 19:30:15",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 500,
      totWin: 0,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256770857444,
      ID: 14682,
      Date: "10/07/2021 19:29:28",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 500,
      totWin: 0,
      product: "Virtual Europa",
      category: "Virtuals",
      username: 256770857444,
      ID: 14681,
      Date: "10/07/2021 19:26:32",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 1000,
      totWin: 0,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256770857444,
      ID: 14680,
      Date: "10/07/2021 19:25:47",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 500,
      totWin: 0,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256770857444,
      ID: 14679,
      Date: "10/07/2021 19:24:03",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 500,
      totWin: 0,
      product: "Virtual Europa",
      category: "Virtuals",
      username: 256770857444,
      ID: 14678,
      Date: "10/07/2021 19:22:38",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 1000,
      totWin: 0,
      product: "Virtual Europa",
      category: "Virtuals",
      username: 256770857444,
      ID: 14677,
      Date: "10/07/2021 19:20:25",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 500,
      totWin: 0,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256770857444,
      ID: 14676,
      Date: "10/07/2021 19:19:46",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 500,
      totWin: 0,
      product: "Virtual Europa",
      category: "Virtuals",
      username: 256770857444,
      ID: 14675,
      Date: "10/07/2021 19:18:31",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 1000,
      totWin: 0,
      product: "Virtual Europa",
      category: "Virtuals",
      username: 256770857444,
      ID: 14674,
      Date: "10/07/2021 19:16:38",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 2001,
      totWin: 0,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256770857444,
      ID: 14673,
      Date: "10/07/2021 19:15:51",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 1920,
      totWin: 5921,
      product: "Virtual Europa",
      category: "Virtuals",
      username: 256770857444,
      ID: 14672,
      Date: "10/07/2021 19:12:08",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 1000,
      totWin: 0,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256770857444,
      ID: 14671,
      Date: "10/07/2021 19:09:43",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 1354.4,
      totWin: 0,
      product: "Virtual Europa",
      category: "Virtuals",
      username: 256770857444,
      ID: 14670,
      Date: "10/07/2021 19:08:28",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 500,
      totWin: 0,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256770857444,
      ID: 14669,
      Date: "10/07/2021 19:07:36",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 1000,
      totWin: 6854.4,
      product: "Virtual Europa",
      category: "Virtuals",
      username: 256770857444,
      ID: 14668,
      Date: "10/07/2021 19:06:49",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 1000,
      totWin: 0,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256770857444,
      ID: 14667,
      Date: "10/07/2021 19:05:49",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 1000,
      totWin: 0,
      product: "Virtual Europa",
      category: "Virtuals",
      username: 256770857444,
      ID: 14666,
      Date: "10/07/2021 19:04:51",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 807.2,
      totWin: 0,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256770857444,
      ID: 14665,
      Date: "10/07/2021 19:04:00",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 1000,
      totWin: 2380,
      product: "Virtual Europa",
      category: "Virtuals",
      username: 256770857444,
      ID: 14664,
      Date: "10/07/2021 19:02:59",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 1000,
      totWin: 3427.2,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256770857444,
      ID: 14663,
      Date: "10/07/2021 19:01:42",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 1525,
      totWin: 0,
      product: "Virtual Europa",
      category: "Virtuals",
      username: 256770857444,
      ID: 14662,
      Date: "10/07/2021 19:00:33",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 1365,
      totWin: 4025,
      product: "Virtual Europa",
      category: "Virtuals",
      username: 256770857444,
      ID: 14661,
      Date: "10/07/2021 18:56:11",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 1000,
      totWin: 0,
      product: "Virtual Europa",
      category: "Virtuals",
      username: 256770857444,
      ID: 14660,
      Date: "10/07/2021 18:52:29",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 2000,
      totWin: 2865,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256770857444,
      ID: 14659,
      Date: "10/07/2021 18:51:30",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 1000,
      totWin: 0,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256770857444,
      ID: 14658,
      Date: "10/07/2021 18:49:21",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 1000,
      totWin: 0,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256770857444,
      ID: 14657,
      Date: "10/07/2021 18:45:31",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 1000,
      totWin: 0,
      product: "Virtual Europa",
      category: "Virtuals",
      username: 256770857444,
      ID: 14656,
      Date: "10/07/2021 18:42:28",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 1000,
      totWin: 0,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256770857444,
      ID: 14655,
      Date: "10/07/2021 18:41:42",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 2952.36,
      totWin: 10762.36,
      product: "Virtual Europa",
      category: "Virtuals",
      username: 256770857444,
      ID: 14654,
      Date: "10/07/2021 18:40:48",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 2000,
      totWin: 0,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256770857444,
      ID: 14653,
      Date: "10/07/2021 18:37:54",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 1000.46,
      totWin: 1190,
      product: "Virtual Europa",
      category: "Virtuals",
      username: 256770857444,
      ID: 14652,
      Date: "10/07/2021 18:35:59",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 1400,
      totWin: 0,
      product: "Virtual Europa",
      category: "Virtuals",
      username: 256770857444,
      ID: 14651,
      Date: "10/07/2021 18:32:20",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 568,
      totWin: 0,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256770857444,
      ID: 14650,
      Date: "10/07/2021 18:30:13",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 1617,
      totWin: 6585.46,
      product: "Virtual Europa",
      category: "Virtuals",
      username: 256770857444,
      ID: 14649,
      Date: "10/07/2021 18:14:12",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 500,
      totWin: 0,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256770857444,
      ID: 14648,
      Date: "10/07/2021 18:01:46",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 14647,
      Date: "10/07/2021 12:46:15",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 14646,
      Date: "10/07/2021 12:45:55",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 14645,
      Date: "10/07/2021 12:45:02",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 14644,
      Date: "10/07/2021 12:43:54",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 14643,
      Date: "10/07/2021 12:43:34",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 14642,
      Date: "10/07/2021 12:43:13",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 14641,
      Date: "10/07/2021 12:42:27",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 14640,
      Date: "10/07/2021 12:41:56",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 14639,
      Date: "10/07/2021 12:41:19",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 14638,
      Date: "10/07/2021 12:40:57",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 14637,
      Date: "10/07/2021 12:40:05",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 14636,
      Date: "10/07/2021 12:39:43",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 14635,
      Date: "10/07/2021 12:29:07",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 14634,
      Date: "10/07/2021 12:28:48",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 14633,
      Date: "10/07/2021 12:27:45",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 14632,
      Date: "10/07/2021 12:27:22",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 14631,
      Date: "10/07/2021 12:26:59",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 14630,
      Date: "10/07/2021 12:26:36",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 4000,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 14629,
      Date: "10/07/2021 12:25:25",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 14628,
      Date: "10/07/2021 12:24:40",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 14627,
      Date: "10/07/2021 12:24:09",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 14626,
      Date: "10/07/2021 12:23:22",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 14625,
      Date: "10/07/2021 12:22:19",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 14624,
      Date: "10/07/2021 12:21:33",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 14623,
      Date: "10/07/2021 12:21:14",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 14622,
      Date: "10/07/2021 12:20:53",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 14621,
      Date: "10/07/2021 12:20:09",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 14620,
      Date: "10/07/2021 12:19:46",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 14619,
      Date: "10/07/2021 12:19:24",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 14618,
      Date: "10/07/2021 12:19:00",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 14617,
      Date: "10/07/2021 12:18:41",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 4000,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 14616,
      Date: "10/07/2021 12:16:57",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 14615,
      Date: "10/07/2021 12:16:31",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 14614,
      Date: "10/07/2021 12:16:01",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 14613,
      Date: "10/07/2021 12:15:18",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 14612,
      Date: "10/07/2021 12:14:33",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 14611,
      Date: "10/07/2021 12:14:09",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 14610,
      Date: "10/07/2021 12:13:41",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 14609,
      Date: "10/07/2021 12:13:20",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 14608,
      Date: "10/07/2021 12:12:53",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 14607,
      Date: "10/07/2021 12:12:32",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 14606,
      Date: "10/07/2021 12:12:06",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 14605,
      Date: "10/07/2021 12:03:25",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 2000,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 14604,
      Date: "10/07/2021 12:02:10",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 2500,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 14603,
      Date: "10/07/2021 12:00:11",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 2500,
      totWin: 1075,
      product: "Virtual Soccer",
      category: "Virtuals",
      username: 256770845346,
      ID: 14602,
      Date: "10/07/2021 14:38:14",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 73750,
      totWin: 58750,
      product: "Money Farm 2",
      category: "Casino",
      username: 256770537411,
      ID: 14601,
      Date: "10/07/2021 14:37:30",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 5000,
      totWin: 800,
      product: "Wolf Quest",
      category: "Casino",
      username: 256770537411,
      ID: 14600,
      Date: "10/07/2021 14:15:25",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 6000,
      totWin: 7828.5,
      product: "Virtual Football Pro",
      category: "Virtuals",
      username: 256779971376,
      ID: 14599,
      Date: "10/07/2021 13:12:07",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 14598,
      Date: "10/07/2021 09:36:45",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 39000,
      totWin: 36600,
      product: "Virtual Soccer",
      category: "Virtuals",
      username: 256754688249,
      ID: 14597,
      Date: "10/07/2021 08:58:11",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 4000,
      totWin: 100,
      product: "Slot Of Money",
      category: "Casino",
      username: 256789156900,
      ID: 14596,
      Date: "10/07/2021 00:19:59",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 3000,
      totWin: 100,
      product: "Ramses Treasure",
      category: "Casino",
      username: 256789156900,
      ID: 14595,
      Date: "10/07/2021 00:17:32",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 2600,
      totWin: 580,
      product: "Fortune Panda",
      category: "Casino",
      username: 256789156900,
      ID: 14594,
      Date: "10/07/2021 00:13:49",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 4800,
      totWin: 800,
      product: "Night At KTV",
      category: "Casino",
      username: 256789156900,
      ID: 14593,
      Date: "10/07/2021 00:11:58",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 1600,
      totWin: 0,
      product: "Slot Of Money",
      category: "Casino",
      username: 256789156900,
      ID: 14592,
      Date: "10/07/2021 00:06:53",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 1600,
      totWin: 200,
      product: "Crystal Mystery",
      category: "Casino",
      username: 256789156900,
      ID: 14591,
      Date: "09/07/2021 23:45:09",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 7500,
      totWin: 3975,
      product: "Virtual Football Pro",
      category: "Virtuals",
      username: 256780850357,
      ID: 14590,
      Date: "09/07/2021 21:55:16",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 33000,
      totWin: 37733.4,
      product: "Virtual Soccer",
      category: "Virtuals",
      username: 256754688249,
      ID: 14589,
      Date: "09/07/2021 21:16:03",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 26000,
      totWin: 28475,
      product: "Virtual Football Pro",
      category: "Virtuals",
      username: 256780850357,
      ID: 14588,
      Date: "09/07/2021 21:11:23",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 3469,
      totWin: 1050,
      product: "Virtual Football Pro",
      category: "Virtuals",
      username: 256784819027,
      ID: 14587,
      Date: "09/07/2021 20:53:41",
      channel: "n/a",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 500,
      totWin: 0,
      product: "Virtual Soccer",
      category: "Virtuals",
      username: 256754688249,
      ID: 14586,
      Date: "09/07/2021 20:00:14",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 1500,
      totWin: 2528,
      product: "Virtual Football Pro",
      category: "Virtuals",
      username: 256780850357,
      ID: 14585,
      Date: "09/07/2021 19:46:44",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 1612,
      totWin: 3315.4,
      product: "Virtual Football Pro",
      category: "Virtuals",
      username: 256780850357,
      ID: 14584,
      Date: "09/07/2021 19:40:34",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 9961,
      totWin: 9285.5,
      product: "Virtual Football Pro",
      category: "Virtuals",
      username: 256780850357,
      ID: 14583,
      Date: "09/07/2021 19:33:56",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 14582,
      Date: "09/07/2021 15:20:54",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 14581,
      Date: "09/07/2021 15:20:07",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 500,
      totWin: 0,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256770857444,
      ID: 14580,
      Date: "09/07/2021 16:12:25",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 13500,
      totWin: 12421.25,
      product: "Virtual Soccer",
      category: "Virtuals",
      username: 256754688249,
      ID: 14579,
      Date: "09/07/2021 15:53:41",
      channel: "n/a",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 2390,
      totWin: 3500,
      product: "Virtual Europa",
      category: "Virtuals",
      username: 256770857444,
      ID: 14578,
      Date: "09/07/2021 15:21:21",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 540,
      totWin: 1890,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256770857444,
      ID: 14577,
      Date: "09/07/2021 14:53:23",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 4170,
      totWin: 6710,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256770857444,
      ID: 14576,
      Date: "09/07/2021 14:51:44",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 3000,
      totWin: 1260,
      product: "Virtual Soccer",
      category: "Virtuals",
      username: 256754688249,
      ID: 14575,
      Date: "09/07/2021 14:45:06",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 500,
      totWin: 0,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256770857444,
      ID: 14574,
      Date: "09/07/2021 14:19:40",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 3500,
      totWin: 2565,
      product: "Virtual Soccer",
      category: "Virtuals",
      username: 256754688249,
      ID: 14573,
      Date: "09/07/2021 14:04:09",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 14572,
      Date: "09/07/2021 08:46:11",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 14571,
      Date: "09/07/2021 08:45:52",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 14570,
      Date: "09/07/2021 08:45:33",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 14569,
      Date: "09/07/2021 08:45:14",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 3800,
      totWin: 500,
      product: "Ramses Treasure",
      category: "Casino",
      username: 256789156900,
      ID: 14568,
      Date: "09/07/2021 02:54:22",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 8400,
      totWin: 5200,
      product: "Slot Of Money",
      category: "Casino",
      username: 256789156900,
      ID: 14567,
      Date: "09/07/2021 02:49:26",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 3500,
      totWin: 4250,
      product: "Storming Flame",
      category: "Casino",
      username: 256789156900,
      ID: 14566,
      Date: "09/07/2021 02:45:23",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 4400,
      totWin: 500,
      product: "Ramses Treasure",
      category: "Casino",
      username: 256789156900,
      ID: 14565,
      Date: "09/07/2021 02:43:11",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 4200,
      totWin: 200,
      product: "Tiger Heart",
      category: "Casino",
      username: 256789156900,
      ID: 14564,
      Date: "09/07/2021 01:03:38",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 4400,
      totWin: 1400,
      product: "Ramses Treasure",
      category: "Casino",
      username: 256789156900,
      ID: 14563,
      Date: "09/07/2021 00:58:07",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 1000,
      totWin: 0,
      product: "Virtual Football Pro",
      category: "Virtuals",
      username: 256780850357,
      ID: 14562,
      Date: "08/07/2021 22:25:23",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 14561,
      Date: "08/07/2021 16:38:09",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 14560,
      Date: "08/07/2021 16:30:39",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 4000,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 14559,
      Date: "08/07/2021 16:29:54",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 1000,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 14558,
      Date: "08/07/2021 16:29:15",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 14557,
      Date: "08/07/2021 16:28:06",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 2000,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 14556,
      Date: "08/07/2021 16:27:33",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 14555,
      Date: "08/07/2021 16:20:32",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 14554,
      Date: "08/07/2021 16:19:10",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 14553,
      Date: "08/07/2021 16:16:13",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 2000,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 14552,
      Date: "08/07/2021 16:13:32",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 14551,
      Date: "08/07/2021 16:12:58",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 28500,
      totWin: 31824.25,
      product: "Virtual Soccer",
      category: "Virtuals",
      username: 256754688249,
      ID: 14550,
      Date: "08/07/2021 19:10:09",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 64400,
      totWin: 25500,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256701052616,
      ID: 14549,
      Date: "08/07/2021 18:29:05",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 15000,
      totWin: 0,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256701052616,
      ID: 14548,
      Date: "08/07/2021 18:20:37",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 10000,
      totWin: 14400,
      product: "Virtual Europa",
      category: "Virtuals",
      username: 256701052616,
      ID: 14547,
      Date: "08/07/2021 18:14:19",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 40000,
      totWin: 37000,
      product: "Virtual Europa",
      category: "Virtuals",
      username: 256701052616,
      ID: 14546,
      Date: "08/07/2021 18:08:36",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 20000,
      totWin: 52500,
      product: "Virtual Europa",
      category: "Virtuals",
      username: 256701052616,
      ID: 14545,
      Date: "08/07/2021 17:53:06",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 5000,
      totWin: 0,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256701052616,
      ID: 14544,
      Date: "08/07/2021 17:49:56",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 33550,
      totWin: 21050,
      product: "Virtual Europa",
      category: "Virtuals",
      username: 256701052616,
      ID: 14543,
      Date: "08/07/2021 17:47:37",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 44790,
      totWin: 70050,
      product: "Virtual Europa",
      category: "Virtuals",
      username: 256701052616,
      ID: 14542,
      Date: "08/07/2021 17:41:46",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 77200,
      totWin: 3240,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256701052616,
      ID: 14541,
      Date: "08/07/2021 17:33:33",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 2000,
      totWin: 3625,
      product: "Virtual Soccer",
      category: "Virtuals",
      username: 256754688249,
      ID: 14540,
      Date: "08/07/2021 17:17:06",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 20000,
      totWin: 0,
      product: "Virtual Europa",
      category: "Virtuals",
      username: 256701052616,
      ID: 14539,
      Date: "08/07/2021 17:13:46",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 125000,
      totWin: 179800,
      product: "Virtual Europa",
      category: "Virtuals",
      username: 256701052616,
      ID: 14538,
      Date: "08/07/2021 17:06:29",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 15000,
      totWin: 26400,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256701052616,
      ID: 14537,
      Date: "08/07/2021 16:53:02",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 20000,
      totWin: 0,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256701052616,
      ID: 14536,
      Date: "08/07/2021 16:47:40",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 74000,
      totWin: 24000,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256701052616,
      ID: 14535,
      Date: "08/07/2021 16:43:21",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 74400,
      totWin: 0,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256701052616,
      ID: 14534,
      Date: "08/07/2021 16:29:44",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 44000,
      totWin: 38400,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256701052616,
      ID: 14533,
      Date: "08/07/2021 16:18:45",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 92944,
      totWin: 122000,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256701052616,
      ID: 14532,
      Date: "08/07/2021 16:13:18",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 13000,
      totWin: 8300,
      product: "Virtual Europa",
      category: "Virtuals",
      username: 256701052616,
      ID: 14531,
      Date: "08/07/2021 15:58:13",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 33980,
      totWin: 33624.8,
      product: "Virtual Europa",
      category: "Virtuals",
      username: 256701052616,
      ID: 14530,
      Date: "08/07/2021 15:49:00",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 61900,
      totWin: 16000,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256701052616,
      ID: 14529,
      Date: "08/07/2021 15:33:28",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 10000,
      totWin: 10500,
      product: "Virtual Europa",
      category: "Virtuals",
      username: 256701052616,
      ID: 14528,
      Date: "08/07/2021 15:15:12",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 210000,
      totWin: 258750,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256701052616,
      ID: 14527,
      Date: "08/07/2021 15:06:24",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 14526,
      Date: "08/07/2021 11:27:42",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 14525,
      Date: "08/07/2021 11:27:24",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 14524,
      Date: "08/07/2021 11:27:07",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 14523,
      Date: "08/07/2021 11:26:49",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 14522,
      Date: "08/07/2021 11:26:29",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 28000,
      totWin: 42650,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256701052616,
      ID: 14521,
      Date: "08/07/2021 14:20:27",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 5000,
      totWin: 0,
      product: "Virtual Europa",
      category: "Virtuals",
      username: 256701052616,
      ID: 14520,
      Date: "08/07/2021 14:13:17",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 84400,
      totWin: 127400,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256701052616,
      ID: 14519,
      Date: "08/07/2021 14:11:26",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 1970,
      totWin: 0,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256701052616,
      ID: 14518,
      Date: "08/07/2021 13:59:36",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 31280,
      totWin: 8250,
      product: "Virtual Europa",
      category: "Virtuals",
      username: 256701052616,
      ID: 14517,
      Date: "08/07/2021 13:48:59",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 131550,
      totWin: 102750,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256701052616,
      ID: 14516,
      Date: "08/07/2021 13:37:36",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 14515,
      Date: "08/07/2021 10:33:21",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 14514,
      Date: "08/07/2021 10:33:03",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 14513,
      Date: "08/07/2021 10:32:45",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 14512,
      Date: "08/07/2021 10:32:26",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 14511,
      Date: "08/07/2021 10:32:06",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 14510,
      Date: "08/07/2021 10:31:47",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 14509,
      Date: "08/07/2021 10:30:17",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 3000,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 14508,
      Date: "08/07/2021 10:29:32",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 14507,
      Date: "08/07/2021 10:27:23",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 14506,
      Date: "08/07/2021 10:26:24",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 14505,
      Date: "08/07/2021 10:24:54",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 14504,
      Date: "08/07/2021 10:24:37",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 14503,
      Date: "08/07/2021 10:24:07",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 14502,
      Date: "08/07/2021 10:23:48",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 3000,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 14501,
      Date: "08/07/2021 10:21:07",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 14500,
      Date: "08/07/2021 10:20:19",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 14499,
      Date: "08/07/2021 10:18:32",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 14498,
      Date: "08/07/2021 10:17:56",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 14497,
      Date: "08/07/2021 10:15:30",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 14496,
      Date: "08/07/2021 10:15:12",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 14495,
      Date: "08/07/2021 10:14:55",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 42000,
      totWin: 40450,
      product: "Virtual Europa",
      category: "Virtuals",
      username: 256701052616,
      ID: 14494,
      Date: "08/07/2021 13:13:14",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 2500,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 14493,
      Date: "08/07/2021 10:13:06",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 12000,
      totWin: 9240,
      product: "Gold Of Ra",
      category: "Casino",
      username: 256770537411,
      ID: 14492,
      Date: "08/07/2021 13:10:12",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 14491,
      Date: "08/07/2021 10:10:06",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 14490,
      Date: "08/07/2021 10:09:49",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 14489,
      Date: "08/07/2021 10:09:31",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 3000,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 14488,
      Date: "08/07/2021 10:07:51",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 11000,
      totWin: 3100,
      product: "DaVinci Codex",
      category: "Casino",
      username: 256770537411,
      ID: 14487,
      Date: "08/07/2021 13:04:40",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 14486,
      Date: "08/07/2021 10:04:09",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 14485,
      Date: "08/07/2021 10:03:48",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 75000,
      totWin: 109050,
      product: "Virtual Europa",
      category: "Virtuals",
      username: 256701052616,
      ID: 14484,
      Date: "08/07/2021 13:03:03",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 2500,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 14483,
      Date: "08/07/2021 10:00:45",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 14482,
      Date: "08/07/2021 09:57:05",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 14481,
      Date: "08/07/2021 09:56:41",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 14480,
      Date: "08/07/2021 09:55:15",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 14479,
      Date: "08/07/2021 09:54:54",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 2500,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 14478,
      Date: "08/07/2021 09:53:59",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 14477,
      Date: "08/07/2021 09:53:41",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 14476,
      Date: "08/07/2021 09:53:24",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 14475,
      Date: "08/07/2021 09:53:03",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 20000,
      totWin: 41300,
      product: "Virtual Europa",
      category: "Virtuals",
      username: 256701052616,
      ID: 14474,
      Date: "08/07/2021 12:52:40",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 2500,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 14473,
      Date: "08/07/2021 09:52:08",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 14472,
      Date: "08/07/2021 09:50:51",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 14471,
      Date: "08/07/2021 09:50:31",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 14470,
      Date: "08/07/2021 09:48:38",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 14469,
      Date: "08/07/2021 09:48:21",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 14468,
      Date: "08/07/2021 09:48:01",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 14467,
      Date: "08/07/2021 09:47:41",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 14466,
      Date: "08/07/2021 09:47:24",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 14465,
      Date: "08/07/2021 09:47:01",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 14464,
      Date: "08/07/2021 09:46:43",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 14463,
      Date: "08/07/2021 09:46:12",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 2800,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 14462,
      Date: "08/07/2021 09:45:49",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 14461,
      Date: "08/07/2021 09:45:27",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 14460,
      Date: "08/07/2021 09:45:07",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 14459,
      Date: "08/07/2021 09:44:48",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 2500,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 14458,
      Date: "08/07/2021 09:44:27",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 14457,
      Date: "08/07/2021 09:44:09",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 14456,
      Date: "08/07/2021 09:42:26",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 14455,
      Date: "08/07/2021 09:41:47",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 14454,
      Date: "08/07/2021 09:41:30",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 14453,
      Date: "08/07/2021 09:41:11",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 14452,
      Date: "08/07/2021 09:40:53",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 14451,
      Date: "08/07/2021 09:40:34",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 2500,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 14450,
      Date: "08/07/2021 09:40:08",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 14449,
      Date: "08/07/2021 09:35:32",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 800,
      totWin: 360,
      product: "Venetia",
      category: "Casino",
      username: 256702851011,
      ID: 14448,
      Date: "08/07/2021 12:35:09",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 14447,
      Date: "08/07/2021 09:34:54",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 14446,
      Date: "08/07/2021 09:34:34",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 14445,
      Date: "08/07/2021 09:32:38",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 4000,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 14444,
      Date: "08/07/2021 09:32:12",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 2500,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 14443,
      Date: "08/07/2021 09:31:50",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 2500,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 14442,
      Date: "08/07/2021 09:31:25",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 14441,
      Date: "08/07/2021 09:31:06",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 14440,
      Date: "08/07/2021 09:30:29",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 14439,
      Date: "08/07/2021 09:30:10",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 14438,
      Date: "08/07/2021 09:29:31",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 14437,
      Date: "08/07/2021 09:28:52",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 14436,
      Date: "08/07/2021 09:28:11",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 2500,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 14435,
      Date: "08/07/2021 09:27:34",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 14434,
      Date: "08/07/2021 09:26:58",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 14433,
      Date: "08/07/2021 08:41:34",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 14432,
      Date: "08/07/2021 08:40:57",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 14431,
      Date: "08/07/2021 08:40:17",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 14430,
      Date: "08/07/2021 08:39:55",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 14429,
      Date: "08/07/2021 08:39:13",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 14428,
      Date: "08/07/2021 08:38:53",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 2500,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 14427,
      Date: "08/07/2021 08:38:19",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 14426,
      Date: "08/07/2021 08:35:41",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 14425,
      Date: "08/07/2021 08:35:20",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 14424,
      Date: "08/07/2021 08:34:58",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 14423,
      Date: "08/07/2021 08:34:34",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 14422,
      Date: "08/07/2021 08:34:02",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 2000,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 14421,
      Date: "08/07/2021 08:33:13",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 3570,
      totWin: 0,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256701052616,
      ID: 14420,
      Date: "08/07/2021 11:17:04",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 14419,
      Date: "08/07/2021 08:05:56",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 200,
      totWin: 0,
      product: "Ramses Treasure",
      category: "Casino",
      username: 256789156900,
      ID: 14418,
      Date: "08/07/2021 02:38:49",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 8000,
      totWin: 2700,
      product: "Slot Of Money",
      category: "Casino",
      username: 256789156900,
      ID: 14417,
      Date: "08/07/2021 02:37:50",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 2800,
      totWin: 1200,
      product: "Star Cash",
      category: "Casino",
      username: 256789156900,
      ID: 14416,
      Date: "08/07/2021 02:34:53",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 3800,
      totWin: 700,
      product: "Ramses Treasure",
      category: "Casino",
      username: 256789156900,
      ID: 14415,
      Date: "08/07/2021 02:30:37",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 1500,
      totWin: 1600,
      product: "Gold Of Ra",
      category: "Casino",
      username: 256789156900,
      ID: 14414,
      Date: "08/07/2021 02:26:43",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 9600,
      totWin: 196900,
      product: "Slot Of Money",
      category: "Casino",
      username: 256781933796,
      ID: 14413,
      Date: "08/07/2021 02:16:50",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 5600,
      totWin: 58600,
      product: "Ramses Treasure",
      category: "Casino",
      username: 256781933796,
      ID: 14412,
      Date: "08/07/2021 02:10:59",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 250,
      totWin: 0,
      product: "Storming Flame",
      category: "Casino",
      username: 256781933796,
      ID: 14411,
      Date: "08/07/2021 01:13:37",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 9200,
      totWin: 3700,
      product: "Slot Of Money",
      category: "Casino",
      username: 256781933796,
      ID: 14410,
      Date: "08/07/2021 01:12:43",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 14400,
      totWin: 9400,
      product: "Slot Of Money",
      category: "Casino",
      username: 256781933796,
      ID: 14409,
      Date: "08/07/2021 01:09:54",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 3500,
      totWin: 5750,
      product: "Storming Flame",
      category: "Casino",
      username: 256781933796,
      ID: 14408,
      Date: "08/07/2021 01:02:42",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 7200,
      totWin: 3800,
      product: "Slot Of Money",
      category: "Casino",
      username: 256781933796,
      ID: 14407,
      Date: "08/07/2021 01:00:58",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 3000,
      totWin: 1500,
      product: "Burning Flame",
      category: "Casino",
      username: 256781933796,
      ID: 14406,
      Date: "08/07/2021 00:51:17",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 6500,
      totWin: 4000,
      product: "Storming Flame",
      category: "Casino",
      username: 256781933796,
      ID: 14405,
      Date: "08/07/2021 00:49:11",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 1000,
      totWin: 0,
      product: "Burning Flame",
      category: "Casino",
      username: 256789156900,
      ID: 14404,
      Date: "07/07/2021 22:56:35",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 7000,
      totWin: 2000,
      product: "Burning Flame",
      category: "Casino",
      username: 256789156900,
      ID: 14403,
      Date: "07/07/2021 22:53:29",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 5750,
      totWin: 800,
      product: "King Of Wealth",
      category: "Casino",
      username: 256789156900,
      ID: 14402,
      Date: "07/07/2021 22:50:41",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 5600,
      totWin: 41800,
      product: "Slot Of Money",
      category: "Casino",
      username: 256789156900,
      ID: 14401,
      Date: "07/07/2021 22:47:41",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 10250,
      totWin: 11000,
      product: "Storming Flame",
      category: "Casino",
      username: 256789156900,
      ID: 14400,
      Date: "07/07/2021 22:44:42",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 4500,
      totWin: 2000,
      product: "Burning Flame",
      category: "Casino",
      username: 256789156900,
      ID: 14399,
      Date: "07/07/2021 22:40:10",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 8095,
      totWin: 1850,
      product: "Virtual Football Pro",
      category: "Virtuals",
      username: 256780850357,
      ID: 14398,
      Date: "07/07/2021 22:24:29",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 16510,
      totWin: 20755,
      product: "Virtual Football Pro",
      category: "Virtuals",
      username: 256780850357,
      ID: 14397,
      Date: "07/07/2021 22:13:12",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 14396,
      Date: "07/07/2021 17:40:08",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 14395,
      Date: "07/07/2021 17:39:55",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 1000,
      totWin: 0,
      product: "Virtual Football Pro",
      category: "Virtuals",
      username: 256780850357,
      ID: 14394,
      Date: "07/07/2021 20:09:49",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 2490,
      totWin: 950,
      product: "Virtual Football Pro",
      category: "Virtuals",
      username: 256780850357,
      ID: 14393,
      Date: "07/07/2021 19:45:32",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 1628,
      totWin: 1570,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256701052616,
      ID: 14392,
      Date: "07/07/2021 18:13:00",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 600,
      totWin: 2598,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256701052616,
      ID: 14391,
      Date: "07/07/2021 18:03:20",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 17900,
      totWin: 9900,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256701052616,
      ID: 14390,
      Date: "07/07/2021 18:01:03",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 12000,
      totWin: 12630,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256701052616,
      ID: 14389,
      Date: "07/07/2021 17:43:07",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 5112,
      totWin: 4950,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256701052616,
      ID: 14388,
      Date: "07/07/2021 17:33:46",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 40000,
      totWin: 49000,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256701052616,
      ID: 14387,
      Date: "07/07/2021 17:25:25",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 1581,
      totWin: 1162,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256701052616,
      ID: 14386,
      Date: "07/07/2021 17:07:43",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 6000,
      totWin: 4860,
      product: "Virtual Soccer",
      category: "Virtuals",
      username: 256754688249,
      ID: 14385,
      Date: "07/07/2021 17:05:49",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 14384,
      Date: "07/07/2021 13:28:56",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 14383,
      Date: "07/07/2021 12:43:42",
      channel: "Online",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 14382,
      Date: "07/07/2021 08:08:04",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 14381,
      Date: "07/07/2021 08:07:30",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 174500,
      totWin: 144900,
      product: "Jumpin Pot",
      category: "Casino",
      username: 256775784921,
      ID: 14380,
      Date: "07/07/2021 05:40:11",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 250,
      totWin: 0,
      product: "Burning Flame",
      category: "Casino",
      username: 256789156900,
      ID: 14379,
      Date: "07/07/2021 01:48:20",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 14378,
      Date: "06/07/2021 21:35:38",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 14377,
      Date: "06/07/2021 21:35:09",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 14376,
      Date: "06/07/2021 21:34:48",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 14375,
      Date: "06/07/2021 21:34:02",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 14374,
      Date: "06/07/2021 21:33:37",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 14373,
      Date: "06/07/2021 21:33:16",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 1000,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 14372,
      Date: "06/07/2021 21:32:12",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 14371,
      Date: "06/07/2021 21:29:57",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 14370,
      Date: "06/07/2021 21:29:29",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 14369,
      Date: "06/07/2021 21:29:02",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 14368,
      Date: "06/07/2021 21:28:05",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 14367,
      Date: "06/07/2021 21:26:52",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 14366,
      Date: "06/07/2021 21:26:27",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 14365,
      Date: "06/07/2021 21:25:55",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 14364,
      Date: "06/07/2021 21:25:26",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 14363,
      Date: "06/07/2021 21:24:59",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 14362,
      Date: "06/07/2021 21:23:22",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 14361,
      Date: "06/07/2021 21:22:36",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 14360,
      Date: "06/07/2021 21:21:14",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 4000,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 14359,
      Date: "06/07/2021 21:20:12",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 1000,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 14358,
      Date: "06/07/2021 21:19:15",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 1000,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 14357,
      Date: "06/07/2021 21:18:31",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 500,
      totWin: 0,
      product: "Virtual Europa",
      category: "Virtuals",
      username: 256750737621,
      ID: 14356,
      Date: "06/07/2021 19:03:31",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 500,
      totWin: 900,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256750737621,
      ID: 14355,
      Date: "06/07/2021 18:57:09",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 1000,
      totWin: 1020,
      product: "Virtual Europa",
      category: "Virtuals",
      username: 256750737621,
      ID: 14354,
      Date: "06/07/2021 18:41:30",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 500,
      totWin: 0,
      product: "Virtual World Cup",
      category: "Virtuals",
      username: 256750737621,
      ID: 14353,
      Date: "06/07/2021 17:21:42",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 500,
      totWin: 0,
      product: "Virtual Europa",
      category: "Virtuals",
      username: 256770857444,
      ID: 14352,
      Date: "06/07/2021 15:59:35",
      channel: "Online",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 506,
      totWin: 0,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256770857444,
      ID: 14351,
      Date: "06/07/2021 15:56:26",
      channel: "Online",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 500,
      totWin: 0,
      product: "Virtual World Cup",
      category: "Virtuals",
      username: 256770857444,
      ID: 14350,
      Date: "06/07/2021 15:41:11",
      channel: "Online",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 300,
      totWin: 0,
      product: "More Cash",
      category: "Casino",
      username: 256770565627,
      ID: 14349,
      Date: "06/07/2021 11:04:08",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 1000,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 14348,
      Date: "06/07/2021 04:44:26",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 14347,
      Date: "06/07/2021 04:43:34",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 1000,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 14346,
      Date: "06/07/2021 04:42:27",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 14345,
      Date: "06/07/2021 04:40:03",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 15000,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 14344,
      Date: "05/07/2021 21:09:07",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 14343,
      Date: "05/07/2021 21:06:33",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 14342,
      Date: "05/07/2021 21:05:57",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 14341,
      Date: "05/07/2021 21:05:38",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 14340,
      Date: "05/07/2021 21:05:38",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 14339,
      Date: "05/07/2021 21:05:37",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 14338,
      Date: "05/07/2021 21:05:37",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 14337,
      Date: "05/07/2021 21:05:37",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 14336,
      Date: "05/07/2021 21:05:37",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 14335,
      Date: "05/07/2021 21:05:37",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 14334,
      Date: "05/07/2021 21:05:37",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 1000,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 14333,
      Date: "05/07/2021 21:05:36",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 14332,
      Date: "05/07/2021 21:05:36",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 1000,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 14331,
      Date: "05/07/2021 21:05:36",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 14330,
      Date: "05/07/2021 21:05:35",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 14329,
      Date: "05/07/2021 21:04:29",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 14328,
      Date: "05/07/2021 21:03:22",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 14327,
      Date: "05/07/2021 21:02:51",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 4000,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 14326,
      Date: "05/07/2021 21:01:40",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 14325,
      Date: "05/07/2021 21:00:47",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 14324,
      Date: "05/07/2021 21:00:16",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 14323,
      Date: "05/07/2021 20:58:55",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 1000,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 14322,
      Date: "05/07/2021 20:58:10",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 1000,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 14321,
      Date: "05/07/2021 20:57:08",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 14320,
      Date: "05/07/2021 20:56:05",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 14319,
      Date: "05/07/2021 20:54:59",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 7600,
      totWin: 800,
      product: "Slot Of Money",
      category: "Casino",
      username: 256789156900,
      ID: 14318,
      Date: "05/07/2021 23:49:11",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 1500,
      totWin: 900,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256779971376,
      ID: 14317,
      Date: "05/07/2021 12:56:19",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 14316,
      Date: "05/07/2021 06:51:55",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 1000,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 14315,
      Date: "05/07/2021 06:45:08",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 4200,
      totWin: 2185,
      product: "Virtual Football Pro",
      category: "Virtuals",
      username: 256780850357,
      ID: 14314,
      Date: "04/07/2021 23:43:14",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 15687,
      totWin: 10495,
      product: "Virtual Football Pro",
      category: "Virtuals",
      username: 256780850357,
      ID: 14313,
      Date: "04/07/2021 23:29:43",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 8000,
      totWin: 4300,
      product: "Virtual Football Pro",
      category: "Virtuals",
      username: 256780850357,
      ID: 14312,
      Date: "04/07/2021 23:08:13",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 14311,
      Date: "04/07/2021 20:06:35",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 5500,
      totWin: 8167.5,
      product: "Virtual Football Pro",
      category: "Virtuals",
      username: 256780850357,
      ID: 14310,
      Date: "04/07/2021 22:17:17",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 8250,
      totWin: 5280,
      product: "Virtual Football Pro",
      category: "Virtuals",
      username: 256780850357,
      ID: 14309,
      Date: "04/07/2021 22:00:10",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 14308,
      Date: "04/07/2021 18:02:06",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 14307,
      Date: "04/07/2021 17:56:00",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 2000,
      totWin: 1050,
      product: "Virtual Football Pro",
      category: "Virtuals",
      username: 256780850357,
      ID: 14306,
      Date: "04/07/2021 20:52:55",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 2000,
      totWin: 0,
      product: "Virtual Euros",
      category: "Virtuals",
      username: 256770857444,
      ID: 14305,
      Date: "04/07/2021 18:53:09",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 500,
      totWin: 0,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256770857444,
      ID: 14304,
      Date: "04/07/2021 18:42:18",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 1000,
      totWin: 0,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256770857444,
      ID: 14303,
      Date: "04/07/2021 18:38:12",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 4500,
      totWin: 5006,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256770857444,
      ID: 14302,
      Date: "04/07/2021 18:29:55",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 14301,
      Date: "04/07/2021 09:35:02",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 14300,
      Date: "04/07/2021 09:34:38",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 14299,
      Date: "04/07/2021 09:31:37",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 7500,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 14298,
      Date: "04/07/2021 09:31:04",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 14297,
      Date: "04/07/2021 09:30:40",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 14296,
      Date: "04/07/2021 09:30:11",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 1000,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 14295,
      Date: "04/07/2021 09:29:30",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 28955,
      totWin: 25300,
      product: "Virtual Football Pro",
      category: "Virtuals",
      username: 256780850357,
      ID: 14294,
      Date: "04/07/2021 10:24:36",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 56500,
      totWin: 68440,
      product: "Castle Blood",
      category: "Casino",
      username: 256775784921,
      ID: 14293,
      Date: "04/07/2021 10:02:05",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 46000,
      totWin: 14150,
      product: "Circus of Horror",
      category: "Casino",
      username: 256775784921,
      ID: 14292,
      Date: "04/07/2021 09:55:02",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 28200,
      totWin: 58680,
      product: "Battle for Atlantis",
      category: "Casino",
      username: 256775784921,
      ID: 14291,
      Date: "04/07/2021 09:48:49",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 159500,
      totWin: 175100,
      product: "Chili Quest",
      category: "Casino",
      username: 256775784921,
      ID: 14290,
      Date: "04/07/2021 09:42:26",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 2000,
      totWin: 6200,
      product: "Chili Quest",
      category: "Casino",
      username: 256775784921,
      ID: 14289,
      Date: "04/07/2021 09:25:00",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 134000,
      totWin: 104200,
      product: "Jumpin Pot",
      category: "Casino",
      username: 256775784921,
      ID: 14288,
      Date: "04/07/2021 08:55:21",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 15000,
      totWin: 15580,
      product: "Virtual Football Pro",
      category: "Virtuals",
      username: 256780850357,
      ID: 14287,
      Date: "04/07/2021 07:57:01",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 65500,
      totWin: 57525,
      product: "Virtual Football Pro",
      category: "Virtuals",
      username: 256780850357,
      ID: 14286,
      Date: "04/07/2021 07:28:53",
      channel: "n/a",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 39850,
      totWin: 46613,
      product: "Virtual Football Pro",
      category: "Virtuals",
      username: 256780850357,
      ID: 14285,
      Date: "03/07/2021 22:56:13",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 99000,
      totWin: 58320,
      product: "Battle for Atlantis",
      category: "Casino",
      username: 256752170079,
      ID: 14284,
      Date: "03/07/2021 22:21:45",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 10800,
      totWin: 11920,
      product: "Battle for Atlantis",
      category: "Casino",
      username: 256752170079,
      ID: 14283,
      Date: "03/07/2021 22:08:14",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 5400,
      totWin: 35800,
      product: "Battle for Atlantis",
      category: "Casino",
      username: 256752170079,
      ID: 14282,
      Date: "03/07/2021 21:59:19",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 10000,
      totWin: 900,
      product: "Chili Quest",
      category: "Casino",
      username: 256752170079,
      ID: 14281,
      Date: "03/07/2021 21:32:28",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 4750,
      totWin: 3875,
      product: "Virtual Football Pro",
      category: "Virtuals",
      username: 256780850357,
      ID: 14280,
      Date: "03/07/2021 19:28:36",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 4500,
      totWin: 1100,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256779971376,
      ID: 14279,
      Date: "03/07/2021 19:01:13",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 4000,
      totWin: 2100,
      product: "Virtual Football Pro",
      category: "Virtuals",
      username: 256780850357,
      ID: 14278,
      Date: "03/07/2021 18:35:38",
      channel: "n/a",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 500,
      totWin: 0,
      product: "Virtual World Cup",
      category: "Virtuals",
      username: 256788078047,
      ID: 14277,
      Date: "03/07/2021 16:41:39",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 500,
      totWin: 0,
      product: "Virtual Europa",
      category: "Virtuals",
      username: 256788078047,
      ID: 14276,
      Date: "03/07/2021 16:35:28",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 5000,
      totWin: 0,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256750743214,
      ID: 14275,
      Date: "03/07/2021 16:14:12",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 14274,
      Date: "03/07/2021 12:11:07",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 1500,
      totWin: 600,
      product: "Chinese Zodiac",
      category: "Casino",
      username: 256787883037,
      ID: 14273,
      Date: "03/07/2021 10:50:09",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 11536,
      totWin: 10282.95,
      product: "Virtual Football Pro",
      category: "Virtuals",
      username: 256780850357,
      ID: 14272,
      Date: "03/07/2021 08:20:30",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 12495,
      totWin: 11564.75,
      product: "Virtual Football Pro",
      category: "Virtuals",
      username: 256780850357,
      ID: 14271,
      Date: "03/07/2021 07:48:44",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 14270,
      Date: "03/07/2021 03:30:26",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 14269,
      Date: "03/07/2021 03:29:45",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 14268,
      Date: "03/07/2021 03:28:59",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 1000,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 14267,
      Date: "03/07/2021 03:27:30",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 26000,
      totWin: 63470,
      product: "Virtual Football Pro",
      category: "Virtuals",
      username: 256780850357,
      ID: 14266,
      Date: "02/07/2021 23:50:20",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 60500,
      totWin: 77325,
      product: "Virtual Football Pro",
      category: "Virtuals",
      username: 256780850357,
      ID: 14265,
      Date: "02/07/2021 23:32:13",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 4721.73,
      totWin: 3478.39,
      product: "Virtual Football Pro",
      category: "Virtuals",
      username: 256780850357,
      ID: 14264,
      Date: "02/07/2021 22:44:22",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 5500,
      totWin: 3990,
      product: "Virtual Football Pro",
      category: "Virtuals",
      username: 256780850357,
      ID: 14263,
      Date: "02/07/2021 22:15:00",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 1000,
      totWin: 1665,
      product: "Virtual Euros",
      category: "Virtuals",
      username: 256789120217,
      ID: 14262,
      Date: "02/07/2021 20:40:36",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 500,
      totWin: 865,
      product: "Virtual Euros",
      category: "Virtuals",
      username: 256789120217,
      ID: 14261,
      Date: "02/07/2021 20:35:37",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 500,
      totWin: 0,
      product: "Virtual Football Pro",
      category: "Virtuals",
      username: 256789120217,
      ID: 14260,
      Date: "02/07/2021 20:33:47",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 500,
      totWin: 1297.5,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256789120217,
      ID: 14259,
      Date: "02/07/2021 20:31:32",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 1000,
      totWin: 0,
      product: "Virtual Euros",
      category: "Virtuals",
      username: 256789120217,
      ID: 14258,
      Date: "02/07/2021 20:11:41",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 14257,
      Date: "02/07/2021 16:08:02",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 1500,
      totWin: 3039.49,
      product: "Virtual Europa",
      category: "Virtuals",
      username: 256788078047,
      ID: 14256,
      Date: "02/07/2021 19:07:57",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 14255,
      Date: "02/07/2021 16:06:12",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 14254,
      Date: "02/07/2021 16:05:34",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 500,
      totWin: 0,
      product: "Virtual World Cup",
      category: "Virtuals",
      username: 256788078047,
      ID: 14253,
      Date: "02/07/2021 18:58:37",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 3500,
      totWin: 4702.5,
      product: "Virtual World Cup",
      category: "Virtuals",
      username: 256788078047,
      ID: 14252,
      Date: "02/07/2021 18:45:18",
      channel: "n/a",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 5500,
      totWin: 3612.5,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256775478737,
      ID: 14251,
      Date: "02/07/2021 18:39:57",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 2000,
      totWin: 1290,
      product: "Virtual Football Pro",
      category: "Virtuals",
      username: 256780850357,
      ID: 14250,
      Date: "02/07/2021 17:50:30",
      channel: "n/a",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 500,
      totWin: 0,
      product: "Virtual Europa",
      category: "Virtuals",
      username: 256788078047,
      ID: 14249,
      Date: "02/07/2021 17:35:22",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 500,
      totWin: 1499.35,
      product: "Virtual World Cup",
      category: "Virtuals",
      username: 256788078047,
      ID: 14248,
      Date: "02/07/2021 17:32:41",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 2500,
      totWin: 1760,
      product: "Virtual Football Pro",
      category: "Virtuals",
      username: 256780850357,
      ID: 14247,
      Date: "02/07/2021 17:13:32",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 14246,
      Date: "02/07/2021 13:10:08",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 7500,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 14245,
      Date: "02/07/2021 12:36:15",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 1000,
      totWin: 0,
      product: "Virtual Soccer",
      category: "Virtuals",
      username: 256788078047,
      ID: 14244,
      Date: "02/07/2021 12:56:26",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 500,
      totWin: 0,
      product: "Virtual Euros",
      category: "Virtuals",
      username: 256788078047,
      ID: 14243,
      Date: "02/07/2021 12:27:22",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 500,
      totWin: 0,
      product: "Virtual World Cup",
      category: "Virtuals",
      username: 256788078047,
      ID: 14242,
      Date: "02/07/2021 12:25:15",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 4500,
      totWin: 1200,
      product: "Chili Quest",
      category: "Casino",
      username: 256774334652,
      ID: 14241,
      Date: "02/07/2021 06:42:35",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 7500,
      totWin: 3000,
      product: "Chili Quest",
      category: "Casino",
      username: 256774334652,
      ID: 14240,
      Date: "02/07/2021 06:38:49",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 14239,
      Date: "01/07/2021 19:35:43",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 14238,
      Date: "01/07/2021 19:35:23",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 1000,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 14237,
      Date: "01/07/2021 19:34:59",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 14236,
      Date: "01/07/2021 19:34:21",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 14235,
      Date: "01/07/2021 19:33:42",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 2000,
      totWin: 0,
      product: "Virtual Football Pro",
      category: "Virtuals",
      username: 256789120217,
      ID: 14234,
      Date: "01/07/2021 22:19:47",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 2000,
      totWin: 2101,
      product: "Virtual Football Pro",
      category: "Virtuals",
      username: 256789120217,
      ID: 14233,
      Date: "01/07/2021 22:08:22",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 1500,
      totWin: 2414.99,
      product: "Virtual Football Pro",
      category: "Virtuals",
      username: 256789120217,
      ID: 14232,
      Date: "01/07/2021 21:59:10",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 500,
      totWin: 2100,
      product: "Virtual Football Pro",
      category: "Virtuals",
      username: 256789120217,
      ID: 14231,
      Date: "01/07/2021 21:31:06",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 500,
      totWin: 2000,
      product: "Virtual Euros",
      category: "Virtuals",
      username: 256789120217,
      ID: 14230,
      Date: "01/07/2021 21:25:42",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 2000,
      totWin: 5405,
      product: "Virtual Soccer",
      category: "Virtuals",
      username: 256789120217,
      ID: 14229,
      Date: "01/07/2021 21:22:09",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 500,
      totWin: 0,
      product: "Virtual Euros",
      category: "Virtuals",
      username: 256789120217,
      ID: 14228,
      Date: "01/07/2021 21:11:38",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 500,
      totWin: 0,
      product: "Virtual Euros",
      category: "Virtuals",
      username: 256789120217,
      ID: 14227,
      Date: "01/07/2021 21:08:26",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 1000,
      totWin: 0,
      product: "Virtual Europa",
      category: "Virtuals",
      username: 256789120217,
      ID: 14226,
      Date: "01/07/2021 21:03:56",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 500,
      totWin: 0,
      product: "Virtual Euros",
      category: "Virtuals",
      username: 256789120217,
      ID: 14225,
      Date: "01/07/2021 20:55:28",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 500,
      totWin: 2005.5,
      product: "Virtual Europa",
      category: "Virtuals",
      username: 256789120217,
      ID: 14224,
      Date: "01/07/2021 20:45:25",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 1000,
      totWin: 1773.25,
      product: "Virtual Euros",
      category: "Virtuals",
      username: 256789120217,
      ID: 14223,
      Date: "01/07/2021 20:41:32",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 1000,
      totWin: 2598.75,
      product: "Virtual Euros",
      category: "Virtuals",
      username: 256789120217,
      ID: 14222,
      Date: "01/07/2021 20:29:25",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 19800,
      totWin: 4500,
      product: "Lucky Babies",
      category: "Casino",
      username: 256756536561,
      ID: 14221,
      Date: "01/07/2021 20:25:02",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 4000,
      totWin: 12300,
      product: "Four Symbols",
      category: "Casino",
      username: 256756536561,
      ID: 14220,
      Date: "01/07/2021 20:21:22",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 1000,
      totWin: 0,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256789120217,
      ID: 14219,
      Date: "01/07/2021 20:19:48",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 4800,
      totWin: 1900,
      product: "Night At KTV",
      category: "Casino",
      username: 256756536561,
      ID: 14218,
      Date: "01/07/2021 20:15:51",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 26250,
      totWin: 16660,
      product: "Wolf Quest",
      category: "Casino",
      username: 256752170079,
      ID: 14217,
      Date: "01/07/2021 19:53:08",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 600,
      totWin: 0,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256752170079,
      ID: 14216,
      Date: "01/07/2021 19:48:28",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 6517,
      totWin: 5170,
      product: "Virtual Football Pro",
      category: "Virtuals",
      username: 256780850357,
      ID: 14215,
      Date: "01/07/2021 17:21:47",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 500,
      totWin: 785,
      product: "Virtual Football Pro",
      category: "Virtuals",
      username: 256780850357,
      ID: 14214,
      Date: "01/07/2021 15:53:23",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 1000,
      totWin: 0,
      product: "Chili Quest",
      category: "Casino",
      username: 256774334652,
      ID: 14213,
      Date: "01/07/2021 15:06:00",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 8000,
      totWin: 1600,
      product: "Chili Quest",
      category: "Casino",
      username: 256752170079,
      ID: 14212,
      Date: "01/07/2021 13:50:30",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 500,
      totWin: 0,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256781922875,
      ID: 14211,
      Date: "01/07/2021 13:08:15",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 5615,
      totWin: 3200,
      product: "Virtual Football Pro",
      category: "Virtuals",
      username: 256780850357,
      ID: 14210,
      Date: "01/07/2021 12:32:52",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 7750,
      totWin: 5450,
      product: "Virtual Football Pro",
      category: "Virtuals",
      username: 256780850357,
      ID: 14209,
      Date: "01/07/2021 12:20:36",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 500,
      totWin: 0,
      product: "Virtual Football Pro",
      category: "Virtuals",
      username: 256779971376,
      ID: 14208,
      Date: "01/07/2021 12:12:57",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 4500,
      totWin: 4960,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256779971376,
      ID: 14207,
      Date: "01/07/2021 12:06:25",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 6490,
      totWin: 9207.75,
      product: "Virtual Football Pro",
      category: "Virtuals",
      username: 256780850357,
      ID: 14206,
      Date: "01/07/2021 11:56:02",
      channel: "n/a",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 39833,
      totWin: 40171.2,
      product: "Virtual Football Pro",
      category: "Virtuals",
      username: 256780850357,
      ID: 14205,
      Date: "01/07/2021 11:41:44",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 5000,
      totWin: 4120,
      product: "Virtual Champions",
      category: "Virtuals",
      username: 256779971376,
      ID: 14204,
      Date: "01/07/2021 11:39:15",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 14203,
      Date: "01/07/2021 08:22:48",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 14202,
      Date: "01/07/2021 08:22:13",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 14201,
      Date: "01/07/2021 08:21:10",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 0,
      totWin: 0,
      product: "Sports",
      category: "SportsBetting",
      username: "",
      ID: 14200,
      Date: "01/07/2021 08:20:22",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
    {
      totAmount: 8000,
      totWin: 7270,
      product: "Virtual Football Pro",
      category: "Virtuals",
      username: 256780850357,
      ID: 14199,
      Date: "01/07/2021 10:08:45",
      channel: "Mobile",
      tax: 0,
      Status: "",
    },
  ]
  if (key == "All") return data
  else return data.filter(item => item.Status == key)
}

export const cardsData = [
  {
    color: "white",
    fontColor: "text-dark",
    title: "Total Void",
    description: "$0.00",
    borderClass: "border border-dark",
  },
  {
    color: "primary",
    fontColor: "text-white",
    title: "Total Stake",
    description: "$50.00",
    borderClass: "",
  },
  {
    color: "danger",
    fontColor: "text-white",
    title: "Max Possible Payout",
    description: "$1,377.45",
    borderClass: "",
  },
  {
    color: "warning",
    fontColor: "text-dark",
    title: "Current Value",
    description: "$0.00",
    borderClass: "",
  },
]
